var Sa = Object.defineProperty, wa = Object.defineProperties;
var Ea = Object.getOwnPropertyDescriptors;
var Lt = Object.getOwnPropertySymbols;
var di = Object.prototype.hasOwnProperty, fi = Object.prototype.propertyIsEnumerable;
var Ln = (t, e, n) => e in t ? Sa(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, w = (t, e) => {
  for (var n in e || (e = {}))
    di.call(e, n) && Ln(t, n, e[n]);
  if (Lt)
    for (var n of Lt(e))
      fi.call(e, n) && Ln(t, n, e[n]);
  return t;
}, j = (t, e) => wa(t, Ea(e));
var hi = (t, e) => {
  var n = {};
  for (var r in t)
    di.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && Lt)
    for (var r of Lt(t))
      e.indexOf(r) < 0 && fi.call(t, r) && (n[r] = t[r]);
  return n;
};
var O = (t, e, n) => Ln(t, typeof e != "symbol" ? e + "" : e, n);
var M = (t, e, n) => new Promise((r, i) => {
  var o = (u) => {
    try {
      a(n.next(u));
    } catch (c) {
      i(c);
    }
  }, s = (u) => {
    try {
      a(n.throw(u));
    } catch (c) {
      i(c);
    }
  }, a = (u) => u.done ? r(u.value) : Promise.resolve(u.value).then(o, s);
  a((n = n.apply(t, e)).next());
});
/*! Gid_version: 2.1.6 */
function ka(t, e) {
  for (var n = 0; n < e.length; n++) {
    const r = e[n];
    if (typeof r != "string" && !Array.isArray(r)) {
      for (const i in r)
        if (i !== "default" && !(i in t)) {
          const o = Object.getOwnPropertyDescriptor(r, i);
          o && Object.defineProperty(t, i, o.get ? o : {
            enumerable: !0,
            get: () => r[i]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }));
}
var xa = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Aa(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Ia(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
var Nn = { exports: {} };
const Ca = {}, Ta = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ca
}, Symbol.toStringTag, { value: "Module" })), pi = /* @__PURE__ */ Ia(Ta);
/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.11.1
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2025
 * @license MIT
 */
var gi;
function Oa() {
  return gi || (gi = 1, function(t) {
    (function() {
      var e = "input is invalid type", n = typeof window == "object", r = n ? window : {};
      r.JS_SHA256_NO_WINDOW && (n = !1);
      var i = !n && typeof self == "object", o = !r.JS_SHA256_NO_NODE_JS && typeof process == "object" && process.versions && process.versions.node && process.type != "renderer";
      o ? r = xa : i && (r = self);
      var s = !r.JS_SHA256_NO_COMMON_JS && !0 && t.exports, a = !r.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer != "undefined", u = "0123456789abcdef".split(""), c = [-2147483648, 8388608, 32768, 128], l = [24, 16, 8, 0], d = [
        1116352408,
        1899447441,
        3049323471,
        3921009573,
        961987163,
        1508970993,
        2453635748,
        2870763221,
        3624381080,
        310598401,
        607225278,
        1426881987,
        1925078388,
        2162078206,
        2614888103,
        3248222580,
        3835390401,
        4022224774,
        264347078,
        604807628,
        770255983,
        1249150122,
        1555081692,
        1996064986,
        2554220882,
        2821834349,
        2952996808,
        3210313671,
        3336571891,
        3584528711,
        113926993,
        338241895,
        666307205,
        773529912,
        1294757372,
        1396182291,
        1695183700,
        1986661051,
        2177026350,
        2456956037,
        2730485921,
        2820302411,
        3259730800,
        3345764771,
        3516065817,
        3600352804,
        4094571909,
        275423344,
        430227734,
        506948616,
        659060556,
        883997877,
        958139571,
        1322822218,
        1537002063,
        1747873779,
        1955562222,
        2024104815,
        2227730452,
        2361852424,
        2428436474,
        2756734187,
        3204031479,
        3329325298
      ], f = ["hex", "array", "digest", "arrayBuffer"], h = [];
      (r.JS_SHA256_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(y) {
        return Object.prototype.toString.call(y) === "[object Array]";
      }), a && (r.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(y) {
        return typeof y == "object" && y.buffer && y.buffer.constructor === ArrayBuffer;
      });
      var p = function(y, b) {
        return function(A) {
          return new C(b, !0).update(A)[y]();
        };
      }, v = function(y) {
        var b = p("hex", y);
        o && (b = g(b, y)), b.create = function() {
          return new C(y);
        }, b.update = function(x) {
          return b.create().update(x);
        };
        for (var A = 0; A < f.length; ++A) {
          var S = f[A];
          b[S] = p(S, y);
        }
        return b;
      }, g = function(y, b) {
        var A = pi, S = pi.Buffer, x = b ? "sha224" : "sha256", k;
        S.from && !r.JS_SHA256_NO_BUFFER_FROM ? k = S.from : k = function(E) {
          return new S(E);
        };
        var D = function(E) {
          if (typeof E == "string")
            return A.createHash(x).update(E, "utf8").digest("hex");
          if (E == null)
            throw new Error(e);
          return E.constructor === ArrayBuffer && (E = new Uint8Array(E)), Array.isArray(E) || ArrayBuffer.isView(E) || E.constructor === S ? A.createHash(x).update(k(E)).digest("hex") : y(E);
        };
        return D;
      }, m = function(y, b) {
        return function(A, S) {
          return new T(A, b, !0).update(S)[y]();
        };
      }, _ = function(y) {
        var b = m("hex", y);
        b.create = function(x) {
          return new T(x, y);
        }, b.update = function(x, k) {
          return b.create(x).update(k);
        };
        for (var A = 0; A < f.length; ++A) {
          var S = f[A];
          b[S] = m(S, y);
        }
        return b;
      };
      function C(y, b) {
        b ? (h[0] = h[16] = h[1] = h[2] = h[3] = h[4] = h[5] = h[6] = h[7] = h[8] = h[9] = h[10] = h[11] = h[12] = h[13] = h[14] = h[15] = 0, this.blocks = h) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], y ? (this.h0 = 3238371032, this.h1 = 914150663, this.h2 = 812702999, this.h3 = 4144912697, this.h4 = 4290775857, this.h5 = 1750603025, this.h6 = 1694076839, this.h7 = 3204075428) : (this.h0 = 1779033703, this.h1 = 3144134277, this.h2 = 1013904242, this.h3 = 2773480762, this.h4 = 1359893119, this.h5 = 2600822924, this.h6 = 528734635, this.h7 = 1541459225), this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0, this.is224 = y;
      }
      C.prototype.update = function(y) {
        if (!this.finalized) {
          var b, A = typeof y;
          if (A !== "string") {
            if (A === "object") {
              if (y === null)
                throw new Error(e);
              if (a && y.constructor === ArrayBuffer)
                y = new Uint8Array(y);
              else if (!Array.isArray(y) && (!a || !ArrayBuffer.isView(y)))
                throw new Error(e);
            } else
              throw new Error(e);
            b = !0;
          }
          for (var S, x = 0, k, D = y.length, E = this.blocks; x < D; ) {
            if (this.hashed && (this.hashed = !1, E[0] = this.block, this.block = E[16] = E[1] = E[2] = E[3] = E[4] = E[5] = E[6] = E[7] = E[8] = E[9] = E[10] = E[11] = E[12] = E[13] = E[14] = E[15] = 0), b)
              for (k = this.start; x < D && k < 64; ++x)
                E[k >>> 2] |= y[x] << l[k++ & 3];
            else
              for (k = this.start; x < D && k < 64; ++x)
                S = y.charCodeAt(x), S < 128 ? E[k >>> 2] |= S << l[k++ & 3] : S < 2048 ? (E[k >>> 2] |= (192 | S >>> 6) << l[k++ & 3], E[k >>> 2] |= (128 | S & 63) << l[k++ & 3]) : S < 55296 || S >= 57344 ? (E[k >>> 2] |= (224 | S >>> 12) << l[k++ & 3], E[k >>> 2] |= (128 | S >>> 6 & 63) << l[k++ & 3], E[k >>> 2] |= (128 | S & 63) << l[k++ & 3]) : (S = 65536 + ((S & 1023) << 10 | y.charCodeAt(++x) & 1023), E[k >>> 2] |= (240 | S >>> 18) << l[k++ & 3], E[k >>> 2] |= (128 | S >>> 12 & 63) << l[k++ & 3], E[k >>> 2] |= (128 | S >>> 6 & 63) << l[k++ & 3], E[k >>> 2] |= (128 | S & 63) << l[k++ & 3]);
            this.lastByteIndex = k, this.bytes += k - this.start, k >= 64 ? (this.block = E[16], this.start = k - 64, this.hash(), this.hashed = !0) : this.start = k;
          }
          return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
        }
      }, C.prototype.finalize = function() {
        if (!this.finalized) {
          this.finalized = !0;
          var y = this.blocks, b = this.lastByteIndex;
          y[16] = this.block, y[b >>> 2] |= c[b & 3], this.block = y[16], b >= 56 && (this.hashed || this.hash(), y[0] = this.block, y[16] = y[1] = y[2] = y[3] = y[4] = y[5] = y[6] = y[7] = y[8] = y[9] = y[10] = y[11] = y[12] = y[13] = y[14] = y[15] = 0), y[14] = this.hBytes << 3 | this.bytes >>> 29, y[15] = this.bytes << 3, this.hash();
        }
      }, C.prototype.hash = function() {
        var y = this.h0, b = this.h1, A = this.h2, S = this.h3, x = this.h4, k = this.h5, D = this.h6, E = this.h7, L = this.blocks, U, q, z, H, $, ye, me, vt, Pn, Fn, Ft;
        for (U = 16; U < 64; ++U)
          $ = L[U - 15], q = ($ >>> 7 | $ << 25) ^ ($ >>> 18 | $ << 14) ^ $ >>> 3, $ = L[U - 2], z = ($ >>> 17 | $ << 15) ^ ($ >>> 19 | $ << 13) ^ $ >>> 10, L[U] = L[U - 16] + q + L[U - 7] + z << 0;
        for (Ft = b & A, U = 0; U < 64; U += 4)
          this.first ? (this.is224 ? (vt = 300032, $ = L[0] - 1413257819, E = $ - 150054599 << 0, S = $ + 24177077 << 0) : (vt = 704751109, $ = L[0] - 210244248, E = $ - 1521486534 << 0, S = $ + 143694565 << 0), this.first = !1) : (q = (y >>> 2 | y << 30) ^ (y >>> 13 | y << 19) ^ (y >>> 22 | y << 10), z = (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7), vt = y & b, H = vt ^ y & A ^ Ft, me = x & k ^ ~x & D, $ = E + z + me + d[U] + L[U], ye = q + H, E = S + $ << 0, S = $ + ye << 0), q = (S >>> 2 | S << 30) ^ (S >>> 13 | S << 19) ^ (S >>> 22 | S << 10), z = (E >>> 6 | E << 26) ^ (E >>> 11 | E << 21) ^ (E >>> 25 | E << 7), Pn = S & y, H = Pn ^ S & b ^ vt, me = E & x ^ ~E & k, $ = D + z + me + d[U + 1] + L[U + 1], ye = q + H, D = A + $ << 0, A = $ + ye << 0, q = (A >>> 2 | A << 30) ^ (A >>> 13 | A << 19) ^ (A >>> 22 | A << 10), z = (D >>> 6 | D << 26) ^ (D >>> 11 | D << 21) ^ (D >>> 25 | D << 7), Fn = A & S, H = Fn ^ A & y ^ Pn, me = D & E ^ ~D & x, $ = k + z + me + d[U + 2] + L[U + 2], ye = q + H, k = b + $ << 0, b = $ + ye << 0, q = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10), z = (k >>> 6 | k << 26) ^ (k >>> 11 | k << 21) ^ (k >>> 25 | k << 7), Ft = b & A, H = Ft ^ b & S ^ Fn, me = k & D ^ ~k & E, $ = x + z + me + d[U + 3] + L[U + 3], ye = q + H, x = y + $ << 0, y = $ + ye << 0, this.chromeBugWorkAround = !0;
        this.h0 = this.h0 + y << 0, this.h1 = this.h1 + b << 0, this.h2 = this.h2 + A << 0, this.h3 = this.h3 + S << 0, this.h4 = this.h4 + x << 0, this.h5 = this.h5 + k << 0, this.h6 = this.h6 + D << 0, this.h7 = this.h7 + E << 0;
      }, C.prototype.hex = function() {
        this.finalize();
        var y = this.h0, b = this.h1, A = this.h2, S = this.h3, x = this.h4, k = this.h5, D = this.h6, E = this.h7, L = u[y >>> 28 & 15] + u[y >>> 24 & 15] + u[y >>> 20 & 15] + u[y >>> 16 & 15] + u[y >>> 12 & 15] + u[y >>> 8 & 15] + u[y >>> 4 & 15] + u[y & 15] + u[b >>> 28 & 15] + u[b >>> 24 & 15] + u[b >>> 20 & 15] + u[b >>> 16 & 15] + u[b >>> 12 & 15] + u[b >>> 8 & 15] + u[b >>> 4 & 15] + u[b & 15] + u[A >>> 28 & 15] + u[A >>> 24 & 15] + u[A >>> 20 & 15] + u[A >>> 16 & 15] + u[A >>> 12 & 15] + u[A >>> 8 & 15] + u[A >>> 4 & 15] + u[A & 15] + u[S >>> 28 & 15] + u[S >>> 24 & 15] + u[S >>> 20 & 15] + u[S >>> 16 & 15] + u[S >>> 12 & 15] + u[S >>> 8 & 15] + u[S >>> 4 & 15] + u[S & 15] + u[x >>> 28 & 15] + u[x >>> 24 & 15] + u[x >>> 20 & 15] + u[x >>> 16 & 15] + u[x >>> 12 & 15] + u[x >>> 8 & 15] + u[x >>> 4 & 15] + u[x & 15] + u[k >>> 28 & 15] + u[k >>> 24 & 15] + u[k >>> 20 & 15] + u[k >>> 16 & 15] + u[k >>> 12 & 15] + u[k >>> 8 & 15] + u[k >>> 4 & 15] + u[k & 15] + u[D >>> 28 & 15] + u[D >>> 24 & 15] + u[D >>> 20 & 15] + u[D >>> 16 & 15] + u[D >>> 12 & 15] + u[D >>> 8 & 15] + u[D >>> 4 & 15] + u[D & 15];
        return this.is224 || (L += u[E >>> 28 & 15] + u[E >>> 24 & 15] + u[E >>> 20 & 15] + u[E >>> 16 & 15] + u[E >>> 12 & 15] + u[E >>> 8 & 15] + u[E >>> 4 & 15] + u[E & 15]), L;
      }, C.prototype.toString = C.prototype.hex, C.prototype.digest = function() {
        this.finalize();
        var y = this.h0, b = this.h1, A = this.h2, S = this.h3, x = this.h4, k = this.h5, D = this.h6, E = this.h7, L = [
          y >>> 24 & 255,
          y >>> 16 & 255,
          y >>> 8 & 255,
          y & 255,
          b >>> 24 & 255,
          b >>> 16 & 255,
          b >>> 8 & 255,
          b & 255,
          A >>> 24 & 255,
          A >>> 16 & 255,
          A >>> 8 & 255,
          A & 255,
          S >>> 24 & 255,
          S >>> 16 & 255,
          S >>> 8 & 255,
          S & 255,
          x >>> 24 & 255,
          x >>> 16 & 255,
          x >>> 8 & 255,
          x & 255,
          k >>> 24 & 255,
          k >>> 16 & 255,
          k >>> 8 & 255,
          k & 255,
          D >>> 24 & 255,
          D >>> 16 & 255,
          D >>> 8 & 255,
          D & 255
        ];
        return this.is224 || L.push(E >>> 24 & 255, E >>> 16 & 255, E >>> 8 & 255, E & 255), L;
      }, C.prototype.array = C.prototype.digest, C.prototype.arrayBuffer = function() {
        this.finalize();
        var y = new ArrayBuffer(this.is224 ? 28 : 32), b = new DataView(y);
        return b.setUint32(0, this.h0), b.setUint32(4, this.h1), b.setUint32(8, this.h2), b.setUint32(12, this.h3), b.setUint32(16, this.h4), b.setUint32(20, this.h5), b.setUint32(24, this.h6), this.is224 || b.setUint32(28, this.h7), y;
      };
      function T(y, b, A) {
        var S, x = typeof y;
        if (x === "string") {
          var k = [], D = y.length, E = 0, L;
          for (S = 0; S < D; ++S)
            L = y.charCodeAt(S), L < 128 ? k[E++] = L : L < 2048 ? (k[E++] = 192 | L >>> 6, k[E++] = 128 | L & 63) : L < 55296 || L >= 57344 ? (k[E++] = 224 | L >>> 12, k[E++] = 128 | L >>> 6 & 63, k[E++] = 128 | L & 63) : (L = 65536 + ((L & 1023) << 10 | y.charCodeAt(++S) & 1023), k[E++] = 240 | L >>> 18, k[E++] = 128 | L >>> 12 & 63, k[E++] = 128 | L >>> 6 & 63, k[E++] = 128 | L & 63);
          y = k;
        } else if (x === "object") {
          if (y === null)
            throw new Error(e);
          if (a && y.constructor === ArrayBuffer)
            y = new Uint8Array(y);
          else if (!Array.isArray(y) && (!a || !ArrayBuffer.isView(y)))
            throw new Error(e);
        } else
          throw new Error(e);
        y.length > 64 && (y = new C(b, !0).update(y).array());
        var U = [], q = [];
        for (S = 0; S < 64; ++S) {
          var z = y[S] || 0;
          U[S] = 92 ^ z, q[S] = 54 ^ z;
        }
        C.call(this, b, A), this.update(q), this.oKeyPad = U, this.inner = !0, this.sharedMemory = A;
      }
      T.prototype = new C(), T.prototype.finalize = function() {
        if (C.prototype.finalize.call(this), this.inner) {
          this.inner = !1;
          var y = this.array();
          C.call(this, this.is224, this.sharedMemory), this.update(this.oKeyPad), this.update(y), C.prototype.finalize.call(this);
        }
      };
      var R = v();
      R.sha256 = R, R.sha224 = v(!0), R.sha256.hmac = _(), R.sha224.hmac = _(!0), s ? t.exports = R : (r.sha256 = R.sha256, r.sha224 = R.sha224);
    })();
  }(Nn)), Nn.exports;
}
var kt = Oa();
const Ra = "gid.sdk.session.", Mn = (t) => `${Ra}${encodeURIComponent(t)}`, Da = () => typeof window == "undefined" ? !1 : window.location.protocol === "https:", yi = (t) => {
  const e = ["path=/", "SameSite=Lax"];
  return Da() && e.push("Secure"), t != null && t.cookieDomain && e.push(`domain=${t.cookieDomain}`), e.join("; ");
}, Pa = {
  get(t) {
    if (typeof sessionStorage == "undefined")
      return;
    const e = sessionStorage.getItem(t);
    if (e != null)
      return JSON.parse(e);
  },
  save(t, e) {
    sessionStorage.setItem(t, JSON.stringify(e));
  },
  remove(t) {
    sessionStorage.removeItem(t);
  }
}, Fa = {
  get(t) {
    if (typeof document == "undefined")
      return;
    const e = Mn(t), n = document.cookie ? document.cookie.split("; ") : [];
    for (const r of n) {
      const i = r.indexOf("=");
      if (i === -1)
        continue;
      const o = r.slice(0, i), s = r.slice(i + 1);
      if (o === e)
        try {
          return JSON.parse(decodeURIComponent(s));
        } catch (a) {
          return;
        }
    }
  },
  save(t, e, n) {
    if (typeof document == "undefined")
      return;
    const r = Mn(t), i = encodeURIComponent(JSON.stringify(e)), o = yi(n);
    document.cookie = `${r}=${i}; ${o}`;
  },
  remove(t, e) {
    if (typeof document == "undefined")
      return;
    const n = Mn(t), r = yi(e);
    document.cookie = `${n}=; Max-Age=0; ${r}`;
  }
}, La = "gid.sdk.session.", jn = (t) => `${La}${t}`, Na = {
  get(t) {
    if (typeof localStorage != "undefined")
      try {
        const e = localStorage.getItem(jn(t));
        return e == null ? void 0 : JSON.parse(e);
      } catch (e) {
        return;
      }
  },
  save(t, e) {
    if (typeof localStorage != "undefined")
      try {
        localStorage.setItem(jn(t), JSON.stringify(e));
      } catch (n) {
      }
  },
  remove(t) {
    if (typeof localStorage != "undefined")
      try {
        localStorage.removeItem(jn(t));
      } catch (e) {
      }
  }
}, Ma = {
  session: Pa,
  local: Na,
  cookie: Fa
}, ja = (t = "session") => Ma[t];
function gt(r) {
  return M(this, arguments, function* (t, e = {}, n) {
    const i = new AbortController(), o = n ? setTimeout(() => i.abort(), n) : null;
    try {
      return yield fetch(t, j(w({}, e), {
        signal: i.signal
      }));
    } catch (s) {
      if (s instanceof Error && s.name === "AbortError") {
        const a = new Error("The request was aborted due to timeout");
        throw a.name = "TimeoutError", a;
      }
      throw s;
    } finally {
      o && clearTimeout(o);
    }
  });
}
const mi = 43, Ua = 11, $a = 128, vi = "/api/v1/sdk/actions/wp-config", Ba = "/oauth2/auth/v1/requests/wafa/widget", Ga = "/oauth2/auth/v1/requests/wafa/web-curtain", qa = "/oauth2/auth/v1/requests/wafa/fauth", Ha = "/oauth2/auth/v1/fauth", za = "/api/v0.3/backend/oauth/revoke", Va = "/api/v1/userinfo", Wa = "/api/v1/backend/userinfo", ve = 119, xt = 30, Ie = 75, Ka = 368, ar = 768, zo = 720, Ja = /^[a-zA-Z0-9-_]+$/, Ya = /^[a-zA-Z0-9_:;.,'"?!(){}[\]@<>=\-+*#$&`|~^%\\]+$/, Xa = 256, Qa = 2048, Un = "webCurtain", $n = "authWidget", Vo = "https://auth.gid.ru", Za = "https://preprod.gid-auth.ru", eu = "/office/cards?wmf=true", tu = "gazprom-pay-close", nu = 500, ru = "https://goevents.auth.gid.ru/", Wo = "https://int.dp.gid.ru", iu = "web_sso", ou = "p", su = "5dd6d752-522a-4852-add6-c5f0a5983bfd", au = `${iu}:${ou}:${su}`, st = "1.2", _t = "popup_auth", uu = 256, Pr = "x-sso-track-id", Ko = "https://d2135734cf83b8c966ea723f7e42f63d@sentry-prod.gid.team/363", ur = "https://kevents.auth.gid.ru", Jo = "https://static-sso.gid.ru/assets/das.obf.js", cu = {
  trackingReceiver: {
    trackingReceiverUrl: Wo,
    writeKey: au
  },
  goya: {
    goyaUrl: ru
  },
  sentry: {
    sentryDsn: Ko,
    environment: "prod"
  },
  kevents: {
    keventsUrl: ur
  },
  kfp: {
    kfpUrl: Jo
  }
}, lu = {
  trackingReceiver: {
    trackingReceiverUrl: Wo,
    writeKey: "web_sso:pr:0e605bbe-3ee1-4feb-a64f-f965c42381a5"
  },
  goya: {
    goyaUrl: "https://goevents-preprod.gid-auth.ru"
  },
  sentry: {
    sentryDsn: "https://697716126da3d86ce62413de755411f5@sentry.gid.team/248",
    environment: "preprod"
  },
  kevents: {
    keventsUrl: "https://kevents-preprod.gid-auth.ru"
  },
  kfp: {
    kfpUrl: "/kfp/preprod/das.obf.js"
  }
}, bt = {
  authSuccess: {
    event_action: "success",
    event_label: "avtorizaciya",
    event_name: "auth-success-avtorizaciya"
  },
  authComplete: {
    event_action: "complete",
    event_label: "avtorizaciya",
    event_name: "auth-complete-avtorizaciya"
  },
  authCodeSuccess: {
    event_action: "success",
    event_label: "authcode",
    event_name: "auth-success-authcode"
  },
  authButtonClickInit: {
    event_action: "button_click",
    event_label: "init",
    event_name: "auth-button_click-init"
  }
}, J = {
  authCodeSuccess: {
    name: "eventAuthCodeReceived",
    event_action: "success",
    event_label: "authcode",
    event_name: "auth-success-authcode"
  },
  authSuccess: {
    name: "eventAuthTokenReceived",
    event_action: "success",
    event_label: "avtorizaciya",
    event_name: "auth-success-avtorizaciya"
  },
  authComplete: {
    name: "eventAuthSuccess",
    event_action: "complete",
    event_label: "avtorizaciya",
    event_name: "auth-complete-avtorizaciya"
  },
  authFlowStarted: {
    name: "eventAuthFlowStarted",
    event_action: "button_click",
    event_label: "init",
    event_name: "auth-button_click-init"
  },
  authFlowStartedForce: {
    name: "eventAuthFlowStartedForce",
    event_action: "button_click",
    event_label: "init",
    event_name: "auth-button_click-init"
  },
  widgetOpen: {
    name: "eventWidgetOpen",
    event_action: "button_click",
    event_label: "open",
    event_name: "widget-button_click-open"
  },
  widgetClose: {
    name: "eventWidgetClose",
    event_action: "button_click",
    event_label: "close",
    event_name: "widget-button_click-close"
  },
  agreementLinkClick: {
    name: "eventAgreementLinkClick",
    event_action: "link_click",
    event_label: "agreement",
    event_name: "widget-link_click-agreement"
  }
}, le = {
  eventHandleRedirectCallbackInvalidParams: {
    name: "eventHandleRedirectCallbackInvalidParams",
    event_action: "error",
    event_label: "avtorizaciya",
    event_name: "auth-error-avtorizaciya"
  },
  eventHandleRedirectCallbackNoParams: {
    name: "eventHandleRedirectCallbackNoParams",
    event_action: "error",
    event_label: "avtorizaciya",
    event_name: "auth-error-avtorizaciya"
  },
  eventNoBackendUrlError: {
    name: "eventNoBackendUrlError",
    event_action: "error",
    event_label: "avtorizaciya",
    event_name: "auth-error-avtorizaciya"
  },
  eventTokenError: {
    name: "eventTokenError",
    event_action: "error",
    event_label: "avtorizaciya",
    event_name: "auth-error-avtorizaciya"
  },
  eventGetTokenError: {
    name: "eventGetTokenError",
    event_action: "error",
    event_label: "avtorizaciya",
    event_name: "auth-error-avtorizaciya"
  },
  eventLoginWithPopupError: {
    name: "eventLoginWithPopupError",
    event_action: "error",
    event_label: "avtorizaciya",
    event_name: "auth-error-avtorizaciya"
  },
  eventCheckPopupForResultParamsError: {
    name: "eventCheckPopupForResultParamsError",
    event_action: "error",
    event_label: "avtorizaciya",
    event_name: "auth-error-avtorizaciya"
  }
};
function yn(t) {
  const e = t.replace(/\n/g, "").replace(/\t/g, "").replace(/>\s+</g, "><");
  return `url("data:image/svg+xml,${encodeURIComponent(e).replace(/'/g, "%27").replace(/"/g, "%22")}")`;
}
const mn = (t, e = "#fff") => `<svg width="28" height="28" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="28" height="28" rx="8" fill="${e}"/><g clip-path="url(#a)" fill="${t}"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.754 7.52c-.374-1.62-1.316-2.935-1.444-3.145-.207.305-.955 1.462-1.335 2.751a9.912 9.912 0 0 0-.335 3.966c.141 1.258.683 2.541.683 2.541.284.674.716 1.398.993 1.754.406-.52 1.348-2.084 1.644-4.124.161-1.137.168-2.129-.206-3.743Zm-1.444 7.467c-.181-.343-.471-.991-.497-1.995-.006-.973.387-1.805.503-1.977.103.172.445.903.483 1.894a4.274 4.274 0 0 1-.49 2.084v-.006Zm1.334-4.722c-.013.617-.09 1.271-.187 1.659a10.062 10.062 0 0 0-.206-2.357c-.155-.738-.6-1.97-.954-2.542-.33.54-.729 1.607-.942 2.535-.213.928-.219 2.046-.219 2.383-.058-.286-.2-1.296-.155-2.307.033-.838.232-1.696.342-2.097.413-1.321.883-2.166.974-2.3a9.99 9.99 0 0 1 .986 2.269 9.81 9.81 0 0 1 .355 2.757h.006Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.948 15.768h-2.85v1.888l.006-.007c.671-.66 1.76-.66 2.431 0 .67.661.67 1.735 0 2.396l-.006.006s-.007 0-.013.007a3.47 3.47 0 0 1-4.849-.006 3.348 3.348 0 0 1 0-4.786 3.448 3.448 0 0 1 2.431-.99V9.743c-3.379 0-6.119 2.701-6.119 6.024 0 3.33 2.74 6.03 6.03 1.76 0 3.346-.736 4.462-1.906v-4.117h-1.612v-.007Z"/><path d="M20.39 21.208v-4.753h.16c.072 0 .123.025.168.082.04.051.065.127.065.223v4.143a.367.367 0 0 1-.065.222.215.215 0 0 1-.167.083h-.161Zm-1.238.673h1.94c.213 0 .387-.038.51-.108a.71.71 0 0 0 .277-.273.994.994 0 0 0 .11-.356c.019-.12.025-.241.019-.35v-3.92c0-.108 0-.229-.02-.35a1.14 1.14 0 0 0-.109-.355.67.67 0 0 0-.277-.274c-.123-.07-.297-.107-.51-.107h-1.94v6.093Zm-1.793 0h1.238v-6.094H17.36v6.094Z"/></g><defs><clipPath id="a"><path fill="${e}" transform="translate(5.98 4.375)" d="M0 0h16.042v17.5H0z"/></clipPath></defs></svg>`, du = '<svg width="78" height="32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.242 5.912c-.664-2.88-2.321-5.226-2.55-5.613-.354.535-1.68 2.607-2.355 4.907-.732 2.562-.846 4.828-.583 7.07.251 2.232 1.2 4.532 1.2 4.532.503 1.207 1.258 2.494 1.75 3.131.72-.933 2.378-3.711 2.892-7.355.286-2.027.297-3.791-.354-6.672Zm-2.55 13.31c-.32-.615-.823-1.765-.88-3.564-.012-1.73.686-3.222.891-3.53.183.308.778 1.606.858 3.371.046 1.73-.526 3.097-.869 3.712v.011Zm2.355-8.414c-.023 1.104-.16 2.254-.32 2.949.057-1.196-.08-2.88-.366-4.201-.274-1.321-1.052-3.519-1.68-4.532-.572.968-1.281 2.87-1.658 4.52-.378 1.651-.389 3.644-.389 4.247-.103-.5-.343-2.3-.274-4.11.057-1.492.411-3.029.606-3.735.731-2.357 1.566-3.86 1.715-4.099.16.24 1.2 2.095 1.738 4.042.537 1.947.651 3.815.628 4.919Z" fill="#0079C2"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.813 20.6h-5.031v3.359l.011-.012a3.031 3.031 0 0 1 4.288 0 3.001 3.001 0 0 1 0 4.27l-.011.012s-.012 0-.023.01a6.02 6.02 0 0 1-4.265 1.754 6.103 6.103 0 0 1-4.288-1.764 6.012 6.012 0 0 1 0-8.529 6.084 6.084 0 0 1 4.288-1.764V9.863C4.825 9.863 0 14.679 0 20.6c0 5.92 4.825 10.737 10.782 10.737 3.11 0 5.9-1.31 7.866-3.404v-7.345h-2.847l.012.012ZM20.295 20.645h4.184V22h-2v9.565h-2.184v-10.92ZM26.835 27.466 27.212 22h.126l.377 5.466h-.88Zm-2.424 4.099h2.15l.205-2.904h1.03L28 31.565h2.15l-1.144-10.92h-3.441l-1.144 10.92h-.011ZM33.032 27.739v2.06c0 .285.217.365.343.365.206 0 .343-.17.343-.364v-2.54c0-.34-.069-.717-.88-.717h-.892v-1.195h.926c.629 0 .846-.137.846-.808v-2.175a.346.346 0 0 0-.343-.353c-.126 0-.343.08-.343.353v1.776h-2.195v-1.548c0-.763.091-1.948 1.623-1.948h1.818c1.532 0 1.624 1.185 1.624 1.948v1.742c0 1.184-.835 1.514-1.487 1.48v.114c1.475-.035 1.487 1.093 1.487 1.48v2.197c0 .763-.092 1.947-1.624 1.947H32.46c-1.532 0-1.623-1.184-1.623-1.947V27.74h2.195ZM37.056 20.645h5.077v10.92h-2.184V22h-.697v9.565h-2.196v-10.92ZM45.608 26.646V22h.286c.24 0 .412.205.412.547v3.564c0 .341-.172.546-.412.546h-.286v-.011Zm-2.195 4.907h2.195v-3.712h1.247c1.532 0 1.635-1.184 1.635-1.947v-3.301c0-.763-.092-1.948-1.635-1.948h-3.442v10.92-.012ZM52.434 29.8c0 .193-.137.364-.343.364a.338.338 0 0 1-.343-.364v-7.435c0-.285.218-.353.343-.353.206 0 .343.17.343.353V29.8Zm-2.88-.182c0 .763.09 1.947 1.634 1.947h1.818c1.532 0 1.624-1.184 1.624-1.947v-7.014c0-.763-.092-1.947-1.624-1.947h-1.818c-1.532 0-1.635 1.184-1.635 1.947v7.014ZM61.456 20.645h2.846v10.92H62.12v-6.843h-.08l-1.132 6.843h-1.75l-1.132-6.843h-.08v6.843h-2.183v-10.92h2.847l1.429 7.675 1.418-7.675Z" fill="#0079C2"/><path d="M72.363 21.795h1.967c.492 0 .892.103 1.2.296.32.194.56.479.732.843.172.364.297.808.366 1.32.069.513.103 1.082.103 1.72 0 1.093-.069 1.97-.229 2.653-.148.683-.411 1.173-.766 1.492-.354.318-.823.466-1.418.466h-1.966v-8.79h.011ZM71.14 31.69h3.247c.594 0 1.098-.114 1.52-.308.424-.205.767-.49 1.041-.842.275-.364.48-.774.64-1.241.149-.467.263-.968.32-1.492.058-.523.092-1.059.092-1.605 0-.547-.023-1.082-.069-1.617a7.652 7.652 0 0 0-.285-1.492 3.706 3.706 0 0 0-.64-1.23 2.802 2.802 0 0 0-1.121-.842c-.458-.205-1.03-.307-1.727-.307h-3.03V31.7l.012-.011Zm-1.99-10.988h-1.223V31.69h1.223V20.702Z" fill="#0079C2"/></svg>', fu = yn(mn("#0079C2")), hu = yn(mn("#0070b4")), pu = yn(mn("#fff", "#0070b4")), gu = yn(mn("#000000")), yu = 'system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"', ze = "#fff", Nt = "#0079C2", mu = "#0070b4", vu = "#d7d7d7", _u = "#898889", bu = "#101318", Su = "rgba(27, 44, 78, 0.2)", wu = "rgba(255, 255, 255, 0.2)", Eu = "rgba(27, 44, 78, 0.1)", ku = "rgba(255, 255, 255, 0.1)", _i = `
  opacity: .65;
  pointer-events: none;
`, Bn = `
  outline: 0;
`, xu = `
  .CLASS_ID-gidbtn-standard, .CLASS_ID-gidbtn-compact, .CLASS_ID-gidbtn-iconic {
    height: 56px;
    min-width: 268px;
    width: 100%;
    max-width: 360px;
    border-radius: 10px;
    border: 1px solid transparent;
    cursor: pointer;
    display: inline-block;
    font-family: ${yu};
    font-size: 17px;
    font-weight: 700;
    line-height: 24px;
    padding: 14px;
    box-sizing: border-box;
    text-align: center;
    text-decoration: none;
    user-select: none;
    vertical-align: middle;
    position: relative;
  }
  .CLASS_ID-gidbtn-compact {
    min-width: 115px;
    width: 115px;
    padding-right: 20px;
    text-align: right;
    font-size: 22px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .CLASS_ID-gidbtn-compact::after, .CLASS_ID-gidbtn-compact::before {
    display: none !important;
  }

  .CLASS_ID-gidbtn-compact svg {
    margin-bottom: 4px;
  }

  .CLASS_ID-gidbtn-iconic {
    min-width: 56px;
    width: 56px;
    background-size: 27px;
    background-position: 0 -21px;
  }

  .CLASS_ID-gidbtn-standard.CLASS_ID-gidbtn-primary, .CLASS_ID-gidbtn-compact.CLASS_ID-gidbtn-primary, .CLASS_ID-gidbtn-iconic.CLASS_ID-gidbtn-primary {
    background-color: ${Nt};
    color: ${ze};
  }
  .CLASS_ID-gidbtn-standard.CLASS_ID-gidbtn-secondary, .CLASS_ID-gidbtn-compact.CLASS_ID-gidbtn-secondary, .CLASS_ID-gidbtn-iconic.CLASS_ID-gidbtn-secondary {
    background-color: ${ze};
    border: 1px solid ${Eu};
    color: ${Nt}
  }

  .CLASS_ID-gidbtn-standard.CLASS_ID-gidbtn-dark, .CLASS_ID-gidbtn-compact.CLASS_ID-gidbtn-dark, .CLASS_ID-gidbtn-iconic.CLASS_ID-gidbtn-dark {
    background-color: ${bu};
    border: 1px solid ${ku};
  }
  .CLASS_ID-gidbtn-standard.CLASS_ID-gidbtn-dark {
    color: ${ze};
  }
  .CLASS_ID-gidbtn-compact.CLASS_ID-gidbtn-dark {
    color: ${ze};
  }

  .CLASS_ID-gidbtn-primary::after, .CLASS_ID-gidbtn-secondary::after, .CLASS_ID-gidbtn-dark::after {
    background-repeat: no-repeat;
    background-position: 0 0;
    background-size: 28px;
    content: '';
    height: 28px;
    width: 28px;
    position: absolute;
    top: 50%;
    left: 12px;
    transform: translateY(-50%);
  }

  .CLASS_ID-gidbtn-primary::after {
    background-image: ${fu};
  }

  .CLASS_ID-gidbtn-dark::after {
    background-image: ${gu};
  }

  .CLASS_ID-gidbtn-secondary::after {
    background-image: ${pu};
    color: ${Nt};
  }

  .CLASS_ID-gidbtn-primary:hover::after {
    background-image: ${hu};
  }

  .CLASS_ID-gidbtn-compact::after {
    background-position: 0 0;
  }

  .CLASS_ID-gidbtn-iconic::after {
    height: 32px;
    width: 32px;
    background-position: -1 0;
    background-size: 32px;
  }

  .CLASS_ID-gidbtn-compact.CLASS_ID-gidbtn-dark path, .CLASS_ID-gidbtn-compact.CLASS_ID-gidbtn-primary path {
    fill: #fff;
  }

  .CLASS_ID-gidbtn-compact::before, .CLASS_ID-gidbtn-standard::before, .CLASS_ID-gidbtn-iconic::before {
    background: ${ze};
    content: '';
    display: inline-block;
    height: 28px;
    width: 28px;
    border-radius: 8px;
    position: absolute;
    top: 50%;
    left: 12px;
    transform: translateY(-50%);
  }
  .CLASS_ID-gidbtn-compact.CLASS_ID-gidbtn-secondary::before,
  .CLASS_ID-gidbtn-standard.CLASS_ID-gidbtn-secondary::before,
  .CLASS_ID-gidbtn-iconic.CLASS_ID-gidbtn-secondary::before,
  .CLASS_ID-gidbtn-compact.CLASS_ID-gidbtn-dark::before,
  .CLASS_ID-gidbtn-standard.CLASS_ID-gidbtn-dark::before,
  .CLASS_ID-gidbtn-iconic.CLASS_ID-gidbtn-dark::before {
    background: ${Nt};
  }

  .CLASS_ID-gidbtn-compact.CLASS_ID-gidbtn-dark::before,
  .CLASS_ID-gidbtn-iconic.CLASS_ID-gidbtn-dark::before {
    background: #fff;
  }

  .CLASS_ID-gidbtn-iconic::before {
    width: 32px;
    height: 32px;
    left: 11px;
  }

  .CLASS_ID-gidbtn-standard.CLASS_ID-gidbtn-primary:hover,
  .CLASS_ID-gidbtn-standard.CLASS_ID-gidbtn-primary:active,
  .CLASS_ID-gidbtn-compact.CLASS_ID-gidbtn-primary:hover,
  .CLASS_ID-gidbtn-compact.CLASS_ID-gidbtn-primary:active,
  .CLASS_ID-gidbtn-iconic.CLASS_ID-gidbtn-primary:hover,
  .CLASS_ID-gidbtn-iconic.CLASS_ID-gidbtn-primary:active {
    ${Bn}
    background-color: ${mu};
    color: ${ze};
  }
  .CLASS_ID-gidbtn-standard.CLASS_ID-gidbtn-secondary:hover,
  .CLASS_ID-gidbtn-standard.CLASS_ID-gidbtn-secondary:active,
  .CLASS_ID-gidbtn-compact.CLASS_ID-gidbtn-secondary:hover,
  .CLASS_ID-gidbtn-compact.CLASS_ID-gidbtn-secondary:active,
  .CLASS_ID-gidbtn-iconic.CLASS_ID-gidbtn-secondary:hover,
  .CLASS_ID-gidbtn-iconic.CLASS_ID-gidbtn-secondary:active {
    ${Bn}
    border: 1px solid ${Su};
  }

  .CLASS_ID-gidbtn-standard.CLASS_ID-gidbtn-dark:hover,
  .CLASS_ID-gidbtn-standard.CLASS_ID-gidbtn-dark:active,
  .CLASS_ID-gidbtn-compact.CLASS_ID-gidbtn-dark:hover,
  .CLASS_ID-gidbtn-compact.CLASS_ID-gidbtn-dark:active,
  .CLASS_ID-gidbtn-iconic.CLASS_ID-gidbtn-dark:hover,
  .CLASS_ID-gidbtn-iconic.CLASS_ID-gidbtn-dark:active {
    ${Bn}
    border: 1px solid ${wu};
  }

  .CLASS_ID-gidbtn-standard.CLASS_ID-gidbtn-primary:disabled,
  .CLASS_ID-gidbtn-compact.CLASS_ID-gidbtn-primary:disabled,
  .CLASS_ID-gidbtn-iconic.CLASS_ID-gidbtn-primary:disabled,
  .CLASS_ID-gidbtn-standard.CLASS_ID-gidbtn-dark:disabled,
  .CLASS_ID-gidbtn-compact.CLASS_ID-gidbtn-dark:disabled,
  .CLASS_ID-gidbtn-iconic.CLASS_ID-gidbtn-dark:disabled {
    ${_i}
    background-color: ${vu};
  }

  .CLASS_ID-gidbtn-standard.CLASS_ID-gidbtn-secondary:disabled,
  .CLASS_ID-gidbtn-compact.CLASS_ID-gidbtn-secondary:disabled,
  .CLASS_ID-gidbtn-iconic.CLASS_ID-gidbtn-secondary:disabled {
    ${_i}
    color: ${_u};
  }
`;
var Te = /* @__PURE__ */ ((t) => (t.Init = "init", t.Resize = "resize", t.Close = "close", t.Login = "login", t.LoginPrompt = "loginPrompt", t.AgreementLinkClick = "agreementLinkClick", t))(Te || {}), At = /* @__PURE__ */ ((t) => (t.TopRight = "top-right", t.BottomRight = "bottom-right", t.TopLeft = "top-left", t.BottomLeft = "bottom-left", t))(At || {});
const bi = (t = "") => {
  var e, n, r, i, o, s, a, u, c, l, d, f;
  try {
    const { searchParams: h } = new URL(t);
    return {
      code: (n = (e = h.get("code")) == null ? void 0 : e.trim()) != null ? n : "",
      state: (i = (r = h.get("state")) == null ? void 0 : r.trim()) != null ? i : "",
      scope: (s = (o = h.get("scope")) == null ? void 0 : o.trim()) != null ? s : "",
      error: (u = (a = h.get("error")) == null ? void 0 : a.trim()) != null ? u : "",
      error_description: (l = (c = h.get("error_description")) == null ? void 0 : c.trim()) != null ? l : "",
      quuid: (f = (d = h.get("quuid")) == null ? void 0 : d.trim()) != null ? f : ""
    };
  } catch (h) {
    throw new Error(`error in parseQueryResult: ${h}`);
  }
}, Au = () => window.crypto, Ve = (t = 43, e = !1) => {
  const r = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz${e ? "" : "0123456789-_~."}`;
  let i = "";
  const o = Au().getRandomValues(new Uint8Array(t));
  return Array.from(o).forEach((a) => {
    i += r[a % r.length];
  }), i;
}, en = (t) => Object.keys(t).filter((e) => typeof t[e] != "undefined").map((e) => `${encodeURIComponent(e)}=${encodeURIComponent(t[e])}`).join("&"), Iu = (t) => {
  const e = kt.sha256(t), n = new Uint8Array(e.length / 2);
  for (let r = 0; r < e.length; r += 2)
    n[r / 2] = parseInt(e.substr(r, 2), 16);
  return n.buffer;
}, Cu = (t) => {
  const e = { "+": "-", "/": "_", "=": "" };
  return t.replace(/[+/=]/g, (n) => e[n]);
}, Tu = (t) => {
  const e = new Uint8Array(t), n = String.fromCharCode(...Array.from(e)), r = window.btoa(n);
  return Cu(r);
}, Si = (...t) => {
  const e = t.join(" ").trim().split(/\s+/);
  return Array.from(new Set(e)).join(" ");
}, Ou = (t, e = !1) => {
  const i = window.screenX + (window.innerWidth - 400) / 2, o = window.screenY + (window.innerHeight - 600) / 2;
  return window.open(
    t,
    "authorize:popup",
    e ? void 0 : `left=${i},top=${o},width=400,height=600,resizable,scrollbars=yes,status=1`
  );
}, Ru = (t, e) => () => {
  const n = document.body.clientWidth, r = document.body.clientHeight;
  if (e.style.top = "auto", e.style.right = "auto", e.style.left = "auto", e.style.bottom = "auto", e.style.transform = "none", n >= ar)
    switch (t) {
      case At.TopRight:
        e.style.top = `${ve}px`, e.style.right = `${Ie}px`;
        break;
      case At.BottomRight:
        e.style.bottom = `${ve}px`, e.style.right = `${Ie}px`;
        break;
      case At.TopLeft:
        e.style.top = `${ve}px`, e.style.left = `${Ie}px`;
        break;
      case At.BottomLeft:
        e.style.bottom = `${ve}px`, e.style.left = `${Ie}px`;
        break;
      default:
        e.style.top = `${ve}px`, e.style.right = `${Ie}px`;
        break;
    }
  else
    e.style.bottom = `${ve}px`, e.style.right = `${Ie}px`, e.style.transform = "translateX(-50%)", e.style.left = "50%";
  r <= zo + ve && (n <= ar ? (e.style.top = "auto", e.style.bottom = `${xt}px`) : (e.style.bottom = "auto", e.style.top = `${xt}px`), e.style.right = `${Ie}px`, e.style.maxHeight = r - xt > 600 ? "600px" : `${r - xt}px`);
}, Du = (t) => () => {
  const e = document.body.clientWidth, n = document.body.clientHeight;
  t.style.top = "50%", t.style.left = "50%", t.style.transform = "translate(-50%, -50%)", t.style.marginLeft = "auto", (e <= ar || n <= zo + ve) && (t.style.top = `${xt}px`, t.style.transform = "none", t.style.left = "50%", t.style.marginLeft = "-190px");
}, Pu = (t, e) => {
  (typeof t != "object" || t === null) && e && console.log("Заголовки указаны некорректно: ", t);
  const n = {};
  let r = null;
  for (const [i, o] of Object.entries(t))
    typeof i == "string" && i.length <= Xa && Ja.test(i) && typeof o == "string" && o.length <= Qa && Ya.test(o) ? n[i] = o.replace(/\\/g, "\\\\").replace(/"/g, '\\"') : r = j(w({}, r || {}), { [i]: o });
  return r && e && console.log("В указанных заголовках используются недопустимые символы: ", r), n;
}, cr = function() {
  return (/* @__PURE__ */ new Date()).getTime();
}, Yo = function() {
  const t = (/* @__PURE__ */ new Date()).getTimezoneOffset(), e = String(Math.floor(Math.abs(t / 60))), n = String(Math.abs(t % 60)), r = /^0*$/.test(n) ? "" : ":" + n.padStart(2, "0");
  return (t > 0 ? "-" : "") + e + r;
}, wi = (t) => t instanceof Error ? JSON.stringify({
  message: t.message,
  name: t.name,
  stack: t.stack
}) : JSON.stringify(t);
function at() {
  return window.navigator.userAgent.substring(0, uu);
}
function We() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
    const e = Math.random() * 16 | 0;
    return (t === "x" ? e : e & 3 | 8).toString(16);
  });
}
const an = (t) => {
  const e = (t || "").trim();
  if (!e) return "";
  try {
    const n = new URL(e);
    return `${n.origin}${n.pathname}`.replace(/\/+$/, "");
  } catch (n) {
    return e.replace(/\/+$/, "");
  }
}, Fu = (t) => {
  const e = (t || "").trim();
  return e ? e.startsWith("/") ? e : `/${e}` : "";
}, ot = (t) => an(t), Lu = (t) => {
  switch (t) {
    case Vo:
      return cu;
    case Za:
      return lu;
    default:
      return null;
  }
}, Xo = (t) => {
  const { protocol: e, hostname: n } = new URL(ot(t));
  if (n.endsWith(".gid-auth.ru")) {
    const r = n.slice(0, -12);
    return r === "auth" || r === "preprod" ? `${e}//account.gid-auth.ru` : `${e}//${r}-account.gid-auth.ru`;
  }
  return n.startsWith("auth.") ? `${e}//account.${n.slice(5)}` : n.includes("-auth.") ? `${e}//${n.replace("-auth.", "-account.")}` : `${e}//account.gid.ru`;
}, Nu = (t) => `${Xo(t)}${eu}`, Mu = (t) => new URL(Xo(t)).origin, Gn = (t) => `code_verifier_${t}`, ju = (t, e) => t === Mu(e);
function Qo(t) {
  const e = new URLSearchParams();
  for (const [n, r] of Object.entries(t))
    r != null && e.append(n, String(r));
  return e.toString();
}
function Uu(t, e, n, r, i, o) {
  return M(this, null, function* () {
    const s = o ? "application/x-www-form-urlencoded" : "application/json", a = o ? Qo(e) : JSON.stringify(e), u = yield gt(t, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: j(w({
        "Content-Type": s
      }, n), {
        [Pr]: i || ""
      }),
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: a
    }, r), c = yield u.json();
    return j(w({}, c), { status: u.status });
  });
}
function Ei(t, e) {
  return M(this, null, function* () {
    const n = yield gt(t, {}, e);
    if (!n.ok) {
      const r = new Error(`SDK config request failed with status ${n.status}`);
      throw r.status = n.status, r;
    }
    try {
      return yield n.json();
    } catch (r) {
      const i = new Error("Failed to parse sdk config response");
      throw i.status = n.status, i.name = "ParseError", i;
    }
  });
}
function $u(t, e) {
  return M(this, null, function* () {
    const n = yield gt(t, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "include"
    }, e);
    if (n.status === 200 || n.status === 204)
      return;
    const r = new Error(
      `Forced auth check failed with status ${n.status}`
    );
    throw r.status = n.status, r;
  });
}
function Bu(t, e) {
  return M(this, null, function* () {
    return yield gt(t, {
      keepalive: !0
    }, e);
  });
}
function Gu(t, e, n, r, i, o) {
  return M(this, null, function* () {
    const s = o ? "application/x-www-form-urlencoded" : "application/json", a = o ? Qo(e) : JSON.stringify(e), u = yield gt(t, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: j(w({
        "Content-Type": s
      }, n), {
        [Pr]: i || ""
      }),
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: a
    }, r);
    if (u.ok)
      return;
    const c = yield u.json();
    return j(w({}, c), { status: u.status });
  });
}
function qu(r, i) {
  return M(this, arguments, function* (t, e, n = {}) {
    const o = n.keycloakEnabled ? Wa : Va, s = new URLSearchParams();
    n.keycloakEnabled && n.keycloakIdpName && s.set("kc_idp_hint", n.keycloakIdpName);
    const a = s.toString(), u = `${an(t)}${o}${a ? `?${a}` : ""}`;
    return yield (yield gt(u, {
      method: "GET",
      headers: w(w({
        Authorization: `Bearer ${e}`
      }, n.headers), n.keycloakEnabled ? { [Pr]: n.externalId || "" } : {})
    }, n.timeout)).json();
  });
}
const Fr = 1, Hu = "gid-auth-sdk:wp-config:v", Zo = 7 * 24 * 60 * 60 * 1e3;
function zu(t) {
  const e = t != null ? t : 7;
  return !Number.isFinite(e) || e < 0 ? Zo : e === 0 ? 0 : e * 24 * 60 * 60 * 1e3;
}
function es(t, e) {
  return `${Hu}${Fr}:${t}:${e}`;
}
function Vu(t, e, n = Zo) {
  if (n <= 0) return null;
  try {
    const r = window.localStorage.getItem(es(t, e));
    if (!r) return null;
    const { v: i, t: o, payload: s } = JSON.parse(r);
    return i !== Fr || typeof o != "number" || !s || Date.now() - o > n ? null : typeof s == "object" && s !== null ? s : null;
  } catch (r) {
    return null;
  }
}
function ki(t, e, n) {
  try {
    const r = {
      v: Fr,
      t: Date.now(),
      payload: n
    };
    window.localStorage.setItem(
      es(t, e),
      JSON.stringify(r)
    );
  } catch (r) {
  }
}
const V = {
  missing_code: "missing_code",
  missing_code_verifier: "missing_code_verifier",
  invalid_state: "invalid_state",
  invalid_scope: "invalid_scope",
  authorization_error: "authorization_error",
  token_fetch_error: "token_fetch_error",
  popup_blocked: "popup_blocked"
}, Oe = {
  [V.missing_code]: "Отсутствует код авторизации",
  [V.missing_code_verifier]: "Отсутствует code_verifier в сессии",
  [V.invalid_state]: "Некорректный параметр state",
  [V.invalid_scope]: "Запрошенный scope недействителен",
  [V.authorization_error]: "Произошла непредвиденная ошибка. Обратитесь в службу поддержки",
  [V.token_fetch_error]: "Ошибка при получении токена",
  [V.popup_blocked]: "Ошибка при попытке открытия popup-окна"
}, De = (t, e) => {
  var n, r;
  return (r = (n = Oe[t]) != null ? n : e) != null ? r : Oe[V.authorization_error];
}, Wu = ({
  error: t,
  error_description: e,
  isCodeValid: n,
  isVerifierValid: r,
  isStateValid: i,
  isScopeValid: o
}) => t ? {
  error: t,
  error_description: e || De(t)
} : n ? r ? i ? o ? {
  error: V.authorization_error,
  error_description: Oe[V.authorization_error]
} : {
  error: V.invalid_scope,
  error_description: Oe[V.invalid_scope]
} : {
  error: V.invalid_state,
  error_description: Oe[V.invalid_state]
} : {
  error: V.missing_code_verifier,
  error_description: Oe[V.missing_code_verifier]
} : {
  error: V.missing_code,
  error_description: Oe[V.missing_code]
};
class un extends Error {
  constructor(e, n) {
    super(n), this.error = e, this.error_description = n, Object.setPrototypeOf(this, un.prototype);
  }
  static fromPayload({ error: e, error_description: n }) {
    return new un(e, n || De(e));
  }
}
const Ku = (t, e) => {
  throw new un(t, e || De(t));
}, B = typeof __SENTRY_DEBUG__ == "undefined" || __SENTRY_DEBUG__, G = globalThis, Fe = "9.33.0";
function vn() {
  return _n(G), G;
}
function _n(t) {
  const e = t.__SENTRY__ = t.__SENTRY__ || {};
  return e.version = e.version || Fe, e[Fe] = e[Fe] || {};
}
function bn(t, e, n = G) {
  const r = n.__SENTRY__ = n.__SENTRY__ || {}, i = r[Fe] = r[Fe] || {};
  return i[t] || (i[t] = e());
}
const Ju = "Sentry Logger ", lr = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], cn = {};
function yt(t) {
  if (!("console" in G))
    return t();
  const e = G.console, n = {}, r = Object.keys(cn);
  r.forEach((i) => {
    const o = cn[i];
    n[i] = e[i], e[i] = o;
  });
  try {
    return t();
  } finally {
    r.forEach((i) => {
      e[i] = n[i];
    });
  }
}
function Yu() {
  let t = !1;
  const e = {
    enable: () => {
      t = !0;
    },
    disable: () => {
      t = !1;
    },
    isEnabled: () => t
  };
  return B ? lr.forEach((n) => {
    e[n] = (...r) => {
      t && yt(() => {
        G.console[n](`${Ju}[${n}]:`, ...r);
      });
    };
  }) : lr.forEach((n) => {
    e[n] = () => {
    };
  }), e;
}
const N = bn("logger", Yu), ts = 50, Ne = "?", xi = /\(error: (.*)\)/, Ai = /captureMessage|captureException/;
function ns(...t) {
  const e = t.sort((n, r) => n[0] - r[0]).map((n) => n[1]);
  return (n, r = 0, i = 0) => {
    const o = [], s = n.split(`
`);
    for (let a = r; a < s.length; a++) {
      const u = s[a];
      if (u.length > 1024)
        continue;
      const c = xi.test(u) ? u.replace(xi, "$1") : u;
      if (!c.match(/\S*Error: /)) {
        for (const l of e) {
          const d = l(c);
          if (d) {
            o.push(d);
            break;
          }
        }
        if (o.length >= ts + i)
          break;
      }
    }
    return Qu(o.slice(i));
  };
}
function Xu(t) {
  return Array.isArray(t) ? ns(...t) : t;
}
function Qu(t) {
  if (!t.length)
    return [];
  const e = Array.from(t);
  return /sentryWrapped/.test(Mt(e).function || "") && e.pop(), e.reverse(), Ai.test(Mt(e).function || "") && (e.pop(), Ai.test(Mt(e).function || "") && e.pop()), e.slice(0, ts).map((n) => j(w({}, n), {
    filename: n.filename || Mt(e).filename,
    function: n.function || Ne
  }));
}
function Mt(t) {
  return t[t.length - 1] || {};
}
const qn = "<anonymous>";
function be(t) {
  try {
    return !t || typeof t != "function" ? qn : t.name || qn;
  } catch (e) {
    return qn;
  }
}
function Ii(t) {
  const e = t.exception;
  if (e) {
    const n = [];
    try {
      return e.values.forEach((r) => {
        r.stacktrace.frames && n.push(...r.stacktrace.frames);
      }), n;
    } catch (r) {
      return;
    }
  }
}
const tn = {}, Ci = {};
function Be(t, e) {
  tn[t] = tn[t] || [], tn[t].push(e);
}
function Ge(t, e) {
  if (!Ci[t]) {
    Ci[t] = !0;
    try {
      e();
    } catch (n) {
      B && N.error(`Error while instrumenting ${t}`, n);
    }
  }
}
function ie(t, e) {
  const n = t && tn[t];
  if (n)
    for (const r of n)
      try {
        r(e);
      } catch (i) {
        B && N.error(
          `Error while triggering instrumentation handler.
Type: ${t}
Name: ${be(r)}
Error:`,
          i
        );
      }
}
let Hn = null;
function Zu(t) {
  const e = "error";
  Be(e, t), Ge(e, ec);
}
function ec() {
  Hn = G.onerror, G.onerror = function(t, e, n, r, i) {
    return ie("error", {
      column: r,
      error: i,
      line: n,
      msg: t,
      url: e
    }), Hn ? Hn.apply(this, arguments) : !1;
  }, G.onerror.__SENTRY_INSTRUMENTED__ = !0;
}
let zn = null;
function tc(t) {
  const e = "unhandledrejection";
  Be(e, t), Ge(e, nc);
}
function nc() {
  zn = G.onunhandledrejection, G.onunhandledrejection = function(t) {
    return ie("unhandledrejection", t), zn ? zn.apply(this, arguments) : !0;
  }, G.onunhandledrejection.__SENTRY_INSTRUMENTED__ = !0;
}
const rs = Object.prototype.toString;
function Lr(t) {
  switch (rs.call(t)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
    case "[object WebAssembly.Exception]":
      return !0;
    default:
      return Se(t, Error);
  }
}
function mt(t, e) {
  return rs.call(t) === `[object ${e}]`;
}
function is(t) {
  return mt(t, "ErrorEvent");
}
function Ti(t) {
  return mt(t, "DOMError");
}
function rc(t) {
  return mt(t, "DOMException");
}
function pe(t) {
  return mt(t, "String");
}
function Nr(t) {
  return typeof t == "object" && t !== null && "__sentry_template_string__" in t && "__sentry_template_values__" in t;
}
function Mr(t) {
  return t === null || Nr(t) || typeof t != "object" && typeof t != "function";
}
function Ct(t) {
  return mt(t, "Object");
}
function Sn(t) {
  return typeof Event != "undefined" && Se(t, Event);
}
function ic(t) {
  return typeof Element != "undefined" && Se(t, Element);
}
function oc(t) {
  return mt(t, "RegExp");
}
function wn(t) {
  return !!(t != null && t.then && typeof t.then == "function");
}
function sc(t) {
  return Ct(t) && "nativeEvent" in t && "preventDefault" in t && "stopPropagation" in t;
}
function Se(t, e) {
  try {
    return t instanceof e;
  } catch (n) {
    return !1;
  }
}
function os(t) {
  return !!(typeof t == "object" && t !== null && (t.__isVue || t._isVue));
}
function ac(t) {
  return typeof Request != "undefined" && Se(t, Request);
}
const jr = G, uc = 80;
function ss(t, e = {}) {
  if (!t)
    return "<unknown>";
  try {
    let n = t;
    const r = 5, i = [];
    let o = 0, s = 0;
    const a = " > ", u = a.length;
    let c;
    const l = Array.isArray(e) ? e : e.keyAttrs, d = !Array.isArray(e) && e.maxStringLength || uc;
    for (; n && o++ < r && (c = cc(n, l), !(c === "html" || o > 1 && s + i.length * u + c.length >= d)); )
      i.push(c), s += c.length, n = n.parentNode;
    return i.reverse().join(a);
  } catch (n) {
    return "<unknown>";
  }
}
function cc(t, e) {
  const n = t, r = [];
  if (!(n != null && n.tagName))
    return "";
  if (jr.HTMLElement && n instanceof HTMLElement && n.dataset) {
    if (n.dataset.sentryComponent)
      return n.dataset.sentryComponent;
    if (n.dataset.sentryElement)
      return n.dataset.sentryElement;
  }
  r.push(n.tagName.toLowerCase());
  const i = e != null && e.length ? e.filter((s) => n.getAttribute(s)).map((s) => [s, n.getAttribute(s)]) : null;
  if (i != null && i.length)
    i.forEach((s) => {
      r.push(`[${s[0]}="${s[1]}"]`);
    });
  else {
    n.id && r.push(`#${n.id}`);
    const s = n.className;
    if (s && pe(s)) {
      const a = s.split(/\s+/);
      for (const u of a)
        r.push(`.${u}`);
    }
  }
  const o = ["aria-label", "type", "name", "title", "alt"];
  for (const s of o) {
    const a = n.getAttribute(s);
    a && r.push(`[${s}="${a}"]`);
  }
  return r.join("");
}
function Ur() {
  try {
    return jr.document.location.href;
  } catch (t) {
    return "";
  }
}
function lc(t) {
  if (!jr.HTMLElement)
    return null;
  let e = t;
  const n = 5;
  for (let r = 0; r < n; r++) {
    if (!e)
      return null;
    if (e instanceof HTMLElement) {
      if (e.dataset.sentryComponent)
        return e.dataset.sentryComponent;
      if (e.dataset.sentryElement)
        return e.dataset.sentryElement;
    }
    e = e.parentNode;
  }
  return null;
}
function ln(t, e = 0) {
  return typeof t != "string" || e === 0 || t.length <= e ? t : `${t.slice(0, e)}...`;
}
function Oi(t, e) {
  if (!Array.isArray(t))
    return "";
  const n = [];
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    try {
      os(i) ? n.push("[VueViewModel]") : n.push(String(i));
    } catch (o) {
      n.push("[value cannot be serialized]");
    }
  }
  return n.join(e);
}
function dc(t, e, n = !1) {
  return pe(t) ? oc(e) ? e.test(t) : pe(e) ? n ? t === e : t.includes(e) : !1 : !1;
}
function En(t, e = [], n = !1) {
  return e.some((r) => dc(t, r, n));
}
function te(t, e, n) {
  if (!(e in t))
    return;
  const r = t[e];
  if (typeof r != "function")
    return;
  const i = n(r);
  typeof i == "function" && as(i, r);
  try {
    t[e] = i;
  } catch (o) {
    B && N.log(`Failed to replace method "${e}" in object`, t);
  }
}
function Me(t, e, n) {
  try {
    Object.defineProperty(t, e, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: n,
      writable: !0,
      configurable: !0
    });
  } catch (r) {
    B && N.log(`Failed to add non-enumerable property "${e}" to object`, t);
  }
}
function as(t, e) {
  try {
    const n = e.prototype || {};
    t.prototype = e.prototype = n, Me(t, "__sentry_original__", e);
  } catch (n) {
  }
}
function $r(t) {
  return t.__sentry_original__;
}
function us(t) {
  if (Lr(t))
    return w({
      message: t.message,
      name: t.name,
      stack: t.stack
    }, Di(t));
  if (Sn(t)) {
    const e = w({
      type: t.type,
      target: Ri(t.target),
      currentTarget: Ri(t.currentTarget)
    }, Di(t));
    return typeof CustomEvent != "undefined" && Se(t, CustomEvent) && (e.detail = t.detail), e;
  } else
    return t;
}
function Ri(t) {
  try {
    return ic(t) ? ss(t) : Object.prototype.toString.call(t);
  } catch (e) {
    return "<unknown>";
  }
}
function Di(t) {
  if (typeof t == "object" && t !== null) {
    const e = {};
    for (const n in t)
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    return e;
  } else
    return {};
}
function fc(t, e = 40) {
  const n = Object.keys(us(t));
  n.sort();
  const r = n[0];
  if (!r)
    return "[object has no keys]";
  if (r.length >= e)
    return ln(r, e);
  for (let i = n.length; i > 0; i--) {
    const o = n.slice(0, i).join(", ");
    if (!(o.length > e))
      return i === n.length ? o : ln(o, e);
  }
  return "";
}
function hc() {
  const t = G;
  return t.crypto || t.msCrypto;
}
function re(t = hc()) {
  let e = () => Math.random() * 16;
  try {
    if (t != null && t.randomUUID)
      return t.randomUUID().replace(/-/g, "");
    t != null && t.getRandomValues && (e = () => {
      const n = new Uint8Array(1);
      return t.getRandomValues(n), n[0];
    });
  } catch (n) {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (n) => (
      // eslint-disable-next-line no-bitwise
      (n ^ (e() & 15) >> n / 4).toString(16)
    )
  );
}
function cs(t) {
  var e, n;
  return (n = (e = t.exception) == null ? void 0 : e.values) == null ? void 0 : n[0];
}
function Re(t) {
  const { message: e, event_id: n } = t;
  if (e)
    return e;
  const r = cs(t);
  return r ? r.type && r.value ? `${r.type}: ${r.value}` : r.type || r.value || n || "<unknown>" : n || "<unknown>";
}
function dr(t, e, n) {
  const r = t.exception = t.exception || {}, i = r.values = r.values || [], o = i[0] = i[0] || {};
  o.value || (o.value = e || ""), o.type || (o.type = "Error");
}
function dt(t, e) {
  const n = cs(t);
  if (!n)
    return;
  const r = { type: "generic", handled: !0 }, i = n.mechanism;
  if (n.mechanism = w(w(w({}, r), i), e), e && "data" in e) {
    const o = w(w({}, i == null ? void 0 : i.data), e.data);
    n.mechanism.data = o;
  }
}
function Pi(t) {
  if (pc(t))
    return !0;
  try {
    Me(t, "__sentry_captured__", !0);
  } catch (e) {
  }
  return !1;
}
function pc(t) {
  try {
    return t.__sentry_captured__;
  } catch (e) {
  }
}
const ls = 1e3;
function Ot() {
  return Date.now() / ls;
}
function gc() {
  const { performance: t } = G;
  if (!(t != null && t.now))
    return Ot;
  const e = Date.now() - t.now(), n = t.timeOrigin == null ? e : t.timeOrigin;
  return () => (n + t.now()) / ls;
}
const ge = gc();
function yc(t) {
  const e = ge(), n = {
    sid: re(),
    init: !0,
    timestamp: e,
    started: e,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: !1,
    toJSON: () => vc(n)
  };
  return ft(n, t), n;
}
function ft(t, e = {}) {
  if (e.user && (!t.ipAddress && e.user.ip_address && (t.ipAddress = e.user.ip_address), !t.did && !e.did && (t.did = e.user.id || e.user.email || e.user.username)), t.timestamp = e.timestamp || ge(), e.abnormal_mechanism && (t.abnormal_mechanism = e.abnormal_mechanism), e.ignoreDuration && (t.ignoreDuration = e.ignoreDuration), e.sid && (t.sid = e.sid.length === 32 ? e.sid : re()), e.init !== void 0 && (t.init = e.init), !t.did && e.did && (t.did = `${e.did}`), typeof e.started == "number" && (t.started = e.started), t.ignoreDuration)
    t.duration = void 0;
  else if (typeof e.duration == "number")
    t.duration = e.duration;
  else {
    const n = t.timestamp - t.started;
    t.duration = n >= 0 ? n : 0;
  }
  e.release && (t.release = e.release), e.environment && (t.environment = e.environment), !t.ipAddress && e.ipAddress && (t.ipAddress = e.ipAddress), !t.userAgent && e.userAgent && (t.userAgent = e.userAgent), typeof e.errors == "number" && (t.errors = e.errors), e.status && (t.status = e.status);
}
function mc(t, e) {
  let n = {};
  t.status === "ok" && (n = { status: "exited" }), ft(t, n);
}
function vc(t) {
  return {
    sid: `${t.sid}`,
    init: t.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(t.started * 1e3).toISOString(),
    timestamp: new Date(t.timestamp * 1e3).toISOString(),
    status: t.status,
    errors: t.errors,
    did: typeof t.did == "number" || typeof t.did == "string" ? `${t.did}` : void 0,
    duration: t.duration,
    abnormal_mechanism: t.abnormal_mechanism,
    attrs: {
      release: t.release,
      environment: t.environment,
      ip_address: t.ipAddress,
      user_agent: t.userAgent
    }
  };
}
function Rt(t, e, n = 2) {
  if (!e || typeof e != "object" || n <= 0)
    return e;
  if (t && Object.keys(e).length === 0)
    return t;
  const r = w({}, t);
  for (const i in e)
    Object.prototype.hasOwnProperty.call(e, i) && (r[i] = Rt(r[i], e[i], n - 1));
  return r;
}
function Fi() {
  return re();
}
function ds() {
  return re().substring(16);
}
const fr = "_sentrySpan";
function Li(t, e) {
  e ? Me(t, fr, e) : delete t[fr];
}
function Ni(t) {
  return t[fr];
}
const _c = 100;
class ce {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = {
      traceId: Fi(),
      sampleRand: Math.random()
    };
  }
  /**
   * Clone all data from this scope into a new scope.
   */
  clone() {
    const e = new ce();
    return e._breadcrumbs = [...this._breadcrumbs], e._tags = w({}, this._tags), e._extra = w({}, this._extra), e._contexts = w({}, this._contexts), this._contexts.flags && (e._contexts.flags = {
      values: [...this._contexts.flags.values]
    }), e._user = this._user, e._level = this._level, e._session = this._session, e._transactionName = this._transactionName, e._fingerprint = this._fingerprint, e._eventProcessors = [...this._eventProcessors], e._attachments = [...this._attachments], e._sdkProcessingMetadata = w({}, this._sdkProcessingMetadata), e._propagationContext = w({}, this._propagationContext), e._client = this._client, e._lastEventId = this._lastEventId, Li(e, Ni(this)), e;
  }
  /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */
  setClient(e) {
    this._client = e;
  }
  /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */
  setLastEventId(e) {
    this._lastEventId = e;
  }
  /**
   * Get the client assigned to this scope.
   */
  getClient() {
    return this._client;
  }
  /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(e) {
    this._scopeListeners.push(e);
  }
  /**
   * Add an event processor that will be called before an event is sent.
   */
  addEventProcessor(e) {
    return this._eventProcessors.push(e), this;
  }
  /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */
  setUser(e) {
    return this._user = e || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && ft(this._session, { user: e }), this._notifyScopeListeners(), this;
  }
  /**
   * Get the user from this scope.
   */
  getUser() {
    return this._user;
  }
  /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */
  setTags(e) {
    return this._tags = w(w({}, this._tags), e), this._notifyScopeListeners(), this;
  }
  /**
   * Set a single tag that will be sent as tags data with the event.
   */
  setTag(e, n) {
    return this._tags = j(w({}, this._tags), { [e]: n }), this._notifyScopeListeners(), this;
  }
  /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */
  setExtras(e) {
    return this._extra = w(w({}, this._extra), e), this._notifyScopeListeners(), this;
  }
  /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */
  setExtra(e, n) {
    return this._extra = j(w({}, this._extra), { [e]: n }), this._notifyScopeListeners(), this;
  }
  /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */
  setFingerprint(e) {
    return this._fingerprint = e, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the level on the scope for future events.
   */
  setLevel(e) {
    return this._level = e, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */
  setTransactionName(e) {
    return this._transactionName = e, this._notifyScopeListeners(), this;
  }
  /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */
  setContext(e, n) {
    return n === null ? delete this._contexts[e] : this._contexts[e] = n, this._notifyScopeListeners(), this;
  }
  /**
   * Set the session for the scope.
   */
  setSession(e) {
    return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * Get the session from the scope.
   */
  getSession() {
    return this._session;
  }
  /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */
  update(e) {
    if (!e)
      return this;
    const n = typeof e == "function" ? e(this) : e, r = n instanceof ce ? n.getScopeData() : Ct(n) ? e : void 0, { tags: i, extra: o, user: s, contexts: a, level: u, fingerprint: c = [], propagationContext: l } = r || {};
    return this._tags = w(w({}, this._tags), i), this._extra = w(w({}, this._extra), o), this._contexts = w(w({}, this._contexts), a), s && Object.keys(s).length && (this._user = s), u && (this._level = u), c.length && (this._fingerprint = c), l && (this._propagationContext = l), this;
  }
  /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._session = void 0, Li(this, void 0), this._attachments = [], this.setPropagationContext({ traceId: Fi(), sampleRand: Math.random() }), this._notifyScopeListeners(), this;
  }
  /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */
  addBreadcrumb(e, n) {
    var o;
    const r = typeof n == "number" ? n : _c;
    if (r <= 0)
      return this;
    const i = j(w({
      timestamp: Ot()
    }, e), {
      // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
      message: e.message ? ln(e.message, 2048) : e.message
    });
    return this._breadcrumbs.push(i), this._breadcrumbs.length > r && (this._breadcrumbs = this._breadcrumbs.slice(-r), (o = this._client) == null || o.recordDroppedEvent("buffer_overflow", "log_item")), this._notifyScopeListeners(), this;
  }
  /**
   * Get the last breadcrumb of the scope.
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * Clear all breadcrumbs from the scope.
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * Add an attachment to the scope.
   */
  addAttachment(e) {
    return this._attachments.push(e), this;
  }
  /**
   * Clear all attachments from the scope.
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /**
   * Get the data of this scope, which should be applied to an event during processing.
   */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Ni(this)
    };
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */
  setSDKProcessingMetadata(e) {
    return this._sdkProcessingMetadata = Rt(this._sdkProcessingMetadata, e, 2), this;
  }
  /**
   * Add propagation context to the scope, used for distributed tracing
   */
  setPropagationContext(e) {
    return this._propagationContext = e, this;
  }
  /**
   * Get propagation context from the scope, used for distributed tracing
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */
  captureException(e, n) {
    const r = (n == null ? void 0 : n.event_id) || re();
    if (!this._client)
      return N.warn("No client configured on scope - will not capture exception!"), r;
    const i = new Error("Sentry syntheticException");
    return this._client.captureException(
      e,
      j(w({
        originalException: e,
        syntheticException: i
      }, n), {
        event_id: r
      }),
      this
    ), r;
  }
  /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */
  captureMessage(e, n, r) {
    const i = (r == null ? void 0 : r.event_id) || re();
    if (!this._client)
      return N.warn("No client configured on scope - will not capture message!"), i;
    const o = new Error(e);
    return this._client.captureMessage(
      e,
      n,
      j(w({
        originalException: e,
        syntheticException: o
      }, r), {
        event_id: i
      }),
      this
    ), i;
  }
  /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */
  captureEvent(e, n) {
    const r = (n == null ? void 0 : n.event_id) || re();
    return this._client ? (this._client.captureEvent(e, j(w({}, n), { event_id: r }), this), r) : (N.warn("No client configured on scope - will not capture event!"), r);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((e) => {
      e(this);
    }), this._notifyingListeners = !1);
  }
}
function bc() {
  return bn("defaultCurrentScope", () => new ce());
}
function Sc() {
  return bn("defaultIsolationScope", () => new ce());
}
class wc {
  constructor(e, n) {
    let r;
    e ? r = e : r = new ce();
    let i;
    n ? i = n : i = new ce(), this._stack = [{ scope: r }], this._isolationScope = i;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(e) {
    const n = this._pushScope();
    let r;
    try {
      r = e(n);
    } catch (i) {
      throw this._popScope(), i;
    }
    return wn(r) ? r.then(
      (i) => (this._popScope(), i),
      (i) => {
        throw this._popScope(), i;
      }
    ) : (this._popScope(), r);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const e = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: e
    }), e;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function ht() {
  const t = vn(), e = _n(t);
  return e.stack = e.stack || new wc(bc(), Sc());
}
function Ec(t) {
  return ht().withScope(t);
}
function kc(t, e) {
  const n = ht();
  return n.withScope(() => (n.getStackTop().scope = t, e(t)));
}
function Mi(t) {
  return ht().withScope(() => t(ht().getIsolationScope()));
}
function xc() {
  return {
    withIsolationScope: Mi,
    withScope: Ec,
    withSetScope: kc,
    withSetIsolationScope: (t, e) => Mi(e),
    getCurrentScope: () => ht().getScope(),
    getIsolationScope: () => ht().getIsolationScope()
  };
}
function Br(t) {
  const e = _n(t);
  return e.acs ? e.acs : xc();
}
function Ae() {
  const t = vn();
  return Br(t).getCurrentScope();
}
function Dt() {
  const t = vn();
  return Br(t).getIsolationScope();
}
function Ac() {
  return bn("globalScope", () => new ce());
}
function Ic(...t) {
  const e = vn(), n = Br(e);
  if (t.length === 2) {
    const [r, i] = t;
    return r ? n.withSetScope(r, i) : n.withScope(i);
  }
  return n.withScope(t[0]);
}
function Y() {
  return Ae().getClient();
}
function Cc(t) {
  const e = t.getPropagationContext(), { traceId: n, parentSpanId: r, propagationSpanId: i } = e, o = {
    trace_id: n,
    span_id: i || ds()
  };
  return r && (o.parent_span_id = r), o;
}
const Tc = "sentry.source", Oc = "sentry.sample_rate", Rc = "sentry.previous_trace_sample_rate", Dc = "sentry.op", Pc = "sentry.origin", fs = "sentry.profile_id", hs = "sentry.exclusive_time", Fc = 0, Lc = 1, Nc = "_sentryScope", Mc = "_sentryIsolationScope";
function ps(t) {
  return {
    scope: t[Nc],
    isolationScope: t[Mc]
  };
}
const jc = "sentry-", Uc = /^sentry-/;
function $c(t) {
  const e = Bc(t);
  if (!e)
    return;
  const n = Object.entries(e).reduce((r, [i, o]) => {
    if (i.match(Uc)) {
      const s = i.slice(jc.length);
      r[s] = o;
    }
    return r;
  }, {});
  if (Object.keys(n).length > 0)
    return n;
}
function Bc(t) {
  if (!(!t || !pe(t) && !Array.isArray(t)))
    return Array.isArray(t) ? t.reduce((e, n) => {
      const r = ji(n);
      return Object.entries(r).forEach(([i, o]) => {
        e[i] = o;
      }), e;
    }, {}) : ji(t);
}
function ji(t) {
  return t.split(",").map(
    (e) => e.split("=").map((n) => {
      try {
        return decodeURIComponent(n.trim());
      } catch (r) {
        return;
      }
    })
  ).reduce((e, [n, r]) => (n && r && (e[n] = r), e), {});
}
function Gc(t) {
  if (typeof t == "boolean")
    return Number(t);
  const e = typeof t == "string" ? parseFloat(t) : t;
  if (!(typeof e != "number" || isNaN(e) || e < 0 || e > 1))
    return e;
}
const gs = 1;
let Ui = !1;
function qc(t) {
  const { spanId: e, traceId: n, isRemote: r } = t.spanContext(), i = r ? e : Gr(t).parent_span_id, o = ps(t).scope, s = r ? (o == null ? void 0 : o.getPropagationContext().propagationSpanId) || ds() : e;
  return {
    parent_span_id: i,
    span_id: s,
    trace_id: n
  };
}
function Hc(t) {
  if (t && t.length > 0)
    return t.map((s) => {
      var a = s, { context: u } = a, c = u, { spanId: e, traceId: n, traceFlags: r } = c, i = hi(c, ["spanId", "traceId", "traceFlags"]), { attributes: o } = a;
      return w({
        span_id: e,
        trace_id: n,
        sampled: r === gs,
        attributes: o
      }, i);
    });
}
function $i(t) {
  return typeof t == "number" ? Bi(t) : Array.isArray(t) ? t[0] + t[1] / 1e9 : t instanceof Date ? Bi(t.getTime()) : ge();
}
function Bi(t) {
  return t > 9999999999 ? t / 1e3 : t;
}
function Gr(t) {
  var r;
  if (Vc(t))
    return t.getSpanJSON();
  const { spanId: e, traceId: n } = t.spanContext();
  if (zc(t)) {
    const { attributes: i, startTime: o, name: s, endTime: a, status: u, links: c } = t, l = "parentSpanId" in t ? t.parentSpanId : "parentSpanContext" in t ? (r = t.parentSpanContext) == null ? void 0 : r.spanId : void 0;
    return {
      span_id: e,
      trace_id: n,
      data: i,
      description: s,
      parent_span_id: l,
      start_timestamp: $i(o),
      // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
      timestamp: $i(a) || void 0,
      status: Kc(u),
      op: i[Dc],
      origin: i[Pc],
      links: Hc(c)
    };
  }
  return {
    span_id: e,
    trace_id: n,
    start_timestamp: 0,
    data: {}
  };
}
function zc(t) {
  const e = t;
  return !!e.attributes && !!e.startTime && !!e.name && !!e.endTime && !!e.status;
}
function Vc(t) {
  return typeof t.getSpanJSON == "function";
}
function Wc(t) {
  const { traceFlags: e } = t.spanContext();
  return e === gs;
}
function Kc(t) {
  if (!(!t || t.code === Fc))
    return t.code === Lc ? "ok" : t.message || "unknown_error";
}
const Jc = "_sentryRootSpan";
function ys(t) {
  return t[Jc] || t;
}
function Gi() {
  Ui || (yt(() => {
    console.warn(
      "[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly."
    );
  }), Ui = !0);
}
function Yc(t) {
  var n;
  if (typeof __SENTRY_TRACING__ == "boolean" && !__SENTRY_TRACING__)
    return !1;
  const e = t || ((n = Y()) == null ? void 0 : n.getOptions());
  return !!e && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
  (e.tracesSampleRate != null || !!e.tracesSampler);
}
const qr = "production", Xc = /^o(\d+)\./, Qc = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function Zc(t) {
  return t === "http" || t === "https";
}
function kn(t, e = !1) {
  const { host: n, path: r, pass: i, port: o, projectId: s, protocol: a, publicKey: u } = t;
  return `${a}://${u}${e && i ? `:${i}` : ""}@${n}${o ? `:${o}` : ""}/${r && `${r}/`}${s}`;
}
function el(t) {
  const e = Qc.exec(t);
  if (!e) {
    yt(() => {
      console.error(`Invalid Sentry Dsn: ${t}`);
    });
    return;
  }
  const [n, r, i = "", o = "", s = "", a = ""] = e.slice(1);
  let u = "", c = a;
  const l = c.split("/");
  if (l.length > 1 && (u = l.slice(0, -1).join("/"), c = l.pop()), c) {
    const d = c.match(/^\d+/);
    d && (c = d[0]);
  }
  return ms({ host: o, pass: i, path: u, projectId: c, port: s, protocol: n, publicKey: r });
}
function ms(t) {
  return {
    protocol: t.protocol,
    publicKey: t.publicKey || "",
    pass: t.pass || "",
    host: t.host,
    port: t.port || "",
    path: t.path || "",
    projectId: t.projectId
  };
}
function tl(t) {
  if (!B)
    return !0;
  const { port: e, projectId: n, protocol: r } = t;
  return ["protocol", "publicKey", "host", "projectId"].find((s) => t[s] ? !1 : (N.error(`Invalid Sentry Dsn: ${s} missing`), !0)) ? !1 : n.match(/^\d+$/) ? Zc(r) ? e && isNaN(parseInt(e, 10)) ? (N.error(`Invalid Sentry Dsn: Invalid port ${e}`), !1) : !0 : (N.error(`Invalid Sentry Dsn: Invalid protocol ${r}`), !1) : (N.error(`Invalid Sentry Dsn: Invalid projectId ${n}`), !1);
}
function nl(t) {
  const e = t.match(Xc);
  return e == null ? void 0 : e[1];
}
function rl(t) {
  const e = typeof t == "string" ? el(t) : ms(t);
  if (!(!e || !tl(e)))
    return e;
}
const il = "_frozenDsc";
function vs(t, e) {
  const n = e.getOptions(), { publicKey: r, host: i } = e.getDsn() || {};
  let o;
  n.orgId ? o = String(n.orgId) : i && (o = nl(i));
  const s = {
    environment: n.environment || qr,
    release: n.release,
    public_key: r,
    trace_id: t,
    org_id: o
  };
  return e.emit("createDsc", s), s;
}
function ol(t, e) {
  const n = e.getPropagationContext();
  return n.dsc || vs(n.traceId, t);
}
function sl(t) {
  var p, v, g, m;
  const e = Y();
  if (!e)
    return {};
  const n = ys(t), r = Gr(n), i = r.data, o = n.spanContext().traceState, s = (v = (p = o == null ? void 0 : o.get("sentry.sample_rate")) != null ? p : i[Oc]) != null ? v : i[Rc];
  function a(_) {
    return (typeof s == "number" || typeof s == "string") && (_.sample_rate = `${s}`), _;
  }
  const u = n[il];
  if (u)
    return a(u);
  const c = o == null ? void 0 : o.get("sentry.dsc"), l = c && $c(c);
  if (l)
    return a(l);
  const d = vs(t.spanContext().traceId, e), f = i[Tc], h = r.description;
  return f !== "url" && h && (d.transaction = h), Yc() && (d.sampled = String(Wc(n)), d.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
  // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
  (m = o == null ? void 0 : o.get("sentry.sample_rand")) != null ? m : (
    // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
    (g = ps(n).scope) == null ? void 0 : g.getPropagationContext().sampleRand.toString()
  )), a(d), e.emit("createDsc", d, n), d;
}
function de(t, e = 100, n = 1 / 0) {
  try {
    return hr("", t, e, n);
  } catch (r) {
    return { ERROR: `**non-serializable** (${r})` };
  }
}
function _s(t, e = 3, n = 100 * 1024) {
  const r = de(t, e);
  return ll(r) > n ? _s(t, e - 1, n) : r;
}
function hr(t, e, n = 1 / 0, r = 1 / 0, i = dl()) {
  const [o, s] = i;
  if (e == null || // this matches null and undefined -> eqeq not eqeqeq
  ["boolean", "string"].includes(typeof e) || typeof e == "number" && Number.isFinite(e))
    return e;
  const a = al(t, e);
  if (!a.startsWith("[object "))
    return a;
  if (e.__sentry_skip_normalization__)
    return e;
  const u = typeof e.__sentry_override_normalization_depth__ == "number" ? e.__sentry_override_normalization_depth__ : n;
  if (u === 0)
    return a.replace("object ", "");
  if (o(e))
    return "[Circular ~]";
  const c = e;
  if (c && typeof c.toJSON == "function")
    try {
      const h = c.toJSON();
      return hr("", h, u - 1, r, i);
    } catch (h) {
    }
  const l = Array.isArray(e) ? [] : {};
  let d = 0;
  const f = us(e);
  for (const h in f) {
    if (!Object.prototype.hasOwnProperty.call(f, h))
      continue;
    if (d >= r) {
      l[h] = "[MaxProperties ~]";
      break;
    }
    const p = f[h];
    l[h] = hr(h, p, u - 1, r, i), d++;
  }
  return s(e), l;
}
function al(t, e) {
  try {
    if (t === "domain" && e && typeof e == "object" && e._events)
      return "[Domain]";
    if (t === "domainEmitter")
      return "[DomainEmitter]";
    if (typeof global != "undefined" && e === global)
      return "[Global]";
    if (typeof window != "undefined" && e === window)
      return "[Window]";
    if (typeof document != "undefined" && e === document)
      return "[Document]";
    if (os(e))
      return "[VueViewModel]";
    if (sc(e))
      return "[SyntheticEvent]";
    if (typeof e == "number" && !Number.isFinite(e))
      return `[${e}]`;
    if (typeof e == "function")
      return `[Function: ${be(e)}]`;
    if (typeof e == "symbol")
      return `[${String(e)}]`;
    if (typeof e == "bigint")
      return `[BigInt: ${String(e)}]`;
    const n = ul(e);
    return /^HTML(\w*)Element$/.test(n) ? `[HTMLElement: ${n}]` : `[object ${n}]`;
  } catch (n) {
    return `**non-serializable** (${n})`;
  }
}
function ul(t) {
  const e = Object.getPrototypeOf(t);
  return e != null && e.constructor ? e.constructor.name : "null prototype";
}
function cl(t) {
  return ~-encodeURI(t).split(/%..|./).length;
}
function ll(t) {
  return cl(JSON.stringify(t));
}
function dl() {
  const t = /* @__PURE__ */ new WeakSet();
  function e(r) {
    return t.has(r) ? !0 : (t.add(r), !1);
  }
  function n(r) {
    t.delete(r);
  }
  return [e, n];
}
function Pt(t, e = []) {
  return [t, e];
}
function fl(t, e) {
  const [n, r] = t;
  return [n, [...r, e]];
}
function qi(t, e) {
  const n = t[1];
  for (const r of n) {
    const i = r[0].type;
    if (e(r, i))
      return !0;
  }
  return !1;
}
function pr(t) {
  const e = _n(G);
  return e.encodePolyfill ? e.encodePolyfill(t) : new TextEncoder().encode(t);
}
function hl(t) {
  const [e, n] = t;
  let r = JSON.stringify(e);
  function i(o) {
    typeof r == "string" ? r = typeof o == "string" ? r + o : [pr(r), o] : r.push(typeof o == "string" ? pr(o) : o);
  }
  for (const o of n) {
    const [s, a] = o;
    if (i(`
${JSON.stringify(s)}
`), typeof a == "string" || a instanceof Uint8Array)
      i(a);
    else {
      let u;
      try {
        u = JSON.stringify(a);
      } catch (c) {
        u = JSON.stringify(de(a));
      }
      i(u);
    }
  }
  return typeof r == "string" ? r : pl(r);
}
function pl(t) {
  const e = t.reduce((i, o) => i + o.length, 0), n = new Uint8Array(e);
  let r = 0;
  for (const i of t)
    n.set(i, r), r += i.length;
  return n;
}
function gl(t) {
  const e = typeof t.data == "string" ? pr(t.data) : t.data;
  return [
    {
      type: "attachment",
      length: e.length,
      filename: t.filename,
      content_type: t.contentType,
      attachment_type: t.attachmentType
    },
    e
  ];
}
const yl = {
  session: "session",
  sessions: "session",
  attachment: "attachment",
  transaction: "transaction",
  event: "error",
  client_report: "internal",
  user_report: "default",
  profile: "profile",
  profile_chunk: "profile",
  replay_event: "replay",
  replay_recording: "replay",
  check_in: "monitor",
  feedback: "feedback",
  span: "span",
  raw_security: "security",
  log: "log_item"
};
function Hi(t) {
  return yl[t];
}
function bs(t) {
  if (!(t != null && t.sdk))
    return;
  const { name: e, version: n } = t.sdk;
  return { name: e, version: n };
}
function ml(t, e, n, r) {
  var o;
  const i = (o = t.sdkProcessingMetadata) == null ? void 0 : o.dynamicSamplingContext;
  return w(w(w({
    event_id: t.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString()
  }, e && { sdk: e }), !!n && r && { dsn: kn(r) }), i && {
    trace: i
  });
}
function vl(t, e) {
  return e && (t.sdk = t.sdk || {}, t.sdk.name = t.sdk.name || e.name, t.sdk.version = t.sdk.version || e.version, t.sdk.integrations = [...t.sdk.integrations || [], ...e.integrations || []], t.sdk.packages = [...t.sdk.packages || [], ...e.packages || []]), t;
}
function _l(t, e, n, r) {
  const i = bs(n), o = w(w({
    sent_at: (/* @__PURE__ */ new Date()).toISOString()
  }, i && { sdk: i }), !!r && e && { dsn: kn(e) }), s = "aggregates" in t ? [{ type: "sessions" }, t] : [{ type: "session" }, t.toJSON()];
  return Pt(o, [s]);
}
function bl(t, e, n, r) {
  const i = bs(n), o = t.type && t.type !== "replay_event" ? t.type : "event";
  vl(t, n == null ? void 0 : n.sdk);
  const s = ml(t, i, r, e);
  return delete t.sdkProcessingMetadata, Pt(s, [[{ type: o }, t]]);
}
var fe;
(function(t) {
  t[t.PENDING = 0] = "PENDING";
  const n = 1;
  t[t.RESOLVED = n] = "RESOLVED";
  const r = 2;
  t[t.REJECTED = r] = "REJECTED";
})(fe || (fe = {}));
function je(t) {
  return new we((e) => {
    e(t);
  });
}
function dn(t) {
  return new we((e, n) => {
    n(t);
  });
}
class we {
  constructor(e) {
    this._state = fe.PENDING, this._handlers = [], this._runExecutor(e);
  }
  /** @inheritdoc */
  then(e, n) {
    return new we((r, i) => {
      this._handlers.push([
        !1,
        (o) => {
          if (!e)
            r(o);
          else
            try {
              r(e(o));
            } catch (s) {
              i(s);
            }
        },
        (o) => {
          if (!n)
            i(o);
          else
            try {
              r(n(o));
            } catch (s) {
              i(s);
            }
        }
      ]), this._executeHandlers();
    });
  }
  /** @inheritdoc */
  catch(e) {
    return this.then((n) => n, e);
  }
  /** @inheritdoc */
  finally(e) {
    return new we((n, r) => {
      let i, o;
      return this.then(
        (s) => {
          o = !1, i = s, e && e();
        },
        (s) => {
          o = !0, i = s, e && e();
        }
      ).then(() => {
        if (o) {
          r(i);
          return;
        }
        n(i);
      });
    });
  }
  /** Excute the resolve/reject handlers. */
  _executeHandlers() {
    if (this._state === fe.PENDING)
      return;
    const e = this._handlers.slice();
    this._handlers = [], e.forEach((n) => {
      n[0] || (this._state === fe.RESOLVED && n[1](this._value), this._state === fe.REJECTED && n[2](this._value), n[0] = !0);
    });
  }
  /** Run the executor for the SyncPromise. */
  _runExecutor(e) {
    const n = (o, s) => {
      if (this._state === fe.PENDING) {
        if (wn(s)) {
          s.then(r, i);
          return;
        }
        this._state = o, this._value = s, this._executeHandlers();
      }
    }, r = (o) => {
      n(fe.RESOLVED, o);
    }, i = (o) => {
      n(fe.REJECTED, o);
    };
    try {
      e(r, i);
    } catch (o) {
      i(o);
    }
  }
}
function gr(t, e, n, r = 0) {
  return new we((i, o) => {
    const s = t[r];
    if (e === null || typeof s != "function")
      i(e);
    else {
      const a = s(w({}, e), n);
      B && s.id && a === null && N.log(`Event processor "${s.id}" dropped event`), wn(a) ? a.then((u) => gr(t, u, n, r + 1).then(i)).then(null, o) : gr(t, a, n, r + 1).then(i).then(null, o);
    }
  });
}
function Sl(t, e) {
  const { fingerprint: n, span: r, breadcrumbs: i, sdkProcessingMetadata: o } = e;
  wl(t, e), r && xl(t, r), Al(t, n), El(t, i), kl(t, o);
}
function zi(t, e) {
  const {
    extra: n,
    tags: r,
    user: i,
    contexts: o,
    level: s,
    sdkProcessingMetadata: a,
    breadcrumbs: u,
    fingerprint: c,
    eventProcessors: l,
    attachments: d,
    propagationContext: f,
    transactionName: h,
    span: p
  } = e;
  jt(t, "extra", n), jt(t, "tags", r), jt(t, "user", i), jt(t, "contexts", o), t.sdkProcessingMetadata = Rt(t.sdkProcessingMetadata, a, 2), s && (t.level = s), h && (t.transactionName = h), p && (t.span = p), u.length && (t.breadcrumbs = [...t.breadcrumbs, ...u]), c.length && (t.fingerprint = [...t.fingerprint, ...c]), l.length && (t.eventProcessors = [...t.eventProcessors, ...l]), d.length && (t.attachments = [...t.attachments, ...d]), t.propagationContext = w(w({}, t.propagationContext), f);
}
function jt(t, e, n) {
  t[e] = Rt(t[e], n, 1);
}
function wl(t, e) {
  const { extra: n, tags: r, user: i, contexts: o, level: s, transactionName: a } = e;
  Object.keys(n).length && (t.extra = w(w({}, n), t.extra)), Object.keys(r).length && (t.tags = w(w({}, r), t.tags)), Object.keys(i).length && (t.user = w(w({}, i), t.user)), Object.keys(o).length && (t.contexts = w(w({}, o), t.contexts)), s && (t.level = s), a && t.type !== "transaction" && (t.transaction = a);
}
function El(t, e) {
  const n = [...t.breadcrumbs || [], ...e];
  t.breadcrumbs = n.length ? n : void 0;
}
function kl(t, e) {
  t.sdkProcessingMetadata = w(w({}, t.sdkProcessingMetadata), e);
}
function xl(t, e) {
  t.contexts = w({
    trace: qc(e)
  }, t.contexts), t.sdkProcessingMetadata = w({
    dynamicSamplingContext: sl(e)
  }, t.sdkProcessingMetadata);
  const n = ys(e), r = Gr(n).description;
  r && !t.transaction && t.type === "transaction" && (t.transaction = r);
}
function Al(t, e) {
  t.fingerprint = t.fingerprint ? Array.isArray(t.fingerprint) ? t.fingerprint : [t.fingerprint] : [], e && (t.fingerprint = t.fingerprint.concat(e)), t.fingerprint.length || delete t.fingerprint;
}
let Ut, Vi, $t;
function Il(t) {
  const e = G._sentryDebugIds;
  if (!e)
    return {};
  const n = Object.keys(e);
  return $t && n.length === Vi || (Vi = n.length, $t = n.reduce((r, i) => {
    Ut || (Ut = {});
    const o = Ut[i];
    if (o)
      r[o[0]] = o[1];
    else {
      const s = t(i);
      for (let a = s.length - 1; a >= 0; a--) {
        const u = s[a], c = u == null ? void 0 : u.filename, l = e[i];
        if (c && l) {
          r[c] = l, Ut[i] = [c, l];
          break;
        }
      }
    }
    return r;
  }, {})), $t;
}
function Cl(t, e, n, r, i, o) {
  const { normalizeDepth: s = 3, normalizeMaxBreadth: a = 1e3 } = t, u = j(w({}, e), {
    event_id: e.event_id || n.event_id || re(),
    timestamp: e.timestamp || Ot()
  }), c = n.integrations || t.integrations.map((g) => g.name);
  Tl(u, t), Dl(u, c), i && i.emit("applyFrameMetadata", e), e.type === void 0 && Ol(u, t.stackParser);
  const l = Fl(r, n.captureContext);
  n.mechanism && dt(u, n.mechanism);
  const d = i ? i.getEventProcessors() : [], f = Ac().getScopeData();
  if (o) {
    const g = o.getScopeData();
    zi(f, g);
  }
  if (l) {
    const g = l.getScopeData();
    zi(f, g);
  }
  const h = [...n.attachments || [], ...f.attachments];
  h.length && (n.attachments = h), Sl(u, f);
  const p = [
    ...d,
    // Run scope event processors _after_ all other processors
    ...f.eventProcessors
  ];
  return gr(p, u, n).then((g) => (g && Rl(g), typeof s == "number" && s > 0 ? Pl(g, s, a) : g));
}
function Tl(t, e) {
  const { environment: n, release: r, dist: i, maxValueLength: o = 250 } = e;
  t.environment = t.environment || n || qr, !t.release && r && (t.release = r), !t.dist && i && (t.dist = i);
  const s = t.request;
  s != null && s.url && (s.url = ln(s.url, o));
}
function Ol(t, e) {
  var r, i;
  const n = Il(e);
  (i = (r = t.exception) == null ? void 0 : r.values) == null || i.forEach((o) => {
    var s, a;
    (a = (s = o.stacktrace) == null ? void 0 : s.frames) == null || a.forEach((u) => {
      u.filename && (u.debug_id = n[u.filename]);
    });
  });
}
function Rl(t) {
  var r, i;
  const e = {};
  if ((i = (r = t.exception) == null ? void 0 : r.values) == null || i.forEach((o) => {
    var s, a;
    (a = (s = o.stacktrace) == null ? void 0 : s.frames) == null || a.forEach((u) => {
      u.debug_id && (u.abs_path ? e[u.abs_path] = u.debug_id : u.filename && (e[u.filename] = u.debug_id), delete u.debug_id);
    });
  }), Object.keys(e).length === 0)
    return;
  t.debug_meta = t.debug_meta || {}, t.debug_meta.images = t.debug_meta.images || [];
  const n = t.debug_meta.images;
  Object.entries(e).forEach(([o, s]) => {
    n.push({
      type: "sourcemap",
      code_file: o,
      debug_id: s
    });
  });
}
function Dl(t, e) {
  e.length > 0 && (t.sdk = t.sdk || {}, t.sdk.integrations = [...t.sdk.integrations || [], ...e]);
}
function Pl(t, e, n) {
  var i, o;
  if (!t)
    return null;
  const r = w(w(w(w(w({}, t), t.breadcrumbs && {
    breadcrumbs: t.breadcrumbs.map((s) => w(w({}, s), s.data && {
      data: de(s.data, e, n)
    }))
  }), t.user && {
    user: de(t.user, e, n)
  }), t.contexts && {
    contexts: de(t.contexts, e, n)
  }), t.extra && {
    extra: de(t.extra, e, n)
  });
  return (i = t.contexts) != null && i.trace && r.contexts && (r.contexts.trace = t.contexts.trace, t.contexts.trace.data && (r.contexts.trace.data = de(t.contexts.trace.data, e, n))), t.spans && (r.spans = t.spans.map((s) => w(w({}, s), s.data && {
    data: de(s.data, e, n)
  }))), (o = t.contexts) != null && o.flags && r.contexts && (r.contexts.flags = de(t.contexts.flags, 3, n)), r;
}
function Fl(t, e) {
  if (!e)
    return t;
  const n = t ? t.clone() : new ce();
  return n.update(e), n;
}
function Ll(t) {
  if (t)
    return Nl(t) ? { captureContext: t } : jl(t) ? {
      captureContext: t
    } : t;
}
function Nl(t) {
  return t instanceof ce || typeof t == "function";
}
const Ml = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "propagationContext"
];
function jl(t) {
  return Object.keys(t).some((e) => Ml.includes(e));
}
function Ss(t, e) {
  return Ae().captureException(t, Ll(e));
}
function Hr(t, e) {
  return Ae().captureEvent(t, e);
}
function Wi(t) {
  const e = Dt(), n = Ae(), { userAgent: r } = G.navigator || {}, i = yc(w(w({
    user: n.getUser() || e.getUser()
  }, r && { userAgent: r }), t)), o = e.getSession();
  return (o == null ? void 0 : o.status) === "ok" && ft(o, { status: "exited" }), ws(), e.setSession(i), i;
}
function ws() {
  const t = Dt(), n = Ae().getSession() || t.getSession();
  n && mc(n), Es(), t.setSession();
}
function Es() {
  const t = Dt(), e = Y(), n = t.getSession();
  n && e && e.captureSession(n);
}
function Ki(t = !1) {
  if (t) {
    ws();
    return;
  }
  Es();
}
const Ul = "7";
function $l(t) {
  const e = t.protocol ? `${t.protocol}:` : "", n = t.port ? `:${t.port}` : "";
  return `${e}//${t.host}${n}${t.path ? `/${t.path}` : ""}/api/`;
}
function Bl(t) {
  return `${$l(t)}${t.projectId}/envelope/`;
}
function Gl(t, e) {
  const n = {
    sentry_version: Ul
  };
  return t.publicKey && (n.sentry_key = t.publicKey), e && (n.sentry_client = `${e.name}/${e.version}`), new URLSearchParams(n).toString();
}
function ql(t, e, n) {
  return e || `${Bl(t)}?${Gl(t, n)}`;
}
const Ji = [];
function Hl(t) {
  const e = {};
  return t.forEach((n) => {
    const { name: r } = n, i = e[r];
    i && !i.isDefaultInstance && n.isDefaultInstance || (e[r] = n);
  }), Object.values(e);
}
function zl(t) {
  const e = t.defaultIntegrations || [], n = t.integrations;
  e.forEach((i) => {
    i.isDefaultInstance = !0;
  });
  let r;
  if (Array.isArray(n))
    r = [...e, ...n];
  else if (typeof n == "function") {
    const i = n(e);
    r = Array.isArray(i) ? i : [i];
  } else
    r = e;
  return Hl(r);
}
function Vl(t, e) {
  const n = {};
  return e.forEach((r) => {
    r && ks(t, r, n);
  }), n;
}
function Yi(t, e) {
  for (const n of e)
    n != null && n.afterAllSetup && n.afterAllSetup(t);
}
function ks(t, e, n) {
  if (n[e.name]) {
    B && N.log(`Integration skipped because it was already installed: ${e.name}`);
    return;
  }
  if (n[e.name] = e, Ji.indexOf(e.name) === -1 && typeof e.setupOnce == "function" && (e.setupOnce(), Ji.push(e.name)), e.setup && typeof e.setup == "function" && e.setup(t), typeof e.preprocessEvent == "function") {
    const r = e.preprocessEvent.bind(e);
    t.on("preprocessEvent", (i, o) => r(i, o, t));
  }
  if (typeof e.processEvent == "function") {
    const r = e.processEvent.bind(e), i = Object.assign((o, s) => r(o, s, t), {
      id: e.name
    });
    t.addEventProcessor(i);
  }
  B && N.log(`Integration installed: ${e.name}`);
}
function Wl(t, e, n) {
  const r = [
    { type: "client_report" },
    {
      timestamp: Ot(),
      discarded_events: t
    }
  ];
  return Pt(e ? { dsn: e } : {}, [r]);
}
function xs(t) {
  const e = [];
  t.message && e.push(t.message);
  try {
    const n = t.exception.values[t.exception.values.length - 1];
    n != null && n.value && (e.push(n.value), n.type && e.push(`${n.type}: ${n.value}`));
  } catch (n) {
  }
  return e;
}
function Kl(t) {
  var u, c, l;
  const { trace_id: e, parent_span_id: n, span_id: r, status: i, origin: o, data: s, op: a } = (c = (u = t.contexts) == null ? void 0 : u.trace) != null ? c : {};
  return {
    data: s != null ? s : {},
    description: t.transaction,
    op: a,
    parent_span_id: n,
    span_id: r != null ? r : "",
    start_timestamp: (l = t.start_timestamp) != null ? l : 0,
    status: i,
    timestamp: t.timestamp,
    trace_id: e != null ? e : "",
    origin: o,
    profile_id: s == null ? void 0 : s[fs],
    exclusive_time: s == null ? void 0 : s[hs],
    measurements: t.measurements,
    is_segment: !0
  };
}
function Jl(t) {
  return {
    type: "transaction",
    timestamp: t.timestamp,
    start_timestamp: t.start_timestamp,
    transaction: t.description,
    contexts: {
      trace: {
        trace_id: t.trace_id,
        span_id: t.span_id,
        parent_span_id: t.parent_span_id,
        op: t.op,
        status: t.status,
        origin: t.origin,
        data: w(w(w({}, t.data), t.profile_id && { [fs]: t.profile_id }), t.exclusive_time && { [hs]: t.exclusive_time })
      }
    },
    measurements: t.measurements
  };
}
const Xi = "Not capturing exception because it's already been captured.", Qi = "Discarded session because of missing or non-string release", As = Symbol.for("SentryInternalError"), Is = Symbol.for("SentryDoNotSendEventError");
function nn(t) {
  return {
    message: t,
    [As]: !0
  };
}
function Vn(t) {
  return {
    message: t,
    [Is]: !0
  };
}
function Zi(t) {
  return !!t && typeof t == "object" && As in t;
}
function eo(t) {
  return !!t && typeof t == "object" && Is in t;
}
class Yl {
  /** Options passed to the SDK. */
  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */
  /** Array of set up integrations. */
  /** Number of calls being processed */
  /** Holds flushable  */
  // eslint-disable-next-line @typescript-eslint/ban-types
  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  constructor(e) {
    if (this._options = e, this._integrations = {}, this._numProcessing = 0, this._outcomes = {}, this._hooks = {}, this._eventProcessors = [], e.dsn ? this._dsn = rl(e.dsn) : B && N.warn("No DSN provided, client will not send events."), this._dsn) {
      const n = ql(
        this._dsn,
        e.tunnel,
        e._metadata ? e._metadata.sdk : void 0
      );
      this._transport = e.transport(j(w({
        tunnel: this._options.tunnel,
        recordDroppedEvent: this.recordDroppedEvent.bind(this)
      }, e.transportOptions), {
        url: n
      }));
    }
  }
  /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureException(e, n, r) {
    const i = re();
    if (Pi(e))
      return B && N.log(Xi), i;
    const o = w({
      event_id: i
    }, n);
    return this._process(
      this.eventFromException(e, o).then(
        (s) => this._captureEvent(s, o, r)
      )
    ), o.event_id;
  }
  /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureMessage(e, n, r, i) {
    const o = w({
      event_id: re()
    }, r), s = Nr(e) ? e : String(e), a = Mr(e) ? this.eventFromMessage(s, n, o) : this.eventFromException(e, o);
    return this._process(a.then((u) => this._captureEvent(u, o, i))), o.event_id;
  }
  /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureEvent(e, n, r) {
    const i = re();
    if (n != null && n.originalException && Pi(n.originalException))
      return B && N.log(Xi), i;
    const o = w({
      event_id: i
    }, n), s = e.sdkProcessingMetadata || {}, a = s.capturedSpanScope, u = s.capturedSpanIsolationScope;
    return this._process(
      this._captureEvent(e, o, a || r, u)
    ), o.event_id;
  }
  /**
   * Captures a session.
   */
  captureSession(e) {
    this.sendSession(e), ft(e, { init: !1 });
  }
  /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */
  /**
   * Get the current Dsn.
   */
  getDsn() {
    return this._dsn;
  }
  /**
   * Get the current options.
   */
  getOptions() {
    return this._options;
  }
  /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */
  getSdkMetadata() {
    return this._options._metadata;
  }
  /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */
  getTransport() {
    return this._transport;
  }
  /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */
  flush(e) {
    const n = this._transport;
    return n ? (this.emit("flush"), this._isClientDoneProcessing(e).then((r) => n.flush(e).then((i) => r && i))) : je(!0);
  }
  /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */
  close(e) {
    return this.flush(e).then((n) => (this.getOptions().enabled = !1, this.emit("close"), n));
  }
  /**
   * Get all installed event processors.
   */
  getEventProcessors() {
    return this._eventProcessors;
  }
  /**
   * Adds an event processor that applies to any event processed by this client.
   */
  addEventProcessor(e) {
    this._eventProcessors.push(e);
  }
  /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */
  init() {
    (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
    // Spotlight enabled. This is particularly important for browser as we
    // don't support the `spotlight` option there and rely on the users
    // adding the `spotlightBrowserIntegration()` to their integrations which
    // wouldn't get initialized with the check below when there's no DSN set.
    this._options.integrations.some(({ name: e }) => e.startsWith("Spotlight"))) && this._setupIntegrations();
  }
  /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */
  getIntegrationByName(e) {
    return this._integrations[e];
  }
  /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */
  addIntegration(e) {
    const n = this._integrations[e.name];
    ks(this, e, this._integrations), n || Yi(this, [e]);
  }
  /**
   * Send a fully prepared event to Sentry.
   */
  sendEvent(e, n = {}) {
    this.emit("beforeSendEvent", e, n);
    let r = bl(e, this._dsn, this._options._metadata, this._options.tunnel);
    for (const o of n.attachments || [])
      r = fl(r, gl(o));
    const i = this.sendEnvelope(r);
    i && i.then((o) => this.emit("afterSendEvent", e, o), null);
  }
  /**
   * Send a session or session aggregrates to Sentry.
   */
  sendSession(e) {
    const { release: n, environment: r = qr } = this._options;
    if ("aggregates" in e) {
      const o = e.attrs || {};
      if (!o.release && !n) {
        B && N.warn(Qi);
        return;
      }
      o.release = o.release || n, o.environment = o.environment || r, e.attrs = o;
    } else {
      if (!e.release && !n) {
        B && N.warn(Qi);
        return;
      }
      e.release = e.release || n, e.environment = e.environment || r;
    }
    this.emit("beforeSendSession", e);
    const i = _l(e, this._dsn, this._options._metadata, this._options.tunnel);
    this.sendEnvelope(i);
  }
  /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */
  recordDroppedEvent(e, n, r = 1) {
    if (this._options.sendClientReports) {
      const i = `${e}:${n}`;
      B && N.log(`Recording outcome: "${i}"${r > 1 ? ` (${r} times)` : ""}`), this._outcomes[i] = (this._outcomes[i] || 0) + r;
    }
  }
  /* eslint-disable @typescript-eslint/unified-signatures */
  /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */
  /**
   * Register a hook on this client.
   */
  on(e, n) {
    const r = this._hooks[e] = this._hooks[e] || [];
    return r.push(n), () => {
      const i = r.indexOf(n);
      i > -1 && r.splice(i, 1);
    };
  }
  /** Fire a hook whenever a span starts. */
  /**
   * Emit a hook that was previously registered via `on()`.
   */
  emit(e, ...n) {
    const r = this._hooks[e];
    r && r.forEach((i) => i(...n));
  }
  /**
   * Send an envelope to Sentry.
   */
  sendEnvelope(e) {
    return this.emit("beforeEnvelope", e), this._isEnabled() && this._transport ? this._transport.send(e).then(null, (n) => (B && N.error("Error while sending envelope:", n), n)) : (B && N.error("Transport disabled"), je({}));
  }
  /* eslint-enable @typescript-eslint/unified-signatures */
  /** Setup integrations for this client. */
  _setupIntegrations() {
    const { integrations: e } = this._options;
    this._integrations = Vl(this, e), Yi(this, e);
  }
  /** Updates existing session based on the provided event */
  _updateSessionFromEvent(e, n) {
    var u;
    let r = n.level === "fatal", i = !1;
    const o = (u = n.exception) == null ? void 0 : u.values;
    if (o) {
      i = !0;
      for (const c of o) {
        const l = c.mechanism;
        if ((l == null ? void 0 : l.handled) === !1) {
          r = !0;
          break;
        }
      }
    }
    const s = e.status === "ok";
    (s && e.errors === 0 || s && r) && (ft(e, j(w({}, r && { status: "crashed" }), {
      errors: e.errors || Number(i || r)
    })), this.captureSession(e));
  }
  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
  _isClientDoneProcessing(e) {
    return new we((n) => {
      let r = 0;
      const i = 1, o = setInterval(() => {
        this._numProcessing == 0 ? (clearInterval(o), n(!0)) : (r += i, e && r >= e && (clearInterval(o), n(!1)));
      }, i);
    });
  }
  /** Determines whether this SDK is enabled and a transport is present. */
  _isEnabled() {
    return this.getOptions().enabled !== !1 && this._transport !== void 0;
  }
  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */
  _prepareEvent(e, n, r, i) {
    const o = this.getOptions(), s = Object.keys(this._integrations);
    return !n.integrations && (s != null && s.length) && (n.integrations = s), this.emit("preprocessEvent", e, n), e.type || i.setLastEventId(e.event_id || n.event_id), Cl(o, e, n, r, this, i).then((a) => {
      if (a === null)
        return a;
      this.emit("postprocessEvent", a, n), a.contexts = w({
        trace: Cc(r)
      }, a.contexts);
      const u = ol(this, r);
      return a.sdkProcessingMetadata = w({
        dynamicSamplingContext: u
      }, a.sdkProcessingMetadata), a;
    });
  }
  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
  _captureEvent(e, n = {}, r = Ae(), i = Dt()) {
    return B && yr(e) && N.log(`Captured error event \`${xs(e)[0] || "<unknown>"}\``), this._processEvent(e, n, r, i).then(
      (o) => o.event_id,
      (o) => {
        B && (eo(o) ? N.log(o.message) : Zi(o) ? N.warn(o.message) : N.warn(o));
      }
    );
  }
  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
  _processEvent(e, n, r, i) {
    const o = this.getOptions(), { sampleRate: s } = o, a = Cs(e), u = yr(e), c = e.type || "error", l = `before send for type \`${c}\``, d = typeof s == "undefined" ? void 0 : Gc(s);
    if (u && typeof d == "number" && Math.random() > d)
      return this.recordDroppedEvent("sample_rate", "error"), dn(
        Vn(
          `Discarding event because it's not included in the random sample (sampling rate = ${s})`
        )
      );
    const f = c === "replay_event" ? "replay" : c;
    return this._prepareEvent(e, n, r, i).then((h) => {
      if (h === null)
        throw this.recordDroppedEvent("event_processor", f), Vn("An event processor returned `null`, will not send event.");
      if (n.data && n.data.__sentry__ === !0)
        return h;
      const v = Ql(this, o, h, n);
      return Xl(v, l);
    }).then((h) => {
      var g;
      if (h === null) {
        if (this.recordDroppedEvent("before_send", f), a) {
          const _ = 1 + (e.spans || []).length;
          this.recordDroppedEvent("before_send", "span", _);
        }
        throw Vn(`${l} returned \`null\`, will not send event.`);
      }
      const p = r.getSession() || i.getSession();
      if (u && p && this._updateSessionFromEvent(p, h), a) {
        const m = ((g = h.sdkProcessingMetadata) == null ? void 0 : g.spanCountBeforeProcessing) || 0, _ = h.spans ? h.spans.length : 0, C = m - _;
        C > 0 && this.recordDroppedEvent("before_send", "span", C);
      }
      const v = h.transaction_info;
      if (a && v && h.transaction !== e.transaction) {
        const m = "custom";
        h.transaction_info = j(w({}, v), {
          source: m
        });
      }
      return this.sendEvent(h, n), h;
    }).then(null, (h) => {
      throw eo(h) || Zi(h) ? h : (this.captureException(h, {
        data: {
          __sentry__: !0
        },
        originalException: h
      }), nn(
        `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${h}`
      ));
    });
  }
  /**
   * Occupies the client with processing and event
   */
  _process(e) {
    this._numProcessing++, e.then(
      (n) => (this._numProcessing--, n),
      (n) => (this._numProcessing--, n)
    );
  }
  /**
   * Clears outcomes on this client and returns them.
   */
  _clearOutcomes() {
    const e = this._outcomes;
    return this._outcomes = {}, Object.entries(e).map(([n, r]) => {
      const [i, o] = n.split(":");
      return {
        reason: i,
        category: o,
        quantity: r
      };
    });
  }
  /**
   * Sends client reports as an envelope.
   */
  _flushOutcomes() {
    B && N.log("Flushing outcomes...");
    const e = this._clearOutcomes();
    if (e.length === 0) {
      B && N.log("No outcomes to send");
      return;
    }
    if (!this._dsn) {
      B && N.log("No dsn provided, will not send outcomes");
      return;
    }
    B && N.log("Sending outcomes:", e);
    const n = Wl(e, this._options.tunnel && kn(this._dsn));
    this.sendEnvelope(n);
  }
  /**
   * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
   */
}
function Xl(t, e) {
  const n = `${e} must return \`null\` or a valid event.`;
  if (wn(t))
    return t.then(
      (r) => {
        if (!Ct(r) && r !== null)
          throw nn(n);
        return r;
      },
      (r) => {
        throw nn(`${e} rejected with ${r}`);
      }
    );
  if (!Ct(t) && t !== null)
    throw nn(n);
  return t;
}
function Ql(t, e, n, r) {
  const { beforeSend: i, beforeSendTransaction: o, beforeSendSpan: s } = e;
  let a = n;
  if (yr(a) && i)
    return i(a, r);
  if (Cs(a)) {
    if (s) {
      const u = s(Kl(a));
      if (u ? a = Rt(n, Jl(u)) : Gi(), a.spans) {
        const c = [];
        for (const l of a.spans) {
          const d = s(l);
          d ? c.push(d) : (Gi(), c.push(l));
        }
        a.spans = c;
      }
    }
    if (o) {
      if (a.spans) {
        const u = a.spans.length;
        a.sdkProcessingMetadata = j(w({}, n.sdkProcessingMetadata), {
          spanCountBeforeProcessing: u
        });
      }
      return o(a, r);
    }
  }
  return a;
}
function yr(t) {
  return t.type === void 0;
}
function Cs(t) {
  return t.type === "transaction";
}
function Zl(t) {
  return [
    {
      type: "log",
      item_count: t.length,
      content_type: "application/vnd.sentry.items.log+json"
    },
    {
      items: t
    }
  ];
}
function ed(t, e, n, r) {
  const i = {};
  return e != null && e.sdk && (i.sdk = {
    name: e.sdk.name,
    version: e.sdk.version
  }), n && r && (i.dsn = kn(r)), Pt(i, [Zl(t)]);
}
G._sentryClientToLogBufferMap = /* @__PURE__ */ new WeakMap();
function Wn(t, e) {
  var o, s;
  const n = (o = td(t)) != null ? o : [];
  if (n.length === 0)
    return;
  const r = t.getOptions(), i = ed(n, r._metadata, r.tunnel, t.getDsn());
  (s = G._sentryClientToLogBufferMap) == null || s.set(t, []), t.emit("flushLogs"), t.sendEnvelope(i);
}
function td(t) {
  var e;
  return (e = G._sentryClientToLogBufferMap) == null ? void 0 : e.get(t);
}
function nd(t, e) {
  e.debug === !0 && (B ? N.enable() : yt(() => {
    console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
  })), Ae().update(e.initialScope);
  const r = new t(e);
  return rd(r), r.init(), r;
}
function rd(t) {
  Ae().setClient(t);
}
const Ts = Symbol.for("SentryBufferFullError");
function id(t) {
  const e = [];
  function n() {
    return t === void 0 || e.length < t;
  }
  function r(s) {
    return e.splice(e.indexOf(s), 1)[0] || Promise.resolve(void 0);
  }
  function i(s) {
    if (!n())
      return dn(Ts);
    const a = s();
    return e.indexOf(a) === -1 && e.push(a), a.then(() => r(a)).then(
      null,
      () => r(a).then(null, () => {
      })
    ), a;
  }
  function o(s) {
    return new we((a, u) => {
      let c = e.length;
      if (!c)
        return a(!0);
      const l = setTimeout(() => {
        s && s > 0 && a(!1);
      }, s);
      e.forEach((d) => {
        je(d).then(() => {
          --c || (clearTimeout(l), a(!0));
        }, u);
      });
    });
  }
  return {
    $: e,
    add: i,
    drain: o
  };
}
const od = 60 * 1e3;
function sd(t, e = Date.now()) {
  const n = parseInt(`${t}`, 10);
  if (!isNaN(n))
    return n * 1e3;
  const r = Date.parse(`${t}`);
  return isNaN(r) ? od : r - e;
}
function ad(t, e) {
  return t[e] || t.all || 0;
}
function ud(t, e, n = Date.now()) {
  return ad(t, e) > n;
}
function cd(t, { statusCode: e, headers: n }, r = Date.now()) {
  const i = w({}, t), o = n == null ? void 0 : n["x-sentry-rate-limits"], s = n == null ? void 0 : n["retry-after"];
  if (o)
    for (const a of o.trim().split(",")) {
      const [u, c, , , l] = a.split(":", 5), d = parseInt(u, 10), f = (isNaN(d) ? 60 : d) * 1e3;
      if (!c)
        i.all = r + f;
      else
        for (const h of c.split(";"))
          h === "metric_bucket" ? (!l || l.split(";").includes("custom")) && (i[h] = r + f) : i[h] = r + f;
    }
  else s ? i.all = r + sd(s, r) : e === 429 && (i.all = r + 60 * 1e3);
  return i;
}
const ld = 64;
function dd(t, e, n = id(
  t.bufferSize || ld
)) {
  let r = {};
  const i = (s) => n.drain(s);
  function o(s) {
    const a = [];
    if (qi(s, (d, f) => {
      const h = Hi(f);
      ud(r, h) ? t.recordDroppedEvent("ratelimit_backoff", h) : a.push(d);
    }), a.length === 0)
      return je({});
    const u = Pt(s[0], a), c = (d) => {
      qi(u, (f, h) => {
        t.recordDroppedEvent(d, Hi(h));
      });
    }, l = () => e({ body: hl(u) }).then(
      (d) => (d.statusCode !== void 0 && (d.statusCode < 200 || d.statusCode >= 300) && B && N.warn(`Sentry responded with status code ${d.statusCode} to sent event.`), r = cd(r, d), d),
      (d) => {
        throw c("network_error"), B && N.error("Encountered error running transport request:", d), d;
      }
    );
    return n.add(l).then(
      (d) => d,
      (d) => {
        if (d === Ts)
          return B && N.error("Skipped sending event because buffer is full."), c("queue_overflow"), je({});
        throw d;
      }
    );
  }
  return {
    send: o,
    flush: i
  };
}
function fd(t) {
  var e;
  ((e = t.user) == null ? void 0 : e.ip_address) === void 0 && (t.user = j(w({}, t.user), {
    ip_address: "{{auto}}"
  }));
}
function hd(t) {
  var e;
  "aggregates" in t ? ((e = t.attrs) == null ? void 0 : e.ip_address) === void 0 && (t.attrs = j(w({}, t.attrs), {
    ip_address: "{{auto}}"
  })) : t.ipAddress === void 0 && (t.ipAddress = "{{auto}}");
}
function pd(t, e, n = [e], r = "npm") {
  const i = t._metadata || {};
  i.sdk || (i.sdk = {
    name: `sentry.javascript.${e}`,
    packages: n.map((o) => ({
      name: `${r}:@sentry/${o}`,
      version: Fe
    })),
    version: Fe
  }), t._metadata = i;
}
const gd = 100;
function Ue(t, e) {
  const n = Y(), r = Dt();
  if (!n) return;
  const { beforeBreadcrumb: i = null, maxBreadcrumbs: o = gd } = n.getOptions();
  if (o <= 0) return;
  const s = Ot(), a = w({ timestamp: s }, t), u = i ? yt(() => i(a, e)) : a;
  u !== null && (n.emit && n.emit("beforeAddBreadcrumb", u, e), r.addBreadcrumb(u, o));
}
let to;
const yd = "FunctionToString", no = /* @__PURE__ */ new WeakMap(), md = () => ({
  name: yd,
  setupOnce() {
    to = Function.prototype.toString;
    try {
      Function.prototype.toString = function(...t) {
        const e = $r(this), n = no.has(Y()) && e !== void 0 ? e : this;
        return to.apply(n, t);
      };
    } catch (t) {
    }
  },
  setup(t) {
    no.set(t, !0);
  }
}), vd = md, _d = [
  /^Script error\.?$/,
  /^Javascript error: Script error\.? on line 0$/,
  /^ResizeObserver loop completed with undelivered notifications.$/,
  // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
  /^Cannot redefine property: googletag$/,
  // This is thrown when google tag manager is used in combination with an ad blocker
  /^Can't find variable: gmo$/,
  // Error from Google Search App https://issuetracker.google.com/issues/396043331
  /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
  // Random error that happens but not actionable or noticeable to end-users.
  `can't redefine non-configurable property "solana"`,
  // Probably a browser extension or custom browser (Brave) throwing this error
  "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
  // Error thrown by GTM, seemingly not affecting end-users
  "Can't find variable: _AutofillCallbackHandler",
  // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
  /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
  // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
  /^Java exception was raised during method invocation$/
  // error from Facebook Mobile browser (https://github.com/getsentry/sentry-javascript/issues/15065)
], bd = "EventFilters", Sd = (t = {}) => {
  let e;
  return {
    name: bd,
    setup(n) {
      const r = n.getOptions();
      e = ro(t, r);
    },
    processEvent(n, r, i) {
      if (!e) {
        const o = i.getOptions();
        e = ro(t, o);
      }
      return Ed(n, e) ? null : n;
    }
  };
}, wd = (t = {}) => j(w({}, Sd(t)), {
  name: "InboundFilters"
});
function ro(t = {}, e = {}) {
  return {
    allowUrls: [...t.allowUrls || [], ...e.allowUrls || []],
    denyUrls: [...t.denyUrls || [], ...e.denyUrls || []],
    ignoreErrors: [
      ...t.ignoreErrors || [],
      ...e.ignoreErrors || [],
      ...t.disableErrorDefaults ? [] : _d
    ],
    ignoreTransactions: [...t.ignoreTransactions || [], ...e.ignoreTransactions || []]
  };
}
function Ed(t, e) {
  if (t.type) {
    if (t.type === "transaction" && xd(t, e.ignoreTransactions))
      return B && N.warn(
        `Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${Re(t)}`
      ), !0;
  } else {
    if (kd(t, e.ignoreErrors))
      return B && N.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${Re(t)}`
      ), !0;
    if (Td(t))
      return B && N.warn(
        `Event dropped due to not having an error message, error type or stacktrace.
Event: ${Re(
          t
        )}`
      ), !0;
    if (Ad(t, e.denyUrls))
      return B && N.warn(
        `Event dropped due to being matched by \`denyUrls\` option.
Event: ${Re(
          t
        )}.
Url: ${fn(t)}`
      ), !0;
    if (!Id(t, e.allowUrls))
      return B && N.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.
Event: ${Re(
          t
        )}.
Url: ${fn(t)}`
      ), !0;
  }
  return !1;
}
function kd(t, e) {
  return e != null && e.length ? xs(t).some((n) => En(n, e)) : !1;
}
function xd(t, e) {
  if (!(e != null && e.length))
    return !1;
  const n = t.transaction;
  return n ? En(n, e) : !1;
}
function Ad(t, e) {
  if (!(e != null && e.length))
    return !1;
  const n = fn(t);
  return n ? En(n, e) : !1;
}
function Id(t, e) {
  if (!(e != null && e.length))
    return !0;
  const n = fn(t);
  return n ? En(n, e) : !0;
}
function Cd(t = []) {
  for (let e = t.length - 1; e >= 0; e--) {
    const n = t[e];
    if (n && n.filename !== "<anonymous>" && n.filename !== "[native code]")
      return n.filename || null;
  }
  return null;
}
function fn(t) {
  var e, n, r;
  try {
    const i = [...(n = (e = t.exception) == null ? void 0 : e.values) != null ? n : []].reverse().find((s) => {
      var a, u, c;
      return ((a = s.mechanism) == null ? void 0 : a.parent_id) === void 0 && ((c = (u = s.stacktrace) == null ? void 0 : u.frames) == null ? void 0 : c.length);
    }), o = (r = i == null ? void 0 : i.stacktrace) == null ? void 0 : r.frames;
    return o ? Cd(o) : null;
  } catch (i) {
    return B && N.error(`Cannot extract url for event ${Re(t)}`), null;
  }
}
function Td(t) {
  var e, n;
  return (n = (e = t.exception) == null ? void 0 : e.values) != null && n.length ? (
    // No top-level message
    !t.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !t.exception.values.some((r) => r.stacktrace || r.type && r.type !== "Error" || r.value)
  ) : !1;
}
function Od(t, e, n, r, i, o) {
  var a;
  if (!((a = i.exception) != null && a.values) || !o || !Se(o.originalException, Error))
    return;
  const s = i.exception.values.length > 0 ? i.exception.values[i.exception.values.length - 1] : void 0;
  s && (i.exception.values = mr(
    t,
    e,
    r,
    o.originalException,
    n,
    i.exception.values,
    s,
    0
  ));
}
function mr(t, e, n, r, i, o, s, a) {
  if (o.length >= n + 1)
    return o;
  let u = [...o];
  if (Se(r[i], Error)) {
    io(s, a);
    const c = t(e, r[i]), l = u.length;
    oo(c, i, l, a), u = mr(
      t,
      e,
      n,
      r[i],
      i,
      [c, ...u],
      c,
      l
    );
  }
  return Array.isArray(r.errors) && r.errors.forEach((c, l) => {
    if (Se(c, Error)) {
      io(s, a);
      const d = t(e, c), f = u.length;
      oo(d, `errors[${l}]`, f, a), u = mr(
        t,
        e,
        n,
        c,
        i,
        [d, ...u],
        d,
        f
      );
    }
  }), u;
}
function io(t, e) {
  t.mechanism = t.mechanism || { type: "generic", handled: !0 }, t.mechanism = j(w(w({}, t.mechanism), t.type === "AggregateError" && { is_exception_group: !0 }), {
    exception_id: e
  });
}
function oo(t, e, n, r) {
  t.mechanism = t.mechanism || { type: "generic", handled: !0 }, t.mechanism = j(w({}, t.mechanism), {
    type: "chained",
    source: e,
    exception_id: n,
    parent_id: r
  });
}
function Rd(t) {
  const e = "console";
  Be(e, t), Ge(e, Dd);
}
function Dd() {
  "console" in G && lr.forEach(function(t) {
    t in G.console && te(G.console, t, function(e) {
      return cn[t] = e, function(...n) {
        ie("console", { args: n, level: t });
        const i = cn[t];
        i == null || i.apply(G.console, n);
      };
    });
  });
}
function Pd(t) {
  return t === "warn" ? "warning" : ["fatal", "error", "warning", "log", "info", "debug"].includes(t) ? t : "log";
}
const Fd = "Dedupe", Ld = () => {
  let t;
  return {
    name: Fd,
    processEvent(e) {
      if (e.type)
        return e;
      try {
        if (Md(e, t))
          return B && N.warn("Event dropped due to being a duplicate of previously captured event."), null;
      } catch (n) {
      }
      return t = e;
    }
  };
}, Nd = Ld;
function Md(t, e) {
  return e ? !!(jd(t, e) || Ud(t, e)) : !1;
}
function jd(t, e) {
  const n = t.message, r = e.message;
  return !(!n && !r || n && !r || !n && r || n !== r || !Rs(t, e) || !Os(t, e));
}
function Ud(t, e) {
  const n = so(e), r = so(t);
  return !(!n || !r || n.type !== r.type || n.value !== r.value || !Rs(t, e) || !Os(t, e));
}
function Os(t, e) {
  let n = Ii(t), r = Ii(e);
  if (!n && !r)
    return !0;
  if (n && !r || !n && r || (n = n, r = r, r.length !== n.length))
    return !1;
  for (let i = 0; i < r.length; i++) {
    const o = r[i], s = n[i];
    if (o.filename !== s.filename || o.lineno !== s.lineno || o.colno !== s.colno || o.function !== s.function)
      return !1;
  }
  return !0;
}
function Rs(t, e) {
  let n = t.fingerprint, r = e.fingerprint;
  if (!n && !r)
    return !0;
  if (n && !r || !n && r)
    return !1;
  n = n, r = r;
  try {
    return n.join("") === r.join("");
  } catch (i) {
    return !1;
  }
}
function so(t) {
  var e;
  return ((e = t.exception) == null ? void 0 : e.values) && t.exception.values[0];
}
function Kn(t) {
  if (!t)
    return {};
  const e = t.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!e)
    return {};
  const n = e[6] || "", r = e[8] || "";
  return {
    host: e[4],
    path: e[5],
    protocol: e[2],
    search: n,
    hash: r,
    relative: e[5] + n + r
    // everything minus origin
  };
}
function Ds(t) {
  if (t !== void 0)
    return t >= 400 && t < 500 ? "warning" : t >= 500 ? "error" : void 0;
}
const Tt = G;
function $d() {
  return "history" in Tt && !!Tt.history;
}
function Bd() {
  if (!("fetch" in Tt))
    return !1;
  try {
    return new Headers(), new Request("http://www.example.com"), new Response(), !0;
  } catch (t) {
    return !1;
  }
}
function vr(t) {
  return t && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(t.toString());
}
function Gd() {
  var n;
  if (typeof EdgeRuntime == "string")
    return !0;
  if (!Bd())
    return !1;
  if (vr(Tt.fetch))
    return !0;
  let t = !1;
  const e = Tt.document;
  if (e && typeof e.createElement == "function")
    try {
      const r = e.createElement("iframe");
      r.hidden = !0, e.head.appendChild(r), (n = r.contentWindow) != null && n.fetch && (t = vr(r.contentWindow.fetch)), e.head.removeChild(r);
    } catch (r) {
      B && N.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", r);
    }
  return t;
}
function qd(t, e) {
  const n = "fetch";
  Be(n, t), Ge(n, () => Hd(void 0, e));
}
function Hd(t, e = !1) {
  e && !Gd() || te(G, "fetch", function(n) {
    return function(...r) {
      const i = new Error(), { method: o, url: s } = zd(r), a = {
        args: r,
        fetchData: {
          method: o,
          url: s
        },
        startTimestamp: ge() * 1e3,
        // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
        virtualError: i,
        headers: Vd(r)
      };
      return ie("fetch", w({}, a)), n.apply(G, r).then(
        (u) => M(this, null, function* () {
          return ie("fetch", j(w({}, a), {
            endTimestamp: ge() * 1e3,
            response: u
          })), u;
        }),
        (u) => {
          if (ie("fetch", j(w({}, a), {
            endTimestamp: ge() * 1e3,
            error: u
          })), Lr(u) && u.stack === void 0 && (u.stack = i.stack, Me(u, "framesToPop", 1)), u instanceof TypeError && (u.message === "Failed to fetch" || u.message === "Load failed" || u.message === "NetworkError when attempting to fetch resource."))
            try {
              const c = new URL(a.fetchData.url);
              u.message = `${u.message} (${c.host})`;
            } catch (c) {
            }
          throw u;
        }
      );
    };
  });
}
function _r(t, e) {
  return !!t && typeof t == "object" && !!t[e];
}
function ao(t) {
  return typeof t == "string" ? t : t ? _r(t, "url") ? t.url : t.toString ? t.toString() : "" : "";
}
function zd(t) {
  if (t.length === 0)
    return { method: "GET", url: "" };
  if (t.length === 2) {
    const [n, r] = t;
    return {
      url: ao(n),
      method: _r(r, "method") ? String(r.method).toUpperCase() : "GET"
    };
  }
  const e = t[0];
  return {
    url: ao(e),
    method: _r(e, "method") ? String(e.method).toUpperCase() : "GET"
  };
}
function Vd(t) {
  const [e, n] = t;
  try {
    if (typeof n == "object" && n !== null && "headers" in n && n.headers)
      return new Headers(n.headers);
    if (ac(e))
      return new Headers(e.headers);
  } catch (r) {
  }
}
function Wd() {
  return "npm";
}
const K = G;
let br = 0;
function Ps() {
  return br > 0;
}
function Kd() {
  br++, setTimeout(() => {
    br--;
  });
}
function pt(t, e = {}) {
  function n(i) {
    return typeof i == "function";
  }
  if (!n(t))
    return t;
  try {
    const i = t.__sentry_wrapped__;
    if (i)
      return typeof i == "function" ? i : t;
    if ($r(t))
      return t;
  } catch (i) {
    return t;
  }
  const r = function(...i) {
    try {
      const o = i.map((s) => pt(s, e));
      return t.apply(this, o);
    } catch (o) {
      throw Kd(), Ic((s) => {
        s.addEventProcessor((a) => (e.mechanism && (dr(a, void 0), dt(a, e.mechanism)), a.extra = j(w({}, a.extra), {
          arguments: i
        }), a)), Ss(o);
      }), o;
    }
  };
  try {
    for (const i in t)
      Object.prototype.hasOwnProperty.call(t, i) && (r[i] = t[i]);
  } catch (i) {
  }
  as(r, t), Me(t, "__sentry_wrapped__", r);
  try {
    Object.getOwnPropertyDescriptor(r, "name").configurable && Object.defineProperty(r, "name", {
      get() {
        return t.name;
      }
    });
  } catch (i) {
  }
  return r;
}
function Jd() {
  const t = Ur(), { referrer: e } = K.document || {}, { userAgent: n } = K.navigator || {}, r = w(w({}, e && { Referer: e }), n && { "User-Agent": n });
  return {
    url: t,
    headers: r
  };
}
function zr(t, e) {
  const n = Vr(t, e), r = {
    type: ef(e),
    value: tf(e)
  };
  return n.length && (r.stacktrace = { frames: n }), r.type === void 0 && r.value === "" && (r.value = "Unrecoverable error caught"), r;
}
function Yd(t, e, n, r) {
  const i = Y(), o = i == null ? void 0 : i.getOptions().normalizeDepth, s = af(e), a = {
    __serialized__: _s(e, o)
  };
  if (s)
    return {
      exception: {
        values: [zr(t, s)]
      },
      extra: a
    };
  const u = {
    exception: {
      values: [
        {
          type: Sn(e) ? e.constructor.name : r ? "UnhandledRejection" : "Error",
          value: of(e, { isUnhandledRejection: r })
        }
      ]
    },
    extra: a
  };
  if (n) {
    const c = Vr(t, n);
    c.length && (u.exception.values[0].stacktrace = { frames: c });
  }
  return u;
}
function Jn(t, e) {
  return {
    exception: {
      values: [zr(t, e)]
    }
  };
}
function Vr(t, e) {
  const n = e.stacktrace || e.stack || "", r = Qd(e), i = Zd(e);
  try {
    return t(n, r, i);
  } catch (o) {
  }
  return [];
}
const Xd = /Minified React error #\d+;/i;
function Qd(t) {
  return t && Xd.test(t.message) ? 1 : 0;
}
function Zd(t) {
  return typeof t.framesToPop == "number" ? t.framesToPop : 0;
}
function Fs(t) {
  return typeof WebAssembly != "undefined" && typeof WebAssembly.Exception != "undefined" ? t instanceof WebAssembly.Exception : !1;
}
function ef(t) {
  const e = t == null ? void 0 : t.name;
  return !e && Fs(t) ? t.message && Array.isArray(t.message) && t.message.length == 2 ? t.message[0] : "WebAssembly.Exception" : e;
}
function tf(t) {
  const e = t == null ? void 0 : t.message;
  return Fs(t) ? Array.isArray(t.message) && t.message.length == 2 ? t.message[1] : "wasm exception" : e ? e.error && typeof e.error.message == "string" ? e.error.message : e : "No error message";
}
function nf(t, e, n, r) {
  const i = (n == null ? void 0 : n.syntheticException) || void 0, o = Wr(t, e, i, r);
  return dt(o), o.level = "error", n != null && n.event_id && (o.event_id = n.event_id), je(o);
}
function rf(t, e, n = "info", r, i) {
  const o = (r == null ? void 0 : r.syntheticException) || void 0, s = Sr(t, e, o, i);
  return s.level = n, r != null && r.event_id && (s.event_id = r.event_id), je(s);
}
function Wr(t, e, n, r, i) {
  let o;
  if (is(e) && e.error)
    return Jn(t, e.error);
  if (Ti(e) || rc(e)) {
    const s = e;
    if ("stack" in e)
      o = Jn(t, e);
    else {
      const a = s.name || (Ti(s) ? "DOMError" : "DOMException"), u = s.message ? `${a}: ${s.message}` : a;
      o = Sr(t, u, n, r), dr(o, u);
    }
    return "code" in s && (o.tags = j(w({}, o.tags), { "DOMException.code": `${s.code}` })), o;
  }
  return Lr(e) ? Jn(t, e) : Ct(e) || Sn(e) ? (o = Yd(t, e, n, i), dt(o, {
    synthetic: !0
  }), o) : (o = Sr(t, e, n, r), dr(o, `${e}`), dt(o, {
    synthetic: !0
  }), o);
}
function Sr(t, e, n, r) {
  const i = {};
  if (r && n) {
    const o = Vr(t, n);
    o.length && (i.exception = {
      values: [{ value: e, stacktrace: { frames: o } }]
    }), dt(i, { synthetic: !0 });
  }
  if (Nr(e)) {
    const { __sentry_template_string__: o, __sentry_template_values__: s } = e;
    return i.logentry = {
      message: o,
      params: s
    }, i;
  }
  return i.message = e, i;
}
function of(t, { isUnhandledRejection: e }) {
  const n = fc(t), r = e ? "promise rejection" : "exception";
  return is(t) ? `Event \`ErrorEvent\` captured as ${r} with message \`${t.message}\`` : Sn(t) ? `Event \`${sf(t)}\` (type=${t.type}) captured as ${r}` : `Object captured as ${r} with keys: ${n}`;
}
function sf(t) {
  try {
    const e = Object.getPrototypeOf(t);
    return e ? e.constructor.name : void 0;
  } catch (e) {
  }
}
function af(t) {
  for (const e in t)
    if (Object.prototype.hasOwnProperty.call(t, e)) {
      const n = t[e];
      if (n instanceof Error)
        return n;
    }
}
const uf = 5e3;
class cf extends Yl {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  constructor(e) {
    const n = lf(e), r = K.SENTRY_SDK_SOURCE || Wd();
    pd(n, "browser", ["browser"], r), super(n);
    const { sendDefaultPii: i, sendClientReports: o, _experiments: s } = this._options, a = s == null ? void 0 : s.enableLogs;
    K.document && (o || a) && K.document.addEventListener("visibilitychange", () => {
      K.document.visibilityState === "hidden" && (o && this._flushOutcomes(), a && Wn(this));
    }), a && (this.on("flush", () => {
      Wn(this);
    }), this.on("afterCaptureLog", () => {
      this._logFlushIdleTimeout && clearTimeout(this._logFlushIdleTimeout), this._logFlushIdleTimeout = setTimeout(() => {
        Wn(this);
      }, uf);
    })), i && (this.on("postprocessEvent", fd), this.on("beforeSendSession", hd));
  }
  /**
   * @inheritDoc
   */
  eventFromException(e, n) {
    return nf(this._options.stackParser, e, n, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  eventFromMessage(e, n = "info", r) {
    return rf(this._options.stackParser, e, n, r, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  _prepareEvent(e, n, r, i) {
    return e.platform = e.platform || "javascript", super._prepareEvent(e, n, r, i);
  }
}
function lf(t) {
  var e;
  return w({
    release: typeof __SENTRY_RELEASE__ == "string" ? __SENTRY_RELEASE__ : (e = K.SENTRY_RELEASE) == null ? void 0 : e.id,
    // This supports the variable that sentry-webpack-plugin injects
    sendClientReports: !0,
    // We default this to true, as it is the safer scenario
    parentSpanIsAlwaysRootSpan: !0
  }, t);
}
const df = typeof __SENTRY_DEBUG__ == "undefined" || __SENTRY_DEBUG__, X = G, ff = 1e3;
let uo, wr, Er;
function hf(t) {
  const e = "dom";
  Be(e, t), Ge(e, pf);
}
function pf() {
  if (!X.document)
    return;
  const t = ie.bind(null, "dom"), e = co(t, !0);
  X.document.addEventListener("click", e, !1), X.document.addEventListener("keypress", e, !1), ["EventTarget", "Node"].forEach((n) => {
    var o, s;
    const i = (o = X[n]) == null ? void 0 : o.prototype;
    (s = i == null ? void 0 : i.hasOwnProperty) != null && s.call(i, "addEventListener") && (te(i, "addEventListener", function(a) {
      return function(u, c, l) {
        if (u === "click" || u == "keypress")
          try {
            const d = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {}, f = d[u] = d[u] || { refCount: 0 };
            if (!f.handler) {
              const h = co(t);
              f.handler = h, a.call(this, u, h, l);
            }
            f.refCount++;
          } catch (d) {
          }
        return a.call(this, u, c, l);
      };
    }), te(
      i,
      "removeEventListener",
      function(a) {
        return function(u, c, l) {
          if (u === "click" || u == "keypress")
            try {
              const d = this.__sentry_instrumentation_handlers__ || {}, f = d[u];
              f && (f.refCount--, f.refCount <= 0 && (a.call(this, u, f.handler, l), f.handler = void 0, delete d[u]), Object.keys(d).length === 0 && delete this.__sentry_instrumentation_handlers__);
            } catch (d) {
            }
          return a.call(this, u, c, l);
        };
      }
    ));
  });
}
function gf(t) {
  if (t.type !== wr)
    return !1;
  try {
    if (!t.target || t.target._sentryId !== Er)
      return !1;
  } catch (e) {
  }
  return !0;
}
function yf(t, e) {
  return t !== "keypress" ? !1 : e != null && e.tagName ? !(e.tagName === "INPUT" || e.tagName === "TEXTAREA" || e.isContentEditable) : !0;
}
function co(t, e = !1) {
  return (n) => {
    if (!n || n._sentryCaptured)
      return;
    const r = mf(n);
    if (yf(n.type, r))
      return;
    Me(n, "_sentryCaptured", !0), r && !r._sentryId && Me(r, "_sentryId", re());
    const i = n.type === "keypress" ? "input" : n.type;
    gf(n) || (t({ event: n, name: i, global: e }), wr = n.type, Er = r ? r._sentryId : void 0), clearTimeout(uo), uo = X.setTimeout(() => {
      Er = void 0, wr = void 0;
    }, ff);
  };
}
function mf(t) {
  try {
    return t.target;
  } catch (e) {
    return null;
  }
}
let Bt;
function Ls(t) {
  const e = "history";
  Be(e, t), Ge(e, vf);
}
function vf() {
  if (X.addEventListener("popstate", () => {
    const e = X.location.href, n = Bt;
    if (Bt = e, n === e)
      return;
    ie("history", { from: n, to: e });
  }), !$d())
    return;
  function t(e) {
    return function(...n) {
      const r = n.length > 2 ? n[2] : void 0;
      if (r) {
        const i = Bt, o = _f(String(r));
        if (Bt = o, i === o)
          return e.apply(this, n);
        ie("history", { from: i, to: o });
      }
      return e.apply(this, n);
    };
  }
  te(X.history, "pushState", t), te(X.history, "replaceState", t);
}
function _f(t) {
  try {
    return new URL(t, X.location.origin).toString();
  } catch (e) {
    return t;
  }
}
const rn = {};
function bf(t) {
  const e = rn[t];
  if (e)
    return e;
  let n = X[t];
  if (vr(n))
    return rn[t] = n.bind(X);
  const r = X.document;
  if (r && typeof r.createElement == "function")
    try {
      const i = r.createElement("iframe");
      i.hidden = !0, r.head.appendChild(i);
      const o = i.contentWindow;
      o != null && o[t] && (n = o[t]), r.head.removeChild(i);
    } catch (i) {
      df && N.warn(`Could not create sandbox iframe for ${t} check, bailing to window.${t}: `, i);
    }
  return n && (rn[t] = n.bind(X));
}
function lo(t) {
  rn[t] = void 0;
}
const It = "__sentry_xhr_v3__";
function Sf(t) {
  const e = "xhr";
  Be(e, t), Ge(e, wf);
}
function wf() {
  if (!X.XMLHttpRequest)
    return;
  const t = XMLHttpRequest.prototype;
  t.open = new Proxy(t.open, {
    apply(e, n, r) {
      const i = new Error(), o = ge() * 1e3, s = pe(r[0]) ? r[0].toUpperCase() : void 0, a = Ef(r[1]);
      if (!s || !a)
        return e.apply(n, r);
      n[It] = {
        method: s,
        url: a,
        request_headers: {}
      }, s === "POST" && a.match(/sentry_key/) && (n.__sentry_own_request__ = !0);
      const u = () => {
        const c = n[It];
        if (c && n.readyState === 4) {
          try {
            c.status_code = n.status;
          } catch (d) {
          }
          const l = {
            endTimestamp: ge() * 1e3,
            startTimestamp: o,
            xhr: n,
            virtualError: i
          };
          ie("xhr", l);
        }
      };
      return "onreadystatechange" in n && typeof n.onreadystatechange == "function" ? n.onreadystatechange = new Proxy(n.onreadystatechange, {
        apply(c, l, d) {
          return u(), c.apply(l, d);
        }
      }) : n.addEventListener("readystatechange", u), n.setRequestHeader = new Proxy(n.setRequestHeader, {
        apply(c, l, d) {
          const [f, h] = d, p = l[It];
          return p && pe(f) && pe(h) && (p.request_headers[f.toLowerCase()] = h), c.apply(l, d);
        }
      }), e.apply(n, r);
    }
  }), t.send = new Proxy(t.send, {
    apply(e, n, r) {
      const i = n[It];
      if (!i)
        return e.apply(n, r);
      r[0] !== void 0 && (i.body = r[0]);
      const o = {
        startTimestamp: ge() * 1e3,
        xhr: n
      };
      return ie("xhr", o), e.apply(n, r);
    }
  });
}
function Ef(t) {
  if (pe(t))
    return t;
  try {
    return t.toString();
  } catch (e) {
  }
}
function kf(t, e = bf("fetch")) {
  let n = 0, r = 0;
  function i(o) {
    const s = o.body.length;
    n += s, r++;
    const a = w({
      body: o.body,
      method: "POST",
      referrerPolicy: "strict-origin",
      headers: t.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: n <= 6e4 && r < 15
    }, t.fetchOptions);
    if (!e)
      return lo("fetch"), dn("No fetch implementation available");
    try {
      return e(t.url, a).then((u) => (n -= s, r--, {
        statusCode: u.status,
        headers: {
          "x-sentry-rate-limits": u.headers.get("X-Sentry-Rate-Limits"),
          "retry-after": u.headers.get("Retry-After")
        }
      }));
    } catch (u) {
      return lo("fetch"), n -= s, r--, dn(u);
    }
  }
  return dd(t, i);
}
const xf = 30, Af = 50;
function kr(t, e, n, r) {
  const i = {
    filename: t,
    function: e === "<anonymous>" ? Ne : e,
    in_app: !0
    // All browser frames are considered in_app
  };
  return n !== void 0 && (i.lineno = n), r !== void 0 && (i.colno = r), i;
}
const If = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, Cf = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, Tf = /\((\S*)(?::(\d+))(?::(\d+))\)/, Of = (t) => {
  const e = If.exec(t);
  if (e) {
    const [, r, i, o] = e;
    return kr(r, Ne, +i, +o);
  }
  const n = Cf.exec(t);
  if (n) {
    if (n[2] && n[2].indexOf("eval") === 0) {
      const s = Tf.exec(n[2]);
      s && (n[2] = s[1], n[3] = s[2], n[4] = s[3]);
    }
    const [i, o] = Ns(n[1] || Ne, n[2]);
    return kr(o, i, n[3] ? +n[3] : void 0, n[4] ? +n[4] : void 0);
  }
}, Rf = [xf, Of], Df = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, Pf = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, Ff = (t) => {
  const e = Df.exec(t);
  if (e) {
    if (e[3] && e[3].indexOf(" > eval") > -1) {
      const o = Pf.exec(e[3]);
      o && (e[1] = e[1] || "eval", e[3] = o[1], e[4] = o[2], e[5] = "");
    }
    let r = e[3], i = e[1] || Ne;
    return [i, r] = Ns(i, r), kr(r, i, e[4] ? +e[4] : void 0, e[5] ? +e[5] : void 0);
  }
}, Lf = [Af, Ff], Nf = [Rf, Lf], Mf = ns(...Nf), Ns = (t, e) => {
  const n = t.indexOf("safari-extension") !== -1, r = t.indexOf("safari-web-extension") !== -1;
  return n || r ? [
    t.indexOf("@") !== -1 ? t.split("@")[0] : Ne,
    n ? `safari-extension:${e}` : `safari-web-extension:${e}`
  ] : [t, e];
}, xn = typeof __SENTRY_DEBUG__ == "undefined" || __SENTRY_DEBUG__, Gt = 1024, jf = "Breadcrumbs", Uf = (t = {}) => {
  const e = w({
    console: !0,
    dom: !0,
    fetch: !0,
    history: !0,
    sentry: !0,
    xhr: !0
  }, t);
  return {
    name: jf,
    setup(n) {
      e.console && Rd(qf(n)), e.dom && hf(Gf(n, e.dom)), e.xhr && Sf(Hf(n)), e.fetch && qd(zf(n)), e.history && Ls(Vf(n)), e.sentry && n.on("beforeSendEvent", Bf(n));
    }
  };
}, $f = Uf;
function Bf(t) {
  return function(n) {
    Y() === t && Ue(
      {
        category: `sentry.${n.type === "transaction" ? "transaction" : "event"}`,
        event_id: n.event_id,
        level: n.level,
        message: Re(n)
      },
      {
        event: n
      }
    );
  };
}
function Gf(t, e) {
  return function(r) {
    if (Y() !== t)
      return;
    let i, o, s = typeof e == "object" ? e.serializeAttribute : void 0, a = typeof e == "object" && typeof e.maxStringLength == "number" ? e.maxStringLength : void 0;
    a && a > Gt && (xn && N.warn(
      `\`dom.maxStringLength\` cannot exceed ${Gt}, but a value of ${a} was configured. Sentry will use ${Gt} instead.`
    ), a = Gt), typeof s == "string" && (s = [s]);
    try {
      const c = r.event, l = Wf(c) ? c.target : c;
      i = ss(l, { keyAttrs: s, maxStringLength: a }), o = lc(l);
    } catch (c) {
      i = "<unknown>";
    }
    if (i.length === 0)
      return;
    const u = {
      category: `ui.${r.name}`,
      message: i
    };
    o && (u.data = { "ui.component_name": o }), Ue(u, {
      event: r.event,
      name: r.name,
      global: r.global
    });
  };
}
function qf(t) {
  return function(n) {
    if (Y() !== t)
      return;
    const r = {
      category: "console",
      data: {
        arguments: n.args,
        logger: "console"
      },
      level: Pd(n.level),
      message: Oi(n.args, " ")
    };
    if (n.level === "assert")
      if (n.args[0] === !1)
        r.message = `Assertion failed: ${Oi(n.args.slice(1), " ") || "console.assert"}`, r.data.arguments = n.args.slice(1);
      else
        return;
    Ue(r, {
      input: n.args,
      level: n.level
    });
  };
}
function Hf(t) {
  return function(n) {
    if (Y() !== t)
      return;
    const { startTimestamp: r, endTimestamp: i } = n, o = n.xhr[It];
    if (!r || !i || !o)
      return;
    const { method: s, url: a, status_code: u, body: c } = o, l = {
      method: s,
      url: a,
      status_code: u
    }, d = {
      xhr: n.xhr,
      input: c,
      startTimestamp: r,
      endTimestamp: i
    }, f = {
      category: "xhr",
      data: l,
      type: "http",
      level: Ds(u)
    };
    t.emit("beforeOutgoingRequestBreadcrumb", f, d), Ue(f, d);
  };
}
function zf(t) {
  return function(n) {
    if (Y() !== t)
      return;
    const { startTimestamp: r, endTimestamp: i } = n;
    if (i && !(n.fetchData.url.match(/sentry_key/) && n.fetchData.method === "POST"))
      if (n.fetchData.method, n.fetchData.url, n.error) {
        const o = n.fetchData, s = {
          data: n.error,
          input: n.args,
          startTimestamp: r,
          endTimestamp: i
        }, a = {
          category: "fetch",
          data: o,
          level: "error",
          type: "http"
        };
        t.emit("beforeOutgoingRequestBreadcrumb", a, s), Ue(a, s);
      } else {
        const o = n.response, s = j(w({}, n.fetchData), {
          status_code: o == null ? void 0 : o.status
        });
        n.fetchData.request_body_size, n.fetchData.response_body_size, o == null || o.status;
        const a = {
          input: n.args,
          response: o,
          startTimestamp: r,
          endTimestamp: i
        }, u = {
          category: "fetch",
          data: s,
          type: "http",
          level: Ds(s.status_code)
        };
        t.emit("beforeOutgoingRequestBreadcrumb", u, a), Ue(u, a);
      }
  };
}
function Vf(t) {
  return function(n) {
    if (Y() !== t)
      return;
    let r = n.from, i = n.to;
    const o = Kn(K.location.href);
    let s = r ? Kn(r) : void 0;
    const a = Kn(i);
    s != null && s.path || (s = o), o.protocol === a.protocol && o.host === a.host && (i = a.relative), o.protocol === s.protocol && o.host === s.host && (r = s.relative), Ue({
      category: "navigation",
      data: {
        from: r,
        to: i
      }
    });
  };
}
function Wf(t) {
  return !!t && !!t.target;
}
const Kf = [
  "EventTarget",
  "Window",
  "Node",
  "ApplicationCache",
  "AudioTrackList",
  "BroadcastChannel",
  "ChannelMergerNode",
  "CryptoOperation",
  "EventSource",
  "FileReader",
  "HTMLUnknownElement",
  "IDBDatabase",
  "IDBRequest",
  "IDBTransaction",
  "KeyOperation",
  "MediaController",
  "MessagePort",
  "ModalWindow",
  "Notification",
  "SVGElementInstance",
  "Screen",
  "SharedWorker",
  "TextTrack",
  "TextTrackCue",
  "TextTrackList",
  "WebSocket",
  "WebSocketWorker",
  "Worker",
  "XMLHttpRequest",
  "XMLHttpRequestEventTarget",
  "XMLHttpRequestUpload"
], Jf = "BrowserApiErrors", Yf = (t = {}) => {
  const e = w({
    XMLHttpRequest: !0,
    eventTarget: !0,
    requestAnimationFrame: !0,
    setInterval: !0,
    setTimeout: !0,
    unregisterOriginalCallbacks: !1
  }, t);
  return {
    name: Jf,
    // TODO: This currently only works for the first client this is setup
    // We may want to adjust this to check for client etc.
    setupOnce() {
      e.setTimeout && te(K, "setTimeout", fo), e.setInterval && te(K, "setInterval", fo), e.requestAnimationFrame && te(K, "requestAnimationFrame", Qf), e.XMLHttpRequest && "XMLHttpRequest" in K && te(XMLHttpRequest.prototype, "send", Zf);
      const n = e.eventTarget;
      n && (Array.isArray(n) ? n : Kf).forEach((i) => eh(i, e));
    }
  };
}, Xf = Yf;
function fo(t) {
  return function(...e) {
    const n = e[0];
    return e[0] = pt(n, {
      mechanism: {
        data: { function: be(t) },
        handled: !1,
        type: "instrument"
      }
    }), t.apply(this, e);
  };
}
function Qf(t) {
  return function(e) {
    return t.apply(this, [
      pt(e, {
        mechanism: {
          data: {
            function: "requestAnimationFrame",
            handler: be(t)
          },
          handled: !1,
          type: "instrument"
        }
      })
    ]);
  };
}
function Zf(t) {
  return function(...e) {
    const n = this;
    return ["onload", "onerror", "onprogress", "onreadystatechange"].forEach((i) => {
      i in n && typeof n[i] == "function" && te(n, i, function(o) {
        const s = {
          mechanism: {
            data: {
              function: i,
              handler: be(o)
            },
            handled: !1,
            type: "instrument"
          }
        }, a = $r(o);
        return a && (s.mechanism.data.handler = be(a)), pt(o, s);
      });
    }), t.apply(this, e);
  };
}
function eh(t, e) {
  var i, o;
  const r = (i = K[t]) == null ? void 0 : i.prototype;
  (o = r == null ? void 0 : r.hasOwnProperty) != null && o.call(r, "addEventListener") && (te(r, "addEventListener", function(s) {
    return function(a, u, c) {
      try {
        th(u) && (u.handleEvent = pt(u.handleEvent, {
          mechanism: {
            data: {
              function: "handleEvent",
              handler: be(u),
              target: t
            },
            handled: !1,
            type: "instrument"
          }
        }));
      } catch (l) {
      }
      return e.unregisterOriginalCallbacks && nh(this, a, u), s.apply(this, [
        a,
        pt(u, {
          mechanism: {
            data: {
              function: "addEventListener",
              handler: be(u),
              target: t
            },
            handled: !1,
            type: "instrument"
          }
        }),
        c
      ]);
    };
  }), te(r, "removeEventListener", function(s) {
    return function(a, u, c) {
      try {
        const l = u.__sentry_wrapped__;
        l && s.call(this, a, l, c);
      } catch (l) {
      }
      return s.call(this, a, u, c);
    };
  }));
}
function th(t) {
  return typeof t.handleEvent == "function";
}
function nh(t, e, n) {
  t && typeof t == "object" && "removeEventListener" in t && typeof t.removeEventListener == "function" && t.removeEventListener(e, n);
}
const rh = () => ({
  name: "BrowserSession",
  setupOnce() {
    if (typeof K.document == "undefined") {
      xn && N.warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
      return;
    }
    Wi({ ignoreDuration: !0 }), Ki(), Ls(({ from: t, to: e }) => {
      t !== void 0 && t !== e && (Wi({ ignoreDuration: !0 }), Ki());
    });
  }
}), ih = "GlobalHandlers", oh = (t = {}) => {
  const e = w({
    onerror: !0,
    onunhandledrejection: !0
  }, t);
  return {
    name: ih,
    setupOnce() {
      Error.stackTraceLimit = 50;
    },
    setup(n) {
      e.onerror && (ah(n), ho("onerror")), e.onunhandledrejection && (uh(n), ho("onunhandledrejection"));
    }
  };
}, sh = oh;
function ah(t) {
  Zu((e) => {
    const { stackParser: n, attachStacktrace: r } = Ms();
    if (Y() !== t || Ps())
      return;
    const { msg: i, url: o, line: s, column: a, error: u } = e, c = dh(
      Wr(n, u || i, void 0, r, !1),
      o,
      s,
      a
    );
    c.level = "error", Hr(c, {
      originalException: u,
      mechanism: {
        handled: !1,
        type: "onerror"
      }
    });
  });
}
function uh(t) {
  tc((e) => {
    const { stackParser: n, attachStacktrace: r } = Ms();
    if (Y() !== t || Ps())
      return;
    const i = ch(e), o = Mr(i) ? lh(i) : Wr(n, i, void 0, r, !0);
    o.level = "error", Hr(o, {
      originalException: i,
      mechanism: {
        handled: !1,
        type: "onunhandledrejection"
      }
    });
  });
}
function ch(t) {
  if (Mr(t))
    return t;
  try {
    if ("reason" in t)
      return t.reason;
    if ("detail" in t && "reason" in t.detail)
      return t.detail.reason;
  } catch (e) {
  }
  return t;
}
function lh(t) {
  return {
    exception: {
      values: [
        {
          type: "UnhandledRejection",
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(t)}`
        }
      ]
    }
  };
}
function dh(t, e, n, r) {
  const i = t.exception = t.exception || {}, o = i.values = i.values || [], s = o[0] = o[0] || {}, a = s.stacktrace = s.stacktrace || {}, u = a.frames = a.frames || [], c = r, l = n, d = pe(e) && e.length > 0 ? e : Ur();
  return u.length === 0 && u.push({
    colno: c,
    filename: d,
    function: Ne,
    in_app: !0,
    lineno: l
  }), t;
}
function ho(t) {
  xn && N.log(`Global Handler attached: ${t}`);
}
function Ms() {
  const t = Y();
  return (t == null ? void 0 : t.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: !1
  };
}
const fh = () => ({
  name: "HttpContext",
  preprocessEvent(t) {
    var r;
    if (!K.navigator && !K.location && !K.document)
      return;
    const e = Jd(), n = w(w({}, e.headers), (r = t.request) == null ? void 0 : r.headers);
    t.request = j(w(w({}, e), t.request), {
      headers: n
    });
  }
}), hh = "cause", ph = 5, gh = "LinkedErrors", yh = (t = {}) => {
  const e = t.limit || ph, n = t.key || hh;
  return {
    name: gh,
    preprocessEvent(r, i, o) {
      const s = o.getOptions();
      Od(
        // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
        zr,
        s.stackParser,
        n,
        e,
        r,
        i
      );
    }
  };
}, mh = yh;
function vh() {
  return _h() ? (xn && yt(() => {
    console.error(
      "[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/"
    );
  }), !0) : !1;
}
function _h() {
  var o;
  if (typeof K.window == "undefined")
    return !1;
  const t = K;
  if (t.nw)
    return !1;
  const e = t.chrome || t.browser;
  if (!((o = e == null ? void 0 : e.runtime) != null && o.id))
    return !1;
  const n = Ur(), r = ["chrome-extension", "moz-extension", "ms-browser-extension", "safari-web-extension"];
  return !(K === K.top && r.some((s) => n.startsWith(`${s}://`)));
}
function bh(t) {
  return [
    // TODO(v10): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
    // eslint-disable-next-line deprecation/deprecation
    wd(),
    vd(),
    Xf(),
    $f(),
    sh(),
    mh(),
    Nd(),
    fh(),
    rh()
  ];
}
function Sh(t = {}) {
  const e = !t.skipBrowserExtensionCheck && vh(), n = j(w({}, t), {
    enabled: e ? !1 : t.enabled,
    stackParser: Xu(t.stackParser || Mf),
    integrations: zl({
      integrations: t.integrations,
      defaultIntegrations: t.defaultIntegrations == null ? bh() : t.defaultIntegrations
    }),
    transport: t.transport || kf
  });
  return nd(cf, n);
}
class wh {
  constructor(e) {
    O(this, "sentryEnabled");
    O(this, "debugConsole");
    this.sentryEnabled = e.sentryEnabled, this.debugConsole = e.debugConsole, e.sentryEnabled && this.initSentry(e);
  }
  initSentry(e) {
    const n = e.sentryDsn || (e.isProd ? Ko : void 0);
    if (!n) {
      console.warn("Sentry enabled but DSN not provided. Sentry initialization skipped.");
      return;
    }
    const r = e.environment || (e.isProd ? "prod" : "test");
    Sh({
      dsn: n,
      environment: r,
      release: e.version,
      sendDefaultPii: !0,
      beforeSend(i) {
        var s;
        return i.type === "session" || !!((s = i.tags) != null && s.context) ? i : null;
      }
    });
  }
  sendErrorToSentry(e, n, r) {
    if (this.sentryEnabled)
      try {
        if (Y()) {
          const i = r != null ? r : {}, o = {}, s = {};
          Object.keys(i).forEach((a) => {
            const u = i[a];
            u == null || u === "" || (["sid", "code", "external_id", "client_id"].includes(a) ? o[a] = String(u) : s[a] = u);
          }), n && (o.context = n), Ss(e, {
            tags: o,
            extra: s
          });
        }
      } catch (i) {
        this.debugConsole && console.warn("Failed to send error to Sentry:", i);
      }
  }
  sendMessageToSentry(e, n, r) {
    if (this.sentryEnabled)
      try {
        if (Y()) {
          const i = r != null ? r : {}, o = {}, s = {};
          Object.keys(i).forEach((c) => {
            const l = i[c];
            ["sid", "code", "external_id"].includes(c) ? o[c] = l : s[c] = l;
          }), n && (o.context = n);
          const a = i.external_id || "-1", u = i.name;
          Hr({
            level: "info",
            message: `sdk-${u}`,
            fingerprint: [u, a],
            tags: o,
            extra: s
          });
        }
      } catch (i) {
        this.debugConsole && console.warn("Failed to send message to Sentry:", i);
      }
  }
}
class Eh {
  constructor(e) {
    O(this, "goyaUrl");
    O(this, "isGoyaActive");
    O(this, "cid");
    O(this, "session_id");
    O(this, "product_name");
    O(this, "appmetrica_device_id");
    O(this, "requestTimeout");
    O(this, "debugConsole");
    O(this, "onError");
    this.goyaUrl = e.goyaUrl, this.isGoyaActive = e.isGoyaActive, this.cid = e.cid, this.session_id = e.session_id, this.product_name = e.product_name, this.appmetrica_device_id = e.appmetrica_device_id, this.requestTimeout = e.requestTimeout, this.debugConsole = e.debugConsole, this.onError = e.onError;
  }
  updateConfig(e) {
    e.isGoyaActive !== void 0 && (this.isGoyaActive = e.isGoyaActive);
  }
  sendEvent(e) {
    return M(this, null, function* () {
      if (!this.shouldSend()) return;
      const n = Object.fromEntries(
        Object.entries(e).filter(([, i]) => i !== void 0)
      ), r = this.buildGoyaUrl(n);
      try {
        yield Bu(r, this.requestTimeout);
      } catch (i) {
        this.onError && this.onError(i), this.debugConsole && console.error("Error in Goya event: ", i);
      }
    });
  }
  buildEvent(e, n) {
    const r = (n == null ? void 0 : n.screen_name) || window.location.pathname;
    return {
      event_category: "auth",
      event_action: e.event_action,
      event_label: e.event_label,
      event_name: e.event_name,
      screen_size: `${window.innerWidth}x${window.innerHeight}`,
      event_timestamp: `${cr()}`,
      event_timezone: Yo(),
      page_url: window.location.origin + window.location.pathname,
      screen_name: r,
      event_group: "event",
      event_element_location: "webview",
      touch_point: "web",
      cid: this.cid,
      session_id: this.session_id,
      product_name: this.product_name,
      appmetrica_device_id: this.appmetrica_device_id,
      gsid: n == null ? void 0 : n.gsid,
      req_id: n == null ? void 0 : n.req_id,
      qr_flow: n == null ? void 0 : n.qr_flow
    };
  }
  shouldSend() {
    return !!(this.isGoyaActive && (this.cid || this.product_name || this.session_id || this.appmetrica_device_id));
  }
  buildGoyaUrl(e) {
    return `${this.goyaUrl}?${en(e)}`;
  }
}
var xr = function(t, e) {
  return xr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, xr(t, e);
};
function ee(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  xr(t, e);
  function n() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
}
var I = function() {
  return I = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, I.apply(this, arguments);
};
function js(t, e) {
  var n = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}
function P(t, e, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(s) {
      s(o);
    });
  }
  return new (n || (n = Promise))(function(o, s) {
    function a(l) {
      try {
        c(r.next(l));
      } catch (d) {
        s(d);
      }
    }
    function u(l) {
      try {
        c(r.throw(l));
      } catch (d) {
        s(d);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(a, u);
    }
    c((r = r.apply(t, e || [])).next());
  });
}
function F(t, e) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, s = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return s.next = a(0), s.throw = a(1), s.return = a(2), typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function a(c) {
    return function(l) {
      return u([c, l]);
    };
  }
  function u(c) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, c[0] && (n = 0)), n; ) try {
      if (r = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done) return o;
      switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
        case 0:
        case 1:
          o = c;
          break;
        case 4:
          return n.label++, { value: c[1], done: !1 };
        case 5:
          n.label++, i = c[1], c = [0];
          continue;
        case 7:
          c = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            n = 0;
            continue;
          }
          if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
            n.label = c[1];
            break;
          }
          if (c[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = c;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(c);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      c = e.call(t, n);
    } catch (l) {
      c = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function W(t, e, n) {
  if (n || arguments.length === 2) for (var r = 0, i = e.length, o; r < i; r++)
    (o || !(r in e)) && (o || (o = Array.prototype.slice.call(e, 0, r)), o[r] = e[r]);
  return t.concat(o || Array.prototype.slice.call(e));
}
function Ar(t, e, n) {
  e.split && (e = e.split("."));
  for (var r = 0, i = e.length, o = t, s, a; r < i && (a = "" + e[r++], !(a === "__proto__" || a === "constructor" || a === "prototype")); )
    o = o[a] = r === i ? n : typeof (s = o[a]) == typeof e ? s : e[r] * 0 !== 0 || ~("" + e[r]).indexOf(".") ? {} : [];
}
var kh = function(t, e) {
  return Object.keys(t).filter(function(n) {
    return e(n, t[n]);
  }).reduce(function(n, r) {
    return n[r] = t[r], n;
  }, {});
}, $e = (
  /** @class */
  function(t) {
    ee(e, t);
    function e(n, r) {
      var i = t.call(this, "".concat(n, " ").concat(r)) || this;
      return i.field = n, i;
    }
    return e;
  }(Error)
);
function Ee(t) {
  return typeof t == "string";
}
function Ir(t) {
  return typeof t == "number";
}
function ut(t) {
  return typeof t == "function";
}
function xh(t) {
  return t != null;
}
function Z(t) {
  return Object.prototype.toString.call(t).slice(8, -1).toLowerCase() === "object";
}
var Kr = "is not a string", Jr = "is not an object", Ah = "is nil";
function Ih(t) {
  if (!xh(t))
    throw new $e("Event", Ah);
  if (typeof t != "object")
    throw new $e("Event", Jr);
}
function Ch(t) {
  if (!Ee(t.type))
    throw new $e(".type", Kr);
}
function Th(t) {
  if (!Ee(t.event))
    throw new $e(".event", Kr);
}
function Oh(t) {
  if (!Z(t.properties))
    throw new $e(".properties", Jr);
}
function Rh(t) {
  if (!Z(t.traits))
    throw new $e(".traits", Jr);
}
function Dh(t) {
  if (!Ee(t.messageId))
    throw new $e(".messageId", Kr);
}
function Ph(t) {
  Ih(t), Ch(t), Dh(t), t.type === "track" && (Th(t), Oh(t)), ["group", "identify"].includes(t.type) && Rh(t);
}
var Fh = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      var n, r;
      this.settings = e, this.createMessageId = e.createMessageId, this.onEventMethodCall = (n = e.onEventMethodCall) !== null && n !== void 0 ? n : function() {
      }, this.onFinishedEvent = (r = e.onFinishedEvent) !== null && r !== void 0 ? r : function() {
      };
    }
    return t;
  }()
), Lh = (
  /** @class */
  function() {
    function t(e) {
      this.settings = new Fh(e);
    }
    return t.prototype.track = function(e, n, r, i) {
      return this.settings.onEventMethodCall({ type: "track", options: r }), this.normalize(I(I({}, this.baseEvent()), { event: e, type: "track", properties: n != null ? n : {}, options: I({}, r), integrations: I({}, i) }));
    }, t.prototype.page = function(e, n, r, i, o) {
      var s;
      this.settings.onEventMethodCall({ type: "page", options: i });
      var a = {
        type: "page",
        properties: I({}, r),
        options: I({}, i),
        integrations: I({}, o)
      };
      return e !== null && (a.category = e, a.properties = (s = a.properties) !== null && s !== void 0 ? s : {}, a.properties.category = e), n !== null && (a.name = n), this.normalize(I(I({}, this.baseEvent()), a));
    }, t.prototype.screen = function(e, n, r, i, o) {
      this.settings.onEventMethodCall({ type: "screen", options: i });
      var s = {
        type: "screen",
        properties: I({}, r),
        options: I({}, i),
        integrations: I({}, o)
      };
      return e !== null && (s.category = e), n !== null && (s.name = n), this.normalize(I(I({}, this.baseEvent()), s));
    }, t.prototype.identify = function(e, n, r, i) {
      return this.settings.onEventMethodCall({ type: "identify", options: r }), this.normalize(I(I({}, this.baseEvent()), { type: "identify", userId: e, traits: n != null ? n : {}, options: I({}, r), integrations: i }));
    }, t.prototype.group = function(e, n, r, i) {
      return this.settings.onEventMethodCall({ type: "group", options: r }), this.normalize(I(I({}, this.baseEvent()), {
        type: "group",
        traits: n != null ? n : {},
        options: I({}, r),
        integrations: I({}, i),
        //
        groupId: e
      }));
    }, t.prototype.alias = function(e, n, r, i) {
      this.settings.onEventMethodCall({ type: "alias", options: r });
      var o = {
        userId: e,
        type: "alias",
        options: I({}, r),
        integrations: I({}, i)
      };
      return n !== null && (o.previousId = n), e === void 0 ? this.normalize(I(I({}, o), this.baseEvent())) : this.normalize(I(I({}, this.baseEvent()), o));
    }, t.prototype.baseEvent = function() {
      return {
        integrations: {},
        options: {}
      };
    }, t.prototype.context = function(e) {
      var n, r = [
        "userId",
        "anonymousId",
        "timestamp",
        "messageId"
      ];
      delete e.integrations;
      var i = Object.keys(e), o = (n = e.context) !== null && n !== void 0 ? n : {}, s = {};
      return i.forEach(function(a) {
        a !== "context" && (r.includes(a) ? Ar(s, a, e[a]) : Ar(o, a, e[a]));
      }), [o, s];
    }, t.prototype.normalize = function(e) {
      var n, r, i = Object.keys((n = e.integrations) !== null && n !== void 0 ? n : {}).reduce(function(f, h) {
        var p, v;
        return I(I({}, f), (p = {}, p[h] = !!(!((v = e.integrations) === null || v === void 0) && v[h]), p));
      }, {});
      e.options = kh(e.options || {}, function(f, h) {
        return h !== void 0;
      });
      var o = I(I({}, i), (r = e.options) === null || r === void 0 ? void 0 : r.integrations), s = e.options ? this.context(e.options) : [], a = s[0], u = s[1], c = e.options, l = js(e, ["options"]), d = I(I(I(I({ timestamp: /* @__PURE__ */ new Date() }, l), { context: a, integrations: o }), u), { messageId: c.messageId || this.settings.createMessageId() });
      return this.settings.onFinishedEvent(d), Ph(d), d;
    }, t;
  }()
);
function Yr(t, e) {
  return new Promise(function(n, r) {
    var i = setTimeout(function() {
      r(Error("Promise timed out"));
    }, e);
    t.then(function(o) {
      return clearTimeout(i), n(o);
    }).catch(r);
  });
}
function Nh(t) {
  return new Promise(function(e) {
    return setTimeout(e, t);
  });
}
function Mh(t, e, n) {
  var r = function() {
    try {
      return Promise.resolve(e(t));
    } catch (i) {
      return Promise.reject(i);
    }
  };
  return Nh(n).then(function() {
    return Yr(r(), 1e3);
  }).catch(function(i) {
    t == null || t.log("warn", "Callback Error", { error: i }), t == null || t.stats.increment("callback_error");
  }).then(function() {
    return t;
  });
}
var Xr = function() {
  var t, e, n = !1, r = new Promise(function(i, o) {
    t = function() {
      for (var s = [], a = 0; a < arguments.length; a++)
        s[a] = arguments[a];
      n = !0, i.apply(void 0, s);
    }, e = function() {
      for (var s = [], a = 0; a < arguments.length; a++)
        s[a] = arguments[a];
      n = !0, o.apply(void 0, s);
    };
  });
  return {
    resolve: t,
    reject: e,
    promise: r,
    isSettled: function() {
      return n;
    }
  };
}, Qr = (
  /** @class */
  function() {
    function t(e) {
      var n;
      this.callbacks = {}, this.warned = !1, this.maxListeners = (n = e == null ? void 0 : e.maxListeners) !== null && n !== void 0 ? n : 10;
    }
    return t.prototype.warnIfPossibleMemoryLeak = function(e) {
      this.warned || this.maxListeners && this.callbacks[e].length > this.maxListeners && (console.warn("Event Emitter: Possible memory leak detected; ".concat(String(e), " has exceeded ").concat(this.maxListeners, " listeners.")), this.warned = !0);
    }, t.prototype.on = function(e, n) {
      return this.callbacks[e] ? (this.callbacks[e].push(n), this.warnIfPossibleMemoryLeak(e)) : this.callbacks[e] = [n], this;
    }, t.prototype.once = function(e, n) {
      var r = this, i = function() {
        for (var o = [], s = 0; s < arguments.length; s++)
          o[s] = arguments[s];
        r.off(e, i), n.apply(r, o);
      };
      return this.on(e, i), this;
    }, t.prototype.off = function(e, n) {
      var r, i = (r = this.callbacks[e]) !== null && r !== void 0 ? r : [], o = i.filter(function(s) {
        return s !== n;
      });
      return this.callbacks[e] = o, this;
    }, t.prototype.emit = function(e) {
      for (var n = this, r, i = [], o = 1; o < arguments.length; o++)
        i[o - 1] = arguments[o];
      var s = (r = this.callbacks[e]) !== null && r !== void 0 ? r : [];
      return s.forEach(function(a) {
        a.apply(n, i);
      }), this;
    }, t;
  }()
);
function jh(t) {
  var e = Math.random() + 1, n = t.minTimeout, r = n === void 0 ? 500 : n, i = t.factor, o = i === void 0 ? 2 : i, s = t.attempt, a = t.maxTimeout, u = a === void 0 ? 1 / 0 : a;
  return Math.min(e * r * Math.pow(o, s), u);
}
var Us = "onRemoveFromFuture", An = (
  /** @class */
  function(t) {
    ee(e, t);
    function e(n, r, i) {
      var o = t.call(this) || this;
      return o.future = [], o.maxAttempts = n, o.queue = r, o.seen = i != null ? i : {}, o;
    }
    return e.prototype.push = function() {
      for (var n = this, r = [], i = 0; i < arguments.length; i++)
        r[i] = arguments[i];
      var o = r.map(function(s) {
        var a = n.updateAttempts(s);
        return a > n.maxAttempts || n.includes(s) ? !1 : (n.queue.push(s), !0);
      });
      return this.queue = this.queue.sort(function(s, a) {
        return n.getAttempts(s) - n.getAttempts(a);
      }), o;
    }, e.prototype.pushWithBackoff = function(n, r) {
      var i = this;
      if (r === void 0 && (r = 0), r == 0 && this.getAttempts(n) === 0)
        return this.push(n)[0];
      var o = this.updateAttempts(n);
      if (o > this.maxAttempts || this.includes(n))
        return !1;
      var s = jh({ attempt: o - 1 });
      return r > 0 && s < r && (s = r), setTimeout(function() {
        i.queue.push(n), i.future = i.future.filter(function(a) {
          return a.id !== n.id;
        }), i.emit(Us);
      }, s), this.future.push(n), !0;
    }, e.prototype.getAttempts = function(n) {
      var r;
      return (r = this.seen[n.id]) !== null && r !== void 0 ? r : 0;
    }, e.prototype.updateAttempts = function(n) {
      return this.seen[n.id] = this.getAttempts(n) + 1, this.getAttempts(n);
    }, e.prototype.includes = function(n) {
      return this.queue.includes(n) || this.future.includes(n) || !!this.queue.find(function(r) {
        return r.id === n.id;
      }) || !!this.future.find(function(r) {
        return r.id === n.id;
      });
    }, e.prototype.pop = function() {
      return this.queue.shift();
    }, Object.defineProperty(e.prototype, "length", {
      get: function() {
        return this.queue.length;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "todo", {
      get: function() {
        return this.queue.length + this.future.length;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(Qr)
), Pe = 256, on = [], qt;
for (; Pe--; ) on[Pe] = (Pe + 256).toString(16).substring(1);
function Zr() {
  var t = 0, e, n = "";
  if (!qt || Pe + 16 > 256) {
    for (qt = Array(t = 256); t--; ) qt[t] = 256 * Math.random() | 0;
    t = Pe = 0;
  }
  for (; t < 16; t++)
    e = qt[Pe + t], t == 6 ? n += on[e & 15 | 64] : t == 8 ? n += on[e & 63 | 128] : n += on[e], t & 1 && t > 1 && t < 11 && (n += "-");
  return Pe++, n;
}
var Uh = (
  /** @class */
  function() {
    function t() {
      this._logs = [];
    }
    return t.prototype.log = function(e, n, r) {
      var i = /* @__PURE__ */ new Date();
      this._logs.push({
        level: e,
        message: n,
        time: i,
        extras: r
      });
    }, Object.defineProperty(t.prototype, "logs", {
      get: function() {
        return this._logs;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.flush = function() {
      if (this.logs.length > 1) {
        var e = this._logs.reduce(function(n, r) {
          var i, o, s, a = I(I({}, r), { json: JSON.stringify(r.extras, null, " "), extras: r.extras });
          delete a.time;
          var u = (s = (o = r.time) === null || o === void 0 ? void 0 : o.toISOString()) !== null && s !== void 0 ? s : "";
          return n[u] && (u = "".concat(u, "-").concat(Math.random())), I(I({}, n), (i = {}, i[u] = a, i));
        }, {});
        console.table ? console.table(e) : console.log(e);
      } else
        this.logs.forEach(function(n) {
          var r = n.level, i = n.message, o = n.extras;
          r === "info" || r === "debug" ? console.log(i, o != null ? o : "") : console[r](i, o != null ? o : "");
        });
      this._logs = [];
    }, t;
  }()
), $h = function(t) {
  var e = {
    gauge: "g",
    counter: "c"
  };
  return e[t];
}, $s = (
  /** @class */
  function() {
    function t() {
      this.metrics = [];
    }
    return t.prototype.increment = function(e, n, r) {
      n === void 0 && (n = 1), this.metrics.push({
        metric: e,
        value: n,
        tags: r != null ? r : [],
        type: "counter",
        timestamp: Date.now()
      });
    }, t.prototype.gauge = function(e, n, r) {
      this.metrics.push({
        metric: e,
        value: n,
        tags: r != null ? r : [],
        type: "gauge",
        timestamp: Date.now()
      });
    }, t.prototype.flush = function() {
      var e = this.metrics.map(function(n) {
        return I(I({}, n), { tags: n.tags.join(",") });
      });
      console.table ? console.table(e) : console.log(e), this.metrics = [];
    }, t.prototype.serialize = function() {
      return this.metrics.map(function(e) {
        return {
          m: e.metric,
          v: e.value,
          t: e.tags,
          k: $h(e.type),
          e: e.timestamp
        };
      });
    }, t;
  }()
), Bh = (
  /** @class */
  function(t) {
    ee(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.gauge = function() {
    }, e.prototype.increment = function() {
    }, e.prototype.flush = function() {
    }, e.prototype.serialize = function() {
      return [];
    }, e;
  }($s)
), ke = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      var n, r, i;
      this.retry = (n = e.retry) !== null && n !== void 0 ? n : !0, this.type = (r = e.type) !== null && r !== void 0 ? r : "plugin Error", this.reason = (i = e.reason) !== null && i !== void 0 ? i : "";
    }
    return t;
  }()
), hn = (
  /** @class */
  function() {
    function t(e, n, r, i) {
      n === void 0 && (n = Zr()), r === void 0 && (r = new Bh()), i === void 0 && (i = new Uh()), this.attempts = 0, this.event = e, this._id = n, this.logger = i, this.stats = r;
    }
    return t.system = function() {
    }, t.prototype.isSame = function(e) {
      return e.id === this.id;
    }, t.prototype.cancel = function(e) {
      throw e || new ke({ reason: "Context Cancel" });
    }, t.prototype.log = function(e, n, r) {
      this.logger.log(e, n, r);
    }, Object.defineProperty(t.prototype, "id", {
      get: function() {
        return this._id;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.updateEvent = function(e, n) {
      var r;
      if (e.split(".")[0] === "integrations") {
        var i = e.split(".")[1];
        if (((r = this.event.integrations) === null || r === void 0 ? void 0 : r[i]) === !1)
          return this.event;
      }
      return Ar(this.event, e, n), this.event;
    }, t.prototype.failedDelivery = function() {
      return this._failedDelivery;
    }, t.prototype.setFailedDelivery = function(e) {
      this._failedDelivery = e;
    }, t.prototype.logs = function() {
      return this.logger.logs;
    }, t.prototype.flush = function() {
      this.logger.flush(), this.stats.flush();
    }, t.prototype.toJSON = function() {
      return {
        id: this._id,
        event: this.event,
        logs: this.logger.logs,
        metrics: this.stats.metrics
      };
    }, t;
  }()
);
function Gh(t, e) {
  var n = {};
  return t.forEach(function(r) {
    var i, o = void 0;
    {
      var s = r[e];
      o = typeof s != "string" ? JSON.stringify(s) : s;
    }
    o !== void 0 && (n[o] = W(W([], (i = n[o]) !== null && i !== void 0 ? i : [], !0), [r], !1));
  }), n;
}
var qh = function(t) {
  return typeof t == "object" && t !== null && "then" in t && typeof t.then == "function";
}, Hh = function() {
  var t, e, n = 0;
  return {
    done: function() {
      return t;
    },
    run: function(r) {
      var i = r();
      return qh(i) && (++n === 1 && (t = new Promise(function(o) {
        return e = o;
      })), i.finally(function() {
        return --n === 0 && e();
      })), i;
    }
  };
};
function zh(t) {
  return P(this, void 0, void 0, function() {
    var e;
    return F(this, function(n) {
      switch (n.label) {
        case 0:
          return n.trys.push([0, 2, , 3]), [4, t()];
        case 1:
          return [2, n.sent()];
        case 2:
          return e = n.sent(), [2, Promise.reject(e)];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function ct(t, e) {
  t.log("debug", "plugin", { plugin: e.name });
  var n = (/* @__PURE__ */ new Date()).getTime(), r = e[t.event.type];
  if (r === void 0)
    return Promise.resolve(t);
  var i = zh(function() {
    return r.apply(e, [t]);
  }).then(function(o) {
    var s = (/* @__PURE__ */ new Date()).getTime() - n;
    return o.stats.gauge("plugin_time", s, ["plugin:".concat(e.name)]), o;
  }).catch(function(o) {
    if (o instanceof ke && o.type === "middleware_cancellation")
      throw o;
    return o instanceof ke ? (t.log("warn", o.type, {
      plugin: e.name,
      error: o
    }), o) : (t.log("error", "plugin Error", {
      plugin: e.name,
      error: o
    }), t.stats.increment("plugin_error", 1, ["plugin:".concat(e.name)]), o);
  });
  return i;
}
function Vh(t, e) {
  return ct(t, e).then(function(n) {
    if (n instanceof hn)
      return n;
    t.log("debug", "Context canceled"), t.stats.increment("context_canceled"), t.cancel(n);
  });
}
var Wh = (
  /** @class */
  function(t) {
    ee(e, t);
    function e(n) {
      var r = t.call(this) || this;
      return r.criticalTasks = Hh(), r.plugins = [], r.failedInitializations = [], r.flushing = !1, r.queue = n, r.queue.on(Us, function() {
        r.scheduleFlush(0);
      }), r;
    }
    return e.prototype.register = function(n, r, i) {
      return P(this, void 0, void 0, function() {
        var o, s, a = this;
        return F(this, function(u) {
          switch (u.label) {
            case 0:
              return this.plugins.push(r), o = function(c) {
                a.failedInitializations.push(r.name), a.emit("initialization_failure", r), console.warn(r.name, c), n.log("warn", "Failed to load destination", {
                  plugin: r.name,
                  error: c
                }), a.plugins = a.plugins.filter(function(l) {
                  return l !== r;
                });
              }, r.type === "destination" && r.name !== "Segment.io" ? (r.load(n, i).catch(o), [3, 4]) : [3, 1];
            case 1:
              return u.trys.push([1, 3, , 4]), [4, r.load(n, i)];
            case 2:
              return u.sent(), [3, 4];
            case 3:
              return s = u.sent(), o(s), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.deregister = function(n, r, i) {
      return P(this, void 0, void 0, function() {
        var o;
        return F(this, function(s) {
          switch (s.label) {
            case 0:
              return s.trys.push([0, 3, , 4]), r.unload ? [4, Promise.resolve(r.unload(n, i))] : [3, 2];
            case 1:
              s.sent(), s.label = 2;
            case 2:
              return this.plugins = this.plugins.filter(function(a) {
                return a.name !== r.name;
              }), [3, 4];
            case 3:
              return o = s.sent(), n.log("warn", "Failed to unload destination", {
                plugin: r.name,
                error: o
              }), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.dispatch = function(n) {
      return P(this, void 0, void 0, function() {
        var r;
        return F(this, function(i) {
          return n.log("debug", "Dispatching"), n.stats.increment("message_dispatched"), this.queue.push(n), r = this.subscribeToDelivery(n), this.scheduleFlush(0), [2, r];
        });
      });
    }, e.prototype.subscribeToDelivery = function(n) {
      return P(this, void 0, void 0, function() {
        var r = this;
        return F(this, function(i) {
          return [2, new Promise(function(o) {
            var s = function(a, u) {
              a.isSame(n) && (r.off("flush", s), o(a));
            };
            r.on("flush", s);
          })];
        });
      });
    }, e.prototype.dispatchSingle = function(n) {
      return P(this, void 0, void 0, function() {
        var r = this;
        return F(this, function(i) {
          return n.log("debug", "Dispatching"), n.stats.increment("message_dispatched"), this.queue.updateAttempts(n), n.attempts = 1, [2, this.deliver(n).catch(function(o) {
            var s = r.enqueuRetry(o, n);
            return s ? r.subscribeToDelivery(n) : (n.setFailedDelivery({ reason: o }), n);
          })];
        });
      });
    }, e.prototype.isEmpty = function() {
      return this.queue.length === 0;
    }, e.prototype.scheduleFlush = function(n) {
      var r = this;
      n === void 0 && (n = 500), !this.flushing && (this.flushing = !0, setTimeout(function() {
        r.flush().then(function() {
          setTimeout(function() {
            r.flushing = !1, r.queue.length && r.scheduleFlush(0);
          }, 0);
        });
      }, n));
    }, e.prototype.deliver = function(n) {
      return P(this, void 0, void 0, function() {
        var r, i, o, s;
        return F(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, this.criticalTasks.done()];
            case 1:
              a.sent(), r = Date.now(), a.label = 2;
            case 2:
              return a.trys.push([2, 4, , 5]), [4, this.flushOne(n)];
            case 3:
              return n = a.sent(), i = Date.now() - r, this.emit("delivery_success", n), n.stats.gauge("delivered", i), n.log("debug", "Delivered", n.event), [2, n];
            case 4:
              throw o = a.sent(), s = o, n.log("error", "Failed to deliver", s), this.emit("delivery_failure", n, s), n.stats.increment("delivery_failed"), o;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.enqueuRetry = function(n, r) {
      var i = !(n instanceof ke) || n.retry;
      return i ? this.queue.pushWithBackoff(r) : !1;
    }, e.prototype.flush = function() {
      return P(this, void 0, void 0, function() {
        var n, r, i;
        return F(this, function(o) {
          switch (o.label) {
            case 0:
              if (this.queue.length === 0)
                return [2, []];
              if (n = this.queue.pop(), !n)
                return [2, []];
              n.attempts = this.queue.getAttempts(n), o.label = 1;
            case 1:
              return o.trys.push([1, 3, , 4]), [4, this.deliver(n)];
            case 2:
              return n = o.sent(), this.emit("flush", n, !0), [3, 4];
            case 3:
              return r = o.sent(), i = this.enqueuRetry(r, n), i || (n.setFailedDelivery({ reason: r }), this.emit("flush", n, !1)), [2, []];
            case 4:
              return [2, [n]];
          }
        });
      });
    }, e.prototype.isReady = function() {
      return !0;
    }, e.prototype.availableExtensions = function(n) {
      var r = this.plugins.filter(function(h) {
        var p, v, g;
        if (h.type !== "destination" && h.name !== "Segment.io")
          return !0;
        var m = void 0;
        return (p = h.alternativeNames) === null || p === void 0 || p.forEach(function(_) {
          n[_] !== void 0 && (m = n[_]);
        }), (g = (v = n[h.name]) !== null && v !== void 0 ? v : m) !== null && g !== void 0 ? g : (h.name === "Segment.io" ? !0 : n.All) !== !1;
      }), i = Gh(r, "type"), o = i.before, s = o === void 0 ? [] : o, a = i.enrichment, u = a === void 0 ? [] : a, c = i.destination, l = c === void 0 ? [] : c, d = i.after, f = d === void 0 ? [] : d;
      return {
        before: s,
        enrichment: u,
        destinations: l,
        after: f
      };
    }, e.prototype.flushOne = function(n) {
      var r, i;
      return P(this, void 0, void 0, function() {
        var o, s, a, u, c, l, p, d, f, h, p, v, g, m, _;
        return F(this, function(C) {
          switch (C.label) {
            case 0:
              if (!this.isReady())
                throw new Error("Not ready");
              n.attempts > 1 && this.emit("delivery_retry", n), o = this.availableExtensions((r = n.event.integrations) !== null && r !== void 0 ? r : {}), s = o.before, a = o.enrichment, u = 0, c = s, C.label = 1;
            case 1:
              return u < c.length ? (l = c[u], [4, Vh(n, l)]) : [3, 4];
            case 2:
              p = C.sent(), p instanceof hn && (n = p), this.emit("message_enriched", n, l), C.label = 3;
            case 3:
              return u++, [3, 1];
            case 4:
              d = 0, f = a, C.label = 5;
            case 5:
              return d < f.length ? (h = f[d], [4, ct(n, h)]) : [3, 8];
            case 6:
              p = C.sent(), p instanceof hn && (n = p), this.emit("message_enriched", n, h), C.label = 7;
            case 7:
              return d++, [3, 5];
            case 8:
              return v = this.availableExtensions((i = n.event.integrations) !== null && i !== void 0 ? i : {}), g = v.destinations, m = v.after, [4, new Promise(function(T, R) {
                setTimeout(function() {
                  var y = g.map(function(b) {
                    return ct(n, b);
                  });
                  Promise.all(y).then(T).catch(R);
                }, 0);
              })];
            case 9:
              return C.sent(), n.stats.increment("message_delivered"), this.emit("message_delivered", n), _ = m.map(function(T) {
                return ct(n, T);
              }), [4, Promise.all(_)];
            case 10:
              return C.sent(), [2, n];
          }
        });
      });
    }, e;
  }(Qr)
), Kh = function(t, e) {
  var n = Date.now() - t;
  return Math.max((e != null ? e : 300) - n, 0);
};
function Jh(t, e, n, r) {
  return P(this, void 0, void 0, function() {
    var i, o;
    return F(this, function(s) {
      switch (s.label) {
        case 0:
          return n.emit("dispatch_start", t), i = Date.now(), e.isEmpty() ? [4, e.dispatchSingle(t)] : [3, 2];
        case 1:
          return o = s.sent(), [3, 4];
        case 2:
          return [4, e.dispatch(t)];
        case 3:
          o = s.sent(), s.label = 4;
        case 4:
          return r != null && r.callback ? [4, Mh(o, r.callback, Kh(i, r.timeout))] : [3, 6];
        case 5:
          o = s.sent(), s.label = 6;
        case 6:
          return r != null && r.debug && o.flush(), [2, o];
      }
    });
  });
}
function Yh(t, e, n, r) {
  var i, o = [t, e, n, r], s = Z(t) ? t.event : t;
  if (!s || !Ee(s))
    throw new Error("Event missing");
  var a = Z(t) ? (i = t.properties) !== null && i !== void 0 ? i : {} : Z(e) ? e : {}, u = {};
  ut(n) || (u = n != null ? n : {}), Z(t) && !ut(e) && (u = e != null ? e : {});
  var c = o.find(ut);
  return [s, a, u, c];
}
function po(t, e, n, r, i) {
  var o, s, a = null, u = null, c = [t, e, n, r, i], l = c.filter(Ee);
  l.length === 1 ? Ee(c[1]) ? (u = c[1], a = null) : (u = l[0], a = null) : l.length === 2 && (typeof c[0] == "string" && (a = c[0]), typeof c[1] == "string" && (u = c[1]));
  var d = c.find(ut), f = c.filter(Z);
  return f.length === 1 ? Z(c[2]) ? (s = {}, o = c[2]) : Z(c[3]) ? (o = {}, s = c[3]) : (o = f[0], s = {}) : f.length === 2 && (o = f[0], s = f[1]), [
    a,
    u,
    o != null ? o : o = {},
    s != null ? s : s = {},
    d
  ];
}
var go = function(t) {
  return function() {
    for (var e, n, r, i = [], o = 0; o < arguments.length; o++)
      i[o] = arguments[o];
    for (var s = {}, a = [
      "callback",
      "options",
      "traits",
      "id"
    ], u = 0, c = i; u < c.length; u++) {
      var l = c[u], d = a.pop();
      if (d === "id") {
        if (Ee(l) || Ir(l)) {
          s.id = l.toString();
          continue;
        }
        if (l == null)
          continue;
        d = a.pop();
      }
      if ((d === "traits" || d === "options") && (l == null || Z(l)) && (s[d] = l), ut(l)) {
        s.callback = l;
        break;
      }
    }
    return [
      (e = s.id) !== null && e !== void 0 ? e : t.id(),
      (n = s.traits) !== null && n !== void 0 ? n : {},
      (r = s.options) !== null && r !== void 0 ? r : {},
      s.callback
    ];
  };
};
function Xh(t, e, n, r) {
  Ir(t) && (t = t.toString()), Ir(e) && (e = e.toString());
  var i = [t, e, n, r], o = i.filter(Ee), s = o[0], a = s === void 0 ? t : s, u = o[1], c = u === void 0 ? null : u, l = i.filter(Z)[0], d = l === void 0 ? {} : l, f = i.find(ut);
  return [a, c, d, f];
}
function ei() {
  return typeof window != "undefined";
}
function Bs() {
  return !ei();
}
function Gs() {
  return ei() ? window.navigator.onLine : !0;
}
function xe() {
  return !Gs();
}
function Qh(t, e) {
  return e = e || {}, new Promise(function(n, r) {
    var i = new XMLHttpRequest(), o = [], s = [], a = {}, u = function() {
      return { ok: (i.status / 100 | 0) == 2, statusText: i.statusText, status: i.status, url: i.responseURL, text: function() {
        return Promise.resolve(i.responseText);
      }, json: function() {
        return Promise.resolve(i.responseText).then(JSON.parse);
      }, blob: function() {
        return Promise.resolve(new Blob([i.response]));
      }, clone: u, headers: { keys: function() {
        return o;
      }, entries: function() {
        return s;
      }, get: function(l) {
        return a[l.toLowerCase()];
      }, has: function(l) {
        return l.toLowerCase() in a;
      } } };
    };
    for (var c in i.open(e.method || "get", t, !0), i.onload = function() {
      i.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(l, d, f) {
        o.push(d = d.toLowerCase()), s.push([d, f]), a[d] = a[d] ? a[d] + "," + f : f;
      }), n(u());
    }, i.onerror = r, i.withCredentials = e.credentials == "include", e.headers) i.setRequestHeader(c, e.headers[c]);
    i.send(e.body || null);
  });
}
var ti = function() {
  return typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : typeof global != "undefined" ? global : null;
}, In = function() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var n = ti();
  return (n && n.fetch || Qh).apply(void 0, t);
}, Cn = "1.82.0", qs = "api.segment.io/v1", Zh = function(t, e, n) {
  var r = e.reduce(function(i, o) {
    var s = o.split(":"), a = s[0], u = s[1];
    return i[a] = u, i;
  }, {});
  return {
    type: "Counter",
    metric: t,
    value: 1,
    tags: I(I({}, r), { library: "analytics.js", library_version: "npm:next-".concat(Cn) })
  };
};
function Yn(t) {
  console.error("Error sending segment performance metrics", t);
}
var ep = (
  /** @class */
  function() {
    function t(e) {
      var n = this, r, i, o, s, a;
      if (this.host = (r = e == null ? void 0 : e.host) !== null && r !== void 0 ? r : qs, this.sampleRate = (i = e == null ? void 0 : e.sampleRate) !== null && i !== void 0 ? i : 1, this.flushTimer = (o = e == null ? void 0 : e.flushTimer) !== null && o !== void 0 ? o : 30 * 1e3, this.maxQueueSize = (s = e == null ? void 0 : e.maxQueueSize) !== null && s !== void 0 ? s : 20, this.protocol = (a = e == null ? void 0 : e.protocol) !== null && a !== void 0 ? a : "https", this.queue = [], this.sampleRate > 0) {
        var u = !1, c = function() {
          u || (u = !0, n.flush().catch(Yn), u = !1, setTimeout(c, n.flushTimer));
        };
        c();
      }
    }
    return t.prototype.increment = function(e, n) {
      if (e.includes("analytics_js.") && n.length !== 0 && !(Math.random() > this.sampleRate) && !(this.queue.length >= this.maxQueueSize)) {
        var r = Zh(e, n);
        this.queue.push(r), e.includes("error") && this.flush().catch(Yn);
      }
    }, t.prototype.flush = function() {
      return P(this, void 0, void 0, function() {
        var e = this;
        return F(this, function(n) {
          switch (n.label) {
            case 0:
              return this.queue.length <= 0 ? [
                2
                /*return*/
              ] : [4, this.send().catch(function(r) {
                Yn(r), e.sampleRate = 0;
              })];
            case 1:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.send = function() {
      return P(this, void 0, void 0, function() {
        var e, n, r;
        return F(this, function(i) {
          return e = { series: this.queue }, this.queue = [], n = { "Content-Type": "text/plain" }, r = "".concat(this.protocol, "://").concat(this.host, "/m"), [2, In(r, {
            headers: n,
            body: JSON.stringify(e),
            method: "POST"
          })];
        });
      });
    }, t;
  }()
), Ht, Hs = (
  /** @class */
  function(t) {
    ee(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.initRemoteMetrics = function(n) {
      Ht = new ep(n);
    }, e.prototype.increment = function(n, r, i) {
      t.prototype.increment.call(this, n, r, i), Ht == null || Ht.increment(n, i != null ? i : []);
    }, e;
  }($s)
), oe = (
  /** @class */
  function(t) {
    ee(e, t);
    function e(n, r) {
      return t.call(this, n, r, new Hs()) || this;
    }
    return e.system = function() {
      return new this({ type: "track", event: "system" });
    }, e;
  }(hn)
);
function tp(t) {
  return Object.prototype.toString.call(t).slice(8, -1).toLowerCase() === "object";
}
var zs = "bpc", Vs = function(t, e, n, r, i, o) {
  return {
    __t: zs,
    c: e,
    p: r,
    u: t,
    s: n,
    t: i,
    r: o
  };
}, np = Object.keys(Vs("", "", "", "", "", ""));
function rp(t) {
  if (!tp(t) || t.__t !== zs) return !1;
  for (var e in t)
    if (!np.includes(e))
      return !1;
  return !0;
}
var ip = function(t, e) {
  return t.indexOf("?") > -1 ? t : t + e;
}, op = function(t) {
  var e = t.indexOf("#");
  return e === -1 ? t : t.slice(0, e);
}, sp = function(t) {
  try {
    return new URL(t).pathname;
  } catch (e) {
    return t[0] === "/" ? t : "/" + t;
  }
}, Ws = function(t) {
  var e = t.c, n = t.p, r = t.s, i = t.u, o = t.r, s = t.t, a = e ? sp(e) : n, u = e ? ip(e, r) : op(i);
  return {
    path: a,
    referrer: o,
    search: r,
    title: s,
    url: u
  };
}, Ks = function() {
  var t = document.querySelector("link[rel='canonical']");
  return Vs(location.href, t && t.getAttribute("href") || void 0, location.search, location.pathname, document.title, document.referrer);
}, ap = function() {
  return Ws(Ks());
};
function up(t, e) {
  return Object.assign.apply(Object, W([{}], e.map(function(n) {
    var r;
    if (t && Object.prototype.hasOwnProperty.call(t, n))
      return r = {}, r[n] = t[n], r;
  }), !1));
}
var Ke = function(t, e) {
  e === void 0 && (e = ap());
  var n = t.context, r;
  t.type === "page" && (r = t.properties && up(t.properties, Object.keys(e)), t.properties = I(I(I({}, e), t.properties), t.name ? { name: t.name } : {})), n.page = I(I(I({}, e), r), n.page);
}, cp = (
  /** @class */
  function(t) {
    ee(e, t);
    function e(n) {
      var r = t.call(this, {
        createMessageId: function() {
          return "ajs-next-".concat(Date.now(), "-").concat(Zr());
        },
        onEventMethodCall: function(i) {
          var o = i.options;
          r.maybeUpdateAnonId(o);
        },
        onFinishedEvent: function(i) {
          return r.addIdentity(i), i;
        }
      }) || this;
      return r.user = n, r;
    }
    return e.prototype.maybeUpdateAnonId = function(n) {
      n != null && n.anonymousId && this.user.anonymousId(n.anonymousId);
    }, e.prototype.addIdentity = function(n) {
      this.user.id() && (n.userId = this.user.id()), this.user.anonymousId() && (n.anonymousId = this.user.anonymousId());
    }, e.prototype.track = function(n, r, i, o, s) {
      var a = t.prototype.track.call(this, n, r, i, o);
      return Ke(a, s), a;
    }, e.prototype.page = function(n, r, i, o, s, a) {
      var u = t.prototype.page.call(this, n, r, i, o, s);
      return Ke(u, a), u;
    }, e.prototype.screen = function(n, r, i, o, s, a) {
      var u = t.prototype.screen.call(this, n, r, i, o, s);
      return Ke(u, a), u;
    }, e.prototype.identify = function(n, r, i, o, s) {
      var a = t.prototype.identify.call(this, n, r, i, o);
      return Ke(a, s), a;
    }, e.prototype.group = function(n, r, i, o, s) {
      var a = t.prototype.group.call(this, n, r, i, o);
      return Ke(a, s), a;
    }, e.prototype.alias = function(n, r, i, o, s) {
      var a = t.prototype.alias.call(this, n, r, i, o);
      return Ke(a, s), a;
    }, e;
  }(Lh)
), lp = function(t) {
  return "addMiddleware" in t && t.type === "destination";
}, ue = {
  getItem: function() {
  },
  setItem: function() {
  },
  removeItem: function() {
  }
};
try {
  ue = ei() && window.localStorage ? window.localStorage : ue;
} catch (t) {
  console.warn("Unable to access localStorage", t);
}
function Js(t) {
  var e = ue.getItem(t);
  return (e ? JSON.parse(e) : []).map(function(n) {
    return new oe(n.event, n.id);
  });
}
function dp(t, e) {
  var n = Js(t), r = W(W([], e, !0), n, !0), i = r.reduce(function(o, s) {
    var a;
    return I(I({}, o), (a = {}, a[s.id] = s, a));
  }, {});
  ue.setItem(t, JSON.stringify(Object.values(i)));
}
function Ys(t) {
  var e = ue.getItem(t);
  return e ? JSON.parse(e) : {};
}
function fp(t, e) {
  var n = Ys(t);
  ue.setItem(t, JSON.stringify(I(I({}, n), e)));
}
function yo(t) {
  ue.removeItem(t);
}
var hp = function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function Cr(t, e, n) {
  n === void 0 && (n = 0);
  var r = 50, i = "persisted-queue:v1:".concat(t, ":lock"), o = function(c) {
    return (/* @__PURE__ */ new Date()).getTime() > c;
  }, s = ue.getItem(i), a = s ? JSON.parse(s) : null, u = a === null || o(a);
  if (u) {
    ue.setItem(i, JSON.stringify(hp() + r)), e(), ue.removeItem(i);
    return;
  }
  !u && n < 3 ? setTimeout(function() {
    Cr(t, e, n + 1);
  }, r) : console.error("Unable to retrieve lock");
}
var Tn = (
  /** @class */
  function(t) {
    ee(e, t);
    function e(n, r) {
      var i = t.call(this, n, []) || this, o = "persisted-queue:v1:".concat(r, ":items"), s = "persisted-queue:v1:".concat(r, ":seen"), a = [], u = {};
      return Cr(r, function() {
        try {
          a = Js(o), u = Ys(s), yo(o), yo(s), i.queue = W(W([], a, !0), i.queue, !0), i.seen = I(I({}, u), i.seen);
        } catch (c) {
          console.error(c);
        }
      }), window.addEventListener("pagehide", function() {
        if (i.todo > 0) {
          var c = W(W([], i.queue, !0), i.future, !0);
          try {
            Cr(r, function() {
              dp(o, c), fp(s, i.seen);
            });
          } catch (l) {
            console.error(l);
          }
        }
      }), i;
    }
    return e;
  }(An)
), pp = (
  /** @class */
  function(t) {
    ee(e, t);
    function e(n) {
      return t.call(this, typeof n == "string" ? new Tn(4, n) : n) || this;
    }
    return e.prototype.flush = function() {
      return P(this, void 0, void 0, function() {
        return F(this, function(n) {
          return xe() ? [2, []] : [2, t.prototype.flush.call(this)];
        });
      });
    }, e;
  }(Wh)
);
function ni(t) {
  for (var e = t.constructor.prototype, n = 0, r = Object.getOwnPropertyNames(e); n < r.length; n++) {
    var i = r[n];
    if (i !== "constructor") {
      var o = Object.getOwnPropertyDescriptor(t.constructor.prototype, i);
      o && typeof o.value == "function" && (t[i] = t[i].bind(t));
    }
  }
  return t;
}
/*! js-cookie v3.0.1 | MIT */
function zt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      t[r] = n[r];
  }
  return t;
}
var gp = {
  read: function(t) {
    return t[0] === '"' && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(t) {
    return encodeURIComponent(t).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function Tr(t, e) {
  function n(i, o, s) {
    if (typeof document != "undefined") {
      s = zt({}, e, s), typeof s.expires == "number" && (s.expires = new Date(Date.now() + s.expires * 864e5)), s.expires && (s.expires = s.expires.toUTCString()), i = encodeURIComponent(i).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var a = "";
      for (var u in s)
        s[u] && (a += "; " + u, s[u] !== !0 && (a += "=" + s[u].split(";")[0]));
      return document.cookie = i + "=" + t.write(o, i) + a;
    }
  }
  function r(i) {
    if (!(typeof document == "undefined" || arguments.length && !i)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], s = {}, a = 0; a < o.length; a++) {
        var u = o[a].split("="), c = u.slice(1).join("=");
        try {
          var l = decodeURIComponent(u[0]);
          if (s[l] = t.read(c, l), i === l)
            break;
        } catch (d) {
        }
      }
      return i ? s[i] : s;
    }
  }
  return Object.create(
    {
      set: n,
      get: r,
      remove: function(i, o) {
        n(
          i,
          "",
          zt({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(i) {
        return Tr(this.converter, zt({}, this.attributes, i));
      },
      withConverter: function(i) {
        return Tr(zt({}, this.converter, i), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(e) },
      converter: { value: Object.freeze(t) }
    }
  );
}
var he = Tr(gp, { path: "/" });
function yp(t) {
  var e = t.hostname, n = e.split("."), r = n[n.length - 1], i = [];
  if (n.length === 4 && parseInt(r, 10) > 0 || n.length <= 1)
    return i;
  for (var o = n.length - 2; o >= 0; --o)
    i.push(n.slice(o).join("."));
  return i;
}
function mp(t) {
  try {
    return new URL(t);
  } catch (e) {
    return;
  }
}
function Xs(t) {
  var e = mp(t);
  if (e)
    for (var n = yp(e), r = 0; r < n.length; ++r) {
      var i = "__tld__", o = n[r], s = { domain: "." + o };
      try {
        if (he.set(i, "1", s), he.get(i))
          return he.remove(i, s), o;
      } catch (a) {
        return;
      }
    }
}
var vp = 365, Qs = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = t.defaults), this.options = I(I({}, t.defaults), e);
    }
    return Object.defineProperty(t, "defaults", {
      get: function() {
        return {
          maxage: vp,
          domain: Xs(window.location.href),
          path: "/",
          sameSite: "Lax"
        };
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.opts = function() {
      return {
        sameSite: this.options.sameSite,
        expires: this.options.maxage,
        domain: this.options.domain,
        path: this.options.path,
        secure: this.options.secure
      };
    }, t.prototype.get = function(e) {
      var n;
      try {
        var r = he.get(e);
        if (r == null)
          return null;
        try {
          return (n = JSON.parse(r)) !== null && n !== void 0 ? n : null;
        } catch (i) {
          return r != null ? r : null;
        }
      } catch (i) {
        return null;
      }
    }, t.prototype.set = function(e, n) {
      typeof n == "string" ? he.set(e, n, this.opts()) : n === null ? he.remove(e, this.opts()) : he.set(e, JSON.stringify(n), this.opts());
    }, t.prototype.remove = function(e) {
      return he.remove(e, this.opts());
    }, t;
  }()
), _p = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.localStorageWarning = function(e, n) {
      console.warn("Unable to access ".concat(e, ", localStorage may be ").concat(n));
    }, t.prototype.get = function(e) {
      var n;
      try {
        var r = localStorage.getItem(e);
        if (r === null)
          return null;
        try {
          return (n = JSON.parse(r)) !== null && n !== void 0 ? n : null;
        } catch (i) {
          return r != null ? r : null;
        }
      } catch (i) {
        return this.localStorageWarning(e, "unavailable"), null;
      }
    }, t.prototype.set = function(e, n) {
      try {
        localStorage.setItem(e, JSON.stringify(n));
      } catch (r) {
        this.localStorageWarning(e, "full");
      }
    }, t.prototype.remove = function(e) {
      try {
        return localStorage.removeItem(e);
      } catch (n) {
        this.localStorageWarning(e, "unavailable");
      }
    }, t;
  }()
), ri = (
  /** @class */
  function() {
    function t() {
      this.cache = {};
    }
    return t.prototype.get = function(e) {
      var n;
      return (n = this.cache[e]) !== null && n !== void 0 ? n : null;
    }, t.prototype.set = function(e, n) {
      this.cache[e] = n;
    }, t.prototype.remove = function(e) {
      delete this.cache[e];
    }, t;
  }()
), Q = {
  Cookie: "cookie",
  LocalStorage: "localStorage",
  Memory: "memory"
};
function Zs(t) {
  return t && t.stores && Array.isArray(t.stores) && t.stores.every(function(e) {
    return Object.values(Q).includes(e);
  });
}
function bp(t) {
  return typeof t == "object" && t.name !== void 0;
}
var Xn = function(t, e, n, r) {
  console.warn("".concat(t.constructor.name, ": Can't ").concat(e, ' key "').concat(n, '" | Err: ').concat(r));
}, Le = (
  /** @class */
  function() {
    function t(e) {
      this.stores = e;
    }
    return t.prototype.get = function(e) {
      for (var n = null, r = 0, i = this.stores; r < i.length; r++) {
        var o = i[r];
        try {
          if (n = o.get(e), n != null)
            return n;
        } catch (s) {
          Xn(o, "get", e, s);
        }
      }
      return null;
    }, t.prototype.set = function(e, n) {
      this.stores.forEach(function(r) {
        try {
          r.set(e, n);
        } catch (i) {
          Xn(r, "set", e, i);
        }
      });
    }, t.prototype.clear = function(e) {
      this.stores.forEach(function(n) {
        try {
          n.remove(e);
        } catch (r) {
          Xn(n, "remove", e, r);
        }
      });
    }, t.prototype.getAndSync = function(e) {
      var n = this.get(e), r = typeof n == "number" ? n.toString() : n;
      return this.set(e, r), r;
    }, t;
  }()
);
function Or(t) {
  var e = t.map(function(n) {
    var r, i;
    switch (bp(n) ? (r = n.name, i = n.settings) : r = n, r) {
      case Q.Cookie:
        return new Qs(i);
      case Q.LocalStorage:
        return new _p();
      case Q.Memory:
        return new ri();
      default:
        throw new Error("Unknown Store Type: ".concat(n));
    }
  });
  return e;
}
function ea(t, e) {
  return t.map(function(n) {
    return e && n === Q.Cookie ? {
      name: n,
      settings: e
    } : n;
  });
}
var Ce = {
  persist: !0,
  cookie: {
    key: "ajs_user_id",
    oldKey: "ajs_user"
  },
  localStorage: {
    key: "ajs_user_traits"
  }
}, ta = (
  /** @class */
  function() {
    function t(e, n) {
      e === void 0 && (e = Ce);
      var r = this, i, o, s, a;
      this.options = {}, this.id = function(c) {
        if (r.options.disable)
          return null;
        var l = r.identityStore.getAndSync(r.idKey);
        if (c !== void 0) {
          r.identityStore.set(r.idKey, c);
          var d = c !== l && l !== null && c !== null;
          d && r.anonymousId(null);
        }
        var f = r.identityStore.getAndSync(r.idKey);
        if (f)
          return f;
        var h = r.legacyUserStore.get(Ce.cookie.oldKey);
        return h ? typeof h == "object" ? h.id : h : null;
      }, this.anonymousId = function(c) {
        var l, d;
        if (r.options.disable)
          return null;
        if (c === void 0) {
          var f = (l = r.identityStore.getAndSync(r.anonKey)) !== null && l !== void 0 ? l : (d = r.legacySIO()) === null || d === void 0 ? void 0 : d[0];
          if (f)
            return f;
        }
        return c === null ? (r.identityStore.set(r.anonKey, null), r.identityStore.getAndSync(r.anonKey)) : (r.identityStore.set(r.anonKey, c != null ? c : Zr()), r.identityStore.getAndSync(r.anonKey));
      }, this.traits = function(c) {
        var l;
        if (!r.options.disable)
          return c === null && (c = {}), c && r.traitsStore.set(r.traitsKey, c != null ? c : {}), (l = r.traitsStore.get(r.traitsKey)) !== null && l !== void 0 ? l : {};
      }, this.options = I(I({}, Ce), e), this.cookieOptions = n, this.idKey = (o = (i = e.cookie) === null || i === void 0 ? void 0 : i.key) !== null && o !== void 0 ? o : Ce.cookie.key, this.traitsKey = (a = (s = e.localStorage) === null || s === void 0 ? void 0 : s.key) !== null && a !== void 0 ? a : Ce.localStorage.key, this.anonKey = "ajs_anonymous_id", this.identityStore = this.createStorage(this.options, n), this.legacyUserStore = this.createStorage(this.options, n, function(c) {
        return c === Q.Cookie;
      }), this.traitsStore = this.createStorage(this.options, n, function(c) {
        return c !== Q.Cookie;
      });
      var u = this.legacyUserStore.get(Ce.cookie.oldKey);
      u && typeof u == "object" && (u.id && this.id(u.id), u.traits && this.traits(u.traits)), ni(this);
    }
    return t.prototype.legacySIO = function() {
      var e = this.legacyUserStore.get("_sio");
      if (!e)
        return null;
      var n = e.split("----"), r = n[0], i = n[1];
      return [r, i];
    }, t.prototype.identify = function(e, n) {
      if (!this.options.disable) {
        n = n != null ? n : {};
        var r = this.id();
        (r === null || r === e) && (n = I(I({}, this.traits()), n)), e && this.id(e), this.traits(n);
      }
    }, t.prototype.logout = function() {
      this.anonymousId(null), this.id(null), this.traits({});
    }, t.prototype.reset = function() {
      this.logout(), this.identityStore.clear(this.idKey), this.identityStore.clear(this.anonKey), this.traitsStore.clear(this.traitsKey);
    }, t.prototype.load = function() {
      return new t(this.options, this.cookieOptions);
    }, t.prototype.save = function() {
      return !0;
    }, t.prototype.createStorage = function(e, n, r) {
      var i = [
        Q.LocalStorage,
        Q.Cookie,
        Q.Memory
      ];
      return e.disable ? new Le([]) : e.persist ? (e.storage !== void 0 && e.storage !== null && Zs(e.storage) && (i = e.storage.stores), e.localStorageFallbackDisabled && (i = i.filter(function(o) {
        return o !== Q.LocalStorage;
      })), r && (i = i.filter(r)), new Le(Or(ea(i, n)))) : new Le([new ri()]);
    }, t.defaults = Ce, t;
  }()
), mo = {
  persist: !0,
  cookie: {
    key: "ajs_group_id"
  },
  localStorage: {
    key: "ajs_group_properties"
  }
}, Sp = (
  /** @class */
  function(t) {
    ee(e, t);
    function e(n, r) {
      n === void 0 && (n = mo);
      var i = t.call(this, I(I({}, mo), n), r) || this;
      return i.anonymousId = function(o) {
      }, ni(i), i;
    }
    return e;
  }(ta)
), ii = "analytics";
function na() {
  return window[ii];
}
function wp(t) {
  ii = t;
}
function Ep(t) {
  window[ii] = t;
}
var kp = function(t) {
  return typeof t == "object" && t !== null && "then" in t && typeof t.then == "function";
}, ra = function(t, e, n) {
  n.getAndRemove(t).forEach(function(r) {
    On(e, r).catch(console.error);
  });
}, xp = function(t, e) {
  return P(void 0, void 0, void 0, function() {
    var n, r, i;
    return F(this, function(o) {
      switch (o.label) {
        case 0:
          n = 0, r = e.getAndRemove("addSourceMiddleware"), o.label = 1;
        case 1:
          return n < r.length ? (i = r[n], [4, On(t, i).catch(console.error)]) : [3, 4];
        case 2:
          o.sent(), o.label = 3;
        case 3:
          return n++, [3, 1];
        case 4:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}, Ap = function(t, e) {
  return P(void 0, void 0, void 0, function() {
    var n, r, i;
    return F(this, function(o) {
      switch (o.label) {
        case 0:
          n = 0, r = e.getAndRemove("register"), o.label = 1;
        case 1:
          return n < r.length ? (i = r[n], [4, On(t, i).catch(console.error)]) : [3, 4];
        case 2:
          o.sent(), o.label = 3;
        case 3:
          return n++, [3, 1];
        case 4:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}, Ip = ra.bind(void 0, "on"), Cp = ra.bind(void 0, "setAnonymousId"), Tp = function(t, e) {
  Object.keys(e.calls).forEach(function(n) {
    e.getAndRemove(n).forEach(function(r) {
      setTimeout(function() {
        On(t, r).catch(console.error);
      }, 0);
    });
  });
}, Je = function(t) {
  if (ia(t)) {
    var e = t.pop();
    return Ws(e);
  }
}, ia = function(t) {
  var e = t[t.length - 1];
  return rp(e);
}, Rr = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e, n, r, i) {
      r === void 0 && (r = function() {
      }), i === void 0 && (i = console.error), this.method = e, this.resolve = r, this.reject = i, this.called = !1, this.args = n;
    }
    return t;
  }()
), Op = (
  /** @class */
  function() {
    function t() {
      for (var e = [], n = 0; n < arguments.length; n++)
        e[n] = arguments[n];
      this._callMap = {}, this.add.apply(this, e);
    }
    return Object.defineProperty(t.prototype, "calls", {
      /**
       * Pull any buffered method calls from the window object, and use them to hydrate the instance buffer.
       */
      get: function() {
        return this._pushSnippetWindowBuffer(), this._callMap;
      },
      set: function(e) {
        this._callMap = e;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.get = function(e) {
      var n;
      return (n = this.calls[e]) !== null && n !== void 0 ? n : [];
    }, t.prototype.getAndRemove = function(e) {
      var n = this.get(e);
      return this.calls[e] = [], n;
    }, t.prototype.add = function() {
      for (var e = this, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      n.forEach(function(i) {
        var o = [
          "track",
          "screen",
          "alias",
          "group",
          "page",
          "identify"
        ];
        o.includes(i.method) && !ia(i.args) && (i.args = W(W([], i.args, !0), [Ks()], !1)), e.calls[i.method] ? e.calls[i.method].push(i) : e.calls[i.method] = [i];
      });
    }, t.prototype.clear = function() {
      this._pushSnippetWindowBuffer(), this.calls = {};
    }, t.prototype.toArray = function() {
      var e;
      return (e = []).concat.apply(e, Object.values(this.calls));
    }, t.prototype._pushSnippetWindowBuffer = function() {
    }, t;
  }()
);
function On(t, e) {
  return P(this, void 0, void 0, function() {
    var n, r;
    return F(this, function(i) {
      switch (i.label) {
        case 0:
          return i.trys.push([0, 3, , 4]), e.called ? [2, void 0] : (e.called = !0, n = t[e.method].apply(t, e.args), kp(n) ? [4, n] : [3, 2]);
        case 1:
          i.sent(), i.label = 2;
        case 2:
          return e.resolve(n), [3, 4];
        case 3:
          return r = i.sent(), e.reject(r), [3, 4];
        case 4:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
var Rp = (
  /** @class */
  function() {
    function t(e) {
      var n = this;
      this.trackSubmit = this._createMethod("trackSubmit"), this.trackClick = this._createMethod("trackClick"), this.trackLink = this._createMethod("trackLink"), this.pageView = this._createMethod("pageview"), this.identify = this._createMethod("identify"), this.reset = this._createMethod("reset"), this.group = this._createMethod("group"), this.track = this._createMethod("track"), this.ready = this._createMethod("ready"), this.alias = this._createMethod("alias"), this.debug = this._createChainableMethod("debug"), this.page = this._createMethod("page"), this.once = this._createChainableMethod("once"), this.off = this._createChainableMethod("off"), this.on = this._createChainableMethod("on"), this.addSourceMiddleware = this._createMethod("addSourceMiddleware"), this.setAnonymousId = this._createMethod("setAnonymousId"), this.addDestinationMiddleware = this._createMethod("addDestinationMiddleware"), this.screen = this._createMethod("screen"), this.register = this._createMethod("register"), this.deregister = this._createMethod("deregister"), this.user = this._createMethod("user"), this.VERSION = Cn, this._preInitBuffer = new Op(), this._promise = e(this._preInitBuffer), this._promise.then(function(r) {
        var i = r[0], o = r[1];
        n.instance = i, n.ctx = o;
      }).catch(function() {
      });
    }
    return t.prototype.then = function() {
      for (var e, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return (e = this._promise).then.apply(e, n);
    }, t.prototype.catch = function() {
      for (var e, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return (e = this._promise).catch.apply(e, n);
    }, t.prototype.finally = function() {
      for (var e, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return (e = this._promise).finally.apply(e, n);
    }, t.prototype._createMethod = function(e) {
      var n = this;
      return function() {
        for (var r, i = [], o = 0; o < arguments.length; o++)
          i[o] = arguments[o];
        if (n.instance) {
          var s = (r = n.instance)[e].apply(r, i);
          return Promise.resolve(s);
        }
        return new Promise(function(a, u) {
          n._preInitBuffer.add(new Rr(e, i, a, u));
        });
      };
    }, t.prototype._createChainableMethod = function(e) {
      var n = this;
      return function() {
        for (var r, i = [], o = 0; o < arguments.length; o++)
          i[o] = arguments[o];
        return n.instance ? ((r = n.instance)[e].apply(r, i), n) : (n._preInitBuffer.add(new Rr(e, i)), n);
      };
    }, t;
  }()
), Vt = {}, Ye = {}, St = {}, Qn = { exports: {} }, vo;
function Rn() {
  return vo || (vo = 1, function(t) {
    t.exports = e(n), t.exports.find = t.exports, t.exports.replace = function(a, u, c, l) {
      return e(i).call(this, a, u, c, l), a;
    }, t.exports.del = function(a, u, c) {
      return e(r).call(this, a, u, null, c), a;
    };
    function e(a) {
      return function(u, c, l, d) {
        var f = d && s(d.normalizer) ? d.normalizer : o;
        c = f(c);
        for (var h, p = !1; !p; ) v();
        function v() {
          for (h in u) {
            var g = f(h);
            if (c.indexOf(g) === 0) {
              var m = c.substr(g.length);
              if (m.charAt(0) === "." || m.length === 0) {
                c = m.substr(1);
                var _ = u[h];
                if (_ == null) {
                  p = !0;
                  return;
                }
                if (!c.length) {
                  p = !0;
                  return;
                }
                u = _;
                return;
              }
            }
          }
          h = void 0, p = !0;
        }
        if (h)
          return u == null ? u : a(u, h, l);
      };
    }
    function n(a, u) {
      if (a.hasOwnProperty(u)) return a[u];
    }
    function r(a, u) {
      return a.hasOwnProperty(u) && delete a[u], a;
    }
    function i(a, u, c) {
      return a.hasOwnProperty(u) && (a[u] = c), a;
    }
    function o(a) {
      return a.replace(/[^a-zA-Z0-9\.]+/g, "").toLowerCase();
    }
    function s(a) {
      return typeof a == "function";
    }
  }(Qn)), Qn.exports;
}
var _o;
function Dp() {
  if (_o) return St;
  _o = 1;
  var t = St.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(St, "__esModule", { value: !0 });
  var e = t(Rn());
  function n(i, o) {
    return function() {
      var s = this.traits(), a = this.properties ? this.properties() : {};
      return e.default(s, "address." + i) || e.default(s, i) || (o ? e.default(s, "address." + o) : null) || (o ? e.default(s, o) : null) || e.default(a, "address." + i) || e.default(a, i) || (o ? e.default(a, "address." + o) : null) || (o ? e.default(a, o) : null);
    };
  }
  function r(i) {
    i.zip = n("postalCode", "zip"), i.country = n("country"), i.street = n("street"), i.state = n("state"), i.city = n("city"), i.region = n("region");
  }
  return St.default = r, St;
}
var wt = {}, bo;
function Pp() {
  if (bo) return wt;
  bo = 1, Object.defineProperty(wt, "__esModule", { value: !0 }), wt.clone = void 0;
  function t(e) {
    if (typeof e != "object")
      return e;
    if (Object.prototype.toString.call(e) === "[object Object]") {
      var n = {};
      for (var r in e)
        Object.prototype.hasOwnProperty.call(e, r) && (n[r] = t(e[r]));
      return n;
    } else return Array.isArray(e) ? e.map(t) : e;
  }
  return wt.clone = t, wt;
}
var Wt = {}, So;
function Fp() {
  if (So) return Wt;
  So = 1, Object.defineProperty(Wt, "__esModule", { value: !0 });
  var t = {
    Salesforce: !0
  };
  function e(n) {
    return !t[n];
  }
  return Wt.default = e, Wt;
}
var Kt = {}, wo;
function oa() {
  if (wo) return Kt;
  wo = 1;
  var t = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
  return Kt.parse = function(e) {
    var n = [1, 5, 6, 7, 11, 12], r = t.exec(e), i = 0;
    if (!r)
      return new Date(e);
    for (var o = 0, s; s = n[o]; o++)
      r[s] = parseInt(r[s], 10) || 0;
    r[2] = parseInt(r[2], 10) || 1, r[3] = parseInt(r[3], 10) || 1, r[2]--, r[8] = r[8] ? (r[8] + "00").substring(0, 3) : 0, r[4] === " " ? i = (/* @__PURE__ */ new Date()).getTimezoneOffset() : r[9] !== "Z" && r[10] && (i = r[11] * 60 + r[12], r[10] === "+" && (i = 0 - i));
    var a = Date.UTC(r[1], r[2], r[3], r[5], r[6] + i, r[7], r[8]);
    return new Date(a);
  }, Kt.is = function(e, n) {
    return typeof e != "string" || n && /^\d{4}-\d{2}-\d{2}/.test(e) === !1 ? !1 : t.test(e);
  }, Kt;
}
var Jt = {}, Eo;
function Lp() {
  if (Eo) return Jt;
  Eo = 1;
  var t = /\d{13}/;
  return Jt.is = function(e) {
    return t.test(e);
  }, Jt.parse = function(e) {
    return e = parseInt(e, 10), new Date(e);
  }, Jt;
}
var Yt = {}, ko;
function Np() {
  if (ko) return Yt;
  ko = 1;
  var t = /\d{10}/;
  return Yt.is = function(e) {
    return t.test(e);
  }, Yt.parse = function(e) {
    var n = parseInt(e, 10) * 1e3;
    return new Date(n);
  }, Yt;
}
var Zn, xo;
function oi() {
  if (xo) return Zn;
  xo = 1;
  var t = oa(), e = Lp(), n = Np(), r = Object.prototype, i = r.toString;
  function o(u) {
    return i.call(u) === "[object Date]";
  }
  function s(u) {
    return i.call(u) === "[object Number]";
  }
  Zn = function(c) {
    return o(c) ? c : s(c) ? new Date(a(c)) : t.is(c) ? t.parse(c) : e.is(c) ? e.parse(c) : n.is(c) ? n.parse(c) : new Date(c);
  };
  function a(u) {
    return u < 315576e5 ? u * 1e3 : u;
  }
  return Zn;
}
var er, Ao;
function Mp() {
  if (Ao) return er;
  Ao = 1;
  var t = oa();
  er = e;
  function e(i, o) {
    return o === void 0 && (o = !0), i && typeof i == "object" ? n(i, o) : Array.isArray(i) ? r(i, o) : t.is(i, o) ? t.parse(i) : i;
  }
  function n(i, o) {
    return Object.keys(i).forEach(function(s) {
      i[s] = e(i[s], o);
    }), i;
  }
  function r(i, o) {
    return i.forEach(function(s, a) {
      i[a] = e(s, o);
    }), i;
  }
  return er;
}
var Io;
function qe() {
  if (Io) return Ye;
  Io = 1;
  var t = Ye.__importDefault || function(l) {
    return l && l.__esModule ? l : { default: l };
  };
  Object.defineProperty(Ye, "__esModule", { value: !0 }), Ye.Facade = void 0;
  var e = t(Dp()), n = Pp(), r = t(Fp()), i = t(oi()), o = t(Rn()), s = t(Mp());
  function a(l, d) {
    d = d || {}, this.raw = n.clone(l), "clone" in d || (d.clone = !0), d.clone && (l = n.clone(l)), "traverse" in d || (d.traverse = !0), "timestamp" in l ? l.timestamp = i.default(l.timestamp) : l.timestamp = /* @__PURE__ */ new Date(), d.traverse && s.default(l), this.opts = d, this.obj = l;
  }
  Ye.Facade = a;
  var u = a.prototype;
  u.proxy = function(l) {
    var d = l.split(".");
    l = d.shift();
    var f = this[l] || this.obj[l];
    return f && (typeof f == "function" && (f = f.call(this) || {}), d.length === 0 ? this.opts.clone ? c(f) : f : (f = o.default(f, d.join(".")), this.opts.clone ? c(f) : f));
  }, u.field = function(l) {
    var d = this.obj[l];
    return this.opts.clone ? c(d) : d;
  }, a.proxy = function(l) {
    return function() {
      return this.proxy(l);
    };
  }, a.field = function(l) {
    return function() {
      return this.field(l);
    };
  }, a.multi = function(l) {
    return function() {
      var d = this.proxy(l + "s");
      if (Array.isArray(d))
        return d;
      var f = this.proxy(l);
      return f && (f = [this.opts.clone ? n.clone(f) : f]), f || [];
    };
  }, a.one = function(l) {
    return function() {
      var d = this.proxy(l);
      if (d)
        return d;
      var f = this.proxy(l + "s");
      if (Array.isArray(f))
        return f[0];
    };
  }, u.json = function() {
    var l = this.opts.clone ? n.clone(this.obj) : this.obj;
    return this.type && (l.type = this.type()), l;
  }, u.rawEvent = function() {
    return this.raw;
  }, u.options = function(l) {
    var d = this.obj.options || this.obj.context || {}, f = this.opts.clone ? n.clone(d) : d;
    if (!l)
      return f;
    if (this.enabled(l)) {
      var h = this.integrations(), p = h[l] || o.default(h, l);
      return typeof p != "object" && (p = o.default(this.options(), l)), typeof p == "object" ? p : {};
    }
  }, u.context = u.options, u.enabled = function(l) {
    var d = this.proxy("options.providers.all");
    typeof d != "boolean" && (d = this.proxy("options.all")), typeof d != "boolean" && (d = this.proxy("integrations.all")), typeof d != "boolean" && (d = !0);
    var f = d && r.default(l), h = this.integrations();
    if (h.providers && h.providers.hasOwnProperty(l) && (f = h.providers[l]), h.hasOwnProperty(l)) {
      var p = h[l];
      typeof p == "boolean" ? f = p : f = !0;
    }
    return !!f;
  }, u.integrations = function() {
    return this.obj.integrations || this.proxy("options.providers") || this.options();
  }, u.active = function() {
    var l = this.proxy("options.active");
    return l == null && (l = !0), l;
  }, u.anonymousId = function() {
    return this.field("anonymousId") || this.field("sessionId");
  }, u.sessionId = u.anonymousId, u.groupId = a.proxy("options.groupId"), u.traits = function(l) {
    var d = this.proxy("options.traits") || {}, f = this.userId();
    l = l || {}, f && (d.id = f);
    for (var h in l)
      if (Object.prototype.hasOwnProperty.call(l, h)) {
        var p = this[h] == null ? this.proxy("options.traits." + h) : this[h]();
        if (p == null)
          continue;
        d[l[h]] = p, delete d[h];
      }
    return d;
  }, u.library = function() {
    var l = this.proxy("options.library");
    return l ? typeof l == "string" ? { name: l, version: null } : l : { name: "unknown", version: null };
  }, u.device = function() {
    var l = this.proxy("context.device");
    (typeof l != "object" || l === null) && (l = {});
    var d = this.library().name;
    return l.type || (d.indexOf("ios") > -1 && (l.type = "ios"), d.indexOf("android") > -1 && (l.type = "android")), l;
  }, u.userAgent = a.proxy("context.userAgent"), u.timezone = a.proxy("context.timezone"), u.timestamp = a.field("timestamp"), u.channel = a.field("channel"), u.ip = a.proxy("context.ip"), u.userId = a.field("userId"), e.default(u);
  function c(l) {
    return n.clone(l);
  }
  return Ye;
}
var Xe = {}, Xt = { exports: {} }, Co;
function He() {
  return Co || (Co = 1, typeof Object.create == "function" ? Xt.exports = function(e, n) {
    n && (e.super_ = n, e.prototype = Object.create(n.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : Xt.exports = function(e, n) {
    if (n) {
      e.super_ = n;
      var r = function() {
      };
      r.prototype = n.prototype, e.prototype = new r(), e.prototype.constructor = e;
    }
  }), Xt.exports;
}
var To;
function jp() {
  if (To) return Xe;
  To = 1;
  var t = Xe.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(Xe, "__esModule", { value: !0 }), Xe.Alias = void 0;
  var e = t(He()), n = qe();
  function r(i, o) {
    n.Facade.call(this, i, o);
  }
  return Xe.Alias = r, e.default(r, n.Facade), r.prototype.action = function() {
    return "alias";
  }, r.prototype.type = r.prototype.action, r.prototype.previousId = function() {
    return this.field("previousId") || this.field("from");
  }, r.prototype.from = r.prototype.previousId, r.prototype.userId = function() {
    return this.field("userId") || this.field("to");
  }, r.prototype.to = r.prototype.userId, Xe;
}
var Qe = {}, Qt = {}, Oo;
function Dn() {
  if (Oo) return Qt;
  Oo = 1, Object.defineProperty(Qt, "__esModule", { value: !0 });
  var t = /.+\@.+\..+/;
  function e(n) {
    return t.test(n);
  }
  return Qt.default = e, Qt;
}
var Ro;
function Up() {
  if (Ro) return Qe;
  Ro = 1;
  var t = Qe.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Object.defineProperty(Qe, "__esModule", { value: !0 }), Qe.Group = void 0;
  var e = t(He()), n = t(Dn()), r = t(oi()), i = qe();
  function o(a, u) {
    i.Facade.call(this, a, u);
  }
  Qe.Group = o, e.default(o, i.Facade);
  var s = o.prototype;
  return s.action = function() {
    return "group";
  }, s.type = s.action, s.groupId = i.Facade.field("groupId"), s.created = function() {
    var a = this.proxy("traits.createdAt") || this.proxy("traits.created") || this.proxy("properties.createdAt") || this.proxy("properties.created");
    if (a)
      return r.default(a);
  }, s.email = function() {
    var a = this.proxy("traits.email");
    if (a)
      return a;
    var u = this.groupId();
    if (n.default(u))
      return u;
  }, s.traits = function(a) {
    var u = this.properties(), c = this.groupId();
    a = a || {}, c && (u.id = c);
    for (var l in a)
      if (Object.prototype.hasOwnProperty.call(a, l)) {
        var d = this[l] == null ? this.proxy("traits." + l) : this[l]();
        if (d == null)
          continue;
        u[a[l]] = d, delete u[l];
      }
    return u;
  }, s.name = i.Facade.proxy("traits.name"), s.industry = i.Facade.proxy("traits.industry"), s.employees = i.Facade.proxy("traits.employees"), s.properties = function() {
    return this.field("traits") || this.field("properties") || {};
  }, Qe;
}
var Ze = {}, Do;
function sa() {
  if (Do) return Ze;
  Do = 1;
  var t = Ze.__importDefault || function(c) {
    return c && c.__esModule ? c : { default: c };
  };
  Object.defineProperty(Ze, "__esModule", { value: !0 }), Ze.Identify = void 0;
  var e = qe(), n = t(Rn()), r = t(He()), i = t(Dn()), o = t(oi()), s = function(c) {
    return c.trim();
  };
  function a(c, l) {
    e.Facade.call(this, c, l);
  }
  Ze.Identify = a, r.default(a, e.Facade);
  var u = a.prototype;
  return u.action = function() {
    return "identify";
  }, u.type = u.action, u.traits = function(c) {
    var l = this.field("traits") || {}, d = this.userId();
    c = c || {}, d && (l.id = d);
    for (var f in c) {
      var h = this[f] == null ? this.proxy("traits." + f) : this[f]();
      h != null && (l[c[f]] = h, f !== c[f] && delete l[f]);
    }
    return l;
  }, u.email = function() {
    var c = this.proxy("traits.email");
    if (c)
      return c;
    var l = this.userId();
    if (i.default(l))
      return l;
  }, u.created = function() {
    var c = this.proxy("traits.created") || this.proxy("traits.createdAt");
    if (c)
      return o.default(c);
  }, u.companyCreated = function() {
    var c = this.proxy("traits.company.created") || this.proxy("traits.company.createdAt");
    if (c)
      return o.default(c);
  }, u.companyName = function() {
    return this.proxy("traits.company.name");
  }, u.name = function() {
    var c = this.proxy("traits.name");
    if (typeof c == "string")
      return s(c);
    var l = this.firstName(), d = this.lastName();
    if (l && d)
      return s(l + " " + d);
  }, u.firstName = function() {
    var c = this.proxy("traits.firstName");
    if (typeof c == "string")
      return s(c);
    var l = this.proxy("traits.name");
    if (typeof l == "string")
      return s(l).split(" ")[0];
  }, u.lastName = function() {
    var c = this.proxy("traits.lastName");
    if (typeof c == "string")
      return s(c);
    var l = this.proxy("traits.name");
    if (typeof l == "string") {
      var d = s(l).indexOf(" ");
      if (d !== -1)
        return s(l.substr(d + 1));
    }
  }, u.uid = function() {
    return this.userId() || this.username() || this.email();
  }, u.description = function() {
    return this.proxy("traits.description") || this.proxy("traits.background");
  }, u.age = function() {
    var c = this.birthday(), l = n.default(this.traits(), "age");
    if (l != null)
      return l;
    if (c instanceof Date) {
      var d = /* @__PURE__ */ new Date();
      return d.getFullYear() - c.getFullYear();
    }
  }, u.avatar = function() {
    var c = this.traits();
    return n.default(c, "avatar") || n.default(c, "photoUrl") || n.default(c, "avatarUrl");
  }, u.position = function() {
    var c = this.traits();
    return n.default(c, "position") || n.default(c, "jobTitle");
  }, u.username = e.Facade.proxy("traits.username"), u.website = e.Facade.one("traits.website"), u.websites = e.Facade.multi("traits.website"), u.phone = e.Facade.one("traits.phone"), u.phones = e.Facade.multi("traits.phone"), u.address = e.Facade.proxy("traits.address"), u.gender = e.Facade.proxy("traits.gender"), u.birthday = e.Facade.proxy("traits.birthday"), Ze;
}
var et = {}, Po;
function si() {
  if (Po) return et;
  Po = 1;
  var t = et.__importDefault || function(c) {
    return c && c.__esModule ? c : { default: c };
  };
  Object.defineProperty(et, "__esModule", { value: !0 }), et.Track = void 0;
  var e = t(He()), n = qe(), r = sa(), i = t(Dn()), o = t(Rn());
  function s(c, l) {
    n.Facade.call(this, c, l);
  }
  et.Track = s, e.default(s, n.Facade);
  var a = s.prototype;
  a.action = function() {
    return "track";
  }, a.type = a.action, a.event = n.Facade.field("event"), a.value = n.Facade.proxy("properties.value"), a.category = n.Facade.proxy("properties.category"), a.id = n.Facade.proxy("properties.id"), a.productId = function() {
    return this.proxy("properties.product_id") || this.proxy("properties.productId");
  }, a.promotionId = function() {
    return this.proxy("properties.promotion_id") || this.proxy("properties.promotionId");
  }, a.cartId = function() {
    return this.proxy("properties.cart_id") || this.proxy("properties.cartId");
  }, a.checkoutId = function() {
    return this.proxy("properties.checkout_id") || this.proxy("properties.checkoutId");
  }, a.paymentId = function() {
    return this.proxy("properties.payment_id") || this.proxy("properties.paymentId");
  }, a.couponId = function() {
    return this.proxy("properties.coupon_id") || this.proxy("properties.couponId");
  }, a.wishlistId = function() {
    return this.proxy("properties.wishlist_id") || this.proxy("properties.wishlistId");
  }, a.reviewId = function() {
    return this.proxy("properties.review_id") || this.proxy("properties.reviewId");
  }, a.orderId = function() {
    return this.proxy("properties.id") || this.proxy("properties.order_id") || this.proxy("properties.orderId");
  }, a.sku = n.Facade.proxy("properties.sku"), a.tax = n.Facade.proxy("properties.tax"), a.name = n.Facade.proxy("properties.name"), a.price = n.Facade.proxy("properties.price"), a.total = n.Facade.proxy("properties.total"), a.repeat = n.Facade.proxy("properties.repeat"), a.coupon = n.Facade.proxy("properties.coupon"), a.shipping = n.Facade.proxy("properties.shipping"), a.discount = n.Facade.proxy("properties.discount"), a.shippingMethod = function() {
    return this.proxy("properties.shipping_method") || this.proxy("properties.shippingMethod");
  }, a.paymentMethod = function() {
    return this.proxy("properties.payment_method") || this.proxy("properties.paymentMethod");
  }, a.description = n.Facade.proxy("properties.description"), a.plan = n.Facade.proxy("properties.plan"), a.subtotal = function() {
    var c = o.default(this.properties(), "subtotal"), l = this.total() || this.revenue();
    if (c)
      return c;
    if (!l)
      return 0;
    if (this.total()) {
      var d = this.tax();
      d && (l -= d), d = this.shipping(), d && (l -= d), d = this.discount(), d && (l += d);
    }
    return l;
  }, a.products = function() {
    var c = this.properties(), l = o.default(c, "products");
    return Array.isArray(l) ? l.filter(function(d) {
      return d !== null;
    }) : [];
  }, a.quantity = function() {
    var c = this.obj.properties || {};
    return c.quantity || 1;
  }, a.currency = function() {
    var c = this.obj.properties || {};
    return c.currency || "USD";
  }, a.referrer = function() {
    return this.proxy("context.referrer.url") || this.proxy("context.page.referrer") || this.proxy("properties.referrer");
  }, a.query = n.Facade.proxy("options.query"), a.properties = function(c) {
    var l = this.field("properties") || {};
    c = c || {};
    for (var d in c)
      if (Object.prototype.hasOwnProperty.call(c, d)) {
        var f = this[d] == null ? this.proxy("properties." + d) : this[d]();
        if (f == null)
          continue;
        l[c[d]] = f, delete l[d];
      }
    return l;
  }, a.username = function() {
    return this.proxy("traits.username") || this.proxy("properties.username") || this.userId() || this.sessionId();
  }, a.email = function() {
    var c = this.proxy("traits.email") || this.proxy("properties.email") || this.proxy("options.traits.email");
    if (c)
      return c;
    var l = this.userId();
    if (i.default(l))
      return l;
  }, a.revenue = function() {
    var c = this.proxy("properties.revenue"), l = this.event(), d = /^[ _]?completed[ _]?order[ _]?|^[ _]?order[ _]?completed[ _]?$/i;
    return !c && l && l.match(d) && (c = this.proxy("properties.total")), u(c);
  }, a.cents = function() {
    var c = this.revenue();
    return typeof c != "number" ? this.value() || 0 : c * 100;
  }, a.identify = function() {
    var c = this.json();
    return c.traits = this.traits(), new r.Identify(c, this.opts);
  };
  function u(c) {
    if (c) {
      if (typeof c == "number")
        return c;
      if (typeof c == "string" && (c = c.replace(/\$/g, ""), c = parseFloat(c), !isNaN(c)))
        return c;
    }
  }
  return et;
}
var tt = {}, Fo;
function aa() {
  if (Fo) return tt;
  Fo = 1;
  var t = tt.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Object.defineProperty(tt, "__esModule", { value: !0 }), tt.Page = void 0;
  var e = t(He()), n = qe(), r = si(), i = t(Dn());
  function o(a, u) {
    n.Facade.call(this, a, u);
  }
  tt.Page = o, e.default(o, n.Facade);
  var s = o.prototype;
  return s.action = function() {
    return "page";
  }, s.type = s.action, s.category = n.Facade.field("category"), s.name = n.Facade.field("name"), s.title = n.Facade.proxy("properties.title"), s.path = n.Facade.proxy("properties.path"), s.url = n.Facade.proxy("properties.url"), s.referrer = function() {
    return this.proxy("context.referrer.url") || this.proxy("context.page.referrer") || this.proxy("properties.referrer");
  }, s.properties = function(a) {
    var u = this.field("properties") || {}, c = this.category(), l = this.name();
    a = a || {}, c && (u.category = c), l && (u.name = l);
    for (var d in a)
      if (Object.prototype.hasOwnProperty.call(a, d)) {
        var f = this[d] == null ? this.proxy("properties." + d) : this[d]();
        if (f == null)
          continue;
        u[a[d]] = f, d !== a[d] && delete u[d];
      }
    return u;
  }, s.email = function() {
    var a = this.proxy("context.traits.email") || this.proxy("properties.email");
    if (a)
      return a;
    var u = this.userId();
    if (i.default(u))
      return u;
  }, s.fullName = function() {
    var a = this.category(), u = this.name();
    return u && a ? a + " " + u : u;
  }, s.event = function(a) {
    return a ? "Viewed " + a + " Page" : "Loaded a Page";
  }, s.track = function(a) {
    var u = this.json();
    return u.event = this.event(a), u.timestamp = this.timestamp(), u.properties = this.properties(), new r.Track(u, this.opts);
  }, tt;
}
var nt = {}, Lo;
function $p() {
  if (Lo) return nt;
  Lo = 1;
  var t = nt.__importDefault || function(o) {
    return o && o.__esModule ? o : { default: o };
  };
  Object.defineProperty(nt, "__esModule", { value: !0 }), nt.Screen = void 0;
  var e = t(He()), n = aa(), r = si();
  function i(o, s) {
    n.Page.call(this, o, s);
  }
  return nt.Screen = i, e.default(i, n.Page), i.prototype.action = function() {
    return "screen";
  }, i.prototype.type = i.prototype.action, i.prototype.event = function(o) {
    return o ? "Viewed " + o + " Screen" : "Loaded a Screen";
  }, i.prototype.track = function(o) {
    var s = this.json();
    return s.event = this.event(o), s.timestamp = this.timestamp(), s.properties = this.properties(), new r.Track(s, this.opts);
  }, nt;
}
var rt = {}, No;
function Bp() {
  if (No) return rt;
  No = 1;
  var t = rt.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(rt, "__esModule", { value: !0 }), rt.Delete = void 0;
  var e = t(He()), n = qe();
  function r(i, o) {
    n.Facade.call(this, i, o);
  }
  return rt.Delete = r, e.default(r, n.Facade), r.prototype.type = function() {
    return "delete";
  }, rt;
}
var Mo;
function Gp() {
  return Mo || (Mo = 1, function(t) {
    var e = Vt.__assign || function() {
      return e = Object.assign || function(l) {
        for (var d, f = 1, h = arguments.length; f < h; f++) {
          d = arguments[f];
          for (var p in d) Object.prototype.hasOwnProperty.call(d, p) && (l[p] = d[p]);
        }
        return l;
      }, e.apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.Delete = t.Screen = t.Page = t.Track = t.Identify = t.Group = t.Alias = t.Facade = void 0;
    var n = qe();
    Object.defineProperty(t, "Facade", { enumerable: !0, get: function() {
      return n.Facade;
    } });
    var r = jp();
    Object.defineProperty(t, "Alias", { enumerable: !0, get: function() {
      return r.Alias;
    } });
    var i = Up();
    Object.defineProperty(t, "Group", { enumerable: !0, get: function() {
      return i.Group;
    } });
    var o = sa();
    Object.defineProperty(t, "Identify", { enumerable: !0, get: function() {
      return o.Identify;
    } });
    var s = si();
    Object.defineProperty(t, "Track", { enumerable: !0, get: function() {
      return s.Track;
    } });
    var a = aa();
    Object.defineProperty(t, "Page", { enumerable: !0, get: function() {
      return a.Page;
    } });
    var u = $p();
    Object.defineProperty(t, "Screen", { enumerable: !0, get: function() {
      return u.Screen;
    } });
    var c = Bp();
    Object.defineProperty(t, "Delete", { enumerable: !0, get: function() {
      return c.Delete;
    } }), t.default = e(e({}, n.Facade), {
      Alias: r.Alias,
      Group: i.Group,
      Identify: o.Identify,
      Track: s.Track,
      Page: a.Page,
      Screen: u.Screen,
      Delete: c.Delete
    });
  }(Vt)), Vt;
}
var ne = Gp();
function pn(t, e) {
  var n = new ne.Facade(t, e);
  return t.type === "track" && (n = new ne.Track(t, e)), t.type === "identify" && (n = new ne.Identify(t, e)), t.type === "page" && (n = new ne.Page(t, e)), t.type === "alias" && (n = new ne.Alias(t, e)), t.type === "group" && (n = new ne.Group(t, e)), t.type === "screen" && (n = new ne.Screen(t, e)), Object.defineProperty(n, "obj", {
    value: t,
    writable: !0
  }), n;
}
var qp = function(t) {
  var e = !1;
  window.addEventListener("pagehide", function() {
    e || (e = !0, t(e));
  }), document.addEventListener("visibilitychange", function() {
    if (document.visibilityState == "hidden") {
      if (e)
        return;
      e = !0;
    } else
      e = !1;
    t(e);
  });
}, ua = (
  /** @class */
  function(t) {
    ee(e, t);
    function e(n, r) {
      var i = t.call(this, n) || this;
      return i.retryTimeout = r, i.name = "RateLimitError", i;
    }
    return e;
  }(Error)
), ca = function(t) {
  return I({ "Content-Type": "text/plain" }, typeof t == "function" ? t() : t);
}, Hp = 500, zp = 64;
function ai(t) {
  var e = encodeURI(JSON.stringify(t)).split(/%..|./).length - 1;
  return e / 1024;
}
function Vp(t) {
  return ai(t) >= Hp - 50;
}
function Wp(t) {
  return ai(t) >= zp - 10;
}
function Kp(t) {
  var e = [], n = 0;
  return t.forEach(function(r) {
    var i = ai(e[n]);
    i >= 64 && n++, e[n] ? e[n].push(r) : e[n] = [r];
  }), e;
}
function Jp(t, e) {
  var n, r, i = [], o = !1, s = (n = e == null ? void 0 : e.size) !== null && n !== void 0 ? n : 10, a = (r = e == null ? void 0 : e.timeout) !== null && r !== void 0 ? r : 5e3, u = 0;
  function c(p) {
    var v;
    if (p.length !== 0) {
      var g = (v = p[0]) === null || v === void 0 ? void 0 : v.writeKey, m = p.map(function(_) {
        var C = _;
        C.sentAt;
        var T = js(C, ["sentAt"]);
        return T;
      });
      return In("https://".concat(t, "/b"), {
        credentials: e == null ? void 0 : e.credentials,
        keepalive: (e == null ? void 0 : e.keepalive) || o,
        headers: ca(e == null ? void 0 : e.headers),
        method: "post",
        body: JSON.stringify({
          writeKey: g,
          batch: m,
          sentAt: (/* @__PURE__ */ new Date()).toISOString()
        }),
        // @ts-ignore - not in the ts lib yet
        priority: e == null ? void 0 : e.priority
      }).then(function(_) {
        var C;
        if (_.status >= 500)
          throw new Error("Bad response from server: ".concat(_.status));
        if (_.status === 429) {
          var T = (C = _.headers) === null || C === void 0 ? void 0 : C.get("x-ratelimit-reset"), R = typeof T == "string" ? parseInt(T) * 1e3 : a;
          throw new ua("Rate limit exceeded: ".concat(_.status), R);
        }
      });
    }
  }
  function l(p) {
    var v;
    return p === void 0 && (p = 1), P(this, void 0, void 0, function() {
      var g;
      return F(this, function(m) {
        return i.length ? (g = i, i = [], [2, (v = c(g)) === null || v === void 0 ? void 0 : v.catch(function(_) {
          var C, T = oe.system();
          T.log("error", "Error sending batch", _), p <= ((C = e == null ? void 0 : e.maxRetries) !== null && C !== void 0 ? C : 10) && (_.name === "RateLimitError" && (u = _.retryTimeout), i.push.apply(i, g), i.map(function(R) {
            if ("_metadata" in R) {
              var y = R;
              y._metadata = I(I({}, y._metadata), { retryCount: p });
            }
          }), f(p + 1));
        })]) : [
          2
          /*return*/
        ];
      });
    });
  }
  var d;
  function f(p) {
    p === void 0 && (p = 1), !d && (d = setTimeout(function() {
      d = void 0, l(p).catch(console.error);
    }, u || a), u = 0);
  }
  qp(function(p) {
    if (o = p, o && i.length) {
      var v = Kp(i).map(c);
      Promise.all(v).catch(console.error);
    }
  });
  function h(p, v) {
    return P(this, void 0, void 0, function() {
      var g;
      return F(this, function(m) {
        return i.push(v), g = i.length >= s || Vp(i) || (e == null ? void 0 : e.keepalive) && Wp(i), [2, g || o ? l() : f()];
      });
    });
  }
  return {
    dispatch: h
  };
}
function Yp(t) {
  function e(n, r) {
    return In(n, {
      credentials: t == null ? void 0 : t.credentials,
      keepalive: t == null ? void 0 : t.keepalive,
      headers: ca(t == null ? void 0 : t.headers),
      method: "post",
      body: JSON.stringify(r),
      // @ts-ignore - not in the ts lib yet
      priority: t == null ? void 0 : t.priority
    }).then(function(i) {
      var o;
      if (i.status >= 500)
        throw new Error("Bad response from server: ".concat(i.status));
      if (i.status === 429) {
        var s = (o = i.headers) === null || o === void 0 ? void 0 : o.get("x-ratelimit-reset"), a = s ? parseInt(s) * 1e3 : 5e3;
        throw new ua("Rate limit exceeded: ".concat(i.status), a);
      }
    });
  }
  return {
    dispatch: e
  };
}
function Xp(t, e, n, r, i) {
  var o, s = t.user();
  delete e.options, e.writeKey = n == null ? void 0 : n.apiKey, e.userId = e.userId || s.id(), e.anonymousId = e.anonymousId || s.anonymousId(), e.sentAt = /* @__PURE__ */ new Date();
  var a = t.queue.failedInitializations || [];
  a.length > 0 && (e._metadata = { failedInitializations: a }), i != null && (i.attempts > 1 && (e._metadata = I(I({}, e._metadata), { retryCount: i.attempts })), i.attempts++);
  var u = [], c = [];
  for (var l in r) {
    var d = r[l];
    l === "Segment.io" && u.push(l), d.bundlingStatus === "bundled" && u.push(l), d.bundlingStatus === "unbundled" && c.push(l);
  }
  for (var f = 0, h = (n == null ? void 0 : n.unbundledIntegrations) || []; f < h.length; f++) {
    var p = h[f];
    c.includes(p) || c.push(p);
  }
  var v = (o = n == null ? void 0 : n.maybeBundledConfigIds) !== null && o !== void 0 ? o : {}, g = [];
  return u.sort().forEach(function(m) {
    var _;
    ((_ = v[m]) !== null && _ !== void 0 ? _ : []).forEach(function(C) {
      g.push(C);
    });
  }), (n == null ? void 0 : n.addBundledMetadata) !== !1 && (e._metadata = I(I({}, e._metadata), { bundled: u.sort(), unbundled: c.sort(), bundledIds: g })), e;
}
var la = function(t, e) {
  return P(void 0, void 0, void 0, function() {
    var n;
    return F(this, function(r) {
      return n = function(i) {
        return P(void 0, void 0, void 0, function() {
          var o;
          return F(this, function(s) {
            switch (s.label) {
              case 0:
                return t(i) ? (o = n, [4, e()]) : [3, 2];
              case 1:
                return [2, o.apply(void 0, [s.sent()])];
              case 2:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, [2, n(void 0)];
    });
  });
};
function Qp(t, e) {
  return P(this, void 0, void 0, function() {
    var n, r = this;
    return F(this, function(i) {
      switch (i.label) {
        case 0:
          return n = [], xe() ? [2, e] : [
            4,
            la(function() {
              return e.length > 0 && !xe();
            }, function() {
              return P(r, void 0, void 0, function() {
                var o, s, a;
                return F(this, function(u) {
                  switch (u.label) {
                    case 0:
                      return o = e.pop(), o ? [4, ct(o, t)] : [
                        2
                        /*return*/
                      ];
                    case 1:
                      return s = u.sent(), a = s instanceof oe, a || n.push(o), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            })
            // re-add failed tasks
          ];
        case 1:
          return i.sent(), n.map(function(o) {
            return e.pushWithBackoff(o);
          }), [2, e];
      }
    });
  });
}
function it(t, e, n, r) {
  var i = this;
  t || setTimeout(function() {
    return P(i, void 0, void 0, function() {
      var o, s;
      return F(this, function(a) {
        switch (a.label) {
          case 0:
            return o = !0, [4, Qp(n, e)];
          case 1:
            return s = a.sent(), o = !1, e.todo > 0 && r(o, s, n, r), [
              2
              /*return*/
            ];
        }
      });
    });
  }, Math.random() * 5e3);
}
function Zp(t, e) {
  var n, r, i, o, s = t.user();
  return e.previousId = (i = (r = (n = e.previousId) !== null && n !== void 0 ? n : e.from) !== null && r !== void 0 ? r : s.id()) !== null && i !== void 0 ? i : s.anonymousId(), e.userId = (o = e.userId) !== null && o !== void 0 ? o : e.to, delete e.from, delete e.to, e;
}
var eg = function(t) {
  return t.name === "Segment.io";
};
function tg(t, e, n) {
  var r, i, o;
  window.addEventListener("pagehide", function() {
    a.push.apply(a, Array.from(u)), u.clear();
  });
  var s = (r = e == null ? void 0 : e.apiKey) !== null && r !== void 0 ? r : "", a = t.options.disableClientPersistence ? new An(t.queue.queue.maxAttempts, []) : new Tn(t.queue.queue.maxAttempts, "".concat(s, ":dest-Segment.io")), u = /* @__PURE__ */ new Set(), c = !1, l = (i = e == null ? void 0 : e.apiHost) !== null && i !== void 0 ? i : qs, d = (o = e == null ? void 0 : e.protocol) !== null && o !== void 0 ? o : "https", f = "".concat(d, "://").concat(l), h = e == null ? void 0 : e.deliveryStrategy, p = h && "strategy" in h && h.strategy === "batching" ? Jp(l, h.config) : Yp(h == null ? void 0 : h.config);
  function v(m) {
    return P(this, void 0, void 0, function() {
      var _, C;
      return F(this, function(T) {
        return xe() ? (a.push(m), it(c, a, g, it), [2, m]) : (u.add(m), _ = m.event.type.charAt(0), C = pn(m.event).json(), m.event.type === "track" && delete C.traits, m.event.type === "alias" && (C = Zp(t, C)), a.getAttempts(m) >= a.maxAttempts ? (u.delete(m), [2, m]) : [2, p.dispatch("".concat(f, "/").concat(_), Xp(t, C, e, n, m)).then(function() {
          return m;
        }).catch(function(R) {
          if (m.log("error", "Error sending event", R), R.name === "RateLimitError") {
            var y = R.retryTimeout;
            a.pushWithBackoff(m, y);
          } else
            a.pushWithBackoff(m);
          return it(c, a, g, it), m;
        }).finally(function() {
          u.delete(m);
        })]);
      });
    });
  }
  var g = {
    metadata: {
      writeKey: s,
      apiHost: l,
      protocol: d
    },
    name: "Segment.io",
    type: "destination",
    version: "0.1.0",
    isLoaded: function() {
      return !0;
    },
    load: function() {
      return Promise.resolve();
    },
    track: v,
    identify: v,
    page: v,
    alias: v,
    group: v,
    screen: v
  };
  return a.todo && it(c, a, g, it), g;
}
var _e = "This is being deprecated and will be not be available in future releases of Analytics JS", tr = ti(), nr = tr == null ? void 0 : tr.analytics;
function ng(t, e, n) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var r = e ? 10 : 1, i = n ? new An(r, []) : new Tn(r, t);
  return new pp(i);
}
var rg = (
  /** @class */
  function() {
    function t(e, n) {
      var r;
      this.timeout = 300, this._getSegmentPluginMetadata = function() {
        var o;
        return (o = n.plugins.find(eg)) === null || o === void 0 ? void 0 : o.metadata;
      }, this.writeKey = e.writeKey;
      var i = {
        integrations: {
          "Segment.io": {
            apiKey: ""
          }
        }
      };
      this.cdnSettings = (r = e.cdnSettings) !== null && r !== void 0 ? r : i, this.cdnURL = e.cdnURL;
    }
    return Object.defineProperty(t.prototype, "apiHost", {
      get: function() {
        var e, n;
        return (n = (e = this._getSegmentPluginMetadata) === null || e === void 0 ? void 0 : e.call(this)) === null || n === void 0 ? void 0 : n.apiHost;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }()
);
function se() {
  console.warn(_e);
}
var da = (
  /** @class */
  function(t) {
    ee(e, t);
    function e(n, r, i, o, s) {
      var a = this, u, c;
      a = t.call(this) || this, a._debug = !1, a.initialized = !1, a.user = function() {
        return a._user;
      }, a.init = a.initialize.bind(a), a.log = se, a.addIntegrationMiddleware = se, a.listeners = se, a.addEventListener = se, a.removeAllListeners = se, a.removeListener = se, a.removeEventListener = se, a.hasListeners = se, a.add = se, a.addIntegration = se;
      var l = r == null ? void 0 : r.cookie, d = (u = r == null ? void 0 : r.disableClientPersistence) !== null && u !== void 0 ? u : !1;
      a.queue = i != null ? i : ng("".concat(n.writeKey, ":event-queue"), r == null ? void 0 : r.retryQueue, d), a.settings = new rg(n, a.queue);
      var f = r == null ? void 0 : r.storage;
      return a._universalStorage = a.createStore(d, f, l), a._user = o != null ? o : new ta(I({ persist: !d, storage: r == null ? void 0 : r.storage }, r == null ? void 0 : r.user), l).load(), a._group = s != null ? s : new Sp(I({ persist: !d, storage: r == null ? void 0 : r.storage }, r == null ? void 0 : r.group), l).load(), a.eventFactory = new cp(a._user), a.integrations = (c = r == null ? void 0 : r.integrations) !== null && c !== void 0 ? c : {}, a.options = r != null ? r : {}, ni(a), a;
    }
    return e.prototype.createStore = function(n, r, i) {
      return n ? new Le([new ri()]) : r && Zs(r) ? new Le(Or(ea(r.stores, i))) : new Le(Or([
        Q.LocalStorage,
        {
          name: Q.Cookie,
          settings: i
        },
        Q.Memory
      ]));
    }, Object.defineProperty(e.prototype, "storage", {
      get: function() {
        return this._universalStorage;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.track = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return P(this, void 0, void 0, function() {
        var i, o, s, a, u, c, l, d = this;
        return F(this, function(f) {
          return i = Je(n), o = Yh.apply(void 0, n), s = o[0], a = o[1], u = o[2], c = o[3], l = this.eventFactory.track(s, a, u, this.integrations, i), [2, this._dispatch(l, c).then(function(h) {
            return d.emit("track", s, h.event.properties, h.event.options), h;
          })];
        });
      });
    }, e.prototype.page = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return P(this, void 0, void 0, function() {
        var i, o, s, a, u, c, l, d, f = this;
        return F(this, function(h) {
          return i = Je(n), o = po.apply(void 0, n), s = o[0], a = o[1], u = o[2], c = o[3], l = o[4], d = this.eventFactory.page(s, a, u, c, this.integrations, i), [2, this._dispatch(d, l).then(function(p) {
            return f.emit("page", s, a, p.event.properties, p.event.options), p;
          })];
        });
      });
    }, e.prototype.identify = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return P(this, void 0, void 0, function() {
        var i, o, s, a, u, c, l, d = this;
        return F(this, function(f) {
          return i = Je(n), o = go(this._user).apply(void 0, n), s = o[0], a = o[1], u = o[2], c = o[3], this._user.identify(s, a), l = this.eventFactory.identify(this._user.id(), this._user.traits(), u, this.integrations, i), [2, this._dispatch(l, c).then(function(h) {
            return d.emit("identify", h.event.userId, h.event.traits, h.event.options), h;
          })];
        });
      });
    }, e.prototype.group = function() {
      for (var n = this, r = [], i = 0; i < arguments.length; i++)
        r[i] = arguments[i];
      var o = Je(r);
      if (r.length === 0)
        return this._group;
      var s = go(this._group).apply(void 0, r), a = s[0], u = s[1], c = s[2], l = s[3];
      this._group.identify(a, u);
      var d = this._group.id(), f = this._group.traits(), h = this.eventFactory.group(d, f, c, this.integrations, o);
      return this._dispatch(h, l).then(function(p) {
        return n.emit("group", p.event.groupId, p.event.traits, p.event.options), p;
      });
    }, e.prototype.alias = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return P(this, void 0, void 0, function() {
        var i, o, s, a, u, c, l, d = this;
        return F(this, function(f) {
          return i = Je(n), o = Xh.apply(void 0, n), s = o[0], a = o[1], u = o[2], c = o[3], l = this.eventFactory.alias(s, a, u, this.integrations, i), [2, this._dispatch(l, c).then(function(h) {
            return d.emit("alias", s, a, h.event.options), h;
          })];
        });
      });
    }, e.prototype.screen = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return P(this, void 0, void 0, function() {
        var i, o, s, a, u, c, l, d, f = this;
        return F(this, function(h) {
          return i = Je(n), o = po.apply(void 0, n), s = o[0], a = o[1], u = o[2], c = o[3], l = o[4], d = this.eventFactory.screen(s, a, u, c, this.integrations, i), [2, this._dispatch(d, l).then(function(p) {
            return f.emit("screen", s, a, p.event.properties, p.event.options), p;
          })];
        });
      });
    }, e.prototype.trackClick = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return P(this, void 0, void 0, function() {
        var i, o;
        return F(this, function(s) {
          switch (s.label) {
            case 0:
              return [4, Promise.resolve().then(() => Zt)];
            case 1:
              return i = s.sent(), [2, (o = i.link).call.apply(o, W([this], n, !1))];
          }
        });
      });
    }, e.prototype.trackLink = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return P(this, void 0, void 0, function() {
        var i, o;
        return F(this, function(s) {
          switch (s.label) {
            case 0:
              return [4, Promise.resolve().then(() => Zt)];
            case 1:
              return i = s.sent(), [2, (o = i.link).call.apply(o, W([this], n, !1))];
          }
        });
      });
    }, e.prototype.trackSubmit = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return P(this, void 0, void 0, function() {
        var i, o;
        return F(this, function(s) {
          switch (s.label) {
            case 0:
              return [4, Promise.resolve().then(() => Zt)];
            case 1:
              return i = s.sent(), [2, (o = i.form).call.apply(o, W([this], n, !1))];
          }
        });
      });
    }, e.prototype.trackForm = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return P(this, void 0, void 0, function() {
        var i, o;
        return F(this, function(s) {
          switch (s.label) {
            case 0:
              return [4, Promise.resolve().then(() => Zt)];
            case 1:
              return i = s.sent(), [2, (o = i.form).call.apply(o, W([this], n, !1))];
          }
        });
      });
    }, e.prototype.register = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return P(this, void 0, void 0, function() {
        var i, o, s = this;
        return F(this, function(a) {
          switch (a.label) {
            case 0:
              return i = oe.system(), o = n.map(function(u) {
                return s.queue.register(i, u, s);
              }), [4, Promise.all(o)];
            case 1:
              return a.sent(), [2, i];
          }
        });
      });
    }, e.prototype.deregister = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return P(this, void 0, void 0, function() {
        var i, o, s = this;
        return F(this, function(a) {
          switch (a.label) {
            case 0:
              return i = oe.system(), o = n.map(function(u) {
                var c = s.queue.plugins.find(function(l) {
                  return l.name === u;
                });
                if (c)
                  return s.queue.deregister(i, c, s);
                i.log("warn", "plugin ".concat(u, " not found"));
              }), [4, Promise.all(o)];
            case 1:
              return a.sent(), [2, i];
          }
        });
      });
    }, e.prototype.debug = function(n) {
      return n === !1 && localStorage.getItem("debug") && localStorage.removeItem("debug"), this._debug = n, this;
    }, e.prototype.reset = function() {
      this._user.reset(), this._group.reset(), this.emit("reset");
    }, e.prototype.timeout = function(n) {
      this.settings.timeout = n;
    }, e.prototype._dispatch = function(n, r) {
      return P(this, void 0, void 0, function() {
        var i;
        return F(this, function(o) {
          return i = new oe(n), i.stats.increment("analytics_js.invoke", 1, [n.type]), xe() && !this.options.retryQueue ? [2, i] : [2, Jh(i, this.queue, this, {
            callback: r,
            debug: this._debug,
            timeout: this.settings.timeout
          })];
        });
      });
    }, e.prototype.addSourceMiddleware = function(n) {
      return P(this, void 0, void 0, function() {
        var r = this;
        return F(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.queue.criticalTasks.run(function() {
                return P(r, void 0, void 0, function() {
                  var o, s, a;
                  return F(this, function(u) {
                    switch (u.label) {
                      case 0:
                        return [4, Promise.resolve().then(() => _g)];
                      case 1:
                        return o = u.sent().sourceMiddlewarePlugin, s = {}, this.queue.plugins.forEach(function(c) {
                          if (c.type === "destination")
                            return s[c.name] = !0;
                        }), a = o(n, s), [4, this.register(a)];
                      case 2:
                        return u.sent(), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              })];
            case 1:
              return i.sent(), [2, this];
          }
        });
      });
    }, e.prototype.addDestinationMiddleware = function(n) {
      for (var r = [], i = 1; i < arguments.length; i++)
        r[i - 1] = arguments[i];
      return this.queue.plugins.filter(lp).forEach(function(o) {
        (n === "*" || o.name.toLowerCase() === n.toLowerCase()) && o.addMiddleware.apply(o, r);
      }), Promise.resolve(this);
    }, e.prototype.setAnonymousId = function(n) {
      return this._user.anonymousId(n);
    }, e.prototype.queryString = function(n) {
      return P(this, void 0, void 0, function() {
        var r;
        return F(this, function(i) {
          switch (i.label) {
            case 0:
              return this.options.useQueryString === !1 ? [2, []] : [4, Promise.resolve().then(() => Hg)];
            case 1:
              return r = i.sent().queryString, [2, r(this, n)];
          }
        });
      });
    }, e.prototype.use = function(n) {
      return n(this), this;
    }, e.prototype.ready = function(n) {
      return n === void 0 && (n = function(r) {
        return r;
      }), P(this, void 0, void 0, function() {
        return F(this, function(r) {
          return [2, Promise.all(this.queue.plugins.map(function(i) {
            return i.ready ? i.ready() : Promise.resolve();
          })).then(function(i) {
            return n(i), i;
          })];
        });
      });
    }, e.prototype.noConflict = function() {
      return console.warn(_e), Ep(nr != null ? nr : this), this;
    }, e.prototype.normalize = function(n) {
      return console.warn(_e), this.eventFactory.normalize(n);
    }, Object.defineProperty(e.prototype, "failedInitializations", {
      get: function() {
        return console.warn(_e), this.queue.failedInitializations;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "VERSION", {
      get: function() {
        return Cn;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.initialize = function(n, r) {
      return P(this, void 0, void 0, function() {
        return F(this, function(i) {
          return console.warn(_e), [2, Promise.resolve(this)];
        });
      });
    }, e.prototype.pageview = function(n) {
      return P(this, void 0, void 0, function() {
        return F(this, function(r) {
          switch (r.label) {
            case 0:
              return console.warn(_e), [4, this.page({ path: n })];
            case 1:
              return r.sent(), [2, this];
          }
        });
      });
    }, Object.defineProperty(e.prototype, "plugins", {
      get: function() {
        var n;
        return console.warn(_e), (n = this._plugins) !== null && n !== void 0 ? n : {};
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "Integrations", {
      get: function() {
        console.warn(_e);
        var n = this.queue.plugins.filter(function(r) {
          return r.type === "destination";
        }).reduce(function(r, i) {
          var o = "".concat(i.name.toLowerCase().replace(".", "").split(" ").join("-"), "Integration"), s = window[o];
          if (!s)
            return r;
          var a = s.Integration;
          return a ? (r[i.name] = a, r) : (r[i.name] = s, r);
        }, {});
        return n;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.push = function(n) {
      var r = this, i = n.shift();
      i && !r[i] || r[i].apply(this, n);
    }, e;
  }(Qr)
), jo = (
  /** @class */
  function(t) {
    ee(e, t);
    function e() {
      var n = t.call(this, { writeKey: "" }, { disableClientPersistence: !0 }) || this;
      return n.initialized = !0, n;
    }
    return e;
  }(da)
);
function fa() {
  return typeof process == "undefined" || !process.env ? {} : process.env;
}
var ig = /(https:\/\/.*)\/analytics\.js\/v1\/(?:.*?)\/(?:platform|analytics.*)?/, og = function() {
  var t, e = Array.prototype.slice.call(document.querySelectorAll("script"));
  return e.forEach(function(n) {
    var r, i = (r = n.getAttribute("src")) !== null && r !== void 0 ? r : "", o = ig.exec(i);
    o && o[1] && (t = o[1]);
  }), t;
}, sn, sg = function() {
  var t, e = sn != null ? sn : (t = na()) === null || t === void 0 ? void 0 : t._cdn;
  return e;
}, ag = function(t) {
  var e = na();
  e && (e._cdn = t), sn = t;
}, ui = function() {
  var t = sg();
  if (t)
    return t;
  var e = og();
  return e || "https://cdn.segment.com";
}, ci = function() {
  var t = ui();
  return "".concat(t, "/next-integrations");
};
function ha(t, e) {
  var n, r = Object.entries((n = e.integrations) !== null && n !== void 0 ? n : {}).reduce(function(i, o) {
    var s, a, u = o[0], c = o[1];
    return typeof c == "object" ? I(I({}, i), (s = {}, s[u] = c, s)) : I(I({}, i), (a = {}, a[u] = {}, a));
  }, {});
  return Object.entries(t.integrations).reduce(function(i, o) {
    var s, a = o[0], u = o[1];
    return I(I({}, i), (s = {}, s[a] = I(I({}, u), r[a]), s));
  }, {});
}
function pa(t) {
  try {
    return decodeURIComponent(t.replace(/\+/g, " "));
  } catch (e) {
    return t;
  }
}
function ug(t) {
  return P(this, void 0, void 0, function() {
    var e;
    return F(this, function(n) {
      return e = navigator.userAgentData, e ? t ? [2, e.getHighEntropyValues(t).catch(function() {
        return e.toJSON();
      })] : [2, e.toJSON()] : [2, void 0];
    });
  });
}
var Et;
function cg() {
  if (Et)
    return Et;
  var t = Xs(window.location.href);
  return Et = {
    expires: 31536e6,
    secure: !1,
    path: "/"
  }, t && (Et.domain = t), Et;
}
function lg(t) {
  var e = {
    btid: "dataxu",
    urid: "millennial-media"
  };
  t.startsWith("?") && (t = t.substring(1)), t = t.replace(/\?/g, "&");
  for (var n = t.split("&"), r = 0, i = n; r < i.length; r++) {
    var o = i[r], s = o.split("="), a = s[0], u = s[1];
    if (e[a])
      return {
        id: u,
        type: e[a]
      };
  }
}
function dg(t) {
  return t.startsWith("?") && (t = t.substring(1)), t = t.replace(/\?/g, "&"), t.split("&").reduce(function(e, n) {
    var r = n.split("="), i = r[0], o = r[1], s = o === void 0 ? "" : o;
    if (i.includes("utm_") && i.length > 4) {
      var a = i.slice(4);
      a === "campaign" && (a = "name"), e[a] = pa(s);
    }
    return e;
  }, {});
}
function fg() {
  var t = he.get("_ga");
  if (t && t.startsWith("amp"))
    return t;
}
function hg(t, e, n) {
  var r, i = new Le(n ? [] : [new Qs(cg())]), o = i.get("s:context.referrer"), s = (r = lg(t)) !== null && r !== void 0 ? r : o;
  s && (e && (e.referrer = I(I({}, e.referrer), s)), i.set("s:context.referrer", s));
}
var pg = function(t) {
  try {
    var e = new URLSearchParams();
    return Object.entries(t).forEach(function(n) {
      var r = n[0], i = n[1];
      Array.isArray(i) ? i.forEach(function(o) {
        return e.append(r, o);
      }) : e.append(r, i);
    }), e.toString();
  } catch (n) {
    return "";
  }
}, gg = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
      var e = this;
      this.name = "Page Enrichment", this.type = "before", this.version = "0.1.0", this.isLoaded = function() {
        return !0;
      }, this.load = function(n, r) {
        return P(e, void 0, void 0, function() {
          var i;
          return F(this, function(o) {
            switch (o.label) {
              case 0:
                this.instance = r, o.label = 1;
              case 1:
                return o.trys.push([1, 3, , 4]), i = this, [4, ug(this.instance.options.highEntropyValuesClientHints)];
              case 2:
                return i.userAgentData = o.sent(), [3, 4];
              case 3:
                return o.sent(), [3, 4];
              case 4:
                return [2, Promise.resolve()];
            }
          });
        });
      }, this.enrich = function(n) {
        var r, i, o = n.event.context, s = o.page.search || "", a = typeof s == "object" ? pg(s) : s;
        o.userAgent = navigator.userAgent, o.userAgentData = e.userAgentData;
        var u = navigator.userLanguage || navigator.language;
        typeof o.locale == "undefined" && typeof u != "undefined" && (o.locale = u), (r = o.library) !== null && r !== void 0 || (o.library = {
          name: "analytics.js",
          version: "".concat("npm:next", "-").concat(Cn)
        }), a && !o.campaign && (o.campaign = dg(a));
        var c = fg();
        c && (o.amp = { id: c }), hg(a, o, (i = e.instance.options.disableClientPersistence) !== null && i !== void 0 ? i : !1);
        try {
          o.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        } catch (l) {
        }
        return n;
      }, this.track = this.enrich, this.identify = this.enrich, this.page = this.enrich, this.group = this.enrich, this.alias = this.enrich, this.screen = this.enrich;
    }
    return t;
  }()
), yg = new gg();
function ga(t) {
  var e = Array.prototype.slice.call(window.document.querySelectorAll("script"));
  return e.find(function(n) {
    return n.src === t;
  });
}
function lt(t, e) {
  var n = ga(t);
  if (n !== void 0) {
    var r = n == null ? void 0 : n.getAttribute("status");
    if (r === "loaded")
      return Promise.resolve(n);
    if (r === "loading")
      return new Promise(function(i, o) {
        n.addEventListener("load", function() {
          return i(n);
        }), n.addEventListener("error", function(s) {
          return o(s);
        });
      });
  }
  return new Promise(function(i, o) {
    var s, a = window.document.createElement("script");
    a.type = "text/javascript", a.src = t, a.async = !0, a.setAttribute("status", "loading");
    for (var u = 0, c = Object.entries({}); u < c.length; u++) {
      var l = c[u], d = l[0], f = l[1];
      a.setAttribute(d, f);
    }
    a.onload = function() {
      a.onerror = a.onload = null, a.setAttribute("status", "loaded"), i(a);
    }, a.onerror = function() {
      a.onerror = a.onload = null, a.setAttribute("status", "error"), o(new Error("Failed to load ".concat(t)));
    };
    var h = window.document.querySelector("script");
    h ? (s = h.parentElement) === null || s === void 0 || s.insertBefore(a, h) : window.document.head.appendChild(a);
  });
}
function mg(t) {
  var e = ga(t);
  return e !== void 0 && e.remove(), Promise.resolve();
}
function li(t, e, n) {
  return P(this, void 0, void 0, function() {
    function r(c, l) {
      return P(this, void 0, void 0, function() {
        var d, f, h;
        return F(this, function(p) {
          switch (p.label) {
            case 0:
              return d = !1, f = null, [4, l({
                payload: pn(c, {
                  clone: !0,
                  traverse: !1
                }),
                integration: t,
                next: function(v) {
                  d = !0, v === null && (f = null), v && (f = v.obj);
                }
              })];
            case 1:
              return p.sent(), !d && f !== null && (f = f, f.integrations = I(I({}, c.integrations), (h = {}, h[t] = !1, h))), [2, f];
          }
        });
      });
    }
    var i, o, s, a, u;
    return F(this, function(c) {
      switch (c.label) {
        case 0:
          i = pn(e, {
            clone: !0,
            traverse: !1
          }).rawEvent(), o = 0, s = n, c.label = 1;
        case 1:
          return o < s.length ? (a = s[o], [4, r(i, a)]) : [3, 4];
        case 2:
          if (u = c.sent(), u === null)
            return [2, null];
          i = u, c.label = 3;
        case 3:
          return o++, [3, 1];
        case 4:
          return [2, i];
      }
    });
  });
}
function vg(t, e) {
  function n(r) {
    return P(this, void 0, void 0, function() {
      var i;
      return F(this, function(o) {
        switch (o.label) {
          case 0:
            return i = !1, [4, t({
              payload: pn(r.event, {
                clone: !0,
                traverse: !1
              }),
              integrations: e != null ? e : {},
              next: function(s) {
                i = !0, s && (r.event = s.obj);
              }
            })];
          case 1:
            if (o.sent(), !i)
              throw new ke({
                retry: !1,
                type: "middleware_cancellation",
                reason: "Middleware `next` function skipped"
              });
            return [2, r];
        }
      });
    });
  }
  return {
    name: "Source Middleware ".concat(t.name),
    type: "before",
    version: "0.1.0",
    isLoaded: function() {
      return !0;
    },
    load: function(r) {
      return Promise.resolve(r);
    },
    track: n,
    page: n,
    screen: n,
    identify: n,
    alias: n,
    group: n
  };
}
const _g = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  applyDestinationMiddleware: li,
  sourceMiddlewarePlugin: vg
}, Symbol.toStringTag, { value: "Module" }));
function ae(t, e) {
  var n = e.methodName, r = e.integrationName, i = e.type, o = e.didError, s = o === void 0 ? !1 : o;
  t.stats.increment("analytics_js.integration.invoke".concat(s ? ".error" : ""), 1, [
    "method:".concat(n),
    "integration_name:".concat(r),
    "type:".concat(i)
  ]);
}
var bg = (
  /** @class */
  function() {
    function t(e, n) {
      this.version = "1.0.0", this.alternativeNames = [], this.loadPromise = Xr(), this.middleware = [], this.alias = this._createMethod("alias"), this.group = this._createMethod("group"), this.identify = this._createMethod("identify"), this.page = this._createMethod("page"), this.screen = this._createMethod("screen"), this.track = this._createMethod("track"), this.action = n, this.name = e, this.type = n.type, this.alternativeNames.push(n.name);
    }
    return t.prototype.addMiddleware = function() {
      for (var e, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      this.type === "destination" && (e = this.middleware).push.apply(e, n);
    }, t.prototype.transform = function(e) {
      return P(this, void 0, void 0, function() {
        var n;
        return F(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, li(this.name, e.event, this.middleware)];
            case 1:
              return n = r.sent(), n === null && e.cancel(new ke({
                retry: !1,
                reason: "dropped by destination middleware"
              })), [2, new oe(n)];
          }
        });
      });
    }, t.prototype._createMethod = function(e) {
      var n = this;
      return function(r) {
        return P(n, void 0, void 0, function() {
          var i, o;
          return F(this, function(s) {
            switch (s.label) {
              case 0:
                return this.action[e] ? (i = r, this.type !== "destination" ? [3, 2] : [4, this.transform(r)]) : [2, r];
              case 1:
                i = s.sent(), s.label = 2;
              case 2:
                return s.trys.push([2, 5, , 6]), [4, this.ready()];
              case 3:
                if (!s.sent())
                  throw new Error("Something prevented the destination from getting ready");
                return ae(r, {
                  integrationName: this.action.name,
                  methodName: e,
                  type: "action"
                }), [4, this.action[e](i)];
              case 4:
                return s.sent(), [3, 6];
              case 5:
                throw o = s.sent(), ae(r, {
                  integrationName: this.action.name,
                  methodName: e,
                  type: "action",
                  didError: !0
                }), o;
              case 6:
                return [2, r];
            }
          });
        });
      };
    }, t.prototype.isLoaded = function() {
      return this.action.isLoaded();
    }, t.prototype.ready = function() {
      return P(this, void 0, void 0, function() {
        return F(this, function(e) {
          switch (e.label) {
            case 0:
              return e.trys.push([0, 2, , 3]), [4, this.loadPromise.promise];
            case 1:
              return e.sent(), [2, !0];
            case 2:
              return e.sent(), [2, !1];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.load = function(e, n) {
      return P(this, void 0, void 0, function() {
        var r, i, o, s;
        return F(this, function(a) {
          switch (a.label) {
            case 0:
              if (this.loadPromise.isSettled())
                return [2, this.loadPromise.promise];
              a.label = 1;
            case 1:
              return a.trys.push([1, 3, , 4]), ae(e, {
                integrationName: this.action.name,
                methodName: "load",
                type: "action"
              }), r = this.action.load(e, n), o = (i = this.loadPromise).resolve, [4, r];
            case 2:
              return o.apply(i, [a.sent()]), [2, r];
            case 3:
              throw s = a.sent(), ae(e, {
                integrationName: this.action.name,
                methodName: "load",
                type: "action",
                didError: !0
              }), this.loadPromise.reject(s), s;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.unload = function(e, n) {
      var r, i;
      return (i = (r = this.action).unload) === null || i === void 0 ? void 0 : i.call(r, e, n);
    }, t;
  }()
);
function Sg(t) {
  if (!Array.isArray(t))
    throw new Error("Not a valid list of plugins");
  var e = ["load", "isLoaded", "name", "version", "type"];
  return t.forEach(function(n) {
    e.forEach(function(r) {
      var i;
      if (n[r] === void 0)
        throw new Error("Plugin: ".concat((i = n.name) !== null && i !== void 0 ? i : "unknown", " missing required function ").concat(r));
    });
  }), !0;
}
function wg(t, e) {
  var n = t[e.creationName], r = t[e.name];
  return t.All === !1 && !n && !r || n === !1 || r === !1;
}
function Eg(t, e) {
  return P(this, void 0, void 0, function() {
    var n, r, i, o, s, a;
    return F(this, function(u) {
      switch (u.label) {
        case 0:
          if (u.trys.push([0, 9, , 10]), n = new RegExp("https://cdn.segment.(com|build)"), r = ui(), !e) return [3, 6];
          i = t.url.split("/"), o = i[i.length - 2], s = t.url.replace(o, btoa(o).replace(/=/g, "")), u.label = 1;
        case 1:
          return u.trys.push([1, 3, , 5]), [4, lt(s.replace(n, r))];
        case 2:
          return u.sent(), [3, 5];
        case 3:
          return u.sent(), [4, lt(t.url.replace(n, r))];
        case 4:
          return u.sent(), [3, 5];
        case 5:
          return [3, 8];
        case 6:
          return [4, lt(t.url.replace(n, r))];
        case 7:
          u.sent(), u.label = 8;
        case 8:
          return typeof window[t.libraryName] == "function" ? [2, window[t.libraryName]] : [3, 10];
        case 9:
          throw a = u.sent(), console.error("Failed to create PluginFactory", t), a;
        case 10:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function kg(t, e, n, r, i, o) {
  var s, a, u;
  return P(this, void 0, void 0, function() {
    var c, l, d, f = this;
    return F(this, function(h) {
      switch (h.label) {
        case 0:
          return c = [], l = (a = (s = t.middlewareSettings) === null || s === void 0 ? void 0 : s.routingRules) !== null && a !== void 0 ? a : [], d = ((u = t.remotePlugins) !== null && u !== void 0 ? u : []).map(function(p) {
            return P(f, void 0, void 0, function() {
              var v, g, m, _, C, T, R;
              return F(this, function(y) {
                switch (y.label) {
                  case 0:
                    if (wg(e, p))
                      return [
                        2
                        /*return*/
                      ];
                    y.label = 1;
                  case 1:
                    return y.trys.push([1, 6, , 7]), g = o == null ? void 0 : o.find(function(b) {
                      var A = b.pluginName;
                      return A === p.name;
                    }), g ? [3, 3] : [4, Eg(p, r == null ? void 0 : r.obfuscate)];
                  case 2:
                    g = y.sent(), y.label = 3;
                  case 3:
                    return v = g, v ? (m = n[p.name], [4, v(I(I({}, p.settings), m))]) : [3, 5];
                  case 4:
                    _ = y.sent(), C = Array.isArray(_) ? _ : [_], Sg(C), T = l.filter(function(b) {
                      return b.destinationName === p.creationName;
                    }), C.forEach(function(b) {
                      var A = new bg(p.creationName, b);
                      T.length && i && A.addMiddleware(i), c.push(A);
                    }), y.label = 5;
                  case 5:
                    return [3, 7];
                  case 6:
                    return R = y.sent(), console.warn("Failed to load Remote Plugin", R), ae(oe.system(), {
                      integrationName: p.name,
                      methodName: "load",
                      type: "action",
                      didError: !0
                    }), [3, 7];
                  case 7:
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          }), [4, Promise.all(d)];
        case 1:
          return h.sent(), [2, c.filter(Boolean)];
      }
    });
  });
}
var rr, Uo, xg = ti(), $o = (rr = (Uo = xg).__SEGMENT_INSPECTOR__) !== null && rr !== void 0 ? rr : Uo.__SEGMENT_INSPECTOR__ = {}, Ag = function(t) {
  var e;
  return (e = $o.attach) === null || e === void 0 ? void 0 : e.call($o, t);
};
function Ig(t, e) {
  return In("".concat(e, "/v1/projects/").concat(t, "/settings")).then(function(n) {
    return n.ok ? n.json() : n.text().then(function(r) {
      throw new Error(r);
    });
  }).catch(function(n) {
    throw console.error(n.message), n;
  });
}
function Cg(t) {
  return fa().NODE_ENV !== "test" && // just one integration means segmentio
  Object.keys(t.integrations).length > 1;
}
function Tg(t) {
  var e, n, r;
  return fa().NODE_ENV !== "test" && ((r = (n = (e = t.middlewareSettings) === null || e === void 0 ? void 0 : e.routingRules) === null || n === void 0 ? void 0 : n.length) !== null && r !== void 0 ? r : 0) > 0;
}
function Og(t, e) {
  Cp(t, e), Ip(t, e);
}
function Rg(t, e, n) {
  return P(this, void 0, void 0, function() {
    return F(this, function(r) {
      switch (r.label) {
        case 0:
          return [4, Pg(t, e)];
        case 1:
          return r.sent(), Tp(t, n), [
            2
            /*return*/
          ];
      }
    });
  });
}
var Dg = function() {
  var t, e, n = (t = window.location.hash) !== null && t !== void 0 ? t : "", r = (e = window.location.search) !== null && e !== void 0 ? e : "", i = r.length ? r : n.replace(/(?=#).*(?=\?)/, "");
  return i;
}, Pg = function(t, e) {
  return P(void 0, void 0, void 0, function() {
    return F(this, function(n) {
      switch (n.label) {
        case 0:
          return e.includes("ajs_") ? [4, t.queryString(e).catch(console.error)] : [3, 2];
        case 1:
          n.sent(), n.label = 2;
        case 2:
          return [
            2
            /*return*/
          ];
      }
    });
  });
};
function Fg(t, e, n, r, i, o, s) {
  var a, u, c;
  return i === void 0 && (i = []), P(this, void 0, void 0, function() {
    var l, d, f, h, p, v, g, m, _, C, T, R, y, b, A, S = this;
    return F(this, function(x) {
      switch (x.label) {
        case 0:
          return Og(n, s), l = i == null ? void 0 : i.filter(function(k) {
            return typeof k == "object";
          }), d = i == null ? void 0 : i.filter(function(k) {
            return typeof k == "function" && typeof k.pluginName == "string";
          }), Tg(e) ? [4, Promise.resolve().then(() => Wg).then(function(k) {
            return k.tsubMiddleware(e.middlewareSettings.routingRules);
          })] : [3, 2];
        case 1:
          return h = x.sent(), [3, 3];
        case 2:
          h = void 0, x.label = 3;
        case 3:
          return f = h, Cg(e) || o.length > 0 ? [4, Promise.resolve().then(() => iy).then(function(k) {
            return k.ajsDestinations(t, e, n.integrations, r, f, o);
          })] : [3, 5];
        case 4:
          return v = x.sent(), [3, 6];
        case 5:
          v = [], x.label = 6;
        case 6:
          return p = v, e.legacyVideoPluginsEnabled ? [4, Promise.resolve().then(() => sy).then(function(k) {
            return k.loadLegacyVideoPlugins(n);
          })] : [3, 8];
        case 7:
          x.sent(), x.label = 8;
        case 8:
          return !((a = r.plan) === null || a === void 0) && a.track ? [4, Promise.resolve().then(() => cy).then(function(k) {
            var D;
            return k.schemaFilter((D = r.plan) === null || D === void 0 ? void 0 : D.track, e);
          })] : [3, 10];
        case 9:
          return m = x.sent(), [3, 11];
        case 10:
          m = void 0, x.label = 11;
        case 11:
          return g = m, _ = ha(e, r), [4, kg(e, n.integrations, _, r, f, d).catch(function(k) {
            return console.error("Failed to load remote plugins", k), [];
          })];
        case 12:
          return C = x.sent(), T = W(W([yg], p, !0), C, !0), g && T.push(g), R = ((u = r.integrations) === null || u === void 0 ? void 0 : u.All) === !1 && !r.integrations["Segment.io"] || r.integrations && r.integrations["Segment.io"] === !1, R ? [3, 14] : (b = (y = T).push, [4, tg(n, _["Segment.io"], e.integrations)]);
        case 13:
          b.apply(y, [x.sent()]), x.label = 14;
        case 14:
          return [4, n.register.apply(n, W(W([], T, !1), l, !1))];
        case 15:
          return A = x.sent(), [4, Ap(n, s)];
        case 16:
          return x.sent(), Object.entries((c = e.enabledMiddleware) !== null && c !== void 0 ? c : {}).some(function(k) {
            var D = k[1];
            return D;
          }) ? [4, Promise.resolve().then(() => dy).then(function(k) {
            var D = k.remoteMiddlewares;
            return P(S, void 0, void 0, function() {
              var E, L;
              return F(this, function(U) {
                switch (U.label) {
                  case 0:
                    return [4, D(A, e, r.obfuscate)];
                  case 1:
                    return E = U.sent(), L = E.map(function(q) {
                      return n.addSourceMiddleware(q);
                    }), [2, Promise.all(L)];
                }
              });
            });
          })] : [3, 18];
        case 17:
          x.sent(), x.label = 18;
        case 18:
          return [4, xp(n, s)];
        case 19:
          return x.sent(), [2, A];
      }
    });
  });
}
function Lg(t, e, n) {
  var r, i, o, s, a, u, c, l, d;
  return e === void 0 && (e = {}), P(this, void 0, void 0, function() {
    var f, h, p, v, g, m, _, C, T, R, y;
    return F(this, function(b) {
      switch (b.label) {
        case 0:
          return e.disable === !0 ? [2, [new jo(), oe.system()]] : (e.globalAnalyticsKey && wp(e.globalAnalyticsKey), t.cdnURL && ag(t.cdnURL), e.initialPageview && n.add(new Rr("page", [])), f = Dg(), h = (r = t.cdnURL) !== null && r !== void 0 ? r : ui(), (i = t.cdnSettings) !== null && i !== void 0 ? (v = i, [3, 3]) : [3, 1]);
        case 1:
          return [4, Ig(t.writeKey, h)];
        case 2:
          v = b.sent(), b.label = 3;
        case 3:
          return p = v, e.updateCDNSettings && (p = e.updateCDNSettings(p)), typeof e.disable != "function" ? [3, 5] : [4, e.disable(p)];
        case 4:
          if (g = b.sent(), g)
            return [2, [new jo(), oe.system()]];
          b.label = 5;
        case 5:
          return m = (s = (o = p.integrations["Segment.io"]) === null || o === void 0 ? void 0 : o.retryQueue) !== null && s !== void 0 ? s : !0, e = I({ retryQueue: m }, e), _ = new da(I(I({}, t), { cdnSettings: p, cdnURL: h }), e), Ag(_), C = (a = t.plugins) !== null && a !== void 0 ? a : [], T = (u = t.classicIntegrations) !== null && u !== void 0 ? u : [], R = (c = e.integrations) === null || c === void 0 ? void 0 : c["Segment.io"], Hs.initRemoteMetrics(I(I({}, p.metrics), { host: (l = R == null ? void 0 : R.apiHost) !== null && l !== void 0 ? l : (d = p.metrics) === null || d === void 0 ? void 0 : d.host, protocol: R == null ? void 0 : R.protocol })), [4, Fg(t.writeKey, p, _, e, C, T, n)];
        case 6:
          return y = b.sent(), _.initialized = !0, _.emit("initialize", t, e), [4, Rg(_, f, n)];
        case 7:
          return b.sent(), [2, [_, y]];
      }
    });
  });
}
var Ng = (
  /** @class */
  function(t) {
    ee(e, t);
    function e() {
      var n = this, r = Xr(), i = r.promise, o = r.resolve;
      return n = t.call(this, function(s) {
        return i.then(function(a) {
          var u = a[0], c = a[1];
          return Lg(u, c, s);
        });
      }) || this, n._resolveLoadStart = function(s, a) {
        return o([s, a]);
      }, n;
    }
    return e.prototype.load = function(n, r) {
      return r === void 0 && (r = {}), this._resolveLoadStart(n, r), this;
    }, e.load = function(n, r) {
      return r === void 0 && (r = {}), new e().load(n, r);
    }, e.standalone = function(n, r) {
      return e.load({ writeKey: n }, r).then(function(i) {
        return i[0];
      });
    }, e;
  }(Rp)
);
const gn = class gn {
  constructor(e) {
    O(this, "segmentAnalytics");
    O(this, "writeKey");
    O(this, "isAnalyticsActive");
    O(this, "debugTrack");
    O(this, "version");
    O(this, "cid");
    O(this, "session_id");
    O(this, "product_name");
    O(this, "appmetrica_device_id");
    O(this, "external_id");
    O(this, "is_popup");
    O(this, "onError");
    O(this, "trackingReceiverUrl");
    O(this, "timedelta");
    O(this, "timedeltaReadyPromise");
    O(this, "resolveTimedeltaReady");
    this.trackingReceiverUrl = e.trackingReceiverUrl, this.writeKey = e.writeKey, this.isAnalyticsActive = e.isAnalyticsActive || !1, this.debugTrack = e.debugTrack, this.version = e.version, this.cid = e.cid, this.session_id = e.session_id, this.product_name = e.product_name, this.appmetrica_device_id = e.appmetrica_device_id, this.external_id = e.external_id, this.is_popup = e.is_popup || !1, this.onError = e.onError, this.timedelta = e.timedelta, this.initTimedeltaReadyState(), this.isAnalyticsActive && this.initAnalytics();
  }
  initAnalytics() {
    this.segmentAnalytics = Ng.load(
      {
        writeKey: this.writeKey,
        cdnURL: this.trackingReceiverUrl
      },
      {
        updateCDNSettings: (e) => {
          var i, o, s, a, u;
          const n = (i = e == null ? void 0 : e.metrics) == null ? void 0 : i.host, r = (s = (o = e == null ? void 0 : e.metrics) == null ? void 0 : o.protocol) != null ? s : "https";
          if (!n) return e;
          try {
            const c = new URL(`${r}://${n}`).searchParams.get("session"), l = Number(c);
            Number.isFinite(l) && (this.timedelta = Date.now() - l, (a = this.resolveTimedeltaReady) == null || a.call(this));
          } catch (c) {
            (u = this.onError) == null || u.call(this, c, "segment updateCDNSettings");
          }
          return e;
        }
      }
    );
  }
  updateConfig(e) {
    var n;
    e.isAnalyticsActive !== void 0 && (this.isAnalyticsActive = e.isAnalyticsActive, e.isAnalyticsActive && !this.segmentAnalytics && this.initAnalytics()), Object.keys(e).forEach((r) => {
      r !== "isAnalyticsActive" && r in this && (this[r] = e[r]);
    }), e.timedelta !== void 0 && ((n = this.resolveTimedeltaReady) == null || n.call(this));
  }
  initTimedeltaReadyState() {
    var e;
    this.timedeltaReadyPromise = new Promise((n) => {
      this.resolveTimedeltaReady = n;
    }), this.timedelta !== void 0 && ((e = this.resolveTimedeltaReady) == null || e.call(this));
  }
  waitForTimedelta(e) {
    return M(this, null, function* () {
      e._timedelta !== void 0 || this.timedelta !== void 0 || (yield Promise.race([
        this.timedeltaReadyPromise,
        new Promise((n) => setTimeout(n, gn.TIMEDELTA_WAIT_TIMEOUT_MS))
      ]));
    });
  }
  buildEventFromConfig(e, n) {
    return j(w({
      name: e.name,
      event_category: "auth",
      event_action: e.event_action,
      event_label: e.event_label,
      event_name: e.event_name,
      screen_size: `${window.innerWidth}x${window.innerHeight}`,
      event_timestamp: `${cr()}`,
      event_timezone: Yo(),
      page_url: window.location.origin + window.location.pathname,
      screen_name: window.location.pathname,
      event_group: "event",
      event_element_location: "webview",
      touch_point: "web",
      cid: this.cid,
      session_id: this.session_id,
      product_name: this.product_name,
      appmetrica_device_id: this.appmetrica_device_id,
      sf: !0,
      client: this.writeKey,
      user_agent: at(),
      ver: st,
      sdk: this.version,
      external_id: this.external_id,
      popup: this.is_popup
    }, n), {
      _timedelta: this.timedelta
    });
  }
  buildDebugEventFromConfig(e, n) {
    return j(w({
      name: e.name,
      event_category: "auth",
      event_action: e.event_action,
      event_label: e.event_label,
      event_name: e.event_name,
      event_group: "event",
      event_timestamp: `${cr()}`,
      user_agent: at(),
      ver: st,
      sdk: this.version,
      cid: this.cid,
      session_id: this.session_id,
      product_name: this.product_name,
      appmetrica_device_id: this.appmetrica_device_id,
      external_id: this.external_id,
      popup: this.is_popup
    }, n), {
      _timedelta: this.timedelta
    });
  }
  sendEvent(e, n) {
    return M(this, null, function* () {
      if (!this.segmentAnalytics) return;
      yield this.waitForTimedelta(e);
      const { name: r } = e, i = r;
      yield new Promise((o) => {
        var s, a;
        (a = this.segmentAnalytics) == null || a.track(
          `sdk-${i}`,
          j(w({}, e), {
            user_agent: e.user_agent || at(),
            ver: st,
            sdk: this.version,
            _timedelta: (s = e._timedelta) != null ? s : this.timedelta
          }),
          {
            traits: { writeKey: this.writeKey }
          },
          () => o()
        );
      });
    });
  }
  /**
   * Отправляет отладочное аналитическое событие
   * @param event - объект события со всеми параметрами
   * @param isError - флаг ошибки
   */
  sendDebugEvent(e, n, r) {
    return M(this, null, function* () {
      var a;
      if (!this.debugTrack || !this.isAnalyticsActive || !this.segmentAnalytics) return;
      yield this.waitForTimedelta(e);
      const { sid: i, name: o } = e;
      if (!i) return;
      const s = o;
      try {
        const u = j(w({}, e), {
          user_agent: e.user_agent || at(),
          ver: st,
          sdk: this.version,
          _timedelta: (a = e._timedelta) != null ? a : this.timedelta
        });
        yield this.segmentAnalytics.track(
          `sdk-${s}`,
          u,
          {
            traits: { writeKey: this.writeKey }
          }
        );
      } catch (u) {
        this.onError && this.onError(u, r || "trackingReceiverDebugEvent");
      }
    });
  }
};
O(gn, "TIMEDELTA_WAIT_TIMEOUT_MS", 500);
let Dr = gn;
class Mg {
  constructor(e) {
    O(this, "sentryReporter");
    O(this, "goyaReporter");
    O(this, "trackingReceiverReporter");
    e.sentry && (this.sentryReporter = new wh(e.sentry)), e.goya && (this.goyaReporter = new Eh(j(w({}, e.goya), {
      onError: (n) => {
        this.sendErrorToSentry(n, "goyaEvent");
      }
    }))), e.trackingReceiver && (this.trackingReceiverReporter = new Dr(j(w({}, e.trackingReceiver), {
      onError: (n, r) => this.sendErrorToSentry(n, r)
    })));
  }
  sendErrorToSentry(e, n, r) {
    var i;
    (i = this.sentryReporter) == null || i.sendErrorToSentry(e, n, r);
  }
  sendMessageToSentry(e, n, r) {
    var i;
    (i = this.sentryReporter) == null || i.sendMessageToSentry(e, n, r);
  }
  sendGoyaEvent(e) {
    var n;
    (n = this.goyaReporter) == null || n.sendEvent(e);
  }
  updateGoyaConfig(e) {
    var n;
    (n = this.goyaReporter) == null || n.updateConfig(e);
  }
  buildGoyaEvent(e, n) {
    var r;
    return (r = this.goyaReporter) == null ? void 0 : r.buildEvent(e, n);
  }
  buildTrackingReceiverEventFromConfig(e, n) {
    var r;
    return (r = this.trackingReceiverReporter) == null ? void 0 : r.buildEventFromConfig(e, n);
  }
  buildTrackingReceiverDebugEventFromConfig(e, n) {
    var r;
    return (r = this.trackingReceiverReporter) == null ? void 0 : r.buildDebugEventFromConfig(e, n);
  }
  sendTrackingReceiverDebugEvent(e, n, r, i) {
    return M(this, null, function* () {
      var s, a;
      const o = (s = this.trackingReceiverReporter) == null ? void 0 : s.buildDebugEventFromConfig(e, n);
      o && (yield (a = this.trackingReceiverReporter) == null ? void 0 : a.sendDebugEvent(o, r, i));
    });
  }
  sendTrackingReceiverEventFromConfig(e, n, r) {
    return M(this, null, function* () {
      var o, s;
      const i = (o = this.trackingReceiverReporter) == null ? void 0 : o.buildEventFromConfig(e, n);
      i && (yield (s = this.trackingReceiverReporter) == null ? void 0 : s.sendEvent(i, r));
    });
  }
  updateTrackingReceiverConfig(e) {
    var n;
    (n = this.trackingReceiverReporter) == null || n.updateConfig(e);
  }
}
const Bo = {
  scope: "openid",
  oauth2CodePath: "/api/v0.3/backend/oauth/token"
};
class jg {
  constructor({
    callback: e,
    clientId: n,
    redirectUri: r,
    postLogoutUri: i,
    webCurtainLoginType: o = "redirect",
    authUrl: s,
    backendUrl: a = "",
    oauth2CodePath: u = Bo.oauth2CodePath,
    scope: c = "",
    keycloak: l,
    buttons: d = [],
    headers: f = {},
    cid: h = "",
    session_id: p = "",
    appmetrica_device_id: v = "",
    debugConsole: g = !1,
    debugTrack: m = !1,
    product_name: _ = "",
    eventsConfig: C,
    trackers: T,
    sentryEnabled: R = !1,
    preventAutoStorageCleanup: y = !1,
    useStorage: b = "session",
    requestTimeout: A = null,
    additionalDataSchema: S,
    configCacheTtlDays: x
  }) {
    O(this, "scriptDAS", document.createElement("script"));
    O(this, "version", "'2.1.6'");
    O(this, "build_number", "'52'");
    O(this, "callback");
    O(this, "client_id");
    O(this, "post_logout_uri");
    O(this, "authUrl");
    O(this, "backendUrl");
    O(this, "oauth2CodePath");
    O(this, "buttons");
    O(this, "webCurtainLoginType");
    O(this, "cid");
    O(this, "product_name");
    O(this, "session_id");
    O(this, "appmetrica_device_id");
    O(this, "debugConsole");
    O(this, "debugTrack");
    O(this, "headers");
    O(this, "kfpUrl");
    O(this, "scope");
    O(this, "redirect_uri");
    O(this, "initial_scope");
    O(this, "is_popup");
    O(this, "initial_redirect_uri");
    O(this, "isNewTab");
    O(this, "buttonId");
    O(this, "popup");
    O(this, "w_auth");
    O(this, "widget_settings");
    O(this, "web_curtain");
    O(this, "keventsUrl");
    O(this, "isProd");
    O(this, "isGoyaActive");
    O(this, "isAnalyticsActive");
    O(this, "trackers");
    O(this, "isPrompt");
    O(this, "isSource");
    O(this, "external_id");
    O(this, "quuid");
    O(this, "isLinkedAntifraudAuthzSession");
    O(this, "ksid");
    O(this, "preventAutoStorageCleanup");
    O(this, "authFlowStorage");
    O(this, "requestTimeout");
    O(this, "additionalDataSchema");
    O(this, "flowName");
    O(this, "widget_sid");
    O(this, "reporter");
    O(this, "loginTags", []);
    O(this, "forcedLoginTag");
    O(this, "isGidGpbFlow", !1);
    O(this, "configCacheTtlMs");
    O(this, "keycloakEnabled");
    O(this, "keycloakConfig");
    O(this, "sendTokenReceivedEvent", () => M(this, null, function* () {
      const e = !!(this.isGoyaActive && (this.cid || this.product_name || this.session_id || this.appmetrica_device_id)), n = this.authFlowStorage.get(this.client_id), r = !!(n != null && n.qu_flow), i = We();
      if (e) {
        const s = n == null ? void 0 : n.gsid, a = this.reporter.buildGoyaEvent(bt.authSuccess, { gsid: s, req_id: i, qr_flow: r });
        a && this.reporter.sendGoyaEvent(a);
      }
      const o = w({
        req_id: i
      }, r ? { qr_flow: !0 } : {});
      yield this.sendTrackingEvent(
        J.authSuccess,
        o
      ), this.sendTrackingEventToSentry(
        `sdk-${J.authSuccess.name}`,
        "eventAuthTokenReceived",
        J.authSuccess,
        o
      );
    }));
    O(this, "sendAuthSuccessEvent", () => M(this, null, function* () {
      const e = !!(this.isGoyaActive && (this.cid || this.product_name || this.session_id || this.appmetrica_device_id));
      let n;
      if (e) {
        const r = this.authFlowStorage.get(this.client_id), i = r == null ? void 0 : r.gsid;
        n = We();
        const o = this.reporter.buildGoyaEvent(
          bt.authComplete,
          { gsid: i, req_id: n, screen_name: "/" }
        );
        o && this.reporter.sendGoyaEvent(o);
      }
      this.sendTrackingEvent(
        J.authComplete,
        {
          req_id: n,
          screen_name: "/"
        }
      ), this.preventAutoStorageCleanup && this.authFlowStorage.remove(this.client_id);
    }));
    O(this, "getUserInfo", (e) => M(this, null, function* () {
      var n;
      try {
        const r = this.keycloakEnabled ? this.backendUrl : this.authUrl;
        if (this.keycloakEnabled && !r) {
          this.logError("backendUrl is required for keycloak userinfo");
          return;
        }
        return yield qu(r, e, {
          keycloakEnabled: this.keycloakEnabled,
          keycloakIdpName: (n = this.keycloakConfig) == null ? void 0 : n.idpName,
          headers: this.headers,
          externalId: this.external_id,
          timeout: this.requestTimeout
        });
      } catch (r) {
        this.reporter.sendErrorToSentry(r, "getUserInfo"), this.logError("Ошибка при получении userinfo", r);
        return;
      }
    }));
    O(this, "openPersonalAccountCards", (e) => M(this, null, function* () {
      const n = Nu(this.authUrl), r = window.open(n, "_blank");
      if (!r)
        return;
      let i = !1, o = 0;
      const s = (c) => {
        i || (i = !0, a(), e == null || e({ type: c }));
      }, a = () => {
        window.removeEventListener("message", u), o && (window.clearInterval(o), o = 0);
      }, u = (c) => {
        c.source === r && ju(c.origin, this.authUrl) && c.data === tu && s("closed");
      };
      o = window.setInterval(() => {
        r.closed && s("closed");
      }, nu), window.addEventListener("message", u);
    }));
    var L, U, q, z;
    const k = Si(
      Bo.scope,
      c
    );
    this.callback = e, this.client_id = n, this.keycloakEnabled = !!(l != null && l.keycloakEnabled), this.keycloakConfig = l, this.redirect_uri = r, this.initial_redirect_uri = r, this.isNewTab = !1, this.post_logout_uri = i;
    const D = ot(s);
    this.authUrl = D, this.backendUrl = an(a), this.oauth2CodePath = Fu(u), this.scope = k, this.initial_scope = k, this.is_popup = window.name === "authorize:popup", this.buttons = d, this.headers = Pu(f, g), this.webCurtainLoginType = o, this.cid = h || void 0, this.product_name = _ || void 0, this.session_id = p || void 0, this.appmetrica_device_id = v || void 0, this.debugConsole = g, this.debugTrack = m, this.buttonId = "", this.popup = null, this.w_auth = !1, this.widget_settings = null, this.web_curtain = !1;
    const E = (U = (L = Lu(D)) != null ? L : C) != null ? U : null;
    this.kfpUrl = ((q = E == null ? void 0 : E.kfp) == null ? void 0 : q.kfpUrl) || Jo, this.keventsUrl = ((z = E == null ? void 0 : E.kevents) == null ? void 0 : z.keventsUrl) || ur, this.trackers = T, this.isGoyaActive = !1, this.isAnalyticsActive = !1, this.isPrompt = !1, this.isSource = !1, this.isLinkedAntifraudAuthzSession = !1, this.preventAutoStorageCleanup = y, this.authFlowStorage = ja(b), this.requestTimeout = A && A * 1e3, this.additionalDataSchema = S, this.configCacheTtlMs = zu(x), this.isProd = D === Vo, this.reporter = new Mg({
      sentry: {
        sentryEnabled: R,
        sentryDsn: E == null ? void 0 : E.sentry.sentryDsn,
        environment: E == null ? void 0 : E.sentry.environment,
        version: this.version,
        isProd: this.isProd,
        debugConsole: g
      },
      goya: {
        goyaUrl: (E == null ? void 0 : E.goya.goyaUrl) || "",
        isGoyaActive: !1,
        cid: this.cid,
        session_id: this.session_id,
        product_name: this.product_name,
        appmetrica_device_id: this.appmetrica_device_id,
        requestTimeout: this.requestTimeout,
        debugConsole: g
      },
      trackingReceiver: {
        trackingReceiverUrl: (E == null ? void 0 : E.trackingReceiver.trackingReceiverUrl) || "",
        writeKey: (E == null ? void 0 : E.trackingReceiver.writeKey) || "",
        isAnalyticsActive: !1,
        debugTrack: this.debugTrack,
        version: this.version,
        cid: this.cid,
        session_id: this.session_id,
        product_name: this.product_name,
        appmetrica_device_id: this.appmetrica_device_id
      }
    });
  }
  getSid() {
    const e = this.authFlowStorage.get(this.client_id);
    return e == null ? void 0 : e.gsid;
  }
  getSentrySessionData(e) {
    let n;
    try {
      n = this.getSid() || this.widget_sid;
    } catch (r) {
      n = void 0;
    }
    return w(w({}, n ? { sid: n } : {}), e);
  }
  resolveTokenClientId() {
    var e;
    return this.keycloakEnabled && ((e = this.keycloakConfig) != null && e.clientId) ? this.keycloakConfig.clientId : this.client_id;
  }
  sendTrackingEvent(e, n) {
    return M(this, null, function* () {
      const r = this.getSid() || this.widget_sid;
      r && (yield this.reporter.sendTrackingReceiverEventFromConfig(e, w({
        sid: r,
        flow_name: this.flowName
      }, n)));
    });
  }
  sendTrackingEventToSentry(e, n, r, i) {
    const o = this.getSid() || this.widget_sid;
    if (!o) return;
    const s = this.reporter.buildTrackingReceiverEventFromConfig(r, w({
      sid: o,
      flow_name: this.flowName
    }, i));
    s && this.reporter.sendMessageToSentry(
      e,
      n,
      w({}, s)
    );
  }
  sendTrackingDebugEventToSentry(e, n, r, i) {
    const o = this.getSid() || this.widget_sid;
    if (!o) return;
    const s = this.reporter.buildTrackingReceiverDebugEventFromConfig(r, w({
      sid: o,
      flow_name: this.flowName
    }, i));
    s && this.reporter.sendMessageToSentry(
      e,
      n,
      w({}, s)
    );
  }
  sendTrackingDebugEvent(e, n, r) {
    const i = this.getSid() || this.widget_sid;
    i && this.reporter.sendTrackingReceiverDebugEvent(e, w({
      sid: i,
      flow_name: this.flowName
    }, n), r).catch(() => {
    });
  }
  injectStyles() {
    if (!document) return;
    this.buttonId = Ve(7, !0);
    const e = /CLASS_ID/g, n = xu.replace(e, this.buttonId), r = document.createElement("style");
    r.innerHTML = n, document.getElementsByTagName("head")[0].appendChild(r);
  }
  refreshToken(e) {
    return M(this, null, function* () {
      const n = {
        grant_type: "refresh_token",
        client_id: this.resolveTokenClientId(),
        refresh_token: e
      }, r = yield this.getToken(n);
      if (!r)
        throw this.logError("Backend URL is not configured"), new Error("Backend URL is not configured");
      return r;
    });
  }
  /**
   * Gets token manually by extracting parameters from the current URL
   * @param backendUrl - Backend URL for token retrieval
   * @returns Promise<TokenResponse | undefined> - token response or undefined if no parameters
   */
  getTokenManually(e) {
    return M(this, null, function* () {
      var n;
      this.reporter.sendMessageToSentry(
        "sdk-getTokenManually",
        "getTokenManually",
        this.getSentrySessionData({
          name: "getTokenManually"
        })
      );
      try {
        return yield this.handleRedirectCallback({
          currentUrl: ((n = window == null ? void 0 : window.location) == null ? void 0 : n.href) || "",
          allowGoyaEvent: !0,
          backendUrl: an(e),
          manualToken: !0
        });
      } catch (r) {
        throw this.reportGetTokenManuallyError(r), r;
      }
    });
  }
  reportGetTokenManuallyError(e) {
    this.reporter.sendErrorToSentry(e, "getTokenManually", this.getSentrySessionData());
  }
  setID() {
    if (!sessionStorage.getItem("bid")) {
      const n = Ve(10, !0);
      sessionStorage.setItem("bid", n);
    }
  }
  renderButtons() {
    this.buttons.length && this.buttons.map((e) => w({
      element: document.querySelector(e.container.trim())
    }, e)).filter((e, n, r) => e.element && r.findIndex((i) => i.element === e.element) === n).forEach((e) => this.renderButton(e));
  }
  renderButton({
    element: e,
    type: n = "standard",
    color: r = "primary"
  }) {
    if (!e) return;
    const i = {
      standard: "Войти с Газпром ID",
      compact: du,
      iconic: ""
    }, o = sessionStorage.getItem("bid") || "", s = document.createElement("button");
    s.className = `${this.buttonId}-gidbtn-${n} ${this.buttonId}-gidbtn-${r}`, s.innerHTML = i[n] || "", s.id = o, s.addEventListener("click", () => {
      if (this.web_curtain) {
        this.initWebCurtain();
        return;
      }
      this.loginWithRedirect();
    }), e.querySelector(`#${o}`) || e.appendChild(s);
  }
  getForcedAuthVariants() {
    return [...this.loginTags];
  }
  getDasKsid() {
    return M(this, null, function* () {
      var e, n;
      try {
        return yield (n = (e = window.kfp) == null ? void 0 : e.login_start) == null ? void 0 : n.call(e);
      } catch (r) {
        this.reporter.sendErrorToSentry(r, "getDasKsid");
      }
    });
  }
  buildAuthorizeUrl() {
    var d;
    const e = this.redirect_uri, n = this.scope, r = Ve(mi), i = Ve(Ua), o = Ve($a), s = Iu(o), a = kt.sha256(r), u = Tu(s);
    let c;
    if (this.keycloakEnabled) {
      if (!((d = this.keycloakConfig) != null && d.authUrl) || !this.keycloakConfig.realmName || !this.keycloakConfig.idpName)
        throw this.logError("keycloakEnabled is true but keycloak config is incomplete"), new Error("Keycloak configuration is incomplete");
      c = {
        code_challenge: u,
        code_challenge_method: "S256",
        response_type: "code",
        redirect_uri: e,
        client_id: this.resolveTokenClientId(),
        scope: n,
        state: r,
        nonce: i,
        kc_idp_hint: this.keycloakConfig.idpName,
        quuid: this.quuid
      };
    } else
      c = {
        code_challenge: u,
        code_challenge_method: "S256",
        response_type: "code",
        redirect_uri: e,
        client_id: this.client_id,
        scope: n,
        state: r,
        nonce: i,
        prompt: this.isPrompt ? "login" : void 0,
        source: this.isSource ? "widget" : void 0,
        sid: this.isAnalyticsActive ? a : void 0,
        cid: this.isGoyaActive || this.isAnalyticsActive ? this.cid : void 0,
        session_id: this.isGoyaActive || this.isAnalyticsActive ? this.session_id : void 0,
        appmetrica_device_id: this.isGoyaActive || this.isAnalyticsActive ? this.appmetrica_device_id : void 0,
        product_name: this.isGoyaActive || this.isAnalyticsActive ? this.product_name : void 0,
        quuid: this.quuid,
        login_tag: this.forcedLoginTag,
        partner_ksid: this.ksid,
        flow: this.isGidGpbFlow ? "gid_gpb" : void 0
      };
    this.isPrompt = !1, this.isSource = !1, this.forcedLoginTag = void 0;
    const l = {
      [Gn(r)]: o,
      redirect_uri: e,
      state: r,
      gsid: a,
      qu_flow: this.quuid ? !0 : void 0
    };
    return this.authFlowStorage.save(this.client_id, l), this.authorizeUrl(c);
  }
  authorizeUrl(e) {
    const n = en(
      e
    );
    if (this.keycloakEnabled && this.keycloakConfig) {
      const i = ot(this.keycloakConfig.authUrl), o = this.keycloakConfig.realmName;
      return `${i}/auth/realms/${o}/protocol/openid-connect/auth?${n}`;
    }
    const r = e.login_tag === "silent_login" ? Ha : "/oauth2/auth";
    return `${this.authUrl}${r}?${n}`;
  }
  buildLogoutUrl(e) {
    var r;
    const n = en(e);
    if (this.keycloakEnabled) {
      if (!((r = this.keycloakConfig) != null && r.authUrl) || !this.keycloakConfig.realmName)
        throw this.logError("keycloakEnabled is true but keycloak config is incomplete"), new Error("Keycloak configuration is incomplete");
      return `${ot(this.keycloakConfig.authUrl)}/auth/realms/${this.keycloakConfig.realmName}/protocol/openid-connect/logout?${n}`;
    }
    return `${this.authUrl}/oauth2/sessions/logout?${n}`;
  }
  getTokenEndpoint(e) {
    var r;
    if (this.keycloakEnabled) {
      if (!((r = this.keycloakConfig) != null && r.authUrl) || !this.keycloakConfig.realmName) {
        this.logError("keycloakEnabled is true but keycloak config is incomplete");
        return;
      }
      return `${ot(this.keycloakConfig.authUrl)}/auth/realms/${this.keycloakConfig.realmName}/protocol/openid-connect/token`;
    }
    const n = e || this.backendUrl;
    if (n)
      return `${n}${this.oauth2CodePath}`;
  }
  getRevokeEndpoint() {
    var e;
    if (this.keycloakEnabled) {
      if (!((e = this.keycloakConfig) != null && e.authUrl) || !this.keycloakConfig.realmName) {
        this.logError("keycloakEnabled is true but keycloak config is incomplete");
        return;
      }
      return `${ot(this.keycloakConfig.authUrl)}/auth/realms/${this.keycloakConfig.realmName}/protocol/openid-connect/revoke`;
    }
    return `${this.backendUrl}${za}`;
  }
  handleRedirectCallback(e) {
    return M(this, null, function* () {
      var k, D, E, L, U, q, z;
      const n = (e == null ? void 0 : e.currentUrl) || ((k = window == null ? void 0 : window.location) == null ? void 0 : k.href) || "", r = (D = e == null ? void 0 : e.allowGoyaEvent) != null ? D : !0, i = (E = e == null ? void 0 : e.manualToken) != null ? E : !1;
      let o = "";
      try {
        o = n ? n.split("?").slice(1).join("") : "";
      } catch (H) {
        throw this.reporter.sendErrorToSentry(
          H,
          i ? "getTokenManually" : "handleRedirectCallback_queryString",
          this.getSentrySessionData()
        ), this.clearAuthFlowData(), new Error(`error in queryString: ${H}`);
      }
      if (!o.length) {
        i && this.reportGetTokenManuallyError(new Error("No callback query params")), this.is_popup && ((L = window == null ? void 0 : window.opener) == null || L.postMessage({ name: _t, url: "" }, window.location.origin));
        return;
      }
      let s;
      try {
        s = bi(n);
      } catch (H) {
        throw this.reporter.sendErrorToSentry(
          H,
          i ? "getTokenManually" : "handleRedirectCallback_parseQuery",
          this.getSentrySessionData()
        ), this.clearAuthFlowData(), new Error(`error in parseQueryResult: ${H}`);
      }
      const {
        code: a,
        state: u,
        scope: c,
        error: l,
        error_description: d,
        quuid: f
      } = s, h = !!c;
      if (f) {
        this.is_popup && ((U = window == null ? void 0 : window.opener) == null || U.postMessage({ name: _t, url: n }, window.location.origin)), this.loginWithQuuidRedirect({ quuid: f });
        return;
      }
      const p = this.authFlowStorage.get(this.client_id);
      if (!u || !a) {
        i && this.reportGetTokenManuallyError(new Error("Missing code or state")), this.sendTrackingDebugEvent(le.eventHandleRedirectCallbackNoParams, {
          scope: c,
          hasCode: !!a,
          hasState: !!u
        }), this.is_popup && ((q = window == null ? void 0 : window.opener) == null || q.postMessage({ name: _t, url: n }, window.location.origin)), l && (p != null && p.state) && this.callback({
          error: l,
          error_description: d || De(l)
        }), this.clearAuthFlowData();
        return;
      }
      let v = p == null ? void 0 : p.gsid;
      v || (v = kt.sha256(u), this.authFlowStorage.save(this.client_id, j(w({}, p), { gsid: v })));
      const g = !!(this.isGoyaActive && (this.cid || this.product_name || this.session_id || this.appmetrica_device_id));
      let m;
      const _ = this.authFlowStorage.get(this.client_id);
      _ && !(_ != null && _.gsid) && (_.gsid = kt.sha256(u), this.authFlowStorage.save(this.client_id, _)), v = _ == null ? void 0 : _.gsid;
      const C = !!(_ != null && _.qu_flow);
      if (g && r) {
        m = We();
        const H = this.reporter.buildGoyaEvent(bt.authCodeSuccess, { gsid: v, req_id: m, qr_flow: C });
        H && this.reporter.sendGoyaEvent(H);
      }
      const T = this.is_popup ? j(w({}, J.authCodeSuccess), { name: "eventAuthCodeReceivedInPopup" }) : J.authCodeSuccess, R = w({
        req_id: m,
        code: `${a.slice(0, 9)}...${a.slice(-9)}`
      }, C ? { qr_flow: !0 } : {});
      if (this.sendTrackingEvent(T, R), this.sendTrackingEventToSentry(
        `sdk-${J.authCodeSuccess.name}`,
        "eventAuthCodeReceived",
        T,
        R
      ), this.is_popup) {
        (z = window == null ? void 0 : window.opener) == null || z.postMessage({ name: _t, url: n }, window.location.origin);
        return;
      }
      const y = a, b = _ == null ? void 0 : _[Gn(u)], A = _ && (_ == null ? void 0 : _.state) === u, S = h ? c.includes("openid") : !0;
      if (l || (!y || !b || !A || !S)) {
        const H = performance.getEntriesByType("navigation")[0];
        this.reporter.sendErrorToSentry(
          l || new Error("Invalid params"),
          i ? "getTokenManually" : "handleRedirectCallback_invalidParams",
          this.getSentrySessionData()
        ), this.sendTrackingDebugEvent(le.eventHandleRedirectCallbackInvalidParams, {
          error: wi(l),
          isCodeValid: !!y,
          isVerifierValid: !!b,
          isStateValid: `${A}`,
          isScopeValid: `${S}`,
          isBot: !!navigator.webdriver || /bot|crawler|spider|google|yandex|bing/i.test(navigator.userAgent),
          referrer: document.referrer,
          navigationType: H == null ? void 0 : H.type,
          screen_size: window.innerWidth + "x" + window.innerHeight
        }, !0), this.clearAuthFlowData();
        const $ = Wu({
          error: l,
          error_description: d,
          isCodeValid: !!y,
          isVerifierValid: !!b,
          isStateValid: !!A,
          isScopeValid: S
        });
        this.callback($), Ku($.error, $.error_description);
      }
      if (!this.is_popup)
        return yield this.prepareAndFetchToken(a, g, e == null ? void 0 : e.backendUrl, i);
    });
  }
  prepareAndFetchToken(e, n = !1, r, i = !1) {
    return M(this, null, function* () {
      var l;
      const o = this.authFlowStorage.get(this.client_id), {
        redirect_uri: s = "",
        state: a = ""
      } = o || {}, u = String((l = o == null ? void 0 : o[Gn(a)]) != null ? l : ""), c = {
        grant_type: "authorization_code",
        client_id: this.resolveTokenClientId(),
        redirect_uri: s,
        code_verifier: u,
        code: e,
        state: a
      };
      return yield this.getToken(c, n, r, i);
    });
  }
  validateBySchema(e, n) {
    return typeof n == "string" ? typeof e === n : n.type === "array" ? Array.isArray(e) && e.every((r) => this.validateBySchema(r, n.items)) : n.type === "object" ? typeof e != "object" || e === null || Array.isArray(e) ? !1 : Object.entries(n.properties).every(
      ([r, i]) => this.validateBySchema(e[r], i)
    ) : !1;
  }
  parseAdditionalData(e) {
    if (e != null)
      try {
        const n = JSON.parse(e);
        if (typeof n != "object" || n === null || Array.isArray(n))
          return;
        if (!this.additionalDataSchema)
          return n;
        const r = {};
        for (const [i, o] of Object.entries(this.additionalDataSchema)) {
          const s = n[i];
          this.validateBySchema(s, o) && (r[i] = s);
        }
        return Object.keys(r).length > 0 ? r : void 0;
      } catch (n) {
        return;
      }
  }
  getToken(e, n = !1, r, i = !1) {
    return M(this, null, function* () {
      const o = this.getTokenEndpoint(r);
      if (!o) {
        this.sendTrackingDebugEvent(le.eventNoBackendUrlError, void 0, !0), this.logError("Token endpoint is not configured"), i && this.reportGetTokenManuallyError(new Error("Token endpoint is not configured"));
        return;
      }
      try {
        const s = yield Uu(
          o,
          e,
          this.headers,
          this.requestTimeout,
          this.external_id,
          this.keycloakEnabled
        );
        if (s.error) {
          this.sendGetTokenErrorEvent(s.error, i), this.callback({
            error: s.error,
            error_description: s.error_description || De(s.error),
            status_code: s.status,
            retry_after_seconds: s.retry_after_seconds
          }), this.shouldClearAuthFlowOnTokenFailure(s.status) && this.clearAuthFlowData();
          return;
        }
        const a = this.parseAdditionalData(
          typeof s.additional_data == "string" ? s.additional_data : void 0
        );
        this.callback({
          access_token: s.access_token,
          additional_data: a,
          expires_in: s.expires_in,
          id_token: s.id_token,
          refresh_token: s.refresh_token,
          scope: s.scope,
          token_type: s.token_type,
          refresh_token_expires_in: s.refresh_token_expires_in
        });
        let u;
        const c = this.authFlowStorage.get(this.client_id), l = !!(c != null && c.qu_flow);
        if (n) {
          const f = c == null ? void 0 : c.gsid;
          u = We();
          const h = this.reporter.buildGoyaEvent(bt.authSuccess, { gsid: f, req_id: u, qr_flow: l });
          h && this.reporter.sendGoyaEvent(h);
        }
        const d = w({
          req_id: u
        }, l ? { qr_flow: !0 } : {});
        return this.sendTrackingEvent(
          J.authSuccess,
          d
        ), this.sendTrackingEventToSentry(
          `sdk-${J.authSuccess.name}`,
          "eventAuthTokenReceived",
          J.authSuccess,
          d
        ), this.preventAutoStorageCleanup || this.clearAuthFlowData(), {
          access_token: s.access_token,
          additional_data: a,
          expires_in: s.expires_in,
          id_token: s.id_token,
          refresh_token: s.refresh_token,
          scope: s.scope,
          token_type: s.token_type,
          refresh_token_expires_in: s.refresh_token_expires_in
        };
      } catch (s) {
        this.sendGetTokenErrorEvent(s, i), this.shouldClearAuthFlowOnTokenFailure(void 0, s) && this.clearAuthFlowData();
        const { message: a } = s;
        throw this.callback({
          error: V.token_fetch_error,
          error_description: a || De(V.token_fetch_error)
        }), new Error("Error in getToken method");
      }
    });
  }
  initDas() {
    return M(this, null, function* () {
      if (!this.kfpUrl) return;
      const e = this.keventsUrl || ur, n = this.isProd ? "22820" : "22821";
      window.dmcsfw = {
        serverUrl: e,
        trackUrl: "/cld_track",
        configUrl: "/oxwdsq",
        bloomDataUrl: "/sd6ktbV.json",
        ClientId: n
      }, this.scriptDAS = document.createElement("script"), this.scriptDAS.src = this.kfpUrl, this.scriptDAS.async = !0;
      const r = this.scriptDAS, i = new Promise((o) => {
        const s = setTimeout(() => o(), 5e3);
        r.onload = () => {
          clearTimeout(s), o();
        }, r.onerror = () => {
          clearTimeout(s), o();
        };
      });
      document.head.appendChild(r), yield i, this.isLinkedAntifraudAuthzSession && (this.ksid = yield this.getDasKsid());
    });
  }
  refreshSdkConfigFromServer() {
    return M(this, null, function* () {
      var d;
      const e = `${this.authUrl}${vi}?client_id=${this.client_id}`, n = yield this.getConfigWithRetry(e, this.requestTimeout);
      ki(this.authUrl, this.client_id, n);
      const { w_auth: r, widget_settings: i, web_curtain: o, trackers: s, external_id: a, login_tag: u, is_linked_antifraud_authz_session: c } = n;
      if ((d = this.trackers) != null && d.trim()) {
        const f = this.trackers.split(",").map((h) => h.trim());
        this.isGoyaActive = f.includes("goya"), this.isAnalyticsActive = f.includes("tracking_receiver");
      } else
        this.isGoyaActive = s && s.includes("goya"), this.isAnalyticsActive = s && s.includes("tracking_receiver");
      this.reporter.updateGoyaConfig({ isGoyaActive: this.isGoyaActive }), this.w_auth = r, this.widget_settings = i, this.web_curtain = o, this.isLinkedAntifraudAuthzSession = !!c;
      const l = a ? `${a}` : this.isAnalyticsActive ? "-1" : void 0;
      this.external_id = l, this.reporter.updateTrackingReceiverConfig({
        isAnalyticsActive: this.isAnalyticsActive,
        external_id: this.external_id
      }), this.loginTags = Array.isArray(u) ? u : [];
    });
  }
  init() {
    return M(this, null, function* () {
      var i, o;
      this.injectStyles(), this.setID(), this.renderButtons();
      const n = new URLSearchParams(((i = window == null ? void 0 : window.location) == null ? void 0 : i.search) || "").get("flow") === "gid_gpb", r = `${this.authUrl}${vi}?client_id=${this.client_id}`;
      try {
        const s = Vu(this.authUrl, this.client_id, this.configCacheTtlMs), a = s != null ? s : yield this.getConfigWithRetry(r, this.requestTimeout);
        s || ki(this.authUrl, this.client_id, a);
        const { w_auth: u, widget_settings: c, web_curtain: l, trackers: d, enable_kfp: f, external_id: h, login_tag: p, is_linked_antifraud_authz_session: v, gid_gpb: g } = a;
        if ((o = this.trackers) != null && o.trim()) {
          const C = this.trackers.split(",").map((T) => T.trim());
          this.isGoyaActive = C.includes("goya"), this.isAnalyticsActive = C.includes("tracking_receiver");
        } else
          this.isGoyaActive = d && d.includes("goya"), this.isAnalyticsActive = d && d.includes("tracking_receiver");
        this.reporter.updateGoyaConfig({ isGoyaActive: this.isGoyaActive }), this.w_auth = u, this.widget_settings = c, this.web_curtain = l, this.isGidGpbFlow = !!g && n, this.isLinkedAntifraudAuthzSession = !!v;
        const m = h ? `${h}` : this.isAnalyticsActive ? "-1" : void 0;
        this.external_id = m, this.reporter.updateTrackingReceiverConfig({
          isAnalyticsActive: this.isAnalyticsActive,
          external_id: this.external_id
        });
        const _ = Array.isArray(p) ? p : [];
        if (this.loginTags = _, f && (yield this.initDas()), this.isGidGpbFlow) {
          yield this.loginWithRedirect();
          return;
        }
      } catch (s) {
        this.reporter.sendErrorToSentry(s, "init"), this.logError("Error getting config: ", s);
      }
      this.setupBFCacheHandlers(), yield this.handleRedirectCallback();
    });
  }
  setupBFCacheHandlers() {
    this.checkBackButtonNavigation(), "persisted" in new PageTransitionEvent("pageshow") && window.addEventListener("pageshow", (e) => {
      e.persisted && this.handleBFCacheRestore();
    });
  }
  handleBFCacheRestore() {
    const e = this.authFlowStorage.get(this.client_id);
    (e == null ? void 0 : e.gsid) && (this.sendAuthFlowCanceledEvent().catch((r) => {
      this.reporter.sendErrorToSentry(r, "sendAuthFlowCanceledEvent"), this.logError("Error sending auth flow canceled event: ", r);
    }), this.clearAuthFlowData());
  }
  checkBackButtonNavigation() {
    const e = this.authFlowStorage.get(this.client_id), n = e == null ? void 0 : e.gsid, r = performance.getEntriesByType("navigation")[0];
    n && (r == null ? void 0 : r.type) === "back_forward" && (this.sendAuthFlowCanceledEvent().catch((i) => {
      this.reporter.sendErrorToSentry(i, "sendAuthFlowCanceledEvent"), this.logError("Error sending auth flow canceled event: ", i);
    }), this.clearAuthFlowData());
  }
  sendAuthFlowCanceledEvent() {
    return M(this, null, function* () {
      const e = at();
      this.sendTrackingEvent({ name: "eventAuthFlowCanceled" }, {
        user_agent: e,
        back_pressed: !0,
        ver: st
      });
    });
  }
  sendGoyaButtonClickInitEvent(e) {
    return M(this, null, function* () {
      if (!!(this.isGoyaActive && (this.cid || this.product_name || this.session_id || this.appmetrica_device_id))) {
        const r = this.authFlowStorage.get(this.client_id), i = r == null ? void 0 : r.gsid, o = !!(r != null && r.qu_flow), s = this.reporter.buildGoyaEvent(bt.authButtonClickInit, { gsid: i, req_id: e, qr_flow: o });
        s && this.reporter.sendGoyaEvent(s);
      }
    });
  }
  sendWidgetGoyaEvent(e, n, r) {
    if (!(this.isGoyaActive && (this.cid || this.product_name || this.session_id || this.appmetrica_device_id))) return;
    const i = this.authFlowStorage.get(this.client_id), o = this.widget_sid || (i == null ? void 0 : i.gsid), s = this.reporter.buildGoyaEvent(
      {
        event_action: e,
        event_label: n,
        event_name: r
      },
      { gsid: o }
    );
    s && this.reporter.sendGoyaEvent(s);
  }
  /**
   * ```js
   * await client.loginWithRedirect();
   * ```
   *
   * Performs a redirect to authorization URL. Random and secure
   * `state` and `nonce` parameters will be auto-generated.
   */
  loginWithRedirect(e) {
    return M(this, null, function* () {
      this.setConfigParams(e);
      const n = this.isSource, r = !!this.forcedLoginTag, i = yield this.buildAuthorizeUrl(), o = this.isGoyaActive && (this.cid || this.product_name || this.session_id || this.appmetrica_device_id);
      let s;
      const a = (e == null ? void 0 : e.quuid) || this.quuid;
      o && (s = We(), yield this.sendGoyaButtonClickInitEvent(s));
      const u = !!a, c = setTimeout(() => {
        this.widget_sid = void 0, window.location.assign(i);
      }, 1e3), l = r ? J.authFlowStartedForce : J.authFlowStarted;
      return this.sendTrackingEvent(
        l,
        j(w({
          req_id: s
        }, u ? { qr_flow: !0, quuid: a } : {}), {
          widget_sid: n ? this.widget_sid : void 0,
          gpb_flow: this.isGidGpbFlow
        })
      ).finally(() => {
        clearTimeout(c), this.widget_sid = void 0, window.location.assign(i);
      });
    });
  }
  buildForcedAuthCheckUrl(e) {
    const n = en({
      client_id: this.client_id,
      scope: this.scope,
      login_tag: e
    });
    return `${this.authUrl}${qa}?${n}`;
  }
  assertLoginTagAllowed(e) {
    if (!e)
      throw new Error("LoginTag is obligatory");
    if (!this.loginTags.length || !this.loginTags.includes(e))
      throw new Error("Forced auth not allowed");
  }
  assertForcedAuthPermitted(e) {
    return M(this, null, function* () {
      const n = this.buildForcedAuthCheckUrl(e);
      try {
        yield $u(n, this.requestTimeout);
      } catch (r) {
        throw this.reporter.sendErrorToSentry(r, "assertForcedAuthPermitted"), new Error("Forced auth not allowed");
      }
    });
  }
  loginWithForcedRedirect(e, n = "redirect") {
    return M(this, null, function* () {
      this.assertLoginTagAllowed(e), yield this.assertForcedAuthPermitted(e), this.forcedLoginTag = e;
      const r = { flowName: `forced_redirect:${e}` };
      if (n === "popup") {
        yield this.loginWithPopup(r);
        return;
      }
      yield this.loginWithRedirect(r);
    });
  }
  loginWithQuuidRedirect(e) {
    return M(this, null, function* () {
      this.loginWithRedirect(e);
    });
  }
  setConfigParams(e) {
    e && (this.scope = e != null && e.scope ? Si(e.scope) : this.initial_scope, this.redirect_uri = (e == null ? void 0 : e.redirectUri) || this.initial_redirect_uri, this.quuid = e == null ? void 0 : e.quuid, this.flowName = e == null ? void 0 : e.flowName);
  }
  initWebCurtain() {
    if (document.getElementById(Un)) return;
    const e = document.getElementById($n);
    e && document.body.removeChild(e);
    const n = document.createElement("iframe"), r = `${this.authUrl}${Ga}?client_id=${this.client_id}&scope=${this.scope.split(" ").join("+")}`, i = Du(n);
    this.initIframe(Un, this.webCurtainLoginType || "redirect", r, n, i);
  }
  initIframe(e, n, r, i, o) {
    i.id = e, i.width = "0", i.height = "0", i.className = "widget_iframe", i.style.position = "fixed", i.style.border = "1px solid rgba(27, 44, 78, 0.1)", i.style.boxSizing = "content-box", i.style.borderRadius = "20px", i.style.maxHeight = "600px", i.style.zIndex = "9999", i.src = r, o(), document.body.appendChild(i), window.addEventListener("resize", o);
    const s = (a) => M(this, null, function* () {
      switch (a.data.customEvent) {
        case Te.Init: {
          i.style.minWidth = `${Ka}px`, i.style.height = `${a.data.frameHeight}px`;
          const u = Ve(mi);
          this.widget_sid = kt.sha256(u), this.sendTrackingEvent(J.widgetOpen), this.sendWidgetGoyaEvent("button_click", "open", "widget-button_click-open");
          break;
        }
        case Te.Resize:
          i.style.height = `${a.data.frameHeight}px`;
          break;
        case Te.Close: {
          this.sendTrackingEvent(J.widgetClose), this.sendWidgetGoyaEvent("button_click", "close", "widget-button_click-close"), document.body.removeChild(i), this.widget_sid = void 0;
          break;
        }
        case Te.Login:
          document.body.removeChild(i), this.isSource = !0, n === "popup" && this.loginWithPopup(), n === "redirect" && this.loginWithRedirect();
          break;
        case Te.LoginPrompt:
          document.body.removeChild(i), this.isPrompt = !0, this.isSource = !0, n === "popup" && this.loginWithPopup(), n === "redirect" && this.loginWithRedirect();
          break;
        case Te.AgreementLinkClick: {
          this.sendTrackingEvent(J.agreementLinkClick), this.sendWidgetGoyaEvent("link_click", "agreement", "widget-link_click-agreement");
          break;
        }
      }
    });
    window.addEventListener("message", s), i.addEventListener("pagehide", function() {
      window.removeEventListener("message", s), window.removeEventListener("resize", o);
    });
  }
  isRetryableConfigError(e) {
    if (!e) return !1;
    const n = e;
    return typeof n.status == "number" ? n.status >= 500 && n.status < 600 : n.name === "TimeoutError" || e instanceof TypeError;
  }
  shouldClearAuthFlowOnTokenFailure(e, n) {
    if (n) {
      const r = n;
      if (r.name === "TimeoutError" || n instanceof TypeError)
        return !1;
      e = r.status;
    }
    return typeof e != "number" || e === 408 || e === 429 || e >= 500 ? !1 : e >= 400 && e < 500;
  }
  sendGetTokenErrorEvent(e, n = !1) {
    const r = e instanceof Error ? e : new Error(typeof e == "string" && e ? e : "Token request failed");
    this.reporter.sendErrorToSentry(
      r,
      n ? "getTokenManually" : "getToken",
      this.getSentrySessionData()
    );
    const i = {
      error: wi(e)
    };
    this.sendTrackingDebugEvent(
      le.eventGetTokenError,
      i,
      !0
    ), this.sendTrackingDebugEventToSentry(
      `sdk-${le.eventGetTokenError.name}`,
      "eventGetTokenError",
      le.eventGetTokenError,
      i
    );
  }
  getConfigWithRetry(e, n) {
    return M(this, null, function* () {
      try {
        return yield Ei(e, n);
      } catch (r) {
        if (this.isRetryableConfigError(r))
          return Ei(e, n);
        throw r;
      }
    });
  }
  initWidget(e, n) {
    var s;
    if (document.getElementById(Un)) return;
    const r = document.createElement("iframe"), i = `${this.authUrl}${Ba}?client_id=${e || this.client_id}&scope=${this.scope.split(" ").join("+")}`, o = Ru(((s = this.widget_settings) == null ? void 0 : s.w_pos) || "", r);
    this.initIframe($n, n, i, r, o);
  }
  getWidget(e, n, r) {
    return M(this, null, function* () {
      this.setConfigParams(r);
      try {
        if (this.w_auth && !this.widget_settings)
          throw new Error("Не заданы настройки авторизационного виджета");
        this.w_auth && this.widget_settings && !document.getElementById($n) && this.initWidget(e, n);
      } catch (i) {
        this.reporter.sendErrorToSentry(i, "getWidget"), this.logError("Ошибка при получении настроект авторизационного виджета", i);
      }
    });
  }
  loginWithNewTab(e) {
    return M(this, null, function* () {
      return this.isNewTab = !0, yield this.loginWithPopup(e);
    });
  }
  /**
   * ```js
   * try {
   *   await client.loginWithPopup();
   * } catch(e) {
   *   // Popup was closed before login completed
   * }
   * ```
   *
   * Opens a popup with the authorization URL. If the response is successful,
   * results will be valid according to their expiration times.
   *
   * IMPORTANT: This method has to be called from an event handler
   * that was started by the user like a button click, for example,
   * otherwise the popup will be blocked in most browsers.
   */
  loginWithPopup(e) {
    return M(this, null, function* () {
      try {
        this.setConfigParams(e);
        const n = this.isSource, r = !!this.forcedLoginTag, i = this.buildAuthorizeUrl(), o = this.isGoyaActive && (this.cid || this.product_name || this.session_id || this.appmetrica_device_id);
        let s;
        const a = (e == null ? void 0 : e.quuid) || this.quuid, u = !!a;
        o && (s = We(), this.sendGoyaButtonClickInitEvent(s));
        const c = r ? J.authFlowStartedForce : J.authFlowStarted;
        if (this.sendTrackingEvent(
          c,
          j(w({
            req_id: s
          }, u ? { qr_flow: !0, quuid: a } : {}), {
            widget_sid: n ? this.widget_sid : void 0,
            gpb_flow: this.isGidGpbFlow
          })
        ), this.widget_sid = void 0, this.popup === null || this.popup.closed) {
          const l = i;
          if (this.popup = Ou("", this.isNewTab), this.isNewTab = !1, this.sendTrackingDebugEvent(le.eventLoginWithPopupError, void 0, !0), !this.popup)
            throw this.reporter.sendErrorToSentry(new Error("Ошибка при попытке открытия popup-окна"), "loginWithPopup_popupError"), this.sendTrackingDebugEvent(le.eventLoginWithPopupError, void 0, !0), this.callback({
              error: V.popup_blocked,
              error_description: De(V.popup_blocked)
            }), new Error("Ошибка при попытке открытия popup-окна");
          this.popup.location.href = l;
          const d = yield this.checkPopupForResult();
          d && (yield this.handleRedirectCallback({ currentUrl: d, allowGoyaEvent: !1 }));
        } else
          return this.popup.focus(), Promise.resolve("Popup-окно уже открыто");
      } catch (n) {
        return this.reporter.sendErrorToSentry(n, "loginWithPopup"), this.clearAuthFlowData(), Promise.reject(n);
      }
    });
  }
  checkPopupForResult() {
    return new Promise((e, n) => {
      const i = new URL(this.redirect_uri).origin;
      let o = null;
      const s = (a) => M(this, null, function* () {
        var u, c;
        try {
          if (a.origin === i && this.popup && !((u = this.popup) != null && u.closed) && ((c = a.data) != null && c.name) && a.data.name === _t) {
            window.removeEventListener("message", s);
            const { code: l, state: d } = bi(a.data.url);
            l && d ? (this.popup.close(), clearInterval(o), e(a.data.url)) : (this.reporter.sendErrorToSentry(new Error("Ошибка при получении авторизационного кода"), "checkPopupForResult_paramsError"), this.sendTrackingDebugEvent(le.eventCheckPopupForResultParamsError, void 0, !0), this.popup.close(), clearInterval(o), n(new Error("Ошибка при получении авторизационного кода")));
          }
        } catch (l) {
          this.reporter.sendErrorToSentry(l, "checkPopupForResult_handleMessage"), n(l);
        }
      });
      window.addEventListener("message", s), o = setInterval(() => {
        if (!this.popup || this.popup.closed && o) {
          window.removeEventListener("message", s), clearInterval(o), this.reporter.sendErrorToSentry(new Error("Попап был закрыт пользователем до завершения авторизации."), "checkPopupForResult_popupClosed");
          const a = at();
          this.sendTrackingEvent({ name: "eventAuthFlowCanceled" }, {
            user_agent: a,
            back_pressed: !1,
            ver: st
          }), this.clearAuthFlowData(), n(new Error("Попап был закрыт пользователем до завершения авторизации."));
          return;
        }
      }, 500);
    });
  }
  /**
   * ```js
   * client.sessionLogout(id_token_hint);
   * ```
   *
   * Clears the application auth session, the Identity Provider session
   * and performs a redirect to the `redirect_uri` URL.
   *
   * @param {string} id_token_hint
   */
  sessionLogout(e) {
    const n = this.buildLogoutUrl({
      id_token_hint: e,
      post_logout_redirect_uri: this.post_logout_uri
    });
    window.location.assign(n);
  }
  /**
   * ```js
   * await client.logout(access_token);
   * ```
   *
   * Revokes the access token and clears the Identity Provider session.
   *
   * @param {string} access_token
   */
  logout(e) {
    return M(this, null, function* () {
      const n = w({
        client_id: this.resolveTokenClientId(),
        token: e
      }, this.keycloakEnabled ? { token_type_hint: "access_token" } : {}), r = this.getRevokeEndpoint();
      if (!r)
        throw this.logError("Revoke endpoint is not configured"), new Error("Revoke endpoint is not configured");
      try {
        yield Gu(
          r,
          n,
          this.headers,
          this.requestTimeout,
          this.external_id,
          this.keycloakEnabled
        );
      } catch (i) {
        throw this.reporter.sendErrorToSentry(i, "logout"), this.logError("Error in logout method: ", i), new Error("Ошибка вызова logout");
      }
    });
  }
  logError(...e) {
    this.debugConsole && console.error(e);
  }
  clearAuthFlowData() {
    this.flowName = void 0, this.authFlowStorage.remove(this.client_id);
  }
}
function yy(t) {
  return M(this, null, function* () {
    const e = new jg(t);
    return yield e.init(), e;
  });
}
function Ug(t) {
  var e = t;
  return !!(e.ctrlKey || e.shiftKey || e.metaKey || e.button && e.button == 1);
}
function $g(t, e) {
  return !!(t.target === "_blank" && e);
}
function Bg(t, e, n, r) {
  var i = this, o = [];
  return t ? (t instanceof Element ? o = [t] : "toArray" in t ? o = t.toArray() : o = t, o.forEach(function(s) {
    s.addEventListener("click", function(a) {
      var u, c, l = e instanceof Function ? e(s) : e, d = n instanceof Function ? n(s) : n, f = s.getAttribute("href") || s.getAttributeNS("http://www.w3.org/1999/xlink", "href") || s.getAttribute("xlink:href") || ((u = s.getElementsByTagName("a")[0]) === null || u === void 0 ? void 0 : u.getAttribute("href")), h = Yr(i.track(l, d, r != null ? r : {}), (c = i.settings.timeout) !== null && c !== void 0 ? c : 500);
      !$g(s, f) && !Ug(a) && f && (a.preventDefault ? a.preventDefault() : a.returnValue = !1, h.catch(console.error).then(function() {
        window.location.href = f;
      }).catch(console.error));
    }, !1);
  }), this) : this;
}
function Gg(t, e, n, r) {
  var i = this;
  if (!t)
    return this;
  t instanceof HTMLFormElement && (t = [t]);
  var o = t;
  return o.forEach(function(s) {
    if (!(s instanceof Element))
      throw new TypeError("Must pass HTMLElement to trackForm/trackSubmit.");
    var a = function(c) {
      var l;
      c.preventDefault ? c.preventDefault() : c.returnValue = !1;
      var d = e instanceof Function ? e(s) : e, f = n instanceof Function ? n(s) : n, h = Yr(i.track(d, f, r != null ? r : {}), (l = i.settings.timeout) !== null && l !== void 0 ? l : 500);
      h.catch(console.error).then(function() {
        s.submit();
      }).catch(console.error);
    }, u = window.jQuery || window.Zepto;
    u ? u(s).submit(a) : s.addEventListener("submit", a, !1);
  }), this;
}
const Zt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  form: Gg,
  link: Bg
}, Symbol.toStringTag, { value: "Module" }));
function Go(t, e) {
  return Object.keys(e).reduce(function(n, r) {
    if (r.startsWith(t)) {
      var i = r.substr(t.length);
      n[i] = e[r];
    }
    return n;
  }, {});
}
function qg(t, e) {
  var n = document.createElement("a");
  n.href = e;
  var r = n.search.slice(1), i = r.split("&").reduce(function(C, T) {
    var R = T.split("="), y = R[0], b = R[1];
    return C[y] = pa(b), C;
  }, {}), o = [], s = i.ajs_uid, a = i.ajs_event, u = i.ajs_aid, c = Z(t.options.useQueryString) ? t.options.useQueryString : {}, l = c.aid, d = l === void 0 ? /.+/ : l, f = c.uid, h = f === void 0 ? /.+/ : f;
  if (u) {
    var p = Array.isArray(i.ajs_aid) ? i.ajs_aid[0] : i.ajs_aid;
    d.test(p) && t.setAnonymousId(p);
  }
  if (s) {
    var v = Array.isArray(i.ajs_uid) ? i.ajs_uid[0] : i.ajs_uid;
    if (h.test(v)) {
      var g = Go("ajs_trait_", i);
      o.push(t.identify(v, g));
    }
  }
  if (a) {
    var m = Array.isArray(i.ajs_event) ? i.ajs_event[0] : i.ajs_event, _ = Go("ajs_prop_", i);
    o.push(t.track(m, _));
  }
  return Promise.all(o);
}
const Hg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  queryString: qg
}, Symbol.toStringTag, { value: "Module" }));
var ir = { exports: {} }, qo;
function zg() {
  return qo || (qo = 1, function(t, e) {
    /*! For license information please see tsub.js.LICENSE.txt */
    (function(n, r) {
      t.exports = r();
    })(self, function() {
      return function() {
        var n = { 2870: function(o, s, a) {
          var u = this && this.__importDefault || function(f) {
            return f && f.__esModule ? f : { default: f };
          };
          Object.defineProperty(s, "__esModule", { value: !0 }), s.Store = s.matches = s.transform = void 0;
          var c = a(4303);
          Object.defineProperty(s, "transform", { enumerable: !0, get: function() {
            return u(c).default;
          } });
          var l = a(2370);
          Object.defineProperty(s, "matches", { enumerable: !0, get: function() {
            return u(l).default;
          } });
          var d = a(1444);
          Object.defineProperty(s, "Store", { enumerable: !0, get: function() {
            return u(d).default;
          } });
        }, 2370: function(o, s, a) {
          var u = this && this.__importDefault || function(g) {
            return g && g.__esModule ? g : { default: g };
          };
          Object.defineProperty(s, "__esModule", { value: !0 });
          var c = u(a(7843));
          function l(g, m) {
            if (!Array.isArray(g))
              return d(g, m) === !0;
            var _, C, T, R, y = g[0];
            switch (y) {
              case "!":
                return !l(g[1], m);
              case "or":
                for (var b = 1; b < g.length; b++)
                  if (l(g[b], m))
                    return !0;
                return !1;
              case "and":
                for (b = 1; b < g.length; b++)
                  if (!l(g[b], m))
                    return !1;
                return !0;
              case "=":
              case "!=":
                return function(S, x, k, D) {
                  switch (f(S) && (S = l(S, D)), f(x) && (x = l(x, D)), typeof S == "object" && typeof x == "object" && (S = JSON.stringify(S), x = JSON.stringify(x)), k) {
                    case "=":
                      return S === x;
                    case "!=":
                      return S !== x;
                    default:
                      throw new Error("Invalid operator in compareItems: ".concat(k));
                  }
                }(d(g[1], m), d(g[2], m), y, m);
              case "<=":
              case "<":
              case ">":
              case ">=":
                return function(S, x, k, D) {
                  if (f(S) && (S = l(S, D)), f(x) && (x = l(x, D)), typeof S != "number" || typeof x != "number")
                    return !1;
                  switch (k) {
                    case "<=":
                      return S <= x;
                    case ">=":
                      return S >= x;
                    case "<":
                      return S < x;
                    case ">":
                      return S > x;
                    default:
                      throw new Error("Invalid operator in compareNumbers: ".concat(k));
                  }
                }(d(g[1], m), d(g[2], m), y, m);
              case "in":
                return function(S, x, k) {
                  return x.find(function(D) {
                    return d(D, k) === S;
                  }) !== void 0;
                }(d(g[1], m), d(g[2], m), m);
              case "contains":
                return T = d(g[1], m), R = d(g[2], m), typeof T == "string" && typeof R == "string" && T.indexOf(R) !== -1;
              case "match":
                return _ = d(g[1], m), C = d(g[2], m), typeof _ == "string" && typeof C == "string" && function(S, x) {
                  var k, D;
                  e: for (; S.length > 0; ) {
                    var E, L;
                    if (E = (k = h(S)).star, L = k.chunk, S = k.pattern, E && L === "")
                      return !0;
                    var U = p(L, x), q = U.t, z = U.ok, H = U.err;
                    if (H)
                      return !1;
                    if (!z || !(q.length === 0 || S.length > 0)) {
                      if (E)
                        for (var $ = 0; $ < x.length; $++) {
                          if (q = (D = p(L, x.slice($ + 1))).t, z = D.ok, H = D.err, z) {
                            if (S.length === 0 && q.length > 0)
                              continue;
                            x = q;
                            continue e;
                          }
                          if (H)
                            return !1;
                        }
                      return !1;
                    }
                    x = q;
                  }
                  return x.length === 0;
                }(C, _);
              case "lowercase":
                var A = d(g[1], m);
                return typeof A != "string" ? null : A.toLowerCase();
              case "typeof":
                return typeof d(g[1], m);
              case "length":
                return function(S) {
                  return S === null ? 0 : Array.isArray(S) || typeof S == "string" ? S.length : NaN;
                }(d(g[1], m));
              default:
                throw new Error("FQL IR could not evaluate for token: ".concat(y));
            }
          }
          function d(g, m) {
            return Array.isArray(g) ? g : typeof g == "object" ? g.value : (0, c.default)(m, g);
          }
          function f(g) {
            return !!Array.isArray(g) && ((g[0] === "lowercase" || g[0] === "length" || g[0] === "typeof") && g.length === 2 || (g[0] === "contains" || g[0] === "match") && g.length === 3);
          }
          function h(g) {
            for (var m = { star: !1, chunk: "", pattern: "" }; g.length > 0 && g[0] === "*"; )
              g = g.slice(1), m.star = !0;
            var _, C = !1;
            e: for (_ = 0; _ < g.length; _++)
              switch (g[_]) {
                case "\\":
                  _ + 1 < g.length && _++;
                  break;
                case "[":
                  C = !0;
                  break;
                case "]":
                  C = !1;
                  break;
                case "*":
                  if (!C)
                    break e;
              }
            return m.chunk = g.slice(0, _), m.pattern = g.slice(_), m;
          }
          function p(g, m) {
            for (var _, C, T = { t: "", ok: !1, err: !1 }; g.length > 0; ) {
              if (m.length === 0)
                return T;
              switch (g[0]) {
                case "[":
                  var R = m[0];
                  m = m.slice(1);
                  var y = !0;
                  (g = g.slice(1)).length > 0 && g[0] === "^" && (y = !1, g = g.slice(1));
                  for (var b = !1, A = 0; ; ) {
                    if (g.length > 0 && g[0] === "]" && A > 0) {
                      g = g.slice(1);
                      break;
                    }
                    var S, x = "";
                    if (S = (_ = v(g)).char, g = _.newChunk, _.err || (x = S, g[0] === "-" && (x = (C = v(g.slice(1))).char, g = C.newChunk, C.err)))
                      return T;
                    S <= R && R <= x && (b = !0), A++;
                  }
                  if (b !== y)
                    return T;
                  break;
                case "?":
                  m = m.slice(1), g = g.slice(1);
                  break;
                case "\\":
                  if ((g = g.slice(1)).length === 0)
                    return T.err = !0, T;
                default:
                  if (g[0] !== m[0])
                    return T;
                  m = m.slice(1), g = g.slice(1);
              }
            }
            return T.t = m, T.ok = !0, T.err = !1, T;
          }
          function v(g) {
            var m = { char: "", newChunk: "", err: !1 };
            return g.length === 0 || g[0] === "-" || g[0] === "]" || g[0] === "\\" && (g = g.slice(1)).length === 0 ? (m.err = !0, m) : (m.char = g[0], m.newChunk = g.slice(1), m.newChunk.length === 0 && (m.err = !0), m);
          }
          s.default = function(g, m) {
            if (!m)
              throw new Error("No matcher supplied!");
            switch (m.type) {
              case "all":
                return !0;
              case "fql":
                return function(_, C) {
                  if (!_)
                    return !1;
                  try {
                    _ = JSON.parse(_);
                  } catch (R) {
                    throw new Error('Failed to JSON.parse FQL intermediate representation "'.concat(_, '": ').concat(R));
                  }
                  var T = l(_, C);
                  return typeof T == "boolean" && T;
                }(m.ir, g);
              default:
                throw new Error("Matcher of type ".concat(m.type, " unsupported."));
            }
          };
        }, 1444: function(o, s) {
          Object.defineProperty(s, "__esModule", { value: !0 });
          var a = function() {
            function u(c) {
              this.rules = [], this.rules = c || [];
            }
            return u.prototype.getRulesByDestinationName = function(c) {
              for (var l = [], d = 0, f = this.rules; d < f.length; d++) {
                var h = f[d];
                h.destinationName !== c && h.destinationName !== void 0 || l.push(h);
              }
              return l;
            }, u;
          }();
          s.default = a;
        }, 4303: function(o, s, a) {
          var u = this && this.__importDefault || function(T) {
            return T && T.__esModule ? T : { default: T };
          };
          Object.defineProperty(s, "__esModule", { value: !0 });
          var c = u(a(374)), l = u(a(7843)), d = u(a(5500)), f = a(9014), h = a(4966);
          function p(T, R) {
            g(T, R.drop, function(y, b) {
              b.forEach(function(A) {
                return delete y[A];
              });
            });
          }
          function v(T, R) {
            g(T, R.allow, function(y, b) {
              Object.keys(y).forEach(function(A) {
                b.includes(A) || delete y[A];
              });
            });
          }
          function g(T, R, y) {
            Object.entries(R).forEach(function(b) {
              var A = b[0], S = b[1], x = function(D) {
                typeof D == "object" && D !== null && y(D, S);
              }, k = A === "" ? T : (0, l.default)(T, A);
              Array.isArray(k) ? k.forEach(x) : x(k);
            });
          }
          function m(T, R) {
            var y = JSON.parse(JSON.stringify(T));
            for (var b in R.map)
              if (R.map.hasOwnProperty(b)) {
                var A = R.map[b], S = b.split("."), x = void 0;
                if (S.length > 1 ? (S.pop(), x = (0, l.default)(y, S.join("."))) : x = T, typeof x == "object") {
                  if (A.copy) {
                    var k = (0, l.default)(y, A.copy);
                    k !== void 0 && (0, f.dset)(T, b, k);
                  } else if (A.move) {
                    var D = (0, l.default)(y, A.move);
                    D !== void 0 && (0, f.dset)(T, b, D), (0, h.unset)(T, A.move);
                  } else
                    A.hasOwnProperty("set") && (0, f.dset)(T, b, A.set);
                  if (A.to_string) {
                    var E = (0, l.default)(T, b);
                    if (typeof E == "string" || typeof E == "object" && E !== null)
                      continue;
                    E !== void 0 ? (0, f.dset)(T, b, JSON.stringify(E)) : (0, f.dset)(T, b, "undefined");
                  }
                }
              }
          }
          function _(T, R) {
            return !(R.sample.percent <= 0) && (R.sample.percent >= 1 || (R.sample.path ? function(b, A) {
              var S = (0, l.default)(b, A.sample.path), x = (0, c.default)(JSON.stringify(S)), k = -64, D = [];
              C(x.slice(0, 8), D);
              for (var E = 0, L = 0; L < 64 && D[L] !== 1; L++)
                E++;
              if (E !== 0) {
                var U = [];
                C(x.slice(9, 16), U), k -= E, D.splice(0, E), U.splice(64 - E), D = D.concat(U);
              }
              return D[63] = D[63] === 0 ? 1 : 0, (0, d.default)(parseInt(D.join(""), 2), k) < A.sample.percent;
            }(T, R) : (y = R.sample.percent, Math.random() <= y)));
            var y;
          }
          function C(T, R) {
            for (var y = 0; y < 8; y++)
              for (var b = T[y], A = 128; A >= 1; A /= 2)
                b - A >= 0 ? (b -= A, R.push(1)) : R.push(0);
          }
          s.default = function(T, R) {
            for (var y = T, b = 0, A = R; b < A.length; b++) {
              var S = A[b];
              switch (S.type) {
                case "drop":
                  return null;
                case "drop_properties":
                  p(y, S.config);
                  break;
                case "allow_properties":
                  v(y, S.config);
                  break;
                case "sample_event":
                  if (_(y, S.config))
                    break;
                  return null;
                case "map_properties":
                  m(y, S.config);
                  break;
                case "hash_properties":
                  break;
                default:
                  throw new Error('Transformer of type "'.concat(S.type, '" is unsupported.'));
              }
            }
            return y;
          };
        }, 4966: function(o, s, a) {
          var u = this && this.__importDefault || function(l) {
            return l && l.__esModule ? l : { default: l };
          };
          Object.defineProperty(s, "__esModule", { value: !0 }), s.unset = void 0;
          var c = u(a(7843));
          s.unset = function(l, d) {
            if ((0, c.default)(l, d)) {
              for (var f = d.split("."), h = f.pop(); f.length && f[f.length - 1].slice(-1) === "\\"; )
                h = f.pop().slice(0, -1) + "." + h;
              for (; f.length; )
                l = l[d = f.shift()];
              return delete l[h];
            }
            return !0;
          };
        }, 9014: function(o, s) {
          s.dset = function(a, u, c) {
            u.split && (u = u.split("."));
            for (var l, d, f = 0, h = u.length, p = a; f < h && (d = u[f++]) !== "__proto__" && d !== "constructor" && d !== "prototype"; )
              p = p[d] = f === h ? c : typeof (l = p[d]) == typeof u ? l : 0 * u[f] != 0 || ~("" + u[f]).indexOf(".") ? {} : [];
          };
        }, 3304: function(o) {
          var s = typeof Float64Array == "function" ? Float64Array : void 0;
          o.exports = s;
        }, 7382: function(o, s, a) {
          var u, c = a(5569), l = a(3304), d = a(8482);
          u = c() ? l : d, o.exports = u;
        }, 8482: function(o) {
          o.exports = function() {
            throw new Error("not implemented");
          };
        }, 6322: function(o, s, a) {
          var u, c = a(2508), l = a(5679), d = a(882);
          u = c() ? l : d, o.exports = u;
        }, 882: function(o) {
          o.exports = function() {
            throw new Error("not implemented");
          };
        }, 5679: function(o) {
          var s = typeof Uint16Array == "function" ? Uint16Array : void 0;
          o.exports = s;
        }, 4773: function(o, s, a) {
          var u, c = a(9773), l = a(3004), d = a(3078);
          u = c() ? l : d, o.exports = u;
        }, 3078: function(o) {
          o.exports = function() {
            throw new Error("not implemented");
          };
        }, 3004: function(o) {
          var s = typeof Uint32Array == "function" ? Uint32Array : void 0;
          o.exports = s;
        }, 7980: function(o, s, a) {
          var u, c = a(8114), l = a(6737), d = a(3357);
          u = c() ? l : d, o.exports = u;
        }, 3357: function(o) {
          o.exports = function() {
            throw new Error("not implemented");
          };
        }, 6737: function(o) {
          var s = typeof Uint8Array == "function" ? Uint8Array : void 0;
          o.exports = s;
        }, 2684: function(o) {
          var s = typeof Float64Array == "function" ? Float64Array : null;
          o.exports = s;
        }, 5569: function(o, s, a) {
          var u = a(3876);
          o.exports = u;
        }, 3876: function(o, s, a) {
          var u = a(1448), c = a(2684);
          o.exports = function() {
            var l, d;
            if (typeof c != "function")
              return !1;
            try {
              d = new c([1, 3.14, -3.14, NaN]), l = u(d) && d[0] === 1 && d[1] === 3.14 && d[2] === -3.14 && d[3] != d[3];
            } catch (f) {
              l = !1;
            }
            return l;
          };
        }, 9048: function(o, s, a) {
          var u = a(3763);
          o.exports = u;
        }, 3763: function(o) {
          var s = Object.prototype.hasOwnProperty;
          o.exports = function(a, u) {
            return a != null && s.call(a, u);
          };
        }, 7009: function(o, s, a) {
          var u = a(6784);
          o.exports = u;
        }, 6784: function(o) {
          o.exports = function() {
            return typeof Symbol == "function" && typeof Symbol("foo") == "symbol";
          };
        }, 3123: function(o, s, a) {
          var u = a(8481);
          o.exports = u;
        }, 8481: function(o, s, a) {
          var u = a(7009)();
          o.exports = function() {
            return u && typeof Symbol.toStringTag == "symbol";
          };
        }, 2508: function(o, s, a) {
          var u = a(3403);
          o.exports = u;
        }, 3403: function(o, s, a) {
          var u = a(768), c = a(9668), l = a(187);
          o.exports = function() {
            var d, f;
            if (typeof l != "function")
              return !1;
            try {
              f = new l(f = [1, 3.14, -3.14, c + 1, c + 2]), d = u(f) && f[0] === 1 && f[1] === 3 && f[2] === c - 2 && f[3] === 0 && f[4] === 1;
            } catch (h) {
              d = !1;
            }
            return d;
          };
        }, 187: function(o) {
          var s = typeof Uint16Array == "function" ? Uint16Array : null;
          o.exports = s;
        }, 9773: function(o, s, a) {
          var u = a(2822);
          o.exports = u;
        }, 2822: function(o, s, a) {
          var u = a(2744), c = a(3899), l = a(746);
          o.exports = function() {
            var d, f;
            if (typeof l != "function")
              return !1;
            try {
              f = new l(f = [1, 3.14, -3.14, c + 1, c + 2]), d = u(f) && f[0] === 1 && f[1] === 3 && f[2] === c - 2 && f[3] === 0 && f[4] === 1;
            } catch (h) {
              d = !1;
            }
            return d;
          };
        }, 746: function(o) {
          var s = typeof Uint32Array == "function" ? Uint32Array : null;
          o.exports = s;
        }, 8114: function(o, s, a) {
          var u = a(8066);
          o.exports = u;
        }, 8066: function(o, s, a) {
          var u = a(8279), c = a(3443), l = a(2731);
          o.exports = function() {
            var d, f;
            if (typeof l != "function")
              return !1;
            try {
              f = new l(f = [1, 3.14, -3.14, c + 1, c + 2]), d = u(f) && f[0] === 1 && f[1] === 3 && f[2] === c - 2 && f[3] === 0 && f[4] === 1;
            } catch (h) {
              d = !1;
            }
            return d;
          };
        }, 2731: function(o) {
          var s = typeof Uint8Array == "function" ? Uint8Array : null;
          o.exports = s;
        }, 1448: function(o, s, a) {
          var u = a(1453);
          o.exports = u;
        }, 1453: function(o, s, a) {
          var u = a(6208), c = typeof Float64Array == "function";
          o.exports = function(l) {
            return c && l instanceof Float64Array || u(l) === "[object Float64Array]";
          };
        }, 9331: function(o, s, a) {
          var u = a(7980), c = { uint16: a(6322), uint8: u };
          o.exports = c;
        }, 5902: function(o, s, a) {
          var u = a(4106);
          o.exports = u;
        }, 4106: function(o, s, a) {
          var u, c, l = a(9331);
          (c = new l.uint16(1))[0] = 4660, u = new l.uint8(c.buffer)[0] === 52, o.exports = u;
        }, 768: function(o, s, a) {
          var u = a(3823);
          o.exports = u;
        }, 3823: function(o, s, a) {
          var u = a(6208), c = typeof Uint16Array == "function";
          o.exports = function(l) {
            return c && l instanceof Uint16Array || u(l) === "[object Uint16Array]";
          };
        }, 2744: function(o, s, a) {
          var u = a(2326);
          o.exports = u;
        }, 2326: function(o, s, a) {
          var u = a(6208), c = typeof Uint32Array == "function";
          o.exports = function(l) {
            return c && l instanceof Uint32Array || u(l) === "[object Uint32Array]";
          };
        }, 8279: function(o, s, a) {
          var u = a(208);
          o.exports = u;
        }, 208: function(o, s, a) {
          var u = a(6208), c = typeof Uint8Array == "function";
          o.exports = function(l) {
            return c && l instanceof Uint8Array || u(l) === "[object Uint8Array]";
          };
        }, 6315: function(o) {
          o.exports = 1023;
        }, 1686: function(o) {
          o.exports = 2147483647;
        }, 3105: function(o) {
          o.exports = 2146435072;
        }, 3449: function(o) {
          o.exports = 2147483648;
        }, 6988: function(o) {
          o.exports = -1023;
        }, 9777: function(o) {
          o.exports = 1023;
        }, 3690: function(o) {
          o.exports = -1074;
        }, 2918: function(o, s, a) {
          var u = a(4772).NEGATIVE_INFINITY;
          o.exports = u;
        }, 4165: function(o) {
          var s = Number.POSITIVE_INFINITY;
          o.exports = s;
        }, 6488: function(o) {
          o.exports = 22250738585072014e-324;
        }, 9668: function(o) {
          o.exports = 65535;
        }, 3899: function(o) {
          o.exports = 4294967295;
        }, 3443: function(o) {
          o.exports = 255;
        }, 7011: function(o, s, a) {
          var u = a(812);
          o.exports = u;
        }, 812: function(o, s, a) {
          var u = a(4165), c = a(2918);
          o.exports = function(l) {
            return l === u || l === c;
          };
        }, 1883: function(o, s, a) {
          var u = a(1797);
          o.exports = u;
        }, 1797: function(o) {
          o.exports = function(s) {
            return s != s;
          };
        }, 513: function(o, s, a) {
          var u = a(5760);
          o.exports = u;
        }, 5760: function(o) {
          o.exports = function(s) {
            return Math.abs(s);
          };
        }, 5848: function(o, s, a) {
          var u = a(677);
          o.exports = u;
        }, 677: function(o, s, a) {
          var u = a(3449), c = a(1686), l = a(7838), d = a(1921), f = a(2490), h = [0, 0];
          o.exports = function(p, v) {
            var g, m;
            return l.assign(p, h, 1, 0), g = h[0], g &= c, m = d(v), f(g |= m &= u, h[1]);
          };
        }, 5500: function(o, s, a) {
          var u = a(8397);
          o.exports = u;
        }, 8397: function(o, s, a) {
          var u = a(4165), c = a(2918), l = a(6315), d = a(9777), f = a(6988), h = a(3690), p = a(1883), v = a(7011), g = a(5848), m = a(4948), _ = a(8478), C = a(7838), T = a(2490), R = [0, 0], y = [0, 0];
          o.exports = function(b, A) {
            var S, x;
            return b === 0 || p(b) || v(b) ? b : (m(R, b), A += R[1], (A += _(b = R[0])) < h ? g(0, b) : A > d ? b < 0 ? c : u : (A <= f ? (A += 52, x = 2220446049250313e-31) : x = 1, C(y, b), S = y[0], S &= 2148532223, x * T(S |= A + l << 20, y[1])));
          };
        }, 4772: function(o, s, a) {
          var u = a(7548);
          o.exports = u;
        }, 7548: function(o) {
          o.exports = Number;
        }, 8478: function(o, s, a) {
          var u = a(4500);
          o.exports = u;
        }, 4500: function(o, s, a) {
          var u = a(1921), c = a(3105), l = a(6315);
          o.exports = function(d) {
            var f = u(d);
            return (f = (f & c) >>> 20) - l | 0;
          };
        }, 2490: function(o, s, a) {
          var u = a(9639);
          o.exports = u;
        }, 4445: function(o, s, a) {
          var u, c, l;
          a(5902) === !0 ? (c = 1, l = 0) : (c = 0, l = 1), u = { HIGH: c, LOW: l }, o.exports = u;
        }, 9639: function(o, s, a) {
          var u = a(4773), c = a(7382), l = a(4445), d = new c(1), f = new u(d.buffer), h = l.HIGH, p = l.LOW;
          o.exports = function(v, g) {
            return f[h] = v, f[p] = g, d[0];
          };
        }, 5646: function(o, s, a) {
          var u;
          u = a(5902) === !0 ? 1 : 0, o.exports = u;
        }, 1921: function(o, s, a) {
          var u = a(6285);
          o.exports = u;
        }, 6285: function(o, s, a) {
          var u = a(4773), c = a(7382), l = a(5646), d = new c(1), f = new u(d.buffer);
          o.exports = function(h) {
            return d[0] = h, f[l];
          };
        }, 9024: function(o, s, a) {
          var u = a(6488), c = a(7011), l = a(1883), d = a(513);
          o.exports = function(f, h, p, v) {
            return l(f) || c(f) ? (h[v] = f, h[v + p] = 0, h) : f !== 0 && d(f) < u ? (h[v] = 4503599627370496 * f, h[v + p] = -52, h) : (h[v] = f, h[v + p] = 0, h);
          };
        }, 4948: function(o, s, a) {
          var u = a(7576), c = a(9422);
          u(c, "assign", a(9024)), o.exports = c;
        }, 9422: function(o, s, a) {
          var u = a(9024);
          o.exports = function(c) {
            return u(c, [0, 0], 1, 0);
          };
        }, 5239: function(o, s, a) {
          var u = a(4773), c = a(7382), l = a(5782), d = new c(1), f = new u(d.buffer), h = l.HIGH, p = l.LOW;
          o.exports = function(v, g, m, _) {
            return d[0] = v, g[_] = f[h], g[_ + m] = f[p], g;
          };
        }, 7838: function(o, s, a) {
          var u = a(7576), c = a(4010);
          u(c, "assign", a(5239)), o.exports = c;
        }, 5782: function(o, s, a) {
          var u, c, l;
          a(5902) === !0 ? (c = 1, l = 0) : (c = 0, l = 1), u = { HIGH: c, LOW: l }, o.exports = u;
        }, 4010: function(o, s, a) {
          var u = a(5239);
          o.exports = function(c) {
            return u(c, [0, 0], 1, 0);
          };
        }, 7576: function(o, s, a) {
          var u = a(7063);
          o.exports = u;
        }, 7063: function(o, s, a) {
          var u = a(6691);
          o.exports = function(c, l, d) {
            u(c, l, { configurable: !1, enumerable: !1, writable: !1, value: d });
          };
        }, 2073: function(o) {
          var s = Object.defineProperty;
          o.exports = s;
        }, 1680: function(o) {
          var s = typeof Object.defineProperty == "function" ? Object.defineProperty : null;
          o.exports = s;
        }, 1471: function(o, s, a) {
          var u = a(1680);
          o.exports = function() {
            try {
              return u({}, "x", {}), !0;
            } catch (c) {
              return !1;
            }
          };
        }, 6691: function(o, s, a) {
          var u, c = a(1471), l = a(2073), d = a(1309);
          u = c() ? l : d, o.exports = u;
        }, 1309: function(o) {
          var s = Object.prototype, a = s.toString, u = s.__defineGetter__, c = s.__defineSetter__, l = s.__lookupGetter__, d = s.__lookupSetter__;
          o.exports = function(f, h, p) {
            var v, g, m, _;
            if (typeof f != "object" || f === null || a.call(f) === "[object Array]")
              throw new TypeError("invalid argument. First argument must be an object. Value: `" + f + "`.");
            if (typeof p != "object" || p === null || a.call(p) === "[object Array]")
              throw new TypeError("invalid argument. Property descriptor must be an object. Value: `" + p + "`.");
            if ((g = "value" in p) && (l.call(f, h) || d.call(f, h) ? (v = f.__proto__, f.__proto__ = s, delete f[h], f[h] = p.value, f.__proto__ = v) : f[h] = p.value), m = "get" in p, _ = "set" in p, g && (m || _))
              throw new Error("invalid argument. Cannot specify one or more accessors and a value or writable attribute in the property descriptor.");
            return m && u && u.call(f, h, p.get), _ && c && c.call(f, h, p.set), f;
          };
        }, 6208: function(o, s, a) {
          var u, c = a(3123), l = a(7407), d = a(4210);
          u = c() ? d : l, o.exports = u;
        }, 7407: function(o, s, a) {
          var u = a(173);
          o.exports = function(c) {
            return u.call(c);
          };
        }, 4210: function(o, s, a) {
          var u = a(9048), c = a(1403), l = a(173);
          o.exports = function(d) {
            var f, h, p;
            if (d == null)
              return l.call(d);
            h = d[c], f = u(d, c);
            try {
              d[c] = void 0;
            } catch (v) {
              return l.call(d);
            }
            return p = l.call(d), f ? d[c] = h : delete d[c], p;
          };
        }, 173: function(o) {
          var s = Object.prototype.toString;
          o.exports = s;
        }, 1403: function(o) {
          var s = typeof Symbol == "function" ? Symbol.toStringTag : "";
          o.exports = s;
        }, 7843: function(o) {
          o.exports = function(s, a, u, c, l) {
            for (a = a.split ? a.split(".") : a, c = 0; c < a.length; c++)
              s = s ? s[a[c]] : l;
            return s === l ? u : s;
          };
        }, 374: function(o, s, a) {
          a.r(s), a.d(s, { default: function() {
            return l;
          } });
          for (var u = [], c = 0; c < 64; )
            u[c] = 0 | 4294967296 * Math.sin(++c % Math.PI);
          function l(d) {
            var f, h, p, v = [f = 1732584193, h = 4023233417, ~f, ~h], g = [], m = unescape(encodeURI(d)) + "", _ = m.length;
            for (d = --_ / 4 + 2 | 15, g[--d] = 8 * _; ~_; )
              g[_ >> 2] |= m.charCodeAt(_) << 8 * _--;
            for (c = m = 0; c < d; c += 16) {
              for (_ = v; m < 64; _ = [p = _[3], f + ((p = _[0] + [f & h | ~f & p, p & f | ~p & h, f ^ h ^ p, h ^ (f | ~p)][_ = m >> 4] + u[m] + ~~g[c | 15 & [m, 5 * m + 1, 3 * m + 5, 7 * m][_]]) << (_ = [7, 12, 17, 22, 5, 9, 14, 20, 4, 11, 16, 23, 6, 10, 15, 21][4 * _ + m++ % 4]) | p >>> -_), f, h])
                f = 0 | _[1], h = _[2];
              for (m = 4; m; )
                v[--m] += _[m];
            }
            for (d = ""; m < 32; )
              d += (v[m >> 3] >> 4 * (1 ^ m++) & 15).toString(16);
            return d;
          }
        } }, r = {};
        function i(o) {
          var s = r[o];
          if (s !== void 0)
            return s.exports;
          var a = r[o] = { exports: {} };
          return n[o].call(a.exports, a, a.exports, i), a.exports;
        }
        return i.d = function(o, s) {
          for (var a in s)
            i.o(s, a) && !i.o(o, a) && Object.defineProperty(o, a, { enumerable: !0, get: s[a] });
        }, i.o = function(o, s) {
          return Object.prototype.hasOwnProperty.call(o, s);
        }, i.r = function(o) {
          typeof Symbol != "undefined" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(o, "__esModule", { value: !0 });
        }, i(2870);
      }();
    });
  }(ir)), ir.exports;
}
var or = /* @__PURE__ */ zg(), Vg = function(t) {
  return function(e) {
    var n = e.payload, r = e.integration, i = e.next, o = new or.Store(t), s = o.getRulesByDestinationName(r);
    s.forEach(function(a) {
      for (var u = a.matchers, c = a.transformers, l = 0; l < u.length; l++)
        if (or.matches(n.obj, u[l]) && (n.obj = or.transform(n.obj, c[l]), n.obj === null))
          return i(null);
    }), i(n);
  };
};
const Wg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  tsubMiddleware: Vg
}, Symbol.toStringTag, { value: "Module" }));
function ya(t, e) {
  var n, r;
  return typeof (e == null ? void 0 : e.enabled) == "boolean" ? e.enabled : (r = (n = t == null ? void 0 : t.__default) === null || n === void 0 ? void 0 : n.enabled) !== null && r !== void 0 ? r : !0;
}
function ma(t) {
  return t.toLowerCase().replace(".", "").replace(/\s+/g, "-");
}
function va(t, e) {
  return e === void 0 && (e = !1), e ? btoa(t).replace(/=/g, "") : void 0;
}
function Kg(t) {
  return ("Integration" in t ? t.Integration : t).prototype.name;
}
function Jg(t, e, n) {
  var r, i;
  try {
    var o = ((i = (r = window == null ? void 0 : window.performance) === null || r === void 0 ? void 0 : r.getEntriesByName(t, "resource")) !== null && i !== void 0 ? i : [])[0];
    o && e.stats.gauge("legacy_destination_time", Math.round(o.duration), W([
      n
    ], o.duration < 100 ? ["cached"] : [], !0));
  } catch (s) {
  }
}
function Yg(t, e, n) {
  var r;
  if ("Integration" in t) {
    var i = {
      user: function() {
        return n.user();
      },
      addIntegration: function() {
      }
    };
    t(i), r = t.Integration;
  } else
    r = t;
  var o = new r(e);
  return o.analytics = n, o;
}
function Xg(t, e, n, r) {
  return P(this, void 0, void 0, function() {
    var i, o, s, a, u, c;
    return F(this, function(l) {
      switch (l.label) {
        case 0:
          i = ma(e), o = va(i, r), s = ci(), a = "".concat(s, "/integrations/").concat(o != null ? o : i, "/").concat(n, "/").concat(o != null ? o : i, ".dynamic.js.gz"), l.label = 1;
        case 1:
          return l.trys.push([1, 3, , 4]), [4, lt(a)];
        case 2:
          return l.sent(), Jg(a, t, e), [3, 4];
        case 3:
          throw u = l.sent(), t.stats.gauge("legacy_destination_time", -1, ["plugin:".concat(e), "failed"]), u;
        case 4:
          return c = window["".concat(i, "Deps")], [
            4,
            Promise.all(c.map(function(d) {
              return lt(s + d + ".gz");
            }))
            // @ts-ignore
          ];
        case 5:
          return l.sent(), window["".concat(i, "Loader")](), [2, window[
            // @ts-ignore
            "".concat(i, "Integration")
          ]];
      }
    });
  });
}
function Qg(t, e, n) {
  return P(this, void 0, void 0, function() {
    var r, i, o, s;
    return F(this, function(a) {
      return r = ci(), i = ma(t), o = va(t, n), s = "".concat(r, "/integrations/").concat(o != null ? o : i, "/").concat(e, "/").concat(o != null ? o : i, ".dynamic.js.gz"), [2, mg(s)];
    });
  });
}
function Zg(t) {
  var e, n, r, i;
  return (i = (n = (e = t == null ? void 0 : t.versionSettings) === null || e === void 0 ? void 0 : e.override) !== null && n !== void 0 ? n : (r = t == null ? void 0 : t.versionSettings) === null || r === void 0 ? void 0 : r.version) !== null && i !== void 0 ? i : "latest";
}
var ey = function(t, e) {
  var n, r = e.type, i = e.bundlingStatus, o = e.versionSettings, s = i !== "unbundled" && (r === "browser" || ((n = o == null ? void 0 : o.componentTypes) === null || n === void 0 ? void 0 : n.includes("browser")));
  return !t.startsWith("Segment") && t !== "Iterable" && s;
}, ty = function(t, e) {
  var n = e.All === !1 && e[t] === void 0;
  return e[t] === !1 || n;
};
function ny(t, e) {
  return P(this, void 0, void 0, function() {
    var n, r = this;
    return F(this, function(i) {
      switch (i.label) {
        case 0:
          return n = [], xe() ? [2, e] : [
            4,
            la(function() {
              return e.length > 0 && Gs();
            }, function() {
              return P(r, void 0, void 0, function() {
                var o, s, a;
                return F(this, function(u) {
                  switch (u.label) {
                    case 0:
                      return o = e.pop(), o ? [4, ct(o, t)] : [
                        2
                        /*return*/
                      ];
                    case 1:
                      return s = u.sent(), a = s instanceof oe, a || n.push(o), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            })
            // re-add failed tasks
          ];
        case 1:
          return i.sent(), n.map(function(o) {
            return e.pushWithBackoff(o);
          }), [2, e];
      }
    });
  });
}
var _a = (
  /** @class */
  function() {
    function t(e, n, r, i, o, s) {
      i === void 0 && (i = {});
      var a = this;
      this.options = {}, this.type = "destination", this.middleware = [], this.initializePromise = Xr(), this.flushing = !1, this.name = e, this.version = n, this.settings = I({}, i), this.disableAutoISOConversion = o.disableAutoISOConversion || !1, this.integrationSource = s, this.settings.type && this.settings.type === "browser" && delete this.settings.type, this.initializePromise.promise.then(function(u) {
        return a._initialized = u;
      }, function() {
      }), this.options = o, this.buffer = o.disableClientPersistence ? new An(4, []) : new Tn(4, "".concat(r, ":dest-").concat(e)), this.scheduleFlush();
    }
    return t.prototype.isLoaded = function() {
      return !!this._ready;
    }, t.prototype.ready = function() {
      var e = this;
      return this.initializePromise.promise.then(function() {
        var n;
        return (n = e.onReady) !== null && n !== void 0 ? n : Promise.resolve();
      });
    }, t.prototype.load = function(e, n) {
      var r;
      return P(this, void 0, void 0, function() {
        var i, o, s, a = this;
        return F(this, function(u) {
          switch (u.label) {
            case 0:
              if (this._ready || this.onReady !== void 0)
                return [
                  2
                  /*return*/
                ];
              u.label = 1;
            case 1:
              return u.trys.push([1, 5, , 6]), (r = this.integrationSource) !== null && r !== void 0 ? (o = r, [3, 4]) : [3, 2];
            case 2:
              return [4, Xg(e, this.name, this.version, this.options.obfuscate)];
            case 3:
              o = u.sent(), u.label = 4;
            case 4:
              return i = o, this.integration = Yg(i, this.settings, n), [3, 6];
            case 5:
              throw s = u.sent(), ae(e, {
                integrationName: this.name,
                methodName: "load",
                type: "classic",
                didError: !0
              }), s;
            case 6:
              this.onReady = new Promise(function(c) {
                var l = function() {
                  a._ready = !0, c(!0);
                };
                a.integration.once("ready", l);
              }), this.integration.on("initialize", function() {
                a.initializePromise.resolve(!0);
              });
              try {
                ae(e, {
                  integrationName: this.name,
                  methodName: "initialize",
                  type: "classic"
                }), this.integration.initialize();
              } catch (c) {
                throw ae(e, {
                  integrationName: this.name,
                  methodName: "initialize",
                  type: "classic",
                  didError: !0
                }), this.initializePromise.resolve(!1), c;
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.unload = function(e, n) {
      return Qg(this.name, this.version, this.options.obfuscate);
    }, t.prototype.addMiddleware = function() {
      for (var e, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      this.middleware = (e = this.middleware).concat.apply(e, n);
    }, t.prototype.shouldBuffer = function(e) {
      return (
        // page events can't be buffered because of destinations that automatically add page views
        e.event.type !== "page" && (xe() || this._ready !== !0 || this._initialized !== !0)
      );
    }, t.prototype.send = function(e, n, r) {
      var i, o;
      return P(this, void 0, void 0, function() {
        var s, a, u, c, l, d;
        return F(this, function(f) {
          switch (f.label) {
            case 0:
              return this.shouldBuffer(e) ? (this.buffer.push(e), this.scheduleFlush(), [2, e]) : (s = (o = (i = this.options) === null || i === void 0 ? void 0 : i.plan) === null || o === void 0 ? void 0 : o.track, a = e.event.event, s && a && this.name !== "Segment.io" && (u = s[a], ya(s, u) ? e.updateEvent("integrations", I(I({}, e.event.integrations), u == null ? void 0 : u.integrations)) : (e.updateEvent("integrations", I(I({}, e.event.integrations), { All: !1, "Segment.io": !0 })), e.cancel(new ke({
                retry: !1,
                reason: "Event ".concat(a, " disabled for integration ").concat(this.name, " in tracking plan"),
                type: "Dropped by plan"
              }))), u != null && u.enabled && (u == null ? void 0 : u.integrations[this.name]) === !1 && e.cancel(new ke({
                retry: !1,
                reason: "Event ".concat(a, " disabled for integration ").concat(this.name, " in tracking plan"),
                type: "Dropped by plan"
              }))), [4, li(this.name, e.event, this.middleware)]);
            case 1:
              if (c = f.sent(), c === null)
                return [2, e];
              l = new n(c, {
                traverse: !this.disableAutoISOConversion
              }), ae(e, {
                integrationName: this.name,
                methodName: r,
                type: "classic"
              }), f.label = 2;
            case 2:
              return f.trys.push([2, 5, , 6]), this.integration ? [4, this.integration.invoke.call(this.integration, r, l)] : [3, 4];
            case 3:
              f.sent(), f.label = 4;
            case 4:
              return [3, 6];
            case 5:
              throw d = f.sent(), ae(e, {
                integrationName: this.name,
                methodName: r,
                type: "classic",
                didError: !0
              }), d;
            case 6:
              return [2, e];
          }
        });
      });
    }, t.prototype.track = function(e) {
      return P(this, void 0, void 0, function() {
        return F(this, function(n) {
          return [2, this.send(e, ne.Track, "track")];
        });
      });
    }, t.prototype.page = function(e) {
      var n;
      return P(this, void 0, void 0, function() {
        return F(this, function(r) {
          switch (r.label) {
            case 0:
              return !((n = this.integration) === null || n === void 0) && n._assumesPageview && !this._initialized && this.integration.initialize(), [4, this.initializePromise.promise];
            case 1:
              return r.sent(), [2, this.send(e, ne.Page, "page")];
          }
        });
      });
    }, t.prototype.identify = function(e) {
      return P(this, void 0, void 0, function() {
        return F(this, function(n) {
          return [2, this.send(e, ne.Identify, "identify")];
        });
      });
    }, t.prototype.alias = function(e) {
      return P(this, void 0, void 0, function() {
        return F(this, function(n) {
          return [2, this.send(e, ne.Alias, "alias")];
        });
      });
    }, t.prototype.group = function(e) {
      return P(this, void 0, void 0, function() {
        return F(this, function(n) {
          return [2, this.send(e, ne.Group, "group")];
        });
      });
    }, t.prototype.scheduleFlush = function() {
      var e = this;
      this.flushing || setTimeout(function() {
        return P(e, void 0, void 0, function() {
          var n;
          return F(this, function(r) {
            switch (r.label) {
              case 0:
                return xe() || this._ready !== !0 || this._initialized !== !0 ? (this.scheduleFlush(), [
                  2
                  /*return*/
                ]) : (this.flushing = !0, n = this, [4, ny(this, this.buffer)]);
              case 1:
                return n.buffer = r.sent(), this.flushing = !1, this.buffer.todo > 0 && this.scheduleFlush(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, Math.random() * 5e3);
    }, t;
  }()
);
function ry(t, e, n, r, i, o) {
  var s, a;
  if (n === void 0 && (n = {}), r === void 0 && (r = {}), Bs())
    return [];
  e.plan && (r = r != null ? r : {}, r.plan = e.plan);
  var u = (a = (s = e.middlewareSettings) === null || s === void 0 ? void 0 : s.routingRules) !== null && a !== void 0 ? a : [], c = e.integrations, l = r.integrations, d = ha(e, r != null ? r : {}), f = o == null ? void 0 : o.reduce(function(p, v) {
    var g;
    return I(I({}, p), (g = {}, g[Kg(v)] = v, g));
  }, {}), h = new Set(W(W([], Object.keys(c).filter(function(p) {
    return ey(p, c[p]);
  }), !0), Object.keys(f || {}).filter(function(p) {
    return Z(c[p]) || Z(l == null ? void 0 : l[p]);
  }), !0));
  return Array.from(h).filter(function(p) {
    return !ty(p, n);
  }).map(function(p) {
    var v = c[p], g = Zg(v), m = new _a(p, g, t, d[p], r, f == null ? void 0 : f[p]), _ = u.filter(function(C) {
      return C.destinationName === p;
    });
    return _.length > 0 && i && m.addMiddleware(i), m;
  });
}
const iy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LegacyDestination: _a,
  ajsDestinations: ry
}, Symbol.toStringTag, { value: "Module" }));
function oy(t) {
  return P(this, void 0, void 0, function() {
    var e;
    return F(this, function(n) {
      switch (n.label) {
        case 0:
          return [
            4,
            Promise.resolve().then(() => py)
            // This is super gross, but we need to support the `window.analytics.plugins` namespace
            // that is linked in the segment docs in order to be backwards compatible with ajs-classic
            // @ts-expect-error
          ];
        case 1:
          return e = n.sent(), t._plugins = e, [
            2
            /*return*/
          ];
      }
    });
  });
}
const sy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  loadLegacyVideoPlugins: oy
}, Symbol.toStringTag, { value: "Module" }));
function ay(t, e) {
  var n, r;
  if (!t || !Object.keys(t))
    return {};
  var i = t.integrations ? Object.keys(t.integrations).filter(function(s) {
    return t.integrations[s] === !1;
  }) : [], o = [];
  return ((n = e.remotePlugins) !== null && n !== void 0 ? n : []).forEach(function(s) {
    i.forEach(function(a) {
      s.creationName == a && o.push(s.name);
    });
  }), ((r = e.remotePlugins) !== null && r !== void 0 ? r : []).reduce(function(s, a) {
    return a.settings.subscriptions && o.includes(a.name) && a.settings.subscriptions.forEach(
      // @ts-expect-error parameter 'sub' implicitly has an 'any' type
      function(u) {
        return s["".concat(a.name, " ").concat(u.partnerAction)] = !1;
      }
    ), s;
  }, {});
}
function uy(t, e) {
  function n(r) {
    var i = t, o = r.event.event;
    if (i && o) {
      var s = i[o];
      if (ya(i, s)) {
        var a = ay(s, e);
        r.updateEvent("integrations", I(I(I({}, r.event.integrations), s == null ? void 0 : s.integrations), a));
      } else
        return r.updateEvent("integrations", I(I({}, r.event.integrations), { All: !1, "Segment.io": !0 })), r;
    }
    return r;
  }
  return {
    name: "Schema Filter",
    version: "0.1.0",
    isLoaded: function() {
      return !0;
    },
    load: function() {
      return Promise.resolve();
    },
    type: "before",
    page: n,
    alias: n,
    track: n,
    identify: n,
    group: n
  };
}
const cy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  schemaFilter: uy
}, Symbol.toStringTag, { value: "Module" }));
function ly(t, e, n) {
  var r;
  return P(this, void 0, void 0, function() {
    var i, o, s, a, u, c = this;
    return F(this, function(l) {
      switch (l.label) {
        case 0:
          return Bs() ? [2, []] : (i = ci(), o = (r = e.enabledMiddleware) !== null && r !== void 0 ? r : {}, s = Object.entries(o).filter(function(d) {
            d[0];
            var f = d[1];
            return f;
          }).map(function(d) {
            var f = d[0];
            return f;
          }), a = s.map(function(d) {
            return P(c, void 0, void 0, function() {
              var f, h, p, v;
              return F(this, function(g) {
                switch (g.label) {
                  case 0:
                    f = d.replace("@segment/", ""), h = f, n && (h = btoa(f).replace(/=/g, "")), p = "".concat(i, "/middleware/").concat(h, "/latest/").concat(h, ".js.gz"), g.label = 1;
                  case 1:
                    return g.trys.push([1, 3, , 4]), [
                      4,
                      lt(p)
                      // @ts-ignore
                    ];
                  case 2:
                    return g.sent(), [2, window["".concat(f, "Middleware")]];
                  case 3:
                    return v = g.sent(), t.log("error", v), t.stats.increment("failed_remote_middleware"), [3, 4];
                  case 4:
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          }), [4, Promise.all(a)]);
        case 1:
          return u = l.sent(), u = u.filter(Boolean), [2, u];
      }
    });
  });
}
const dy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  remoteMiddlewares: ly
}, Symbol.toStringTag, { value: "Module" }));
var sr = { exports: {} }, Ho;
function fy() {
  return Ho || (Ho = 1, function(t, e) {
    (function(n, r) {
      t.exports = r();
    })(window, function() {
      return function(n) {
        var r = {};
        function i(o) {
          if (r[o]) return r[o].exports;
          var s = r[o] = { i: o, l: !1, exports: {} };
          return n[o].call(s.exports, s, s.exports, i), s.l = !0, s.exports;
        }
        return i.m = n, i.c = r, i.d = function(o, s, a) {
          i.o(o, s) || Object.defineProperty(o, s, { enumerable: !0, get: a });
        }, i.r = function(o) {
          typeof Symbol != "undefined" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(o, "__esModule", { value: !0 });
        }, i.t = function(o, s) {
          if (1 & s && (o = i(o)), 8 & s || 4 & s && typeof o == "object" && o && o.__esModule) return o;
          var a = /* @__PURE__ */ Object.create(null);
          if (i.r(a), Object.defineProperty(a, "default", { enumerable: !0, value: o }), 2 & s && typeof o != "string") for (var u in o) i.d(a, u, function(c) {
            return o[c];
          }.bind(null, u));
          return a;
        }, i.n = function(o) {
          var s = o && o.__esModule ? function() {
            return o.default;
          } : function() {
            return o;
          };
          return i.d(s, "a", s), s;
        }, i.o = function(o, s) {
          return Object.prototype.hasOwnProperty.call(o, s);
        }, i.p = "", i(i.s = 2);
      }([function(n, r, i) {
        i.r(r);
        var o = typeof fetch == "function" ? fetch.bind() : function(s, a) {
          return a = a || {}, new Promise(function(u, c) {
            var l = new XMLHttpRequest();
            for (var d in l.open(a.method || "get", s, !0), a.headers) l.setRequestHeader(d, a.headers[d]);
            function f() {
              var h, p = [], v = [], g = {};
              return l.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(m, _, C) {
                p.push(_ = _.toLowerCase()), v.push([_, C]), h = g[_], g[_] = h ? h + "," + C : C;
              }), { ok: (l.status / 100 | 0) == 2, status: l.status, statusText: l.statusText, url: l.responseURL, clone: f, text: function() {
                return Promise.resolve(l.responseText);
              }, json: function() {
                return Promise.resolve(l.responseText).then(JSON.parse);
              }, blob: function() {
                return Promise.resolve(new Blob([l.response]));
              }, headers: { keys: function() {
                return p;
              }, entries: function() {
                return v;
              }, get: function(m) {
                return g[m.toLowerCase()];
              }, has: function(m) {
                return m.toLowerCase() in g;
              } } };
            }
            l.withCredentials = a.credentials == "include", l.onload = function() {
              u(f());
            }, l.onerror = c, l.send(a.body);
          });
        };
        r.default = o;
      }, function(n, r, i) {
        Object.defineProperty(r, "__esModule", { value: !0 });
        var o = /* @__PURE__ */ function() {
          function a(u, c) {
            for (var l = 0; l < c.length; l++) {
              var d = c[l];
              d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(u, d.key, d);
            }
          }
          return function(u, c, l) {
            return c && a(u.prototype, c), l && a(u, l), u;
          };
        }(), s = function() {
          function a(u, c) {
            (function(l, d) {
              if (!(l instanceof d)) throw new TypeError("Cannot call a class as a function");
            })(this, a), this.pluginName = u;
          }
          return o(a, [{ key: "track", value: function(u, c) {
            window.analytics.track(u, c, { integration: { name: this.pluginName } });
          } }]), a;
        }();
        r.default = s;
      }, function(n, r, i) {
        Object.defineProperty(r, "__esModule", { value: !0 }), r.YouTubeAnalytics = r.VimeoAnalytics = void 0;
        var o = a(i(3)), s = a(i(4));
        function a(u) {
          return u && u.__esModule ? u : { default: u };
        }
        r.VimeoAnalytics = o.default, r.YouTubeAnalytics = s.default;
      }, function(n, r, i) {
        Object.defineProperty(r, "__esModule", { value: !0 });
        var o = /* @__PURE__ */ function() {
          function c(l, d) {
            for (var f = 0; f < d.length; f++) {
              var h = d[f];
              h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(l, h.key, h);
            }
          }
          return function(l, d, f) {
            return d && c(l.prototype, d), f && c(l, f), l;
          };
        }(), s = a(i(0));
        function a(c) {
          return c && c.__esModule ? c : { default: c };
        }
        var u = function(c) {
          function l(d, f) {
            (function(p, v) {
              if (!(p instanceof v)) throw new TypeError("Cannot call a class as a function");
            })(this, l);
            var h = function(p, v) {
              if (!p) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return !v || typeof v != "object" && typeof v != "function" ? p : v;
            }(this, (l.__proto__ || Object.getPrototypeOf(l)).call(this, "VimeoAnalytics"));
            return h.authToken = f, h.player = d, h.metadata = { content: {}, playback: { videoPlayer: "Vimeo" } }, h.mostRecentHeartbeat = 0, h.isPaused = !1, h;
          }
          return function(d, f) {
            if (typeof f != "function" && f !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof f);
            d.prototype = Object.create(f && f.prototype, { constructor: { value: d, enumerable: !1, writable: !0, configurable: !0 } }), f && (Object.setPrototypeOf ? Object.setPrototypeOf(d, f) : d.__proto__ = f);
          }(l, c), o(l, [{ key: "initialize", value: function() {
            var d = this, f = { loaded: this.retrieveMetadata, play: this.trackPlay, pause: this.trackPause, ended: this.trackEnded, timeupdate: this.trackHeartbeat };
            for (var h in f) this.registerHandler(h, f[h]);
            this.player.getVideoId().then(function(p) {
              d.retrieveMetadata({ id: p });
            }).catch(console.error);
          } }, { key: "registerHandler", value: function(d, f) {
            var h = this;
            this.player.on(d, function(p) {
              h.updateMetadata(p), f.call(h, p);
            });
          } }, { key: "trackPlay", value: function() {
            this.isPaused ? (this.track("Video Playback Resumed", this.metadata.playback), this.isPaused = !1) : (this.track("Video Playback Started", this.metadata.playback), this.track("Video Content Started", this.metadata.content));
          } }, { key: "trackEnded", value: function() {
            this.track("Video Playback Completed", this.metadata.playback), this.track("Video Content Completed", this.metadata.content);
          } }, { key: "trackHeartbeat", value: function() {
            var d = this.mostRecentHeartbeat, f = this.metadata.playback.position;
            f !== d && f - d >= 10 && (this.track("Video Content Playing", this.metadata.content), this.mostRecentHeartbeat = Math.floor(f));
          } }, { key: "trackPause", value: function() {
            this.isPaused = !0, this.track("Video Playback Paused", this.metadata.playback);
          } }, { key: "retrieveMetadata", value: function(d) {
            var f = this;
            return new Promise(function(h, p) {
              var v = d.id;
              (0, s.default)("https://api.vimeo.com/videos/" + v, { headers: { Authorization: "Bearer " + f.authToken } }).then(function(g) {
                return g.ok ? g.json() : p(g);
              }).then(function(g) {
                f.metadata.content.title = g.name, f.metadata.content.description = g.description, f.metadata.content.publisher = g.user.name, f.metadata.playback.position = 0, f.metadata.playback.totalLength = g.duration;
              }).catch(function(g) {
                return console.error("Request to Vimeo API Failed with: ", g), p(g);
              });
            });
          } }, { key: "updateMetadata", value: function(d) {
            var f = this;
            return new Promise(function(h, p) {
              f.player.getVolume().then(function(v) {
                v && (f.metadata.playback.sound = 100 * v), f.metadata.playback.position = d.seconds, h();
              }).catch(p);
            });
          } }]), l;
        }(a(i(1)).default);
        r.default = u;
      }, function(n, r, i) {
        Object.defineProperty(r, "__esModule", { value: !0 });
        var o = /* @__PURE__ */ function() {
          function d(f, h) {
            for (var p = 0; p < h.length; p++) {
              var v = h[p];
              v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(f, v.key, v);
            }
          }
          return function(f, h, p) {
            return h && d(f.prototype, h), p && d(f, p), f;
          };
        }(), s = u(i(0)), a = u(i(1));
        function u(d) {
          return d && d.__esModule ? d : { default: d };
        }
        var c = function(d) {
          function f(h, p) {
            (function(g, m) {
              if (!(g instanceof m)) throw new TypeError("Cannot call a class as a function");
            })(this, f);
            var v = function(g, m) {
              if (!g) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return !m || typeof m != "object" && typeof m != "function" ? g : m;
            }(this, (f.__proto__ || Object.getPrototypeOf(f)).call(this, "YoutubeAnalytics"));
            return v.player = h, v.apiKey = p, v.playerLoaded = !1, v.playbackStarted = !1, v.contentStarted = !1, v.isPaused = !1, v.isBuffering = !1, v.isSeeking = !1, v.lastRecordedTime = { timeReported: Date.now(), timeElapsed: 0 }, v.metadata = [{ playback: { video_player: "youtube" }, content: {} }], v.playlistIndex = 0, v;
          }
          return function(h, p) {
            if (typeof p != "function" && p !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof p);
            h.prototype = Object.create(p && p.prototype, { constructor: { value: h, enumerable: !1, writable: !0, configurable: !0 } }), p && (Object.setPrototypeOf ? Object.setPrototypeOf(h, p) : h.__proto__ = p);
          }(f, d), o(f, [{ key: "initialize", value: function() {
            window.segmentYoutubeOnStateChange = this.onPlayerStateChange.bind(this), window.segmentYoutubeOnReady = this.onPlayerReady.bind(this), this.player.addEventListener("onReady", "segmentYoutubeOnReady"), this.player.addEventListener("onStateChange", "segmentYoutubeOnStateChange");
          } }, { key: "onPlayerReady", value: function(h) {
            this.retrieveMetadata();
          } }, { key: "onPlayerStateChange", value: function(h) {
            var p = this.player.getCurrentTime();
            switch (this.metadata[this.playlistIndex] && (this.metadata[this.playlistIndex].playback.position = this.metadata[this.playlistIndex].content.position = p, this.metadata[this.playlistIndex].playback.quality = this.player.getPlaybackQuality(), this.metadata[this.playlistIndex].playback.sound = this.player.isMuted() ? 0 : this.player.getVolume()), h.data) {
              case -1:
                if (this.playerLoaded) break;
                this.retrieveMetadata(), this.playerLoaded = !0;
                break;
              case YT.PlayerState.BUFFERING:
                this.handleBuffer();
                break;
              case YT.PlayerState.PLAYING:
                this.handlePlay();
                break;
              case YT.PlayerState.PAUSED:
                this.handlePause();
                break;
              case YT.PlayerState.ENDED:
                this.handleEnd();
            }
            this.lastRecordedTime = { timeReported: Date.now(), timeElapsed: 1e3 * this.player.getCurrentTime() };
          } }, { key: "retrieveMetadata", value: function() {
            var h = this;
            return new Promise(function(p, v) {
              var g = h.player.getVideoData(), m = h.player.getPlaylist() || [g.video_id], _ = m.join();
              (0, s.default)("https://www.googleapis.com/youtube/v3/videos?id=" + _ + "&part=snippet,contentDetails&key=" + h.apiKey).then(function(C) {
                if (!C.ok) {
                  var T = new Error("Segment request to Youtube API failed (likely due to a bad API Key. Events will still be sent but will not contain video metadata)");
                  throw T.response = C, T;
                }
                return C.json();
              }).then(function(C) {
                h.metadata = [];
                for (var T = 0, R = 0; R < m.length; R++) {
                  var y = C.items[R];
                  h.metadata.push({ content: { title: y.snippet.title, description: y.snippet.description, keywords: y.snippet.tags, channel: y.snippet.channelTitle, airdate: y.snippet.publishedAt } }), T += l(y.contentDetails.duration);
                }
                for (R = 0; R < m.length; R++) h.metadata[R].playback = { total_length: T, video_player: "youtube" };
                p();
              }).catch(function(C) {
                h.metadata = m.map(function(T) {
                  return { playback: { video_player: "youtube" }, content: {} };
                }), v(C);
              });
            });
          } }, { key: "handleBuffer", value: function() {
            var h = this.determineSeek();
            this.playbackStarted || (this.playbackStarted = !0, this.track("Video Playback Started", this.metadata[this.playlistIndex].playback)), h && !this.isSeeking && (this.isSeeking = !0, this.track("Video Playback Seek Started", this.metadata[this.playlistIndex].playback)), this.isSeeking && (this.track("Video Playback Seek Completed", this.metadata[this.playlistIndex].playback), this.isSeeking = !1);
            var p = this.player.getPlaylist();
            p && this.player.getCurrentTime() === 0 && this.player.getPlaylistIndex() !== this.playlistIndex && (this.contentStarted = !1, this.playlistIndex === p.length - 1 && this.player.getPlaylistIndex() === 0 && (this.track("Video Playback Completed", this.metadata[this.player.getPlaylistIndex()].playback), this.track("Video Playback Started", this.metadata[this.player.getPlaylistIndex()].playback))), this.track("Video Playback Buffer Started", this.metadata[this.playlistIndex].playback), this.isBuffering = !0;
          } }, { key: "handlePlay", value: function() {
            this.contentStarted || (this.playlistIndex = this.player.getPlaylistIndex(), this.playlistIndex === -1 && (this.playlistIndex = 0), this.track("Video Content Started", this.metadata[this.playlistIndex].content), this.contentStarted = !0), this.isBuffering && (this.track("Video Playback Buffer Completed", this.metadata[this.playlistIndex].playback), this.isBuffering = !1), this.isPaused && (this.track("Video Playback Resumed", this.metadata[this.playlistIndex].playback), this.isPaused = !1);
          } }, { key: "handlePause", value: function() {
            var h = this.determineSeek();
            this.isBuffering && (this.track("Video Playback Buffer Completed", this.metadata[this.playlistIndex].playback), this.isBuffering = !1), this.isPaused || (h ? (this.track("Video Playback Seek Started", this.metadata[this.playlistIndex].playback), this.isSeeking = !0) : (this.track("Video Playback Paused", this.metadata[this.playlistIndex].playback), this.isPaused = !0));
          } }, { key: "handleEnd", value: function() {
            this.track("Video Content Completed", this.metadata[this.playlistIndex].content), this.contentStarted = !1;
            var h = this.player.getPlaylistIndex(), p = this.player.getPlaylist();
            (p && h === p.length - 1 || h === -1) && (this.track("Video Playback Completed", this.metadata[this.playlistIndex].playback), this.playbackStarted = !1);
          } }, { key: "determineSeek", value: function() {
            var h = this.isPaused || this.isBuffering ? 0 : Date.now() - this.lastRecordedTime.timeReported, p = 1e3 * this.player.getCurrentTime() - this.lastRecordedTime.timeElapsed;
            return Math.abs(h - p) > 2e3;
          } }]), f;
        }(a.default);
        function l(d) {
          var f = d.match(/PT(\d+H)?(\d+M)?(\d+S)?/);
          return f = f.slice(1).map(function(h) {
            if (h != null) return h.replace(/\D/, "");
          }), 3600 * (parseInt(f[0]) || 0) + 60 * (parseInt(f[1]) || 0) + (parseInt(f[2]) || 0);
        }
        r.default = c;
      }]);
    });
  }(sr)), sr.exports;
}
var ba = fy();
const hy = /* @__PURE__ */ Aa(ba), py = /* @__PURE__ */ ka({
  __proto__: null,
  default: hy
}, [ba]);
export {
  jg as AuthClient,
  Oe as ERROR_DESCRIPTIONS,
  V as SDK_ERROR_CODES,
  yy as createAuthClient
};
